export const tl = {
    "name": "Tagalog",
    "flagCode": "ph",
    "locale": "tl-tl",
    "project": {
        "name": "QUp Bagong CC"
    },
    "MigrationBanner": {
        "title": "Next-Generation Command Center",
        "subtitle": "I-explore ang bagong dashboard at kumpletuhin ang migration bago ang %{deadline}.",
        "tryNow": "Subukan Ngayon",
        "dismiss": "Isara"
    },

    "Sidebar": {
        "Product_Discovery": "Pagtuklas ng Produkto",
        "Setting": "Mga setting",
        "Map": "Mapa",
        "Cue": "Pila",
        "Invoice": "Invoice",
        "Supplier": "Tagapagtustos",
        "Vehicle": "Sasakyan",
        "Merchant": "Merchant",
        "ImportBookings": "Mag-import ng Transport Booking",
        "ImportDeliveryBookings": "Mag-import ng Mga Delivery Booking",
        "Trip": "Biyahe",
        "New_booking": "Bagong Booking",
        "City": "lungsod",
        "Chauffeur": "Transportasyon",
        "Delivery": "Paghahatid",
        "Shuttle": "Shuttle",
        "Intercity": "Intercity",
        "Customer": "Mga customer",
        "Driver": "Mga driver",
        "REPORTS": "Mga ulat",
        "Corporate": "Korporasyon",
        "mDispatcher": "Kasosyo",
        "Reservation": "Kalendaryo",
        "withdrawalRequest": "Mga kahilingan sa withdrawal",
        "Driver_Settlement": "Pag-aayos ng Driver",
        "Dashboard": "Analitika",
        "SmartData": "Smart na datos",
        "Smart_Data": "Matalinong datos",
        "Campaign_Builder": "Tagabuo ng kampanya",
        "Company_operator": "Operator ng kumpanya",
        "Queuing_area": "Lugar ng pila",
        "Withdrawal_Requests": "Mga Kahilingan sa Pag-withdraw",
        "pickUp": "Pulutin/ Sunduin",
        "dropOff": "Ilaglag/ Naihatid",
        "SignUpNotifications": "Mga Notification sa Pag-sign Up",
        "Payout": "Bayad",
        "Payout_label": "Bayad",
        "Invoice_Setting": "Invoice",
        "payout": {
            "payoutDriver": "Bayad sa Driver",
            "payoutMerchant": "Bayad sa Mangangalakal",
            "payoutSupplier": "Bayad sa Supplier",
            "Pay_To_Driver": "Magbayad sa mga Driver",
            "payoutDriverHistory": "Kasaysayan ng Pagbabayad ng Driver",
            "Pay_To_Merchant": "Magbayad sa mga Merchant",
            "Payout_History_For_Merchant": "Kasaysayan ng Merchant ng Payout",
            "Pay_To_Supplier": "Magbayad sa mga Supplier",
            "payoutSupplierHistory": "Kasaysayan ng Payout Supplier",
            "Driver_Payout": "Bayad sa Driver",
            "Supplier_Payout": "Bayad sa Supplier",
            "Merchant_Payout": "Bayad sa Mangangalakal"
        },
        "number_of_records_to_export": "Bilang ng mga tala na ie-export",
        "export": "I-export",
        "Airline": "Airline",
        "driverPayout": {
            "Pay_to_driver": "Magbayad sa mga Driver",
            "Payout_history": "Kasaysayan ng Pagbabayad"
        },
        "Reports": {
            "Driver_Referral_history": "Tinutukoy ng driver ang customer",
            "Driver_refers_Pax": "Mga driver",
            "Refund": "Refund",
            "Driver_refers_Pax_Customers": "Mga customer",
            "Driver_refers_Pax_Bookings": "Mga booking",
            "Driver_refers_customer_Drivers": "Tinutukoy ng driver ang customer (Mga Driver)",
            "Driver_refers_customer_Customers": "Tinutukoy ng driver ang customer (Mga Customer)",
            "Driver_refers_customer_Bookings": "Tinutukoy ng driver ang customer (Mga Booking)",
            "Passenger_refers_Passengers": "Tinutukoy ng customer ang customer",
            "Driver_refers_drivers_Referrer": "Tinutukoy ng driver ang mga driver (Referrer)",
            "Deletion_request": "Kahilingan sa pagtanggal",
            "Driver_refers_drivers_Referee": "Tinutukoy ng driver ang mga driver (Referee)",
            "Supplier_Wallet": "Supplier Wallet",
            "Driver_refers_Driver": "Driver ay tumutukoy sa driver",
            "Driver_refers_driver_Referrer": "Referrer",
            "Driver_refers_driver_Referee": "Referee",
            "Referral_history": "Kasaysayan ng referral",
            "Booking_details": "Mga detalye ng booking",
            "Financial": "Pananalapi",
            "Financial_driver": "Driver",
            "Financial_fleet": "Armada",
            "Financial_company": "kumpanya",
            "Financial_Driver": "Pinansyal (Driver)",
            "Financial_Fleet": "Pinansyal (Fleet)",
            "Financial_Company": "Pinansyal (Kumpanya)",
            "Financial_fleet_profit": "Fleet na kita",
            "Financial_Company_Tooltip": "Ulat ng netong kita ng mga driver, na nakagrupo ayon sa kumpanya",
            "Financial_Driver_ToolTip": "Net na ulat ng kita ng bawat driver",
            "Financial_Fleet_Profit_ToolTip": "Kita ng fleet",
            "Driver_activity": "Aktibidad ng driver",
            "Revenue_Summary": "Buod ng kita",
            "Revenue_fleet": "Armada",
            "Revenue_driver": "Driver",
            "Revenue_monthly": "Buwan-buwan",
            "Revenue_Summary_Fleet": "Buod ng Kita (Fleet)",
            "Revenue_Summary_Driver": "Buod ng Kita (Driver)",
            "Revenue_Summary_Monthly": "Buod ng Kita (Buwanang)",
            "Total_adjustment": "Kabuuang pagsasaayos",
            "Promotion": "Promosyon",
            "Incident_Cancellation": "Insidente at Pagkansela",
            "Booking_logs": "Mga log ng booking",
            "Rating": "Marka",
            "Thumbs_rating": "Marka",
            "Stars_rating": "Marka",
            "Operator_logs": "Mga log ng operator",
            "Daily": "Araw-araw",
            "Daily_Driver": "Araw-araw na Driver",
            "Daily_Car": "Araw-araw na Sasakyan",
            "Daily_Driver_Car": "Pang-araw-araw na Sasakyan ng Driver",
            "mDispatcher": "Kasosyo",
            "Corporate": "Lịch trình của công ty",
            "Driver_login_status": "Katayuan ng pag-login ng driver",
            "Car_activity": "Aktibidad ng sasakyan",
            "Partner": "Kasosyo",
            "Prepaid_top_up": "Korporatibong prepaid",
            "Affiliation": "Pagkakaugnay",
            "Affiliation_penalty_compensation": "Parusa/Kabayaran",
            "Affiliation_payout_history": "Kasaysayan ng paninirahan",
            "Affiliation_bookings": "Mga booking",
            "Booking_summary": "Buod ng booking",
            "Cash_Wallet": "Cash wallet",
            "Credit_Wallet": "Credit wallet",
            "Driver_wallet": "wallet ng driver",
            "Driver_Deposit": "Deposito ng driver",
            "Driver_cash_wallet": "Cash Wallet",
            "Driver_Deposit_old": "Deposito ng driver",
            "Document_expiry": "Pag-expire ng dokumento",
            "Settlement": "Pag-aayos",
            "Unapproved_Driver": "Hindi naaprubahang driver",
            "Approved_Driver": "Inaprubahang driver",
            "Pay_to_driver": "Magbayad sa driver",
            "Settlement_history": "Kasaysayan ng paninirahan",
            "Withdrawal_History": "Pag-alis ng driver",
            "creditWalletTooltip": "Nagdedeposito ang driver sa credit wallet",
            "Incomplete_payment": "Hindi kumpletong bayad",
            "Driver_withdrawal": "Pag-withdraw ng Driver",
            "Incident_&_Cancellation": "Insidente at Pagkansela",
            "Passenger_wallet": "Wallet ng pasahero",
            "Accept_Cancel_rate": "Pagganap ng driver",
            "Acceptance/Cancellation_rate": "Pagganap ng driver",
            "driverDepositTooltip": "Nagdedeposito ang driver sa credit wallet",
            "Customer_quest": "Paghanap",
            "First_will_win": "Unang mananalo",
            "Largest_will_win": "Pinakamalaki ang mananalo",
            "redeemed": "Kodigo #",
            "Code_#": "Kodigo #",
            "Quests": "Paghanap",
            "Merchant_Report": "Mangangalakal",
            "Merchant_Financial_Report": "Pananalapi",
            "Merchant_Cash_Report": "Cash wallet",
            "Merchant_Credit_Report": "Credit wallet",
            "Deletion_Request": "Kahilingan sa pagtanggal",
            "Driver_Rating": "Driver ng rate ng customer",
            "Passenger_Rating": "Customer rate ng driver",
            "Company_settlement": "Settlement ng kumpanya",
            "Export": "I-export ang Kasaysayan",
            "Third_Party_Booking": "Pag-book ng 3rd party",
            "BookingDotCom": "Booking.com",
            "Third_Party_Booking_Bookingcom": "Pag-book ng Third Party (Booking.com)",
            "Third_Party_Booking_HolidayTaxis": "Third Party Booking (HolidayTaxis)",
            "Third_Party_Booking_Karhoo": "Third Party Booking (Karhoo)",
            "Third_Party_Booking_Hoppa": "Third Party Booking (Hoppa)",
            "Third_Party_Booking_Klook": "Third Party Booking (Klook)",
            "Third_Party_Booking_TransferZ": "Third Party Booking (TransferZ)",
            "supplierWallet": "Supplier Wallet"
        },
        "Settings": {
            "Block_Passenger": "Harangin ang Pasahero",
            "Fleet_info": "Impormasyon ng fleet",
            "Product_Discovery": "Pagdiskubre ng Produkto",
            "Surchage_Policy": "Patakaran sa Surcharge",
            "RateLegacy": "Rate (Legacy)",
            "Driver": "Driver",
            "Merchant": "Merchant",
            "Calendar": "Kalendaryo",
            "Socaial": "Socaial",
            "Quest": "Quest",
            "Referral": "Rekomendasyon",
            "Addon_Template": "Add-On Template",
            "Social": "Panlipunan",
            "Shift": "Shift",
            "Rate_Templates": "Mga Template ng Rate",
            "Supplier_Plan": "Supplier Plan",
            "Vehicle_Lead_Time": "Oras ng Paghihintay para sa Sasakyan",
            "Penalty_Policy": "Patakaran sa Parusa",
            "Stripe_connect": "Stripe Connect",
            "stripe_title_connect": "I-activate ang iyong Stripe Connect account upang awtomatikong matanggap ang iyong payout.",
            "Payment_info": "Impormasyon sa pagsingil",
            "Permission": "Pahintulot",
            "Driver_refer_driver": "Sumangguni sa driver ang driver",
            "Show_referal_history": "Ipakita/itago ang history ng referral sa driver app",
            "companyTooltip": "Supplier ng kumpanya",
            "User": "Gumagamit",
            "General": "Heneral",
            "Regular": "Regular",
            "Sharing": "Pagbabahagi ng Kalye",
            "Flat": "patag",
            "Hourly": "Oras-oras - Araw-araw",
            "Company": "kumpanya",
            "Dispatch": "Pagpapadala",
            "Voice_SMS": "Boses at SMS",
            "Rate": "Rate",
            "RateNew": "Rate",
            "Car": "kotse",
            "Car_type": "Uri ng kotse",
            "Car_mgmt": "Pamamahala ng sasakyan",
            "Car_Make": "Gumawa at Modelo",
            "Meeting_Zone": "Meeting Zone",
            "Restricted_Zone": "Pinagbabawal na Lugar",
            "Stripe_Connect": "Stripe connect",
            "Voice_&_SMS": "Boses at SMS",
            "Street-sharing_rate": "Rate ng pagbabahagi ng kalye",
            "Partner_type": "Uri ng kasosyo",
            "Shift_template": "Template ng shift",
            "Billing_Usage": "Paggamit ng Pagsingil",
            "Driver_App": "Driver App",
            "Shift_settings": "Mga setting ng shift",
            "Operation": "Operasyon",
            "Driver_Note": "Tala ng driver",
            "Promotion_code": "Code ng promosyon",
            "Point_config": "Point config",
            "Code_#": "Kodigo #",
            "Voucher_code": "Kodigo #",
            "Campaign": "Kampanya",
            "Queuing_area": "Lugar ng pila",
            "Referral_code": "Referral code",
            "City": "lungsod",
            "category": "Kategorya",
            "3rd_party_location": "lokasyon ng 3rd party",
            "Zone": "Sona",
            "App_banner": "Banner ng app",
            "App_banner_pegasus": "Banner ng app (Pegasus)",
            "Flight_integration": "Pagsasama ng Flight",
            "SMS_integration": "Pagsasama ng SMS",
            "Invoice_Setting": "Invoice",
            "Payout_Setting": "Template ng Bayad",
            "AI_Atlas": "Atlas AI Chatbot",
            "Driver_refers_customer": "Tinutukoy ng driver ang customer",
            "Pax_refers_Pax": "Tinutukoy ng customer ang customer",
            "Customer_refers_customer": "Tinutukoy ng customer ang customer",
            "Dynamic_Surcharge": "Dynamic na Surcharge",
            "Dynamic_Fare": "Dynamic na Pamasahe",
            "FlatZone": "Patag na rate",
            "IntercityZone": "Intercity",
            "Intercity_Zone": "Intercity Zone",
            "Intercity_Rate": "Intercity Rate",
            "Car_Color": "Kulay ng kotse",
            "third_party_integration": "integrasyon ng 3rd party",
            "bookingCom": "Booking.com",
            "HolidayTaxis": "HolidayTaxis",
            "Karhoo": "Karhoo",
            "Corporate": "Korporatibo",
            "KarhooIntegration": "Karhoo Integration",
            "holidaytaxis": "HolidayTaxis",
            "karhoo": "Karhoo",
            "hoppa": "Hoppa",
            "Hoppa": "Hoppa",
            "HoppaIntegration": "Hoppa Integration",
            "Third_Party_Integration_Hoppa": "3rd party Integration (Hoppa.com)",
            "titleHoppa": "Hoppa API Mga Kredensyal",
            "noteHoppa": "Makipag-ugnayan sa teknikal na koponan ng Hoppa upang bigyan ka ng client at secret key para kumonekta sa kanilang sistema.",
            "titleHoppaWebhook": "Webhook Konpigurasyon",
            "noteHoppaWebhook": "Ibigay ang mga parameter sa ibaba para sa Hoppa upang i-configure. Ang mga kredensyal na ito ay ginagamit upang makipag-ugnayan sa pagitan ng parehong platform. Para sa anumang isyu, mangyaring makipag-ugnayan sa iyong tech provider.",
            "klook": "Klook",
            "Klook": "Klook",
            "KlookIntegration": "Klook Integration",
            "Third_Party_Integration_Klook": "3rd party Integration (Klook.com)",
            "titleKlook": "Klook API Credentials",
            "noteKlook": "Makipag-ugnayan sa teknikal na koponan ng Klook upang bigyan ka ng kliyente at lihim na susi upang kumonekta sa kanilang sistema.",
            "titleKlookWebhook": "Webhook Konpigurasyon",
            "noteKlookWebhook": "Ibigay ang mga parameter sa ibaba para sa Klook upang i-configure. Ang mga kredensyal na ito ay ginagamit upang makipag-ugnayan sa pagitan ng parehong platform. Para sa anumang isyu, mangyaring makipag-ugnayan sa iyong tech provider.",
            "transferZ": "TransferZ",
            "TransferZ": "TransferZ",
            "TransferZIntegration": "TransferZ Pagsasama",
            "Third_Party_Integration_TransferZ": "3rd party Integration (TransferZ.com)",
            "titleTransferZ": "TransferZ API Mga Kredensyal",
            "noteTransferZ": "Makipag-ugnayan sa teknikal na koponan ng TransferZ upang bigyan ka ng kliyente at lihim na susi upang kumonekta sa kanilang sistema.",
            "titleTransferZWebhook": "Webhook Konpigurasyon",
            "noteTransferZWebhook": "Ibigay ang mga parameter sa ibaba para sa TransferZ upang i-configure. Ang mga kredensyal na ito ay ginagamit upang makipag-ugnayan sa pagitan ng parehong platform. Para sa anumang isyu, mangyaring makipag-ugnayan sa iyong tech provider.",
            "Third_Party_Integration_Booking": "Pagsasama ng 3rd party (Booking.com)",
            "Third_Party_Integration_HolidayTaxis": "3rd party Integration (HolidayTaxis)",
            "Third_Party_Integration_Karhoo": "Pagsasama ng 3rd party (Karhoo.com)",
            "Third_Party_Integration_Mozio": "Pagsasama ng 3rd party (Mozio.com)",
            "invoiceBranding": "Pagba-brand ng Invoice",
            "invoiceLogo": "Logo ng Invoice",
            "invoiceColor": "Kulay ng Invoice",
            "payoutBranding": "Payout Branding",
            "titleInvoice": "I-customize ang impormasyon ng header at footer ng iyong kumpanya.",
            "titlePayout": "I-customize ang impormasyon ng header at footer ng iyong kumpanya.",
            "titleheader": "Pamagat ng Header",
            "descriptionHeader": "Paglalarawan ng Header",
            "placehodelHeader": "Halimbawa, magdagdag ng mga detalye ng kumpanya tulad ng email, numero ng telepono, address, numero ng buwis, atbp.",
            "titleFooter": "Pamagat ng Footer",
            "placehodelFooter": "Halimbawa, magdagdag ng impormasyon sa bank wire, o anumang patakaran atbp",
            "descriptionFooter": "Paglalarawan ng Footer",
            "defaultEmailMessage": "Default na Mensahe sa Email",
            "placeholderEmailMessage": "Ang halaga ay ililipat sa iyong account gamit ang iyong piniling paraan ng pagbabayad. Mangyaring huwag mag-atubiling makipag-ugnayan sa amin sa <email> kung mayroon kang anumang mga katanungan.\n\nSalamat sa mga serbisyong ibinigay. Inaasahan namin ang isang matagumpay na pakikipagtulungan sa hinaharap.\n\nLubos na gumagalang,  \nTeam Good Journey\n\nKung walang pagtutol na natanggap sa loob ng pitong araw, ang self-billed invoice ay itinuturing na naaprubahan.",
            "titleBookingCom": "Mga Kredensyal ng Booking.com API",
            "noteBookingCom": "Makipag-ugnayan sa technical team ng booking.com para bigyan ka ng kliyente, at sikretong key para kumonekta sa kanilang system.",
            "clientKey": "Susi ng Kliyente",
            "placeHolderClientKey": "Ipasok ang client key",
            "secretKey": "Lihim na Susi",
            "placeHolderSecretKey": "Ipasok ang client key",
            "titleBookingComWebhook": "Configuration ng Webhook",
            "noteBookingComWebhook": "Ibigay ang mga parameter sa ibaba para i-configure ng booking.com. Ang mga kredensyal na ito ay ginagamit upang makipag-usap sa pagitan ng parehong mga platform. Para sa anumang mga isyu mangyaring makipag-ugnayan sa iyong tech provider.",
            "webhook": "URL ng Fleet Webhook",
            "clientId": "Fleet Client Key",
            "clientSecret": "Fleet Secret Key",
            "driver_app": "Driver App",
            "Jobs_tab": "Tab ng Trabaho",
            "Email_config": "Email na pagsasaayos",
            "Driver_fields": "Mga field ng driver",
            "Driver_document": "Dokumento ng driver",
            "Selected": "Napili",
            "API_Management": "Pamamahala ng API",
            "Penalty_Policy_Customer": "Patakaran sa Parusa ng Customer",
            "Penalty_Policy_Supplier": "Patakaran sa Parusa ng Supplier",
            "Stop_Sales": "Huminto ng Benta",
            "RestrictedZone": "Pinagbabawal na Lugar",
            "MeetingZone": "Meeting Zone",
            "block_passenger": "Harangin ang Pasahero",
            "Billing_usage": "Pagbabayad ng Paggamit"
        }
    },
    "welcome": {
        "next": "Next",
        "getStarted": "Get Started",
        "step1": {
            "title": "Product Discovery",
            "description": "Welcome to Good Journey! Access all the products included in your plan, such as the <span class=\"highlight-white\">Driver App, Customer Web Booker</span> and more.",
            "button": "Learn more"
        },
        "step2": {
            "title": "Introducing Fleet Wallet",
            "description": "Once you reach your free allowance, any additional overage will check your fleet wallet to deduct per additional request.",
            "moreInfo": "💡 Maintain a positive balance, check usage and transaction reports here."
        },
        "step3": {
            "title": "Never Miss a Beat",
            "description": "You can setup <span class=\"highlight-white\">Automated Top-up</span> to ensure no service disruption on top of usage.",
            "description2": "This ensures your drivers stay on the road and your data keeps flowing, no matter how busy things get."
        },
        "step4": {
            "title": "Getting Started",
            "description": "We’re thrilled to have you onboard! Check out our <span class=\"highlight-white\">Guides & Tutorials</span> section to master the platform and get the most out of your fleet management tools."
        }
    },
    "productDiscovery": {
        "title": "Pagtuklas ng Produkto",
        "fleetCode": "Fleet Code",
        "fleetCodeDescription": "Ang mga drayber na gumagamit ng global driver app ay kinakailangang ilagay ang code na ito bago mag-log in.",
        "description": "Tuklasin at i-activate ang mga tool na nagpapagana sa iyong fleet. Ma-access ang Driver App, Customer App, Web Booking Portal, at Partner Booker Apps — lahat ay dinisenyo upang pasimplihin ang operasyon, kumonekta sa mga pasahero, at palaguin ang iyong negosyo.",
        "web": "Web",
        "ios": "iOS",
        "android": "Android",
        "guide": "Patnubay",
        "gallery": "Galeriya",
        "downloadLinks": "Mga Link ng Pag-download",
        "customize": "Mga Setting",
        "base": "Knowledge Base",
        "base_description": "Ang iyong all-in-one na gabay sa platform. Tuklasin ang mga hakbang-hakbang na tutorial, FAQs, at pinakamahusay na mga kasanayan upang masterin ang mga booking, dispatch, pagbabayad, at iba pa.",
        "base_allowed": {
            "platform_guides": "Mga Gabay sa Plataporma",
            "step_by_step_tutorials": "Mga Tutorial na Hakbang-hakbang",
            "faqs_troubleshooting": "Mga FAQ at Pagsusuri ng Problema",
            "best_practices": "Pinakamahusay na Kasanayan",
            "product_releases_updates": "Paglabas ng Produkto at Mga Update"
        },
        "driver_app": "Aplikasyon ng drayber",
        "driver_app_description": "Ibigay sa iyong mga drayber ang isang app upang pamahalaan ang mga trabaho, kumpletuhin ang mga biyahe, at i-update ang mga booking nang walang hirap.",
        "driver_app_allowed": {
            "booking_notifications": "Mga Abiso sa Pag-book",
            "trip_management": "Pamamahala ng Biyahe",
            "navigate_realtime_tracking": "Navigasyon at Real-Time na Pagsubaybay",
            "inapp_communication_support": "Komunikasyon at Suporta sa App",
            "track_driver_earnings": "Subaybayan ang Kita ng Driver",
            "driver_signup_link": "Link para sa Pag-sign Up ng Driver"
        },
        "passenger_app": "Passenger App",
        "passenger_app_description": "Mag-book at mag-manage ng mga biyahe nang madali. Ang Passenger App ay nag-aalok ng isang premium na karanasan para sa mga manlalakbay — mula sa agarang pag-book hanggang sa real-time na mga update — na tinitiyak ang kaginhawaan, pagiging maaasahan, at kontrol sa bawat hakbang.",
        "passenger_app_allowed": {
            "seamless_ride_booking": "Walang Putol na Pag-book ng Sakay",
            "realtime_tracking_notifications": "Real-Time na Pagsubaybay at Mga Abiso",
            "inapp_communication": "Komunikasyon sa App",
            "flexible_payment_receipts": "Flexible na Bayad at Resibo",
            "ride_history_favorites": "Kasaysayan ng Sakay at Paborito"
        },
        "web_driver_app": "Driver Web App",
        "web_driver_app_description": "Bigyan ang mga subcontractor at partner drivers ng madaling paraan upang tanggapin at pamahalaan ang mga trabaho nang hindi nag-iinstall ng app. Ang Driver Web App ay tumatakbo nang direkta sa browser — perpekto para sa mga one-off na driver o partner na gumagamit ng kanilang sariling mga sistema, na may mga notification na ipinapadala sa pamamagitan ng email, SMS, o web alerts.",
        "web_driver_app_allowed": {
            "job_access_via_web_link": "Access sa Trabaho sa Pamamagitan ng Web Link",
            "trip_management": "Pamamahala ng Biyahe",
            "notifications_email_sms_web": "Mga Abiso sa Email/SMS/Web",
            "navigation_status_updates": "Pag-navigate at Mga Update sa Katayuan",
            "simple_lightweight": "Simple at Magaan",
            "signup_link": "Link para sa Pag-sign Up ng Driver"
        },
        "web_passenger_app": "Web Booking App",
        "web_passenger_app_description": "Bigyan ang iyong mga customer at kasosyo ng kakayahang mag-book ng mga biyahe nang direkta mula sa iyong website. Ang Web Booking App ay ginawa para sa mga airport transfer, chauffeur services, at on-demand reservations — nagbibigay sa mga OTA, hotel, at travel agent ng simpleng paraan upang ikonekta ang mga manlalakbay sa iyong fleet.",
        "web_passenger_app_allowed": {
            "embed_anywhere": "I-embed kahit saan",
            "create_ride_bookings": "Lumikha ng Mga Booking ng Sakay",
            "seamless_web_experience": "Walang Putol na Karanasan sa Web",
            "partner_ready": "Handa sa Kasosyo",
            "customer_friendly_checkout": "Maginhawang Pagbabayad para sa mga Customer"
        },
        "concierge_booker": "Concierge Booker",
        "concierge_booker_description": "Isang simpleng web app para sa mga kasosyo at kawani — mula sa mga concierge ng hotel at valet hanggang sa mga bartender at host ng restaurant — upang lumikha ng mga biyahe para sa kanilang mga bisita sa loob lamang ng ilang pag-click. Bawat gumagamit ay may sariling login, maaaring mag-book sa ngalan ng mga manlalakbay, at subaybayan ang mga komisyon na kinita.",
        "concierge_booker_allowed": {
            "quick_guest_booking": "Mabilis na Pag-book ng Bisita",
            "individual_user_login": "Mga Indibidwal na Pag-login ng Gumagamit",
            "commission_tracking": "Pagsubaybay sa Komisyon",
            "easy_web_access": "Madaling Pag-access sa Web",
            "partner_friendly_setup": "Partner-Friendly Setup"
        },
        "gojo_api": "Good Journey API",
        "gojo_api_description": "Bumuo nang may kumpiyansa. I-access ang aming developer portal upang tuklasin ang mga API reference, mga gabay sa integrasyon, at mga halimbawa ng workflow para sa mga booking, dispatch, pagbabayad, at iba pa.",
        "gojo_api_allowed": {
            "comprehensive_api_reference": "Komprehensibong Sanggunian ng API",
            "integration_guides": "Mga Gabay sa Pagsasama",
            "sandbox_testing_tools": "Sandbox at Mga Kasangkapan sa Pagsubok"
        },
        "gojo_canvas": "Magandang Paglalakbay Canvas",
        "gojo_canvas_description": "Idisenyo at i-customize ang iyong super-app na karanasan. Ang Good Journey Canvas ay nagbibigay sa iyo ng buong malikhaing kontrol upang pamahalaan ang mga menu, mga form ng paghahatid, mga promosyon, at mga layout ng home-screen — lahat mula sa isang simpleng interface.",
        "gojo_canvas_allowed": {
            "menu_management": "Pamamahala ng Menu",
            "custom_delivery_forms": "Mga Pasadyang Form ng Paghahatid",
            "super_app_home_builder": "Super-App Tagabuo ng Bahay",
            "promotion_advertising": "Mga Promosyon at Advertising",
            "flexible_content_management": "Flexible na Pamamahala ng Nilalaman"
        },
        "gojo_chatbot": "Magandang Paglalakbay AI Chat Bot",
        "gojo_chatbot_description": "Mag-book ng mga biyahe sa pamamagitan ng isang pag-uusap. Ang AI-powered chat assistant ay tumutulong sa mga customer, kasosyo, o kawani na lumikha ng mga booking nang agad — sa pamamagitan ng pag-type ng mga kahilingan, natural na pagsasalita, o kahit na pag-upload ng mga itinerary.",
        "gojo_chatbot_allowed": {
            "conversational_booking": "Pagbu-book sa Usapan",
            "file_itinerary_uploads": "Pag-upload ng File at Itinerary",
            "multi_channel_access": "Multi-Channel Access",
            "smart_suggestions": "Smart Suggestions",
            "operator_assistance": "Tulong ng Operator"
        },
        "concierge_booker_web_setting": "Mga Setting - Concierge Booker",
        "pax_app_setting": "Mga Setting - Passenger App",
        "driver_app_setting": "Mga Setting - Pandaigdigang Driver App",
        "pax_web_setting": "Mga Setting - Web Booking App",
        "driver_web_setting": "Mga Setting - Driver Web App",
        "save": "I-save",
        "cancel": "Ikansela",
        "themes": "Mga Tema",
        "links": "Mga Link",
        "ios_driver_app": "iOS Driver App",
        "android_driver_app": "Android Driver App",
        "gallery_driver_app": "Gallery Driver App",
        "ios_pax_app": "iOS Pasahero App",
        "android_pax_app": "Android Passenger App",
        "gallery_pax_app": "Gallery Passenger App",
        "light_mode": "Light Mode",
        "dark_mode": "Madilim na Mode",
        "primary_color": "Pangunahing Kulay",
        "secondary_color": "Pangalawang Kulay",
        "longName": "PWA Mahabang Pangalan",
        "shortName": "PWA Maikling Pangalan",
        "adsTracking": "Pagmamanman ng Mga Anunsyo",
        "googleId": "Google Tag ID",
        "metaId": "Meta Pixel ID",
        "customUrl": "Link ng Pag-book",
        "partnerLink": "Partner Web Link",
        "webBookingSettings": "Mga Setting ng Web Booking",
        "enableBookNow": "Ngayon Mga Pag-book",
        "enableBookLater": "Mga Susunod na Booking",
        "enableGuestCheckout": "Pagbabayad bilang Bisita",
        "quoteSettings": "Quote Settings",
        "icon192": "PWA App Icon (192x192)",
        "icon512": "PWA App Icon (512x512)",
        "icon192Driver": "PWA App Icon (192x192)",
        "icon512Driver": "PWA App Icon (512x512)",
        "pax_app": "Aplikasyon ng Pasahero",
        "default": "Default",
        "customized": "Naangkop",
        "html": "HTML",
        "about": "Tungkol sa",
        "email": "Suporta sa Email",
        "enablePhone": "Numero ng telepono",
        "phone": "",
        "policy": "Link Patakaran sa Privacy",
        "termOfUse": "Mga Tuntunin ng Paggamit ng Link",
        "site": "Website",
        "logoDriverIOS": "Logo - IOS",
        "logoDriverAndroid": "Logo - Android",
        "htmlUrl": "HTML na file",
        "Update_fail": "Nangyari ang mga pagkakamali",
        "Update_success": "Ang mga setting ay matagumpay na na-update",
        "driverSignUp": "Link ng Pag-sign Up ng Driver",
        "customUrlDriver": "Link ng Driver Web App"
    },
    "APIKeySetting": {
        "APIKey": "Mga API Key",
        "APIKey_title": "Huwag ibahagi ang iyong API key sa iba, o ilantad ito sa browser o iba pang client-side code. Upang maprotektahan ang seguridad ng iyong account, maaari ding awtomatikong i-disable ng Good Journey ang anumang API key na nakita naming nag-leak sa publiko.",
        "newKeyBtn": "Gumawa ng bagong key",
        "updateApplication": "I-update ang Application",
        "RegisterApp": "Magrehistro ng bagong aplikasyon",
        "RegisterBtn": "Magrehistro ng Aplikasyon",
        "appDescription": "Paglalarawan ng App",
        "webhookUrl": "Webhook Endpoint",
        "appName": "Pangalan ng App",
        "clientKey": "Suskey ng Kliyente",
        "secretKey": "Lihim na Susi",
        "hostedEndPoint": "Mga naka-host na endpoint",
        "maxEndpoints": "Maaari kang magkaroon ng maximum na 5 endpoint",
        "addEndpoint": "Magdagdag ng Endpoint",
        "updateEndpoint": "I-update ang Endpoint",
        "ManageWebhooks": "Pamahalaan ang Webhooks",
        "CreateWebhook": "Lumikha ng mga webhook",
        "subscriptionID": "Subscription ID",
        "webhookURL": "Webhook URL",
        "signingSecret": "Lihim na pumipirma",
        "eventsToSend": "Mga kaganapang ipapadala",
        "listeningFor": "Nakikinig Para sa",
        "assignedDriver": "Nakatalagang Driver",
        "bookingStatus": "Katayuan ng Pag-book",
        "driverLocation": "Lokasyon ng Driver",
        "titleSigningSecret": "Ang sikretong ito ay ibinigay ng iyong kapareha. Kung sa anumang kadahilanan ay nakompromiso ang lihim, maaari mong i-update ang lihim, o tanggalin ang web hook.",
        "notUsingHTTPS": "Hindi gumagamit ng HTTPS ang URL ng webhook.",
        "invalidURL": "Di-wasto ang URL ng webhook.",
        "clientType": "Uri ng Kliyente",
        "individual": "Indibidwal",
        "corporate": "Korporatibo",
        "signingSecretLength": "Ang signing secret ay dapat hindi bababa sa 30 na karakter ang haba.",
        "bookingCreated": "Naipon ang Booking",
        "partner": "Kabartner",
        "fleetManager": "Tagapamahala ng Pangkalahatang Sasakyan",
        "apiProvider": "API Provider",
        "selectAPITitle": "Pumili ng API na nais mong isama",
        "isAutoAccept": "Auto tanggapin ang booking",
        "isAutoAcceptPA": "Awtomatikong tanggapin ang nakabinbing pagbabago",
        "assignedVehicle": "Nakatakdang Sasakyan"
    },
    "messages": {
        "credits": {
            "406": "Nabigo ang pagkilos",
            "407": "Nabigo ang pagkilos",
            "416": "Nagamit na ang kupon",
            "417": "Ang iyong account ay hindi aktibo. Mangyaring makipag-ugnayan sa aming administrator",
            "418": "Nagkaroon ng mga error sa pagbabayad",
            "419": "Di-wasto ang promo code!",
            "420": "Inilapat ang promo code na ito para sa isa pang biyahe. Mangyaring gumamit ng isa pa.",
            "421": "Hindi wasto ang numero ng card.",
            "422": "Ang petsa ng pag-expire ay hindi wasto.",
            "429": "Hindi wasto ang zip code.",
            "430": "Hindi tugma ang AVS Postal Code",
            "431": "Hindi na-verify ang AVS Postal Code",
            "432": "Hindi wasto ang CVV.",
            "433": "Hindi tugma ang CVV",
            "434": "Hindi na-verify ang CVV",
            "435": "Ang tagapagbigay ng CVV ay hindi nakikilahok",
            "436": "Ang inyong card ay tinanggihan",
            "437": "Nabigo ang pag-verify ng credit card. Pakisuri ang iyong impormasyon at subukang muli.",
            "439": "Hindi naproseso ang CVV",
            "441": "Walang data ng CVV mula sa nagbigay",
            "443": "Walang data mula sa issuer/banknet switch",
            "445": "Hindi maproseso ng AVS System",
            "446": "Ang nag-isyu na bangko ay hindi sumusuporta sa AVS",
            "447": "Hindi suportado ang AVS para sa iyong negosyo",
            "448": "Na-block ang card na ito dahil sa paulit-ulit na hindi matagumpay na mga pagtatangka sa pagbabayad. Mangyaring baguhin ang iyong paraan ng pagbabayad o subukang muli sa ibang pagkakataon",
            "452": "Tinanggihan ang iyong card. Mangyaring magpasok ng isa pang credit card na nakarehistro sa parehong lugar ng iyong numero ng telepono",
            "453": "Hindi sinusuportahan ang payment.gateway na ito",
            "454": "Hindi tugma ang AVS Address",
            "455": "AVS Parehong postal code at address ay hindi magkatugma",
            "458": "Nabigong magpatunay",
            "459": "Ang mga bank card ay hindi supprt",
            "461": "Ang card na ito ay hindi dapat",
            "462": "Hindi wasto ang pangalan ng may hawak ng card",
            "463": "Ang verification code ay hindi wasto",
            "464": "Ang Bangko ay hindi nagsusupprt sa pagbuo at pagpapadala ng verification code",
            "470": "Pakilagay ang email address ng manlalakbay bago gumawa ng booking gamit ang credit card",
            "474": "Pakilagay ang pangalan ng manlalakbay bago gumawa ng booking gamit ang credit card",
            "475": "Kinakailangan ang numero ng telepono",
            "476": "Di wasto ang halaga",
            "524": "Hindi Sapat na Pondo. Walang sapat na pondo ang account para masakop ang halaga ng transaksyon.",
            "911": "Hindi namin ma-authenticate ang iyong paraan ng pagbabayad. Mangyaring pumili ng ibang paraan ng pagbabayad at subukang muli.",
            "2000": "Huwag Igalang",
            "2001": "Hindi Sapat na Pondo. Walang sapat na pondo ang account para masakop ang halaga ng transaksyon.",
            "2002": "Lumagpas na sa limitasyon",
            "2003": "Lumampas sa Limitasyon ng Aktibidad ng Cardholder",
            "2004": "Nag-expire na Card",
            "2005": "Di-wastong Numero ng Credit Card",
            "2006": "Di-wastong Petsa ng Pag-expire",
            "2007": "Walang account",
            "2008": "Error sa Haba ng Card Account",
            "2009": "Walang Ganitong Nag-isyu",
            "2010": "Tinanggihan ng Tagabigay ng Card ang CVV",
            "2011": "Kinakailangan ang Pahintulot sa Boses. Hinihiling ng bangko ng cardholder na tumawag ang merchant upang makakuha ng espesyal na authorization code upang makumpleto ang transaksyong ito",
            "2012": "Tinanggihan ang Processor - Posibleng Nawala ang Card",
            "2013": "Tinanggihan ang Processor - Posibleng Nanakaw na Card",
            "2014": "Tinanggihan ang Processor - Pinaghihinalaang Panloloko",
            "2015": "Hindi Pinapayagan ang Transaksyon",
            "2016": "Duplicate na Transaksyon",
            "2017": "Huminto sa Pagsingil ang Cardholder",
            "2018": "Inihinto ng May-ari ng Card ang Lahat ng Pagsingil",
            "2019": "Di-wastong Transaksyon",
            "2020": "Paglabag",
            "2021": "Paglabag sa Seguridad",
            "2022": "Tinanggihan - Available ang Updated Cardholder",
            "2023": "Hindi Sinusuportahan ng Processor ang Feature na Ito",
            "2024": "Hindi Pinagana ang Uri ng Card",
            "2025": "Error sa Pag-set up - Merchant",
            "2026": "Di-wastong Merchant ID",
            "2027": "Error sa Pag-set up - Halaga",
            "2028": "Error sa Pag-set up - Hierarchy",
            "2029": "Error sa Pag-set up - Card",
            "2030": "Error sa Pag-set Up - Terminal",
            "2031": "Error sa Pag-encrypt",
            "2032": "Hindi Pinahihintulutan ang Surcharge",
            "2033": "Hindi Pabagu-bagong Data",
            "2034": "Walang Nagawa",
            "2035": "Bahagyang Pag-apruba Para sa Halaga Sa Bersyon ng Pangkat III",
            "2036": "Hindi mahanap ang pahintulot upang baligtarin",
            "2037": "Nabaliktad na",
            "2038": "Tinanggihan ang Processor. Ang bangko ng customer ay ayaw tanggapin ang transaksyon, kailangang makipag-ugnayan sa kanilang bangko para sa higit pang mga detalye.",
            "2039": "Di-wastong Authorization Code",
            "2040": "Di-wastong Tindahan",
            "2041": "Tinanggihan - Tumawag Para sa Pag-apruba",
            "2042": "Di-wastong Client ID",
            "2043": "Error - Huwag Muling Subukan, Tawagan ang Tagabigay",
            "2044": "Tinanggihan - Tawagan ang Tagabigay",
            "2045": "Di-wastong Numero ng Merchant",
            "2046": "Tinanggihan. Ang bangko ng customer ay ayaw tanggapin ang transaksyon, kailangang makipag-ugnayan sa kanilang bangko para sa higit pang mga detalye.",
            "2047": "Tawagan ang Tagapagbigay. Pick Up Card. Ang error na ito ay nagpapahiwatig na ang card ay naiulat na nawala o ninakaw ng cardholder.",
            "2048": "Di-wastong Halaga",
            "2049": "Di-wastong SKU Number",
            "2050": "Di-wastong Credit Plan",
            "2051": "Hindi tumutugma ang Numero ng Credit Card sa paraan ng pagbabayad",
            "2052": "Di-wastong Level III na Pagbili",
            "2053": "Iniulat ang card bilang nawala o nanakaw",
            "2054": "Ang halaga ng pagbaligtad ay hindi tumutugma sa halaga ng pahintulot",
            "2055": "Di-wastong Numero ng Dibisyon ng Transaksyon",
            "2056": "Ang halaga ng transaksyon ay lumampas sa limitasyon ng dibisyon ng transaksyon",
            "2057": "Naglagay ng paghihigpit ang Issuer o Cardholder sa card",
            "2058": "Merchant hindi MasterCard SecureCode pinagana.",
            "2060": "Nabigo ang Pag-verify ng Address at Card Security Code",
            "2061": "Di-wastong Data ng Transaksyon",
            "2062": "Di-wastong Halaga ng Buwis",
            "2064": "Di-wastong Code ng Pera",
            "2078": "Di-wastong Data ng Secure na Pagbabayad",
            "2080": "Di-wastong mga kredensyal ng user",
            "3000": "Hindi Available ang Processor Network - Subukang Muli",
            "4001": "Tinanggihan ang Settlement",
            "4006": "Ang halaga ng pagkuha ay lumampas sa pinapayagang limitasyon",
            "81703": "Ang uri ng credit card ay hindi tinatanggap ng merchant account na ito.",
            "81706": "Kinakailangan ang CVV",
            "81707": "Ang CVV ay dapat na 3 o 4 na digit.",
            "81709": "Kinakailangan ang petsa ng pag-expire.",
            "81710": "Ang petsa ng pag-expire ay hindi wasto.",
            "81714": "Kinakailangan ang numero ng credit card.",
            "81715": "Di-wasto ang numero ng credit card.",
            "81716": "Ang numero ng credit card ay dapat na 12-19 digit.",
            "81717": "Ang numero ng credit card ay hindi tinatanggap na numero ng pagsubok.",
            "81718": "Hindi maa-update ang numero ng credit card sa isang hindi sinusuportahang uri ng card kapag nauugnay ito sa mga subscription.",
            "81723": "Masyadong mahaba ang pangalan ng cardholder. Maximum na 175 character.",
            "81809": "Ang Postal code ay maaaring maglaman ng hindi hihigit sa 9 na letra o numero na mga character",
            "81813": "Ang Postal code ay maaari lamang maglaman ng mga titik, numero, puwang, at gitling",
            "91722": "Kinakailangan ang token ng paraan ng pagbabayad.",
            "91723": "Ang pag-update ng Umiiral na Token ay hindi wasto",
            "91730": "Hindi sinusuportahan ang pag-verify sa merchant account na ito.",
            "91734": "Ang uri ng credit card ay hindi tinatanggap ng merchant account na ito.",
            "91738": "Ang tinukoy na paraan ng pagbabayad ay hindi isang credit card.",
            "91745": "Mga di-wastong param para sa pag-update ng credit card.",
            "91826": "Hindi wasto ang postal code. Ang Postal code ay dapat na isang string ng 5 o 9 na digit, opsyonal na pinaghihiwalay ng isang gitling o isang puwang.",
            "-1": "Na-deactivate ang customer account na ito. Mangyaring makipag-ugnayan sa aming administrator."
        },
        "reBookingMsg": {
            "303": "Ang oras na iyong pinili ay dapat na mas huli kaysa sa kasalukuyang oras!",
            "304": "Hindi nakita ang booking na ito",
            "500": "Ang ilang impormasyon sa pag-book ay hindi wasto o nawawala. Pakisuri at subukang muli!"
        },
        "promoMsg": {
            "304": "Ang promo code ay hindi wasto",
            "306": "Di-wastong code ng promosyon. Sa ibang zone daw ang promo.",
            "413": "Paumanhin, hindi available ang promo code na ito sa ngayon",
            "414": "Ang promo code ay hindi wasto",
            "415": "Ang promo code ay hindi wasto",
            "416": "Nagamit na ang promo code na ito.",
            "419": "Paumanhin, hindi available ang promo code na ito sa ngayon",
            "420": "Paumanhin, naabot mo na ang iyong limitadong paggamit ng promo",
            "421": "Paumanhin, naabot na ng promo code na ito ang inilabas nitong limitasyon sa paggamit",
            "422": "Ang promo code na ito ay hindi magagamit sa ilalim ng iyong account",
            "423": "Paumanhin, naabot mo na ang iyong limitadong badyet sa promo",
            "424": "Di-wastong code ng promosyon. Sa mga nirefer na customer lang daw ang promo",
            "425": "Naabot na ng promo code na ito ang limitasyon sa paggamit nito bawat araw.",
            "426": "Naabot mo na ang iyong limitadong paggamit ng promo bawat araw.",
            "427": "Hindi mailapat ang code ng promosyon. Hindi kumpleto ang profile ng customer na ito.",
            "428": "Naubos na ng customer na ito ang buwanang code ng promosyon.",
            "430": "Naubos mo na ang iyong taunang mga code ng promosyon.",
            "431": "Hindi magagamit ang code ng promosyon para sa paraan ng pagbabayad na ito.",
            "432": "Ang halaga ng pamasahe na ito ay hindi karapat-dapat para sa code na pang-promosyon.",
            "433": "Ang code na pang-promosyon ay hindi karapat-dapat na gamitin sa napiling oras.",
            "434": "Paumanhin, naabot mo na ang iyong limitadong badyet sa promo.",
            "phoneInvalid": "Mangyaring ipasok ang numero ng telepono ng pasahero bago ilapat ang promo code"
        },
        "updateBookingMsg": {
            "303": "Nabigong i-update ang booking. Pakisubukang muli!",
            "304": "Hindi nakita ang booking na ito",
            "pickUpTime": "Ang oras na iyong pinili ay dapat na mas huli kaysa sa kasalukuyang oras!",
            "pickup": "Walang available na serbisyo sa pag-book sa lugar na ito",
            "destination": "Ang ilang impormasyon sa pag-book ay hindi wasto o nawawala. Pakisuri at subukang muli!",
            "dispatchType": "Ang ilang impormasyon sa pag-book ay hindi wasto o nawawala. Pakisuri at subukang muli!"
        },
        "sessionExpired": {
            "403": "Na-log out ka dahil naka-log in ang iyong account mula sa ibang device o nag-expire na ang session mo"
        },
        "not_found": {
            "404": "Hindi matagpuan ang pahinang iyong hiniling."
        },
        "booking": {
            "303": "Ang oras na iyong pinili ay dapat na mas huli kaysa sa kasalukuyang oras!",
            "304": "Hindi nakita ang booking na ito",
            "305": "Kinansela o nakumpleto ng Booking.com ang booking; mangyaring tanggihan ang trabaho upang alisin ito sa pila.",
            "306": "Walang itinalagang rate sa napiling uri ng kotse. Upang maglapat ng rate para sa anumang uri ng kotse, mangyaring pumunta sa Mga Setting > Kotse > Uri ng Kotse.",
            "307": "Hindi ma-update ang booking. Pakisubukan muli mamaya.",
            "407": "I-type ang rate na sinusuportahan ko ang dagdag na lokasyon",
            "500": "Ang ilang impormasyon sa pag-book ay hindi wasto o nawawala. Pakisuri at subukang muli!",
            "upgroup_success": "Matagumpay na naalis sa pangkat ang booking",
            "Please_Select_driver": "Mangyaring pumili ng driver",
            "assign_driver_vehicle_success": "Ang Driver/Sasakyan ay matagumpay na naitalaga",
            "assign_driver_success": "Matagumpay na naitalaga ang driver",
            "detach_driver_success": "Matagumpay na naalis ang driver",
            "detach_vehicle_success": "Ang sasakyan ay matagumpay na naalis.",
            "Group_success": "Matagumpay na na-grupo ang booking",
            "change_supplier_success": "Ang booking ay matagumpay na nabago ang mga supplier.",
            "change_supplier_partial": "Bahagyang Tagumpay: Nabigo ang batch assignment para sa mga sumusunod na biyahe (Booking IDs) dahil sa mga patuloy na aksyon: {0}.",
            "detach_driver_partial": "Bahagyang Tagumpay: Nabigo ang batch assignment para sa mga sumusunod na biyahe (Booking IDs) dahil sa mga patuloy na aksyon: {0}.",
            "assign_driver_partial": "Bahagyang Tagumpay: Nabigo ang batch assignment para sa mga sumusunod na biyahe (Booking IDs) dahil sa mga patuloy na aksyon: {0}.",
            "update_dispatch": "Update at Dispatch",
            "remove_booking_false": "Nabigong alisin ang booking",
            "remove_booking_success": "Matagumpay na naalis ang booking",
            "GROUP_NOT_FOUND": "Hindi nakita ang Group Id",
            "NO_SHARING_BOOKINGS": "Maaari ka lang magpangkat ng mga booking kung pinapayagan ng booking ng customer ang ride-sharing.",
            "DIFFERENT_CAR_TYPES": "Ang booking na sinusubukan mong pangkat ay may ibang uri ng kotse",
            "LIMIT_EXCEEDED_ON_SEATS_OR_LUGGAGE": "Nalampasan ang mga upuan o bagahe. Paki-double check ang kapasidad ng sasakyan.",
            "INVALID_CAR_TYPE": "Hindi maitalaga ang driver, tingnan ang upuan ng sasakyan ng driver at kapasidad ng bagahe.",
            "VALIDATION_ERROR": "Error sa pagpapatunay",
            "INTERNAL": "Panloob na error ng server",
            "fare_gt_zero": "Ang pamasahe ay dapat na higit sa 0!",
            "edit_total_fail": "Nabigo ang pag-edit ng kabuuang halaga!",
            "complete_fail": "Hindi makukumpleto ang booking!",
            "cancle_fail": "Nagkaproblema noong kinansela ang booking na ito. Pakisubukang muli!",
            "incident_fail": "Nabigo ang insidente",
            "phone_invalid": "Mangyaring magpasok ng wastong numero ng telepono!",
            "add_psg_fail": "Hindi makapagdagdag ng bagong pasahero",
            "REMOVE_RECIPIENT_DELIVERED": "Hindi maalis ang tatanggap ay naihatid na",
            "REMOVE_LAST_ACTIVE_RECIPIENT": "Hindi maalis ang huling aktibong tatanggap",
            "ORDER_HAS_BEEN_FINISHED": "Ang order ay tapos na",
            "end_booking_leave": "Ang pag-alis sa page na ito ay magtatapos sa iyong booking.",
            "update_booking_fail": "Nabigong i-update ang booking",
            "EXTERNAL_ID_EXISTED": "Ang External ID ay umiiral na sa sistema.",
            "area_service_unavailable": "Walang available na serbisyo sa pag-book sa lugar na ito",
            "pickupSameDestination": "Ang pick-up address ay dapat na iba sa destinasyon.",
            "time_invalid": "Ang oras na iyong pinili ay dapat na mas huli kaysa sa kasalukuyang oras!",
            "psg_inactivate": "Na-deactivate ang customer account na ito. Mangyaring makipag-ugnayan sa aming administrator",
            "data_incorect": "Nagkaproblema. Subukang muli mamaya.",
            "preAuthorize": "Pakisuri ang iyong account dahil ang halagang {0} ay kinakailangan upang magarantiya ang iyong booking",
            "booking_limited": "Paumanhin, naabot mo na ang maximum na bilang ng mga booking kada minuto/araw. Subukang muli mamaya.",
            "minimumBookAhead": "Ang oras ng pagkuha ng reserbasyon ay dapat na hindi bababa sa {0} (mga) oras {1} (na) minuto mula sa kasalukuyang oras",
            "exDoDiffDo": "Ang karagdagang destinasyon ay dapat na iba sa destinasyon.",
            "recurringTimeRange": "Petsa na wala sa saklaw. Makakagawa ka lang ng mga booking {0} (na) buwan nang maaga. Mangyaring makipag-ugnayan sa admin para sa anumang mga isyu.",
            "recipientsLimit": "Ang maximum na bilang ng mga tatanggap ay {0}.",
            "maximumBookAhead": "Ang oras ng pagkuha ng reserbasyon ay hindi maaaring lumampas sa {0} (na) araw mula sa kasalukuyang oras",
            "Please_select_or_add_a_card": "Mangyaring pumili o magdagdag ng card!",
            "Unable_to_process_by_fare_zero": "Hindi namin maproseso ang iyong kahilingan, mangyaring baguhin ang uri ng kotse o uri ng booking at subukang muli. Kung kailangan mo ng anumang tulong, mangyaring makipag-ugnayan sa aming team ng suporta",
            "Can_not_connect_to_server": "Hindi makakonekta sa server!",
            "Check_connection_or_contact_system_support": "Pakisuri ang iyong koneksyon o makipag-ugnayan sa suporta ng system para sa tulong!",
            "Create_new_booking_success": "Matagumpay na nalikha ang isang bagong booking!",
            "Create_new_recurring_booking_success": "Matagumpay na nalikha ang bagong (mga) booking",
            "Update_booking_success": "Matagumpay na na-update ang booking na ito!",
            "addon_exceeded": "{0} quota exceeded.",
            "addon_exceeded_with_params": "Mangyaring i-reload ang iyong wallet balance upang magpatuloy sa paggamit ng {0}.",
            "Booking_drop_of_success": "Tagumpay ang pag-drop off ng booking",
            "Cancel_booking_success": "Matagumpay na nakansela ang booking na ito!",
            "Cancel_booking_fails": "Hindi maaring i-cancel ang booking na ito!",
            "adjust_fare_booking_success": "Ang pamasahe ay matagumpay na naitama!",
            "adjust_fare_booking_fail": "Nabigong ayusin ang pasahe!",
            "Booking_detail_not_found": "Hindi mahanap ang detalye ng booking!",
            "Check_promo_error": "Suriin ang error sa promoCode!",
            "Invalid_format": "Di-wastong format",
            "Flight_not_found": "Hindi nahanap ang flight!",
            "Add_new_credit_error": "Magdagdag ng bagong credit error!",
            "Socket_server_disconnected": "Nadiskonekta ang socket server!",
            "Please_reload_page_or_check_your_connection": "Paumanhin. Hindi maproseso ang iyong kahilingan. Pakisubukang muli.",
            "request_timeout": "Paumanhin. Timeout ng iyong kahilingan. Pakisubukang muli.",
            "Check_customer_error": "Suriin ang error ng customer!",
            "Please_select_car_type": "Mangyaring pumili ng uri ng kotse",
            "DropOff_country": "Paumanhin, ang iyong hiniling na destinasyon ay wala sa aming lugar ng serbisyo!",
            "Different_Country": "Ang mga lokasyon ng pickup at drop-off ay dapat nasa 2 magkaibang bansa.",
            "Please_enter_destination_for_ridesharing_booking": "Mangyaring ilagay ang destinasyon para sa ride-sharing booking",
            "Extra_detination_must_be_difference_from_destination": "Ang karagdagang destinasyon ay dapat na naiiba sa kasalukuyang destinasyon",
            "Pickup_address_must_be_different_from_destination": "Dapat na iba ang pick-up address sa destinasyon",
            "Best_price": "Pinakamahusay na presyo",
            "You_may_be_charged_extra_fee_if_your_trip_excceds": "Maaari kang singilin ng dagdag na bayad kung lumampas ang iyong biyahe",
            "You_may_be_charged_extra_fee_if_your_trip_excceds_with_params": "Maaari kang singilin ng karagdagang bayad kung lumampas ang iyong biyahe sa {0} {1}, {2} {3}",
            "Reject_booking_success": "Matagumpay na tinanggihan ang booking na ito!",
            "Reject_fail": "Nagkaproblema noong tinanggihan ang booking na ito. Pakisubukang muli!",
            "Please_select_payment_method": "Mangyaring pumili ng paraan ng pagbabayad",
            "Driver_signed_out_or_deactivated": "Kaka-sign out o na-deactivate ang driver na ito",
            "reservation_booking_overlaps": "Paumanhin, nag-o-overlap ang reservation na ito sa isa pang tinanggap ng Driver.",
            "driver_is_not_available": "Paumanhin, hindi available ang driver na ito sa ngayon.",
            "seats_luggage_limit": "Hindi maitalaga ang booking sa driver. Lampas sa limitasyon ang upuan o bagahe.",
            "full_capacity": "Ang booking na ito ay hindi maaaring italaga sa driver dahil naabot na ng biyahe ang maximum capacity nito.",
            "marked_failed_ok": "Ang order ay minarkahan bilang nabigo.",
            "warning_markFail_lastRecipient": "Ito ang huling tatanggap ng booking na ito. Kung magpapatuloy ka sa pagmamarka sa order na ito bilang nabigo, kakailanganin mong kumpletuhin ang booking na ito.",
            "BOOKINGS_LIMIT_EXCEEDED": "Maaari ka lamang magtalaga ng maximum na 5 mga order sa bawat pangkat",
            "bookingCanceled": "Kinansela o nakumpleto ng Booking.com ang booking; mangyaring tanggihan ang trabaho upang alisin ito sa pila.",
            "contact_info_required": "Pakisuyong pumili ng wastong profile ng gumagamit o lumikha ng bago bago magpatuloy. Bilang alternatibo, maaari kang lumikha ng booking para sa bisita.",
            "UNSUPPORTED_ZONE": "Hindi suportado ang Zone",
            "INVALID_GUEST_PHONE_NUMBER": "Di wasto ang numero ng telepono ng pasahero",
            "NEGATIVE_FLEET_BALANCE": "Mukhang masyadong mababa ang iyong balanse upang makagawa ng bagong booking. Mangyaring magdagdag ng pondo o bayaran ang anumang natitirang utang upang magpatuloy."
        },
        "item_no_found": "Walang nakitang item",
        "commonMessages": {
            "greater_than_0": "Mangyaring magpasok ng halagang mas mataas sa 0.",
            "Required_field": "Kinakailangan ang field na ito",
            "bankPhone_is_required": "Di-wasto ang numero ng telepono",
            "bankPhone": "Numero ng telepono",
            "distance_from_equa_or_smaller": "Ang distansya na 'mula' ay dapat na mas maliit kaysa o katumbas ng distansya 'sa'",
            "must_be_number": "Mangyaring magpasok ng wastong numero",
            "equal_or_greater_than_0": "Mangyaring magpasok ng halagang katumbas o higit sa 0.",
            "must_be_integer": "Pakilagay ang integer number",
            "invalid_email_format": "Mangyaring maglagay ng wastong email.",
            "greater_or_equa": "Mangyaring magpasok ng halagang mas malaki sa o katumbas ng {0}.",
            "value_must_between": "Mangyaring magpasok ng halaga sa pagitan ng {0} at {1}.",
            "large_10x_markup_price": "Ang na-edit na pamasahe ay hindi dapat lumampas sa 10x na tinantyang pamasahe.",
            "greater_than": "Mangyaring magpasok ng halagang higit sa {0}.",
            "less_than": "Mangyaring magpasok ng halagang mas mababa sa {0}.",
            "less_or_equal": "Mangyaring magpasok ng halagang mas mababa sa o katumbas ng {0}.",
            "driver_earnings_warning": "Mga offline na pagbabayad: Ang kita ng driver ay hindi dapat lumampas sa nakolektang pamasahe.",
            "limit_amount": "Mangyaring magpasok ng isang halaga na mas mababa sa o katumbas ng halaga ng limitasyon",
            "Integer_from_range": "Pakipasok ang numero ng integer mula sa {0} - {1}",
            "integer_greater_than_0": "Mangyaring maglagay ng integer na numero na mas malaki sa 0. (Mas mababa sa 100 na may porsyento at ang decimal separator ay 1 character)",
            "Error_message": "Error!",
            "callcenter_newbooking_message": "Bagong kahilingan sa pag-book gamit ang telepono <span class='bold'>{0}</span>",
            "callcenter_existed_booking_message": "Isang aktibong booking <span class='bold'>#{0}</span> ang umiiral sa telepono <span class='bold'>{1}</span>",
            "callcenter_close_newbooking_form_warning": "Mangyaring isara/kumpletuhin ang iyong kasalukuyang aklat bago makatanggap ng bagong kahilingan ng customer",
            "Emergency_SOS_Title": "Emergency SOS",
            "Please_enter_a_future_date": "Mangyaring maglagay ng petsa sa hinaharap",
            "Card_holder_is_required": "Kinakailangan ang card holder",
            "Card_number_is_required": "Kinakailangan ang numero ng card",
            "Expired_date_is_required": "Kinakailangan ang petsa ng pag-expire",
            "Credit_code_is_required": "Pakipasok ang credit code (huling pagpapatunay)",
            "Expired_date_is_invalid": "Ang petsa ng pag-expire ay hindi wasto. Pakilagay ang expiration date sa format na mm/yy",
            "cvv_is_required": "Kinakailangan ang CVV",
            "City_is_required": "Kinakailangan ang lungsod",
            "State_is_required": "Kinakailangan ang estado",
            "Address_is_required": "Kinakailangan ang address",
            "Zipcode_is_required": "Kinakailangan ang zip code",
            "Country_is_required": "Kinakailangan ang bansa",
            "Over_query_limit": "Hindi makapag-load ang Google API dahil sa pansamantalang error. Subukang muli mamaya.",
            "outOfInputQueueOrder": "Ang order # ay hindi maaaring mas malaki kaysa sa kabuuang bilang ng mga driver sa pila.",
            "Same_pickup_destination": "Ang pick-up address ay dapat na iba sa destination address.",
            "Max_length": "Ang maximum na haba ay {0} (na) character.",
            "choose_at_least_one": "Mangyaring pumili ng kahit isang opsyon.",
            "choose_at_least_one_intercity_schedule": "Mangyaring magdagdag ng iskedyul o payagan ang customer na humiling ng kanilang gustong oras.",
            "startDate_greater_than_endDate": "Ang petsa ng pagsisimula ay mas malaki kaysa sa petsa ng pagtatapos"
        },
        "trip": {
            "cancel_trip_success": "Matagumpay na nakansela ang biyaheng ito!",
            "data_incorect": "Walang driver na nakatalaga. Pumili ng driver mula sa dropdown list. <br/> Kung walang available na mga driver, piliin ang Auto Dispatch upang italaga sa ibang pagkakataon.",
            "INTERNAL": "Error sa panloob na server.",
            "NOT_FOUND": "Hindi nakita ang biyahe o di-wastong katayuan.",
            "SAME_DRIVER": "Ang assignee ay dapat na iba sa kasalukuyang driver.",
            "OVERLAP": "Paumanhin, ang biyaheng ito ay nag-o-overlap sa isa pa na tinatanggap ng driver na ito.",
            "CANNOT_ASSIGN": "Ang driver na ito ay hindi wasto (ibig sabihin, ang driver ay hindi natagpuan, hindi online, o hindi naka-log in)."
        },
        "car_mgmt": {
            "Search_car_color": "Maghanap ng kulay ng kotse",
            "Searching": "Naghahanap"
        },
        "driver_note": {
            "Search_driver_note": "Maghanap ng tala ng driver",
            "Searching": "Naghahanap"
        }
    },
    "errors": {
        "303": "hindi nahanap ang user",
        "453": "Hindi suportado ang gateway",
        "553": "Paumanhin! Ang customer ay may kasalukuyang nagbu-book, pakisubukang muli sa ibang pagkakataon.",
        "1007": "Ang panahon sa pagitan ng petsa ng pagsisimula at petsa ng pagtatapos ay dapat na mas mababa sa 60 araw!!",
        "3001": "Umiiral ang numero ng telepono",
        "3002": "Di-wastong petsa ng kapanganakan",
        "3003": "Ang petsa ng pag-expire ay hindi wasto",
        "3004": "Hindi nahanap ang driver",
        "3005": "Nawawalang impormasyon sa settlement ng driver (address ng bangko, lungsod, estado, zipcode)",
        "3006": "Nawawalang impormasyon ng bank account (nameOfAccount, typeOfAccount, routingNumber, accountNumber, ssn)",
        "3007": "Hindi mo maaaring i-edit ang driver na ito, na may trabaho.",
        "3008": "Ang driver na ito ay kasalukuyang nagla-log in. Mangyaring hilingin sa kanya na mag-log out upang i-edit ang kanyang impormasyon.",
        "3009": "Ang driver na ito ay tumanggap ng isa o higit pang reserbasyon. Mangyaring italaga ang (mga) booking sa ibang mga driver bago i-update/palitan ang impormasyon ng driver.",
        "3010": "Nabigo ang pagpapadala ng koneksyon.",
        "3011": "Ang driver na ito ay dapat na naka-setup para sa operasyon bago ma-activate.",
        "3012": "Ang driver na ito ay dapat na naka-setup para sa operasyon bago ma-activate.",
        "3013": "Ang item lamang sa hindi aktibong katayuan ang maaaring tanggalin.",
        "3014": "Nawawala ang mga kinakailangang field. Mangyaring suriin.",
        "3015": "Di-wastong taon ng kapanganakan. Mangyaring suriin.",
        "3016": "Di-wastong zip code. Mangyaring suriin.",
        "3017": "Di-wastong estado/lalawigan. Mangyaring suriin.",
        "3018": "Di-wastong pangalan ng account. Mangyaring suriin.",
        "3019": "Di-wastong numero ng pagruruta. Mangyaring suriin.",
        "3020": "Kinakailangan ang kaarawan. Mangyaring suriin.",
        "3021": "Di-wastong ssn number. Mangyaring suriin.",
        "3022": "Ang bank account ng driver ay hindi makakatanggap ng mga pondo.",
        "3023": "Hindi mapapatakbo ang mga naka-log in na driver. Subukang muli mamaya.",
        "3026": "Wala na ang driver.",
        "3027": "Hindi naka-set up ang bank account ng driver. Mangyaring pumunta sa Drivers module upang i-set up ang kanyang bank account.",
        "3028": "Nabigong bayaran ang (mga) napiling driver. Pakisubukang muli.",
        "3029": "Nabigong i-clear ang data ng kita ng driver. Pakisubukang muli.",
        "3032": "Umiiral na ang username na ito sa aming system. Mangyaring magpasok ng isa pa.",
        "3033": "Di-wastong BSB. Ang numero ay dapat na 6 na digit sa format na xxxxxx.",
        "3036": "Kinakailangan ang Captcha",
        "3037": "Ang Captcha ay hindi wasto",
        "3039": "Kinakailangan ang Group ID.",
        "3040": "Ang numero ng teleponong ito ay ginagamit na ng isang driver ng %{brandName} (ibig sabihin, hindi maaaring ma-duplicate ang numero ng telepono). Mangyaring magpasok ng isa pa",
        "3041": "Umiiral ang username.",
        "3044": "Nadoble ang National ID.",
        "3045": "May sasakyan na ang driver, Pakisariwa ang pahina",
        "3046": "Ang kumpanya ng sasakyan at ang kumpanya ng drayber ay magkaiba.",
        "4001": "Ang iyong plate number ay umiral na sa system. Mangyaring maglagay ng isa pa.",
        "4002": "Di-wastong petsa ng pag-expire",
        "4003": "Dapat i-deactivate ang sasakyan bago tanggalin",
        "4004": "Hindi nahanap ang sasakyan",
        "4005": "Hindi na aktibo ang sasakyang ito",
        "4006": "Ang sasakyang ito ay ginagamit at hindi maaaring tanggalin o i-deactivate",
        "4007": "Kinakailangan ang plate number",
        "4009": "Ang sasakyan ay itinatakda sa isang booking.",
        "4010": "Ang sasakyan ay itinatakda sa isang drayber.",
        "5001": "Umiiral ang kumpanya",
        "5004": "Hindi natagpuan ang kumpanya",
        "6001": "Umiral ang modelo ng sasakyan",
        "6004": "Hindi nakita ang modelo ng sasakyan",
        "6005": "Ginagamit ang modelo ng sasakyan",
        "7001": "Ang pangalan ng paggawa ng iyong sasakyan ay umiral na sa system. Mangyaring maglagay ng isa pa.",
        "7004": "Hindi nahanap ang paggawa ng sasakyan",
        "8001": "Umiral ang uri ng sasakyan",
        "8004": "Hindi nakita ang uri ng sasakyan",
        "9001": "Nagkaroon ng patag na ruta",
        "9004": "Hindi nahanap ang patag na ruta",
        "10001": "Umiral ang zone",
        "10004": "Hindi nahanap ang zone",
        "11001": "Umiral ang zone",
        "11002": "Ang lugar na ito ay magkakapatong sa isa pa. Mangyaring iguhit itong muli.",
        "11003": "Ang zone ay dapat na isang polygon object",
        "11004": "Hindi nahanap ang zone",
        "11005": "Ginagamit ang sona",
        "12001": "Umiral ang inbox",
        "12002": "Mangyaring i-configure ang SMS Twilio",
        "12004": "Hindi nakita ang inbox",
        "12005": "Walang tatanggap na tumutugma sa iyong mga filter. Pakisuri ang listahan at subukang muli.",
        "12006": "Walang customer sa file.",
        "13001": "Ang promotion code na ito ay umiiral na sa system. Mangyaring maglagay ng isa pa",
        "13002": "Maling petsa",
        "13003": "Pribado",
        "13004": "Hindi nakita ang code ng promosyon",
        "13005": "Bagong Customer lang",
        "13006": "Lampas sa Limitasyon ng Dami",
        "13007": "Lampas sa Limitasyon ng Badyet",
        "13008": "Lampas sa Kabuuang Limitasyon sa Paggamit",
        "13011": "Na-deactivate o tinanggal ang kampanyang ito sa promosyon",
        "13012": "Di-wasto ang hanay ng petsa",
        "13013": "Di-wastong code ng promosyon. Sa ibang zone daw ang promo",
        "13014": "Na-deactivate ang zone na iyong pinili.",
        "14004": "Hindi nakita ang booking",
        "15002": "Na-deactivate ang iyong fleet. Mangyaring makipag-ugnayan sa aming administrator",
        "15004": "Hindi nahanap ang fleet",
        "16001": "Ang iyong pangalan ng flat rate ay umiral na sa system. Mangyaring maglagay ng isa pa",
        "16004": "Hindi nakita ang pamasahe",
        "17001": "Ang pangalan ay umiral",
        "17004": "Hindi nakita ang rate ng package",
        "18001": "Ang pangalan ay umiral",
        "18002": "Ginagamit ang pamasahe",
        "18004": "Hindi nakita ang pamasahe",
        "19001": "Ang iyong pangalan ng package ay umiral na sa system. Mangyaring maglagay ng isa pa.",
        "19002": "Ginagamit ang pamasahe",
        "19004": "Hindi nakita ang pamasahe",
        "20001": "Umiiral na ang username na ito sa aming system. Mangyaring magpasok ng isa pa.",
        "20002": "Ang iyong account ay hindi aktibo. Mangyaring makipag-ugnayan sa aming administrator",
        "20003": "Ang iyong inilagay na username o password ay mali. Pakisubukang muli",
        "20004": "Ang username ay hindi nakarehistro sa system.",
        "20005": "Ang link na ito ay nag-expire",
        "20006": "Hindi tugma ang kasalukuyang password. Pakisubukang muli.",
        "20007": "Umiiral na ang user #",
        "20008": "Ang email na ito ay umiiral na sa aming sistema. Mangyaring magpasok ng iba.",
        "20012": "Ang Fleet ID ay umiiral na",
        "21001": "Ang iyong pangalan ng pahintulot ay umiral na sa system. Mangyaring maglagay ng isa pa.",
        "21002": "Hindi ma-deactivate ang pahintulot na ito dahil kasalukuyang nakatalaga ito sa (mga) user.",
        "21003": "Aktibo ang tungkulin",
        "21004": "Hindi nakita ang tungkulin",
        "22001": "Umiiral ang customer",
        "22004": "Hindi nahanap ang customer",
        "22005": "Di-wastong Format ng File.",
        "22006": "Umiiral ang numero ng telepono",
        "24001": "Di-wasto ang numero ng telepono",
        "25001": "Ang pangalan na ito ay umiiral na sa system. Mangyaring maglagay ng isa pa.",
        "25002": "Di-wastong hanay ng oras",
        "25004": "Hindi nahanap ang shift",
        "26001": "Ang pangalan na ito ay umiiral na sa system. Mangyaring maglagay ng isa pa.",
        "26002": "Ang shift na ito ay kasalukuyang ginagamit sa pagpapatakbo, mangyaring alisin ito sa pagkakatalaga bago tanggalin",
        "26004": "Hindi nahanap ang template ng shift",
        "27001": "Ang kampanya ay umiiral",
        "27002": "Ang kampanya ay isinaaktibo",
        "27004": "Hindi natagpuan ang kampanya",
        "28001": "Umiral ang lungsod",
        "28002": "Ang lungsod ay isinaaktibo",
        "28003": "Ginagamit ang lungsod",
        "28004": "Hindi natagpuan ang lungsod",
        "29002": "Ang numero ng telepono ay umiiral",
        "30001": "Hindi nakita ang lugar ng pila",
        "30002": "Lugar ng pila sa paggamit",
        "30003": "Umiiral na sa system ang pangalan ng iyong queuing area. Mangyaring maglagay ng isa pa",
        "30004": "Ang lugar ng pila ay hindi dapat mag-overlap sa isa't isa",
        "30005": "Di-wasto ang mga coordinate ng lugar ng pila",
        "30006": "Di-wasto ang mga pick-up area",
        "31001": "Ang iyong company Id ay umiral na sa system. Mangyaring maglagay ng isa pa.",
        "31002": "Umiiral na ang username na ito sa aming system. Mangyaring magpasok ng isa pa.",
        "31003": "Hindi natagpuan ang kumpanya.",
        "31004": "Hindi nahanap ang Corporate User.",
        "31005": "Tanging mga corporate na hindi aktibo ang maaaring tanggalin.",
        "31006": "Ang teleponong ito ay umiiral na sa Mga Gumagamit ng Corp. Mangyaring maglagay ng isa pa.",
        "31007": "Hindi nahanap ang corporate traveler.",
        "31008": "Hindi nahanap ang card.",
        "31009": "Ang teleponong ito ay umiiral na sa sistema. Mangyaring mag-input ng iba.",
        "31010": "Na-deactivate ang kumpanyang ito. Mangyaring makipag-ugnayan sa administrator para sa higit pang impormasyon",
        "31011": "Hindi maaaring i-activate ang manlalakbay na ito dahil kabilang ito sa isang hindi aktibong corporate account",
        "31013": "Mayroon nang negosyong may ganitong pangalan",
        "31014": "Pakisuyong magtalaga ng rate para sa hindi bababa sa isang uri ng sasakyan",
        "31015": "Ang email/telepono na ito ay naka-link na sa ibang account.",
        "31016": "Ang email/telepono na ito ay naka-link sa ibang corporate account. Mangyaring i-update ang profile o alisin ang gumagamit mula sa umiiral na account bago sila italaga sa bago.",
        "31017": "Ang email/telepono na ito ay walang laman. Mangyaring maglagay ng wastong email/telepono.",
        "32001": "Ang iyong pangalan ng serbisyo ay umiral na sa system. Mangyaring maglagay ng isa pa.",
        "32004": "Ang serbisyo ay hindi mahanap",
        "33002": "Ang mga hanay ng oras ay hindi dapat mag-overlap sa bawat isa",
        "34001": "Ang code ay umiiral",
        "34013": "Di-wasto ang hanay ng petsa",
        "36001": "Ang pangalan ay umiral",
        "39001": "Kailangan ang dokumento",
        "43001": "Nandiyan ang Template ng Parusa",
        "43002": "Hindi natagpuan ang Template ng Parusa",
        "44001": "Umiiral ang Rate Template",
        "44002": "Hindi natagpuan ang Rate Template",
        "44003": "Ang Rate Template ay kasalukuyang nakatalaga sa isang korporasyon. Mangyaring alisin ito bago magtanggal.",
        "45001": "Nakabawas na Patakaran sa Surcharge",
        "45002": "Hindi natagpuan ang Patakaran sa Surcharge",
        "45003": "Hindi natagpuan ang Surcharge Item",
        "46001": "Umiiral ang pangalan",
        "46002": "Item na hindi natagpuan",
        "47001": "Umiiral ang Stop Sales",
        "47002": "Hindi natagpuan ang Stop Sales",
        "48003": "Ang Pasadyang Lokasyon ay hindi naglalaman ng parehong sona",
        "49003": "Duplicate corporate sa payout",
        "49004": "Ang Imei ay umiiral",
        "50001": "Add-on template existed",
        "50002": "Add-on template not found",
        "50003": "Add-on service existed",
        "50004": "Add-on service not found",
        "71001": "Umiral ang dynamic na surcharge",
        "71002": "Ang lugar na ito ay magkakapatong sa isa pa. Mangyaring iguhit itong muli.",
        "71003": "Ang dynamic na surcharge ay dapat na isang polygon object",
        "71004": "Hindi nakita ang dynamic na surcharge",
        "72001": "Umiral ang dynamic na pamasahe",
        "72002": "Ang lugar na ito ay magkakapatong sa isa pa. Mangyaring iguhit itong muli.",
        "72003": "Ang dynamic na pamasahe ay dapat na isang polygon object",
        "72004": "Hindi nakita ang dynamic na pamasahe",
        "74001": "Umiral ang zone",
        "74002": "Ang lugar na ito ay magkakapatong sa isa pa. Mangyaring iguhit itong muli.",
        "74003": "Ang Zone ay dapat isang polygon na bagay",
        "74004": "Hindi natagpuan ang zone fare",
        "74005": "Hindi nakita ang pamasahe sa zone",
        "80001": "Umiral ang banner ng app.",
        "80002": "Hindi nahanap ang banner ng app.",
        "80003": "Ang item lamang sa hindi aktibong katayuan ang maaaring tanggalin.",
        "81001": "Walang laman ang pag-upload ng file.",
        "81002": "Limitado ang laki ng pag-upload ng file.",
        "82002": "Nagkaproblema habang nagse-set up ng flightaware. Subukang muli mamaya.",
        "90001": "Umiral ang intercity zone",
        "90002": "Ang lugar na ito ay magkakapatong sa isa pa. Mangyaring iguhit itong muli.",
        "90003": "Ang intercity zone ay dapat na isang polygon object",
        "90004": "Hindi nahanap ang intercity zone",
        "90005": "Ginagamit ang intercity zone",
        "91001": "Ang intercity rate ay umiiral",
        "91002": "Ginagamit ang intercity rate",
        "91003": "Hindi nahanap ang intercity rate",
        "92001": "Ang pangalan ng ruta ay umiiral",
        "92002": "Hindi nahanap ang ruta",
        "92003": "Umiiral na ang rutang ito sa ibang ruta, pakisuri at subukang muli",
        "92004": "May aktibong biyahe sa rutang ito.",
        "93001": "Ang driver note ay umiral na sa system. Mangyaring magpasok ng isa pa.",
        "93002": "Maaaring tanggalin ang tala ng driver na hindi aktibo.",
        "93003": "Ginagamit ang tala ng driver.",
        "93004": "Hindi nakita ang tala ng driver.",
        "94001": "Ang pangalan ng kulay ng iyong sasakyan ay umiral na sa system. Mangyaring maglagay ng isa pa.",
        "94002": "Hindi nakita ang kulay ng kotse",
        "400000": "Hindi wasto ang numero ng telepono!",
        "400002": "Isang error sa pagpapatunay ang nangyari.",
        "400003": "Tinanggihan ang pahintulot",
        "400005": "Ang nilalaman ng file ay hindi wasto",
        "400008": "Pakisok ang pangalan ng zone",
        "500000": "Error sa panloob na sistema.",
        "500001": "Mangyaring i-configure ang SMS Twilio",
        "500002": "Humiling ng timeout. Subukang muli mamaya",
        "500004": "Panloob na error ng sistema",
        "600001": "Hindi nahanap ang lokasyon",
        "600002": "Ang mga coordinate ng Longitude at Latitude na ito ay umiral sa system. Mangyaring magdagdag ng isa pa",
        "610001": "Nagkaroon ng kategorya",
        "610002": "Hindi nahanap ang kategorya",
        "610003": "Umiiral ang kategorya sa lokasyon ng party",
        "700001": "Ginagamit ang uri",
        "700002": "Hindi nahanap ang partner",
        "700003": "Ang pangalan ng uri ng iyong kasosyo ay umiral na sa system. Mangyaring maglagay ng isa pa.",
        "800000": "Ang tindahang ito ay itinalaga sa isa pang merchant account. Mangyaring pumili ng isa pa.",
        "800001": "Ang bank account ng merchant ay hindi makakatanggap ng mga pondo.",
        "800002": "Ang bank account ng merchant ay hindi makakatanggap ng mga pondo.",
        "limitMessage": {
            "upgrade": "Upgrade",
            "cancel": "Cancel",
            "driver": {
                "title": "Driver limit reached",
                "description": "Your current subscription allows up to %{limitation} drivers. To add more drivers, please upgrade to the higher plan."
            },
            "vehicle": {
                "title": "Vehicle limit reached",
                "description": "Your current subscription allows up to %{limitation} vehicles. To add more vehicles, please upgrade to the higher plan."
            },
            "operator": {
                "title": "Operator limit reached",
                "description": "Your current subscription allows up to %{limitation} operators. To add more operators, please upgrade to the higher plan."
            }
        },
        "31016_2": "Mensahe: Ang email/telepono na ito ay naka-link na sa ibang account. Mangyaring makipag-ugnayan sa iyong tagapamahala ng account para sa tulong.",
        "undefined": "Nagkaproblema sa aming server, pakisubukang muli.",
        "completeBooking": {
            "113": "Hindi namin ma-authenticate ang iyong paraan ng pagbabayad. Mangyaring pumili ng ibang paraan ng pagbabayad at subukang muli.",
            "450": "Ang balanse ay hindi sapat para magbayad. Mangyaring pumili ng ibang paraan.",
            "451": "Ang balanse ay hindi sapat para magbayad. Mangyaring pumili ng ibang paraan.",
            "521": "Walang sapat na pondo ang wallet."
        },
        "upload_file_fail": "Di-wastong file, pakisuri at subukang muli.",
        "upload_photo_fail": "Di-wastong file, pakisuri at subukang muli.",
        "missing_some_field": "Di-wastong field, pakisuri at subukang muli.",
        "validAddress": "Pakisuyong pumili ng wastong address."
    },
    "statusDisplay": {
        "supplierAccepted": "Tinatanggap ng supplier",
        "pendingAmmendment": "Nakatakdang pagbabago",
        "supplierAllocated": "Nakatakdang tagapagtustos",
        "delivery_supplierAccepted": "Tinatanggap ng supplier",
        "completedWithoutService": "Nakumpleto nang walang driver",
        "confirmed": "Kumpirmadong reserbasyon",
        "pending": "Nakabinbin",
        "queue": "Nagpapadala",
        "offered": "Nagpapadala",
        "booked": "Papunta na ang Driver",
        "engaged": "P.O.B",
        "droppedOff": "Nahulog/ Naihatid",
        "inReview": "Kailangan ng Pagsusuri",
        "pre": "Tinanggap ang order",
        "recurrent": "Ulit-ulit",
        "vacant": "",
        "vacantTime": "",
        "arrived": "Dumating at naghihintay",
        "completed": "Nakumpleto",
        "canceled": "Kinansela",
        "noShow": "Walang Palabas",
        "driverNoShow": "Hindi dumating na driver",
        "action": "Naghihintay ng proseso",
        "incident": "Insidente",
        "pickupTimeExceeded": "Oras ng pahinga",
        "canceledByCC": "Kinansela ni CC",
        "canceledByPassenger": "Kinansela ng pasahero",
        "canceledByDriver": "Kinansela ng driver",
        "canceledByPartner": "Kinansela ng partner",
        "canceledBymDispatcher": "Kinansela ng partner",
        "canceledByCorporateAdmin": "Kinansela ng Corporate Admin",
        "canceledByAPI": "Kinansela ng API",
        "canceledByWebBooking": "Kinansela sa pamamagitan ng web booking",
        "canceledByTimeout": "Kinansela ng timeout",
        "accepted": "Tinatanggap",
        "rejected": "Tinanggihan",
        "canceledByCorpAd": "Kinansela ng Corporate Admin",
        "started": "Nagsimula",
        "intransit": "Sa biyahe",
        "empty": "Walang laman",
        "notLive": "Bahagyang - hindi live",
        "live": "Bahagyang - live",
        "full": "Puno",
        "delivering": "Naghahatid",
        "delivery_booked": "Driver sa daan patungo sa nagpadala",
        "delivery_arrived": "Dumating at naghihintay ng nagpadala",
        "shopForYou_booked": "Driver sa paraan upang mangolekta ng pera",
        "shopForYou_arrived": "Dumating at naghihintay upang mangolekta ng pera",
        "collecting": "Driver sa paraan upang mangolekta ng mga kalakal",
        "confirmed_delivery": "Nakumpirma",
        "food_booked": "Driver papunta sa merchant",
        "food_collecting": "Dumating at naghihintay upang mangolekta ng item",
        "mart_collecting": "Dumating at naghihintay upang mangolekta ng item",
        "otwMerchant": "Driver papunta sa merchant",
        "arrivedAndWaitingToCollectItem": "Dumating at naghihintay na kunin ang item",
        "canceledByAirlineAdmin": "Kinansela ng Airline Admin",
        "partialCompleted": "Bahagyang Nakumpleto",
        "failed": "Nabigo",
        "allocated": "Inilaan"
    },
    "tripTypes": {
        "scheduled": "Mga naka-iskedyul na biyahe",
        "requested": "Humiling ng mga biyahe",
        "preferred": "Mas gusto"
    },
    "login": {
        "Username": "Username",
        "Password": "Password",
        "Remember_me": "Alalahanin mo ako",
        "Forgot_your_password": "Nakalimutan ang iyong password",
        "Login": "Mag log in"
    },
    "invoice": {
        "createBtn": "Gumawa ng invoice",
        "searchPlInvoice": "Maghanap ng kliyente, contact, numero ng invoice",
        "searchPl": "Maghanap ng bookId, pangalan ng customer",
        "createInvoice": "Lumikha ng Invoice",
        "invoicePeriod": "Panahon ng Invoice",
        "invoicePeriodNote": "Maaari kang pumili ng buwan-buwan na hanay ng petsa.",
        "viewEdit": "Tingnan/I-edit",
        "billingContact": "Contact sa pagsingil",
        "memo": "Memo",
        "memoMessage": "Mag-iwan ng mensahe sa customer",
        "dueDate": "Takdang petsa",
        "updateInvoice": "I-update ang Invoice",
        "chargeCustomer": "Singilin ang Customer",
        "invoiceNumber": "Numero ng Invoice",
        "noItem": "Hindi. Mga item",
        "issuedDate": "Petsa ng Paglabas",
        "refId": "Ref #",
        "pickupTime": "Oras ng pagkuha",
        "pickup": "Lokasyon ng Pick Up",
        "destination": "I-drop Off ang Lokasyon/ Lokasyon ng pagbababaan",
        "customerName": "Pangalan ng Customer",
        "totalAmount": "Amount Due",
        "amountDue": "Halagang dapat bayaran",
        "sendInvoice": "Magpadala ng Invoice",
        "copyInvoice": "Kopyahin ang Invoice",
        "downloadPDF": "I-download bilang PDF",
        "paymentLink": "Link sa pagbabayad",
        "deleteInvoice": "Tanggalin ang Invoice",
        "onlySave": "I-save ang Invoice",
        "saveSend": "I-save at Ipadala ang Invoice",
        "sendEmail": "Magpadala ng Email",
        "addRecipients": "Magdagdag ng Mga Tatanggap",
        "editInvoice": "I-edit ang Invoice",
        "check": "Suriin",
        "wire": "Kawad",
        "digitalWallet": "Digital Wallet",
        "cash": "Pera",
        "completedTime": "Nakumpletong Oras",
        "Status": "Katayuan",
        "bookingStatus": "Katayuan ng Pag-book",
        "chargeBtn": "Singilin {0}",
        "pastDue": "Lampas na sa takdang panahon",
        "payCompleted": "Matagumpay na nabayaran ang invoice na ito!",
        "Delete": "Tanggalin ang invoice?",
        "Delete_content": "Permanenteng aalisin ng pagkilos na ito ang invoice na ito. Kung kinakailangan, maaari kang lumikha ng bago para sa (mga) order na ito.",
        "viewInvoice": "Tingnan ang Invoice",
        "pending": "Nakabinbin",
        "paid": "Binayaran",
        "CopyLink": "Kopyahin ang Link",
        "partial": "Bahagyang",
        "corporatePrepaid": "Corporate Prepaid"
    },
    "cue": {
        "bookingServiceType": "Uri ng serbisyo",
        "pointToPoint": "Point To Point",
        "fromAirport": "Mula sa Paliparan",
        "toAirport": "Sa Paliparan",
        "hourly": "Oras-oras",
        "roundTrip": "Round Trip",
        "jobVisibility": "Pagkakita sa Trabaho",
        "jobPubic": "Publiko",
        "jobPrivate": "Pribado",
        "jobSetPubic": "I-set sa Pampubliko",
        "jobSetPrivate": "I-set sa Pribado",
        "supplierAccepted": "Tinatanggap ng supplier",
        "pendingAmmendment": "Nakatakdang pagbabago",
        "supplierAllocated": "Nakatakdang tagapagtustos",
        "creationTime": "Oras ng paglikha",
        "Pax": "Pax #",
        "Luggage": "Mga bagahe",
        "allocated": "Inilaan",
        "completedWithoutService": "Nakumpleto nang walang driver",
        "shuttle": "Shuttle",
        "farmIn": "Farm In",
        "chargeCode": "Code ng Pagsingil",
        "clientCaseMatter": "Paglalarawan ng Biyahe",
        "operatorNote": "Mga Panloob na Tala",
        "farmOut": "Ilipat sa iba",
        "roaming": "Roaming",
        "FlightUpdate": "Update sa Flight",
        "networkType": "Uri ng network",
        "InHouse": "Sa loob ng bahay",
        "External": "Panlabas",
        "carHailing": "Sasakyan Hailing",
        "uploadBookings": "Mag-upload ng Mga Booking",
        "moreActions": "Higit pang mga Aksyon",
        "rideSharing": "Pagbabahaginan ng pagsakay",
        "Rearrange": "Muling ayusin",
        "GroupId": "Grupo ID #",
        "Active": "Aktibo",
        "Finished": "Tapos na",
        "Home_affiliate": "Tahanan / Kaakibat",
        "Booking_type": "Uri ng booking",
        "From": "Mula sa",
        "balanceWallet": "{0}: {1} ang natitira",
        "partialWallet": "Bahagyang pagbabayad gamit ang Wallet",
        "To": "Upang/ Patungo",
        "Status": "Katayuan",
        "Migration_Status": "Katayuan ng Migration",
        "Migrated": "nag-migrate",
        "Select_Status": "Piliin ang Katayuan",
        "Operator": "Operator",
        "Car_types": "Mga uri ng sasakyan",
        "Service_class": "Klase ng serbisyo",
        "Booking_from": "Pagbu-book mula sa",
        "All": "Lahat",
        "Pending": "Nakabinbin",
        "Dispatching": "Nagpapadala",
        "Waiting_for_process": "Naghihintay ng proseso",
        "Confirmed_reservation": "Kumpirmadong reserbasyon",
        "Driver_on_the_way": "Papunta na ang Driver",
        "Arrived_and_waiting": "Dumating at naghihintay",
        "Passenger_on_board": "Pasahero na sakay",
        "Dropped_off": "Nahulog/ Naihatid",
        "combobox_select": "Pumili...",
        "Search_here": "Maghanap dito",
        "Bookingid": "# ng booking",
        "Pickup_Drop_Off": "Pickup/ Drop Off",
        "Pickup_Drop_Off_Crew": "Oras ng Pickup/Drop Off",
        "Pickup_Drop_Off_Local_Time": "Oras ng Operator",
        "Pickup_Location_Destination": "Lokasyon/Patutunguhan ng Pickup",
        "Passenger": "pasahero",
        "Intercity_Route": "Intercity na ruta",
        "Airport_Pickup": "Pagsundo sa paliparan",
        "Airport_Pickup_Crew": "Paliparan",
        "Flight_Status": "Katayuan",
        "Payment": "Pagbabayad",
        "Vehicle": "Sasakyan",
        "Car_type": "Uri ng Sasakyan",
        "Driver": "Driver",
        "Estimated_Fare": "Tinatayang Pamasahe",
        "Notes": "Mga Tala",
        "Note": "Tandaan",
        "Type": "Uri",
        "Home": "Bahay",
        "Affiliate": "Kaakibat",
        "now": "Ngayon (Transport)",
        "reservation": "Reserbasyon (Transportasyon)",
        "recurring": "Umuulit (Transportasyon)",
        "No_show": "Walang Palabas",
        "Canceled_by_CC": "Kinansela ng CC",
        "Canceled_by_passenger": "Kinansela ng pasahero",
        "Canceled_by_partner": "Kinansela ng partner",
        "Canceled_by_mDispatcher": "Kinansela ng partner",
        "Canceled_by_Corporate_Admin": "Kinansela ng Corporate Admin",
        "Canceled_by_API": "Kinansela ng API",
        "canceled_By_Web_Booking": "Kinansela sa pamamagitan ng web booking",
        "canceled_By_Time_Out": "Kinansela ng timeout",
        "Canceled": "Kinansela",
        "Completed": "Nakumpleto",
        "Incident": "Insidente",
        "Payment_Method": "Paraan ng Pagbayad",
        "No_Phone": "Walang Telepono",
        "VIP": "VIP",
        "Non_VIP": "Hindi VIP",
        "Passenger_type": "Uri ng pasahero",
        "Error_load_booking": "Hindi ma-load ang booking, Pakisubukang muli o i-refresh ang page!",
        "Edit_total_success": "Kabuuang matagumpay na na-edit!",
        "Edit_total_fail": "Ang kabuuang pamasahe ay dapat na katumbas o mas malaki sa {0}",
        "Time_out": "Oras na pahinga",
        "Ride_Service": "Serbisyo sa pagsakay",
        "Regulation": "Regulasyon",
        "Ride_Sharing": "Pagbabahaginan ng pagsakay",
        "Unmatching": "Hindi tugma",
        "Matching": "Pagtutugma",
        "all": "Lahat",
        "matching": "Pagtutugma",
        "unmatching": "Hindi tugma",
        "regulation": "Regulasyon",
        "Support_service": "Serbisyong pang-supporta",
        "SOS": "SOS",
        "Non_SOS": "Hindi SOS",
        "Corporate": "Korporatibo",
        "Individual": "Indibidwal",
        "On_curb": "Sa gilid ng bangketa",
        "Meet_Greet": "Pagkikita at Pagbati",
        "Close": "Isara",
        "auto_refrest_cue": "Auto-refresh ({0} segundo)",
        "Ride_type": "Uri ng pagsakay",
        "Edit_total_note": "Tandaan: maa-update ang subtotal, tech fee, booking fee, buwis at tip kapag binago ang kabuuang halaga",
        "Booking": "Pagbu-book",
        "Edit_fare": "I-edit ang pamasahe",
        "Adjust_price": "Ayusin ang Presyo",
        "Total": "Kabuuan",
        "Reason": "Dahilan",
        "Please_enter_reason": "Pakilagay ang dahilan.",
        "Save": "I-save",
        "Cancel": "Kanselahin",
        "dmc": "Board ng reserbasyon",
        "corp": "Booking board (CTM)",
        "Zone": "Lugar ng pagkuha",
        "dropOffZone": "Zone ng pagbaba",
        "mDispatcher": "Kasosyo",
        "streetSharing": "pagbabahagi ng kalye",
        "Driver_No_Job_found": "Naghihintay ng mga takdang-aralin...",
        "expandFilter": "Ipakita ang filter",
        "collapseFilter": "Itago ang filter",
        "clearSelectedItems": "I-clear ang Napiling Mga Item",
        "Accepted": "Tinanggap",
        "Yes": "Oo",
        "No": "Hindi",
        "Order_accepted": "Tinanggap ang order",
        "Confirmed": "Kinumpirma",
        "spotTime": "Spot Time",
        "ETA": "ETA",
        "spareTime": "Bakanteng oras",
        "expectedTime": "Inaasahang oras ng pagkuha",
        "Driver_on_the_way_to_sender": "Driver sa daan patungo sa nagpadala",
        "Driver_on_the_way_to_recipient": "Driver papunta sa tatanggap",
        "Driver_on_the_way_to_collect_cash": "Driver sa paraan upang mangolekta ng pera",
        "Driver_on_the_way_to_collect_goods": "Driver sa paraan upang mangolekta ng mga kalakal",
        "Arrived_waiting_for_sender": "Dumating at naghihintay ng nagpadala",
        "Arrived_waiting_for_recipient": "Dumating at naghihintay ng tatanggap",
        "Arrived_waiting_to_collect_cash": "Dumating at naghihintay upang mangolekta ng pera",
        "Arrived_waiting_to_deliver_goods": "Dumating at naghihintay na maghatid ng mga kalakal",
        "Delivered": "Naghahatid",
        "delivery": "Paghahatid",
        "Service": "Serbisyo",
        "intercity": "Intercity",
        "Transport": "Transportasyon",
        "About_Sender": "Tungkol sa Sender",
        "About_Merchant": "Tungkol sa Merchant",
        "About_Recipient": "Tungkol sa Tatanggap",
        "photos": "Mga larawan",
        "listOfItems": "Listahan ng item",
        "cashOnPickUp": "COP",
        "Package_information": "Impormasyon sa package",
        "otwMerchant": "Driver papunta sa merchant",
        "arrivedAndWaitingToCollectItem": "Dumating at naghihintay upang mangolekta ng item",
        "Save_Filter": "I-save ang Filter",
        "add_favorite_filter": "Magdagdag ng filter",
        "favorite_filter_name": "Pangalan",
        "list_favorite_filter": "Pamahalaan ang mga filter",
        "favorite_filter_actions": "Aksyon",
        "clear_all_filters": "I-clear ang lahat ng mga filter",
        "Delete_Filter": "Tanggalin ang Filter",
        "CONFIRM_DELETE_FILTER_TEMPLATE": "Sigurado ka bang gusto mong tanggalin ang filter na ito?",
        "batchDelivery": "Batch Delivery",
        "editFare": {
            "creditTransactionFee": "Mga bayarin sa credit card",
            "preferredAdjustment": "Ginustong pagsasaayos",
            "editFareFee": "I-edit ang pamasahe at bayarin",
            "markupPrice": "Presyo ng markup",
            "quotedPrice": "Sinipi na presyo",
            "basicFare": "Pangunahing pamasahe",
            "preferredEarning": "Ginustong kita",
            "difference": "Pagkakaiba",
            "rushHourFee": "Patong na singil",
            "serviceFee": "Magdagdag ng serbisyo",
            "otherFees": "Iba pang bayad",
            "subTotal": "Sub kabuuan",
            "airportFee": "Bayad sa paliparan",
            "meetDriverFee": "Kilalanin ang driver",
            "deliveryFee": "Bayad sa paghahatid",
            "tollFee": "Bayad sa toll",
            "parkingFee": "Bayad sa paradahan",
            "gasFee": "Bayad sa gas",
            "techFee": "bayad sa tech",
            "tip": "Tip",
            "bookingFee": "Bayad sa pagpapareserba",
            "tax": "Buwis",
            "promoAmount": "Promo amt",
            "etaFare": "Kabuuan",
            "fleetService": "Serbisyo ng armada",
            "Note_serviceFee": "(upang i-edit ang karagdagang serbisyo, bisitahin ang panlabas na listahan)",
            "startingFee": "Nagsisimula",
            "moveFeeInJourney": "Paglipat",
            "waitFeeInJourney": "Naghihintay (sa biyahe)",
            "total": " kabuuan",
            "totalPayout": "Bayad",
            "updatedTotal": "Nabagong Kabuuan",
            "updatedPayout": "Naka-update na Bayad",
            "profit": "Kita",
            "extraWaitFee": "Bayad sa paghihintay Paunang",
            "heavyTraffic": "Mabigat na trapiko",
            totalWithoutPromo: 'Total before promo',
        },
        "partialCompleted": "Bahagyang Nakumpleto",
        "failed": "Nabigo",
        "Recurring": "Umuulit #",
        "DragAndDrop": "I-drag at i-drop upang muling ayusin ang mga kolum.",
        "bookingCom": "Booking.com",
        "syncingCompleted": "Nakumpleto ang pag-sync",
        "groupManifest": "Manifesto ng Grupo",
        "assignSuppliers": "Mag-assign ng mga Supplier",
        "viewActions": "Tingnan ang mga Aksyon",
        "holidaytaxis": "HolidayTaxis",
        "karhoo": "Karhoo",
        "klook": "Klook",
        "transferZ": "TransferZ",
        "pickupTime": "Pick-up time",
        "AssignSupplier": "Magtalaga ng Supplier",
        "sharedTransfer": "Pinagsamang Transfer (%{id})",
        "batchDeliveryGroup": "Batch Delivery (%{id})",
        "foundersFund": "Founders Fund",
        "zeroCommission": "Zero Komisyon",
        "unassignDriver": "Alisin ang Driver",
        "notUnassignDriver": "Hindi maalis ang driver, Pakisubukan muli",
        "notAssignDriver": "Hindi maitalaga ang driver, Pakisubukan muli",
        "selectDriver": "Pumili ng Driver",
        "unassignVehicle": "Alisin ang Sasakyan",
        "unassignAll": "Alisin ang Lahat ng Takdang Gawain",
        "notUnassignAll": "Hindi maalis ang lahat, Pakisubukan muli",
        "unassignAllSuccess": "Ang sasakyan at drayber ay matagumpay na naalis.",
        "unassign_all_partial": "Bahagyang Tagumpay: Nabigo ang batch unassignment para sa mga sumusunod na biyahe (Booking IDs) dahil sa mga patuloy na aksyon: {0}.",
        "notUnassignVehicle": "Hindi maalis ang sasakyan, Pakisubukan muli",
        "notAssignVehicle": "Hindi maitalaga ang sasakyan, Pakisubukan muli",
        "selectVehicle": "Pumili ng Sasakyan",
        "confirmUnassign": "Sigurado ka bang nais mong alisin ang pagkatalaga?",
        "printMeetingBoard": "I-print ang Meeting Board",
        "needReview": "Kailangan ng Pagsusuri"
    },
    "trip": {
        "Driver_vehicle": "sasakyan ng driver",
        "tripId": "# ng biyahe",
        "tripTypes": "Mga uri ng biyahe",
        "Start_Time": "Oras ng simula",
        "Seats_Status": "Katayuan ng mga upuan",
        "No_Of_Booking": "Bilang ng mga booking",
        "Vehicle": "sasakyan ng driver",
        "Estimated_Fare": "pamasahe",
        "capacityStatus": "Katayuan ng upuan",
        "Trip_Types": "Mga uri ng biyahe",
        "scheduled": "Mga naka-iskedyul na biyahe",
        "requested": "Humiling ng mga biyahe",
        "preferred": "Mas gusto",
        "All": "Lahat",
        "Confirmed": "Nakumpirma",
        "Started": "Nagsimula",
        "In_Transit": "Sa Transit",
        "Empty": "Walang laman",
        "Partial_not_live": "Bahagyang - hindi live",
        "Partial_live": "Bahagyang - live",
        "Full": "Puno",
        "Error_load_trip": "Hindi ma-load ang biyahe, Pakisubukang muli o i-refresh ang pahina!"
    },
    "tripDetails": {
        "Trip_ID": "paglalakbay sa pagitan ng lungsod",
        "DRIVER_JOB": "Impormasyon ng driver",
        "BOOKINGS": "Mga booking",
        "updateTrip": "I-update ang Biyahe",
        "cancelTrip": "Kanselahin ang Biyahe",
        "note_cancel": "Mangyaring italaga ang lahat ng booking sa ibang driver bago kanselahin ang biyaheng ito.",
        "TRIP_INFORMATION": "Impormasyon sa Biyahe",
        "route": "Ruta",
        "startTime": "Oras ng simula",
        "distance": "Distansya",
        "duration": "Tagal",
        "fare": "pamasahe",
        "cartype": "Intercity na uri ng sasakyan",
        "seatStatus": "Katayuan ng upuan",
        "started": "Nagsimula",
        "intransit": "Sa biyahe",
        "empty": "Walang laman",
        "notLive": "Bahagyang - hindi live",
        "live": "Bahagyang - live",
        "full": "Puno",
        "noOfBooking": "Bilang ng booking",
        "luggage": "Mga bagahe",
        "nameDriver": "Pangalan",
        "vehicleType": "Sasakyan",
        "assignDriver": "Magtalaga ng driver",
        "pickUpAddress": "Pulutin",
        "destinationAddress": "Ilaglag/ Ihatid",
        "customerName": "Pangalan",
        "customerPhone": "Telepono",
        "customerNumber": "Mga upuan",
        "customerLuggageNumber": "Mga bagahe",
        "additionalService": "Karagdagang serbisyo",
        "paymentBooking": "Pagbabayad",
        "note": "Tandaan",
        "CONFIRM_UPDATE": "kumpirmahin ang pag-update",
        "CONFIRM_UPDATE_MESSAGE": "Sigurado ka bang gusto mong i-update ang biyaheng ito?",
        "Yes": "Oo",
        "No": "Hindi",
        "Update_info": "Oo, I-update ang impormasyon"
    },
    "newbooking": {
        "Addon_driver_capability": "This assignment does not fully meet the customer’s service requirements. Missing Requirements ({0})",
        "Search_Vehicle": "Maghanap ng sasakyan",
        "rideSharing_multi_point": "1 pick-up at 1 drop off point lang ang pinapayagan para sa ride sharing booking.",
        "Pick_up_time": "Oras ng pagkuha",
        "Drop_off_time": "Oras ng pagbaba",
        "All_Suppliers": "Lahat ng mga supplier",
        "Recipient": "tatanggap",
        "All": "Lahat",
        "New_Booking": "Bagong Booking",
        "GoogleMapRoute": "Google Map",
        "BOOKING_INFORMATION": "Impormasyon sa Pag-book",
        "TIP_PROMO": "Tip - Promo",
        "Pick_up": "Pulutin",
        "instructions": "Mga tagubilin",
        "instructions_placeholder": "Ilista ang iyong mga tagubilin dito...",
        "Enter_a_location": "Maglagay ng lokasyon",
        "Enter_a_location_delivery": "Maglagay ng lokasyon",
        "Enter_3rd_party_location": "Ilagay ang lokasyon ng 3rd party",
        "Enter_a_sender": "Magpasok ng isang Nagpadala",
        "Enter_a_recipient": "Maglagay ng Recipient",
        "Vehicle_Selection": "Pagpili ng Sasakyan",
        "Destination": "Patutunguhan",
        "Pickup_time": "Oras ng pagkuha",
        "Note": "Tandaan",
        "note_for_driver": "Paalala para sa driver",
        "affiliate_note": "Paalala para sa kaakibat",
        "affiliate_note_placeholder": "Maglagay ng mga kaakibat na tala para sa mga operator",
        "operator_note": "Ipasok ang panloob na mga tala para sa mga operator",
        "TRAVELER_INFORMATION": "Impormasyon ng Manlalakbay",
        "Traveler_type": "Uri ng manlalakbay",
        "Individual": "Indibidwal",
        "Corporation": "Korporasyon",
        "Phone_number": "Numero ng telepono",
        "First_name": "Pangalan",
        "Last_name": "Huling pangalan",
        "Email_address": "Email address",
        "Corp_id": "Korporasyon id",
        "Manager_name": "Pangalan ng manager",
        "Manager_email": "Email ng manager",
        "Cost_centre": "Sentro ng gastos",
        "Department": "Kagawaran",
        "Corp_division": "Dibisyon ng korporasyon",
        "Tip": "Tip",
        "Promo_code": "Promo code",
        "Apply": "Mag-apply",
        "Promo": "Promo:",
        "DISPATCH": "Pagpapadala",
        "Auto_dispatch": "Awtomatikong pagpapadala",
        "Assign_driver": "Magtalaga ng driver",
        "FarmOut": "Ilipat sa iba",
        "Driver": "Driver",
        "Driver_Supplier": "Supplier/Driver",
        "PAYMENT_METHOD": "Paraan ng Pagbabayad",
        "OPERATOR_NOTE": "Mga Panloob na Tala",
        "TRIP_ESTIMATE": "Pagtatantya ng Biyahe",
        "Choose_a_stored_card": "Pumili ng nakaimbak na card",
        "Choose_a_payment_method": "Pumili ng paraan ng pagbabayad",
        "Use_new_card": "Gumamit ng bagong card",
        "Card_holder": "May hawak ng card",
        "Card_number": "Numero ng card",
        "Expired_date": "Petsa ng pag-expire(mm/yy)",
        "ccv": "CVV",
        "Distance": "Distansya",
        "Duration": "Tagal",
        "Fare": "pamasahe",
        "Route": "Ruta",
        "Create": "Lumikha",
        "Cancel": "Kanselahin",
        "Meet_driver": "Kilalanin ang driver",
        "Airline": "Airline",
        "Flight": "Lipad #",
        "FLY_INFO": "Impormasyon sa Paglipad",
        "Ride_Sharing": "Pagbabahagi ng Sakay",
        "Round_trip": "Papunta at pabalik",
        "Car_type": "Uri ng kotse",
        "Address": "Address",
        "City": "lungsod",
        "State": "Estado",
        "Zip_code": "Zip code",
        "Remove": "Alisin",
        "Client_case_matter": "Bagay sa kaso ng kliyente / paglalarawan ng biyahe",
        "Charge_code": "Code ng singil / Code ng biyahe",
        "CANCEL_BOOKING": "Isara ang Pag-book Kumpirmahin",
        "CANCEL_BOOKING_CONFIRM": "Gusto mo bang umalis sa form na ito? Mawawala ang lahat ng data ng booking.",
        "Search_here": "Maghanap dito",
        "No_support_location": "Sa kasamaang palad, ang serbisyo ay hindi magagamit sa lugar na ito",
        "Closest_driver_message": "Ang pinakamalapit na driver ay humigit-kumulang {0} ang layo",
        "No_cars_available": "Walang available na sasakyan sa loob ng radius ng pagpapadala.",
        "processed_by_affiliate": "Ang iyong mga kahilingan ay ipoproseso ng aming mga kasosyong kaakibat",
        "FlightExample": "Flight #, hal. AA1097",
        "Yes": "Oo",
        "No": "Hindi",
        "dispatch_3rd": "Pagpapadala sa pamamagitan ng 3rd party",
        "Company": "kumpanya",
        "Card_required": "Mangyaring pumili o magdagdag ng card!",
        "Tip_value": "Wala",
        "Calendar": "Kalendaryo",
        "Extra_Destination": "Karagdagang destinasyon",
        "Driver_credit_limited_balance_warning": "Ang balanse ng driver na ito ay mas mababa sa o katumbas ng limitadong halaga",
        "Meet_Greet_option": "Pagkikita at Pagbati",
        "On_Curb_option": "Sa gilid ng bangketa",
        "Extra_Services": "Karagdagang serbisyo",
        "Addl_Services": "Karagdagang serbisyo",
        "Save": "I-save",
        "Regular": "Regular",
        "Please_fill_in_all_the_required_fields": "Paki-sagutan ang mga kailangan.",
        "Route_names_not_dup": "Huwag ulitin ang mga pangalan ng ruta.",
        "Please_select_weekdays": "Mangyaring piliin ang umuulit sa mga araw na gusto mong mangyari ang booking na ito",
        "Flat_rate": "Patag na bayad",
        "All_company": "Lahat ng kumpanya",
        "Best_price": "Pinakamahusay na presyo",
        "PromoTitle": "Promo",
        "Show_more": "Ipakita pa",
        "Warning_pending_payment": "Ang customer na ito ay may hindi kumpletong pagbabayad mula sa mga nakaraang booking: %{fare}",
        "Warning_outstanding_balance": "Ang natitirang balanse ay ilalapat sa pagtatapos ng biyahe.",
        "Not_available": "Hindi magagamit",
        "Warning_assigned_rate": "Mangyaring i-set up at italaga ang rate para sa napiling uri ng kotse upang magpatuloy.",
        "PaxLuggageNumber": "Numero ng pasahero/bagahe",
        "paxNumber": "pasahero",
        "luggageNumber": "Mga bagahe",
        "Date": "Petsa",
        "Single": "Walang asawa",
        "Recurring": "Paulit-ulit",
        "Date_range": "Na-customize na mga araw",
        "WeekDays": "Ulitin sa mga araw",
        "Create_Route": "Lumikha ng Ruta",
        "Pickup_Point": "Pulutin/ Sunduin",
        "Drag_To_Render": "I-drag at i-drop upang muling ayusin",
        "DropOff_Point": "Mga Babaan/ Mga Bagsakan",
        "Sender": "Nagpadala",
        "Recipients": "Mga tatanggap",
        "Sender_Infomation": "Impormasyon ng Nagpadala",
        "Recipient_Infomation": "Impormasyon ng Recipient",
        "Recipient_Name": "Pangalan ng makakatanggap *",
        "Recipient_Phone": "Numero ng telepono *",
        "Room_floor_block": "Kwarto, sahig, at bloke (opsyonal)",
        "Details": "Mga Detalye",
        "Package_Content": "Nilalaman ng Package *",
        "Order_ID": "Order # (hal. shopify order #)",
        "Instructions_for_driver": "Mga tagubilin para sa driver",
        "Cost_of_Goods": "Cash on Delivery (COD)",
        "Enter_amount": "Ilagay ang halaga",
        "Additional_Information": "Karagdagang Impormasyon",
        "Insurance": "Seguro",
        "Special_Care": "Espesyal na pag-aalaga",
        "Delivery_Fee": "Bayarin sa Paghahatid",
        "Item_fees": "Mga bayarin sa item",
        "Tech_Fee": "Bayad sa Teknolohiya",
        "Tax": "Buwis",
        "driverNotes": "Mga Tala sa Pagmamaneho",
        "rejectModal": "Tanggihan ang booking",
        "rejectModalBody": "Sigurado ka bang gusto mong tanggihan ang booking na ito?",
        "rejectButton": "Tanggihan ang booking",
        "acceptModal": "Tanggapin ang booking",
        "acceptModalBody": "Sigurado ka bang gusto mong Tanggapin ang booking na ito?",
        "ConfirmedTo": "Kinumpirma sa ({0})",
        "proceedAction": "Sigurado ka bang nais mong ipagpatuloy ang aksyong ito?",
        "acceptButton": "Tanggapin ang booking",
        "denyModal": "Tanggihan ang booking",
        "denyModalBody": "Sigurado ka bang gusto mong tanggihan ang booking na ito?",
        "denyButton": "Tanggihan ang booking",
        "Accept_booking_success": "Matagumpay na natanggap ang booking na ito!",
        "Deny_booking_success": "Matagumpay na tinanggihan ang booking na ito!",
        "adjustFare": "Ayusin ang pamasahe",
        "totalFare": "Kabuuang Pamasahe",
        "Profit": "Kita",
        "DriverEarning": "Kinita ng Driver",
        "Payout": "Bayad",
        "totalPayout": "Kabuuang bayad",
        "DriverPayOut": "Payout ng Driver",
        "confirmReject": "Kumpirmahin ang Pagtanggi",
        "confirmCancelMSG": "Sigurado ka bang gusto mong tanggihan ang booking na ito? Maaari kang magkaroon ng multa mula sa iyong provider.",
        "reasonCancel3rd": "Dahilan ng pagtanggi",
        "welcome_psg": "Maligayang pagdating pasahero",
        "AmountDue": "Halagang dapat bayaran",
        "Fleet_Company": "Flota",
        "Search_driver_hydra": "Susubukan naming hanapin ka ng driver sa lalong madaling panahon.",
        "ExternalID": "Panlabas na ID",
        "viewRate": "Rate ng Pagtingin",
        "PointToPoint": "Tuktok sa tuktok",
        "Offer_driver": "Nag-aalok ng Driver",
        "Assign_driver_vehicle": "Magtalaga ng Driver / Sasakyan",
        "notify_via_email": "Abisuhan ang Customer sa pamamagitan ng Email",
        "fleetFare": "Fleet Fare",
        "onlySave": "I-save",
        "saveCharge": "I-save at Singilin",
        "saveRefund": "I-save at I-refund",
        "lateCancelConfirm": "Sigurado ka bang nais mong tapusin ang booking na ito bilang",
        "canceledDriverConfirm": "Sigurado ka bang nais mong kanselahin ang booking na ito para sa driver? Magkakaroon ng penalty fee.",
        "canceledDriverNoChargeConfirm": "Sigurado ka bang nais mong kanselahin ang booking na ito para sa drayber?",
        "canceledCustomerNoChargeConfirm": "Sigurado ka bang nais mong itakda ang customer na ito bilang isang",
        "noshowDriverConfirmCharge": "Sigurado ka bang nais mong itala ang drayber bilang hindi nagpakita? Maaaring ipataw ang isang multa.",
        "noshowDriverConfirmNoCharge": "Are you should you want to mark this customer as a no show?",
        "NoShowConfirm": "Ang patakaran sa hindi pagdalo ay ipapatupad.",
        "completeConfirm": "Sigurado ka bang nais mong Kumpletuhin nang walang driver?",
        "completeChargeConfirm": "Buong singil ay ipapataw sa customer. Ang driver ay hindi makakatanggap ng anumang komisyon mula sa booking na ito.",
        "PricingPlan": "Plano ng Pagpepresyo",
        "editFerviceFees": "upang i-edit ang mga bayarin sa serbisyo, bisitahin ang panlabas na listahan",
        "ungroupAll": "I-unGroup Lahat",
        "satisfaction": "kasiyahan",
        "Reassign": "Muling italaga",
        "addNote": "Magdagdag ng tala",
        "noteMagicSend": "Pumili ng magic wand o i-type ang [ upang agad na ma-access ang mga mungkahi sa booking keywords.",
        "items": "Mga Item",
        "PaidAmount": "Halagang Nabayaran",
        "ExternalPartner": "Panlabas na Kasosyo",
        "ExternalPartnerNote": "Mga independiyenteng kasosyo na namamahala sa kanilang sariling mga driver at sasakyan. Ang mga pagbabayad ay direktang pinangangasiwaan sa supplier.",
        "InHousePartner": "Kasosyo sa Loob ng Kumpanya",
        "InHousePartnerNote": "Direktang pinamamahalaan ng iyong fleet. Ang mga bayad ay ginagawa nang direkta sa mga driver.",
        "Role": "Role",
        "Client": "Kliyente",
        "ApplyCancellation": "Mag-apply ng patakaran sa pagkansela",
        "unassigned": "hindi itinalaga",
        "bookingSelected": "napiling reserbasyon",
        "Update": "Update",
        "emailInvoice": "Email Invoice",
        "Receipt": "Resibo",
        "addItem": "Magdagdag ng Item",
        "newCustomer": "Magdagdag ng Bagong Customer",
        "forGuest": "Mag-book para sa bisita",
        "invalid_some_field": "Di wastong larangan, pakisuri at subukan muli.",
        "ExpandCorp": "Palawakin ang Mga Detalye ng Kumpanya",
        "hideCorp": "Tago ang Detalye ng Kumpanya",
        "searchCusPlaceholder": "Maghanap ng pangalan ng contact, telepono, email",
        "CorporationGuest": "Korporasyon - Bisita",
        "IndividualGuest": "Indibidwal - Bisita",
        "passInfo": "Impormasyon ng Pasahero",
        "noAdjustmentPickupTime": "Walang pagbabago sa oras ng pickup",
        "whenFlightArrives": "Kapag dumating ang flight",
        "minAfterArrival": "{0} min pagkatapos ng pagdating ng flight",
        "pickupInstructions": "Mga Tagubilin sa Pagkuha",
        "selectMeetingPoint": "Pumili ng Punto ng Pulong para sa Pagkuha",
        "durationTrip": "Tagal (Oras)"
    },
    "bookingDetailLogs": {
        "recipient": "Tumatanggap",
        "updatedInfo": "Na-update na impormasyon",
        "updatedField": "Naka-update na larangan",
        "valueBefore": "Halaga bago",
        "valueAfter": "Halaga pagkatapos",
        "location": "Lokasyon",
        "etaFare": "Pamasahe",
        "dispatchType": "Pagpapadala",
        "drvInfo": "Driver",
        "meetingPoint": "Punktong Pulungan",
        "vehicleTypeRequest": "Hiling ng Sasakyan",
        "clientCaseMatter": "Paglalarawan ng biyahe",
        "chargeCode": "Kodigo ng biyahe",
        "driverEarningType": "Uri ng Kita ng Driver",
        "editedDriverEarning": "Kita ng driver",
        "reasonEditFare": "Dahilan",
        "bookingReference": "Panlabas na ID",
        "tip": "Tip",
        "type": "Uri ng serbisyo",
        "promo": "Promo",
        "dispatch3rd": "Ipadala ang 3rd",
        "rideSharing": "Pagbabahagi ng Sakay",
        "notes": "Mga tala ng drayber",
        "operatorNote": "Panloob na tala",
        "welcomeMessage": "Mensaheng Maligayang Pagdating",
        "flightNumber": "Numero ng Flight",
        "fullName": "Buong Pangalan",
        "email": "Email",
        "cardMask": "Mask ng card",
        "paymentType": "Paraan ng pagbabayad",
        "recipients": "Mga Tumanggap",
        "sender": "Nagpadala",
        "pickupName": "Pangalan ng Pickup",
        "pickupPhone": "Pickup Telepono",
        "pickupEmail": "Pickup Email",
        "supplierEarningType": "Uri ng bayad",
        "editedSupplierEarning": "Halaga ng pagbabayad",
        "route": "Pangalan ng ruta",
        "markupDifference": "Pagkakaiba ng Markup",
        "selectedDates": "Napiling Petsa",
        "services": "Serbisyo ng fleet",
        "destinationAddress": "Lokasyon ng patutunguhan",
        "pickupAddress": "Lokasyon ng pick-up",
        "tripType": "Uri ng Biyahe",
        "pickUpTime": "Oras ng pagkuha",
        "paxNumber": "Pasahero",
        "luggageNumber": "Biyaheng Bagahe",
        "vehicle": "Sasakyan",
        "minutesToArrive": "Inaasahang pagdating ng drayber",
        "affiliateNote": "Nota ng Kaakibat",
        "packageRateName": "Pangalan ng pakete",
        "supplierCompanies": "Kumpanya",
        "puPoints": "Lokasyon ng kuha",
        "doPoints": "Lokasyon ng patutunguhan",
        "promoValue": "Halaga ng promo",
        "packageInfo": "Impormasyon ng pakete",
        "orderId": "Order Id",
        "cashOnDelivery": "Bayad sa pag-deliver",
        "externalId": "Panlabas na Id",
        "recurring": "Paulit-ulit",
        "batchDelivery": "Batch Delivery",
        "payout": "Bayad",
        "locationDetails": "Mga Detalye ng Lokasyon",
        "name": "Pangalan",
        "phone": "Telepono",
        "address": "Address",
        "basicFare": "Batayang pamasahe",
        "airportFee": "Bayad sa paliparan",
        "bookingFee": "Bayad sa reserbasyon",
        "creditTransactionFee": "Bayarin sa credit card",
        "fleetService": "Serbisyo ng fleet",
        "fleetServices": "Serbisyo ng fleet",
        "gasFee": "Bayad sa gas",
        "meetDriverFee": "Bayad sa pagkuha ng drayber",
        "moveFeeInJourney": "Bayad sa paglipat",
        "otherFees": "Ibang bayad",
        "parkingFee": "Bayad sa paradahan",
        "promoAmount": "Promo amt",
        "rushHourFee": "Bayad sa oras ng rurok",
        "serviceFee": "Bayad sa serbisyo",
        "startingFee": "Bayad sa pagsisimula",
        "subTotal": "Sub kabuuan",
        "tax": "Buwis",
        "techFee": "Bayad sa teknolohiya",
        "tollFee": "Bayad sa toll",
        "waitFeeInJourney": "Bayad sa paghihintay (sa biyahe)",
        "psgPhone": "Telepono ng pasahero",
        "totalAddonFee": "Addon fee",
        "addonServices": "Addon services"
    },
    "bookingdetail": {
        "RefreshFare": "I-refresh ang Pamasahe",
        "noShowAction": "Walang Pagpapakita na Aksyon",
        "noShowClose": "Ilapat ang No-show at Isara ang Booking",
        "noShowNotClose": "Ilapat ang No-show at Unassign",
        "cancelAction": "Ikansela ang Aksyon",
        "cancelClose": "Ilapat ang Kanselahin at Isara ang Booking",
        "cancelNotClose": "Ilapat ang Kanselahin at Alisin ang Takdang Gawain",
        "settings": "Mga Setting",
        "updateSuccessJobVisibilitySingle": "Matagumpay na na-update ang visibility",
        "updateSuccessJobVisibilityMulti": "%{number} mga booking ay matagumpay na na-update",
        "failApi": "May nangyaring mali!",
        "settingsTooltip": "Ang drayber ay nakatalaga na o ang biyahe ay kasalukuyang isinasagawa.",
        "shareJobPublicly": "Ibahagi ang Trabaho Nang Publiko",
        "groupOder": "Pagkakasunod-sunod ng pangkat",
        "ExistingGroup": "Umiiral na Grupo",
        "NewGroup": "Bagong grupo",
        "Search_trip": "Hanapin ang biyahe #",
        "All": "Lahat",
        "creditTransactionFee": "Mga bayarin sa credit card",
        "partial_payment": "Paunang bayad",
        "Write_off_debt": "Isulat ang utang",
        "Booking_detail": "Pagbu-book",
        "Order_detail": "Umorder",
        "Completed_Booking": "Nakumpleto ang Pag-book",
        "Late_Cancel_Passenger": "Huling pagkansela ng pasahero",
        "Late_Cancel_Driver": "Huling pagkansela ng drayber",
        "No_Show_Passenger": "Hindi pagdating ng pasahero",
        "No_Show_Driver": "Walang dumating na driver",
        "Late_Cancel": "Huling pagkansela",
        "Cancel_Driver": "Kanselahin ng driver",
        "No_Show": "Walang Palabas/ Hindi Dumating",
        "Without_driver": "Kumpleto nang walang driver",
        "Complete_driver": "Kumpleto sa driver",
        "BOOKING_INFORMATION": "Impormasyon sa pag-book",
        "TIP_PROMO": "Tip - Promo",
        "Rearrange_Column": "Ayusin muli ang Column",
        "Pick_up": "Pulutin/ Sunduin",
        "Enter_a_location": "Maglagay ng lokasyon",
        "Destination": "Patutunguhan",
        "Pickup_time": "Oras ng pagkuha/ Pagsundo",
        "Notes": "Mga Tala",
        "TRAVELER_INFORMATION": "Impormasyon ng manlalakbay",
        "Traveler_type": "Uri ng manlalakbay",
        "Individual": "Indibidwal",
        "Corporation": "Korporasyon",
        "Phone_number": "Numero ng telepono",
        "First_name": "Pangalan",
        "Last_name": "Huling pangalan",
        "Email_address": "Email address",
        "Corp_id": "Korporasyon id",
        "Manager_name": "Pangalan ng manager",
        "Manager_email": "Email ng manager",
        "Cost_centre": "Sentro ng gastos",
        "Department": "Kagawaran",
        "Corp_division": "Dibisyon ng korporasyon",
        "Tip": "Tip",
        "Promo_code": "Promo code",
        "Apply": "Mag-apply",
        "Promo": "Promo",
        "DISPATCH": "Pagpapadala",
        "Auto_dispatch": "Awtomatikong pagpapadala",
        "Assign_driver": "Magtalaga ng driver",
        "Driver": "Driver",
        "PAYMENT_METHOD": "Paraan ng pagbabayad",
        "Payment_methods": "Mga paraan ng pagbabayad",
        "pending_payment": "Nakabinbing Pagbabayad",
        "TRIP_ESTIMATE": "Pagtatantya ng biyahe",
        "Choose_a_stored_card": "Pumili ng nakaimbak na card",
        "Choose_a_payment_method": "Pumili ng paraan ng pagbabayad",
        "OPERATOR_NOTE": "Mga Panloob na Tala",
        "Use_new_card": "Gumamit ng bagong card",
        "Card_holder": "May hawak ng card",
        "Card_number": "Numero ng card",
        "Expired_date": "Petsa ng pag-expire(mm/yy)",
        "ccv": "CVV",
        "Distance": "Distansya",
        "Duration": "Tagal",
        "Fare": "pamasahe",
        "Route": "Ruta",
        "Meet_driver": "Kilalanin ang driver",
        "Airline": "Airline",
        "Flight": "Lipad #",
        "FLY_INFO": "Impormasyon ng flight",
        "Ride_Sharing": "Pagbabahagi ng Sakay",
        "Round_trip": "Papunta at pabalik",
        "Car_type": "Uri ng kotse",
        "Address": "Address",
        "City": "lungsod",
        "State": "Estado",
        "Zip_code": "Zip code",
        "Remove": "Alisin",
        "New_Booking": "Bagong Booking",
        "Clone_Booking": "Clone Booking",
        "New_Order": "Bagong Order",
        "ViewTrackLink": "Tingnan ang Link ng Track",
        "driverLink": "Driver link",
        "ClickCopy": "I-click upang kopyahin ang link",
        "meetingBoard": "Pagpupulong \n Lupon",
        "ViewLog": "Tingnan ang mga dispatch log",
        "Message": "Mensahe",
        "Update_Booking": "I-update ang Booking",
        "Cancel_Booking": "Kanselahin ang Booking",
        "Complete_with_payment": "Kumpleto sa Pagbabayad",
        "Incident": "Insidente",
        "CONFIRM_CANCEL": "kumpirmahin kanselahin",
        "CONFIRM_CANCEL_MESSAGE": "Sigurado ka bang gusto mong kanselahin ang booking na ito?",
        "CONFIRM_UPDATE": "kumpirmahin ang pag-update",
        "CONFIRM_UPDATE_MESSAGE": "Sigurado ka bang gusto mong i-update ang booking na ito?",
        "CONFIRM_RESET_EDIT_FARE_MESSAGE": "Na-reset ang iyong na-edit na pamasahe, mangyaring suriin bago magpatuloy.",
        "Close": "Isara",
        "Update_info": "Oo, I-update ang impormasyon",
        "Update_info_dispatch": "Oo, I-update ang impormasyon at pagpapadala",
        "Update_info_tooltip": "Kung itatalaga mo ang booking na ito sa isang bagong driver, mangyaring piliin ang \"Oo, I-update ang impormasyon at ipadala\" na button.",
        "BOOKING": "Pagbu-book",
        "DROPPED_OFF": "Nahulog/ Naihatid",
        "Payment_Type": "Uri ng Pagbabayad",
        "Total": "Kabuuan",
        "Next": "Susunod",
        "Pay_here": "Magbayad dito",
        "Complete_booking": "Kumpleto na ang booking",
        "Complete_booking_tooltip": "Paki-click ang \"I-update ang booking\" upang i-save ang iyong mga pagbabago bago magpatuloy.",
        "Cancel": "Kanselahin",
        "Back": "Bumalik",
        "Tax": "Buwis",
        "Booking_fees": "Mga bayarin sa pag-book",
        "Tech_fees": "Mga bayad sa tech",
        "Subtotal": "Subtotal",
        "Other_fees": "Iba pang bayad",
        "Waiting_fee": "Bayad sa paghihintay",
        "Toll_fees": "Mga toll fee",
        "Heavy_traffic": "Matinding trapiko",
        "Rush_hour": "Patong na singil",
        "Basic_fare": "Pangunahing pamasahe",
        "Ok": "Sige",
        "Input_reason": "Input na dahilan",
        "Client_case_matter": "Bagay sa kaso ng kliyente / paglalarawan ng biyahe",
        "Charge_code": "Code ng singil / Code ng biyahe",
        "Enter_3rd_party_location": "Ilagay ang lokasyon ng 3rd party",
        "Company": "kumpanya",
        "Check_promo_error": "Suriin ang error sa promoCode!",
        "Add_new_credit_error": "Magdagdag ng bagong credit error!",
        "Can_not_get_fare_setting": "Hindi makakuha ng setting ng pamasahe!",
        "Can_not_get_affilate_fare_setting": "Hindi makakuha ng mga setting ng pamasahe ng Affiliate!",
        "Can_not_check_commisson": "hindi masuri ang commisson!",
        "No_flight_info": "Walang impormasyon sa paglipad!",
        "Socket_server_disconnected": "Nadiskonekta ang socket server!",
        "Please_reload_page_or_check_your_connection": "Paumanhin. Hindi maproseso ang iyong kahilingan. Pakisubukang muli.",
        "View_Logs": "Tingnan ang mga log",
        "Bookingid": "# ng booking",
        "Calendar": "Kalendaryo",
        "Extra_Destination": "Karagdagang destinasyon",
        "Meet_Greet_option": "Pagkikita at Pagbati",
        "On_Curb_option": "Sa gilid ng bangketa",
        "Credit_Card": "Kard ng kredito",
        "Charge": "singilin",
        "No_charge": "Walang bayad",
        "QR_Code_method_not_allow_error_message": "Mangyaring pumili ng ibang uri ng pagbabayad dahil ang QRCode ay hindi magagamit na magbayad sa dashboard!",
        "change_payment_method_note": "Kung gusto mong baguhin ang paraan ng pagbabayad, mangyaring bumalik sa booking form.",
        "Airport_Fee": "Bayad sa Paliparan",
        "Addi_service": "Mga Add'l Services",
        "Additional_Services": "Karagdagang serbisyo",
        "Minimum": "pinakamababa",
        "Search_here": "Maghanap dito",
        "No_Driver_Yet": "Wala pang driver na nakatalaga",
        "Personal_Card": "Personal na card",
        "Reject_booking": "Tanggihan ang Booking",
        "Confirm_reject": "Kumpirmahin ang pagtanggi",
        "Confirm_reject_message": "Sigurado ka bang gusto mong tanggihan ang booking na ito?",
        "Confirm_reject_booking_with_charge": "Sisingilin ka ng {0}% ng naka-quote na pamasahe batay sa aming patakaran sa pagkansela. Sigurado ka bang gusto mong tanggihan ang booking na ito?",
        "Yes": "Oo",
        "No": "Hindi",
        "shortTrip": "Maikling Biyahe",
        "Add_new_card": "Magdagdag ng bagong card",
        "Require_customer_info": "Mangyaring ipasok ang impormasyon ng customer upang magpatuloy.",
        "Require_corp_info": "Pakilagay ang impormasyon ng kumpanya upang magpatuloy.",
        "Require_corp_customer_info": "Kailangan ng impormasyon ng gumagamit upang lumikha ng bagong kard.",
        "confirm_force_overlap": "Kumpirmasyon",
        "confirm_force_overlap_message": "Nag-o-overlap ang booking na ito sa mga tinatanggap na booking ng driver. Sigurado ka bang gusto mong italaga ito sa driver na ito?",
        "select": "Pumili",
        "PICKUP_TIME_RANGE": "Tinatayang pickup sa {0}",
        "food": "Pagkain",
        "mart": "Mart",
        "Order_summary": "Buod ng Order",
        "addOnPrice": "Inayos ang presyo",
        "applicableFee": "Kabuuan (naaangkop)",
        "itemValue": "Halaga ng item",
        "promotion_note_paymentMethod": "Ang order na ito ay inilalapat ang promotion code na may limitadong paraan ng pagbabayad: %{method}.",
        "promotion_note_minimum_fare": "Ang order na ito ay inilalapat ang code na pang-promosyon na may limitadong minimum na pamasahe: %{fare}.",
        "promotion_note_schedules": "Ang order na ito ay inilalapat na promotion code na may limitadong oras ng pagkuha.",
        "edited_fare_note": "Ito ay mga tala sa pagsasaayos ng pamasahe para sa sanggunian lamang. Mangyaring bisitahin ang mga ulat upang tingnan ang huling pamasahe at bayad.",
        "view_good_receipt": "Tingnan ang resibo ng mga kalakal",
        "confirmRemoveGroupTransport": "Sigurado ka bang gusto mong alisin ang kasalukuyang booking mula sa manifest na ito?",
        "confirmRemoveGroupDelivery": "Sigurado ka bang gusto mong alisin ang kasalukuyang booking sa grupong ito?",
        "confirmUngroupTransport": "Sigurado ka bang gusto mong i-ungroup ang lahat ng booking mula sa manifest na ito?",
        "confirmUngroupDelivery": "Sigurado ka bang gusto mong i-ungroup ang lahat ng booking mula sa grupong ito?",
        "view_delivery_receipt": "Tingnan ang larawan ng paghahatid",
        "select_time": "Pumili ng oras",
        "InputReason": "Input na dahilan",
        "viewOrder": "Tingnan ang Order",
        "markFailed": "Markahan bilang nabigo",
        "corporateName": "Pangalan ng Kumpanya",
        "sendMessage": "Magpadala ng Mensahe",
        "AmountDueBefore": "Halaga ng Dapat Nauna",
        "AmountDueAfter": "Halaga na Babayaran Pagkatapos",
        "chargeCustomer": "Singilin ang Customer",
        "pending": "Hindi bayad",
        "refundPayment": "Refund Customer",
        "refundableAmount": "Maibabalik na halaga",
        "refundReason": "Magdagdag ng dahilan ng refund",
        "refundBtn": "Ibalik ang {0}",
        "partial": "Bahagyang",
        "paid": "Binayaran",
        "ViewPaymentLogs": "Tingnan ang mga log ng pagbabayad",
        "pmActivity": "Aktibidad sa Pagbabayad",
        "paidStatus": "Bayad na katayuan",
        "paymentLog": "Log ng Pagbabayad",
        "extraWaitFee": "Bayad sa paghihintay Paunang",
        "extraWaitTime": "Oras ng paghihintay (Pangunahin)",
        "copied": "Kopya",
        "warnningCancelCorporate": "Pakitandaan, maaaring magkaroon ka ng singil na halaga alinsunod sa aming patakaran sa pagkansela.",
        "customerAdjustments": "Mga Pag-aayos ng Customer",
        "customerAdjustmentsTooltip": "Mga Pag-aayos ng Customer",
        "supplierDriverAdjustments": "Mga Pag-aayos ng Supplier/Driver",
        "updateSummary": "Buod ng Update",
        "orderDetails": "Mga Detalye ng Order",
        "saveAndSendEmail": "I-save at Ipadala ang E-Resibo",
        "pastDetacted": "Nakatagpuang Nakaraang Pagbabayad",
        "pastDetactedContent": "Naghahanda ka nang gumawa ng isang booking sa nakaraan.",
        "DriverSupplier": "Driver/Supplier",
        "supplierCancelCharge": "Babala: Parusa sa Pagkansela",
        "supplierCancelNoCharge": "Kumpirmahin ang Kanselasyon",
        "supplierCancelChargeBody": "Sigurado ka bang nais mong kanselahin ang booking?",
        "willChargedPenalty": "Ikaw ay sisingilin ng parusa na {0}.",
        "noChargedPenalty": "Ito ay isang libreng pagkansela, walang parusa na sisingilin.",
        "errorGetToken": "Hindi makuha ang token, pakisubukan muli mamaya",
        "unlinkFlight": "Alisin ang Ugnayan ng Flight",
        "unlinkFlightBody": "Mag-ingat! Ang pagbabago ng oras ng pickup ay mag-aalis ng pagkakakonekta sa iyong mga detalye ng flight at aalisin ang numero ng flight."
    },
    "map": {
        "AWS_map_hint": "Tip: Pindutin ang Enter o Esc upang tapusin ang pagguhit.",
        "Apple_map_hint": "Tip: Pindutin at hawakan upang i-drag at i-resize ang polygon.",
        "Enter_a_location": "Maglagay ng lokasyon",
        "All_company": "Lahat ng kumpanya",
        "All_cars": "Lahat ng sasakyan",
        "Show_all_cars": "Ipakita ang lahat ng mga kotse",
        "Hide_all_cars": "Itago ang lahat ng sasakyan",
        "Vacant": "Available",
        "Dispatching": "Nagpapadala",
        "Driver_on_the_way": "Papunta na ang Driver",
        "Arrived_and_waiting": "Dumating at naghihintay",
        "P_O_B": "P.O.B",
        "Dropped_off": "Nahulog/ Naihatid",
        "Waiting_for_process": "Naghihintay ng proseso",
        "Unavailable": "Hindi magagamit",
        "Total_Drivers": "Kabuuang mga Driver",
        "Estimate": "Tantyahin",
        "Destination": "Patutunguhan",
        "Pickup": "Pulutin",
        "Start_point": "Panimulang punto",
        "Passenger": "pasahero",
        "Driver_name": "Pangalan ng driver",
        "Search_car_here": "maghanap ng pangalan ng kotse/driver",
        "Error_load_booking": "Hindi ma-load ang booking, Pakisubukang muli o i-refresh ang page!",
        "Show_all": "Ipakita lahat",
        "BookCardInfo": "Impormasyon ng Booking Card",
        "drvPhoneNo": "Numero ng Telepono ng Driver",
        "vhcPhoneNo": "Numero ng Telepono ng Sasakyan",
        "driversLiveMap": "Mapa ng mga Driver",
        "heatMap": "Mapa ng Demand",
        "Trip": "Biyahe",
        "traffic": "Trapiko",
        "bicyclingLayers": "Pagbibisikleta",
        "layer": "Layer",
        "trafficBicycling": "Trapiko, Pagbibisikleta",
        "All_airline": "Lahat ng airline"
    },
    "customer": {
        "Customers": "Mga customer",
        "Points": "Mga puntos",
        "Migration_Status": "Katayuan ng Migration",
        "ADD_CUSTOMER": "Magdagdag ng customer",
        "EDIT_CUSTOMER": "I-edit ang customer",
        "Add": "Idagdag",
        "Activate": "I-activate",
        "Deactivate": "I-deactivate",
        "Delete": "Tanggalin",
        "Import": "Angkat",
        "Download_template": "I-download ang template",
        "View_Message": "Mensahe",
        "Send_Message": "Magpadala ng Mensahe",
        "Export_to_excel": "I-export sa excel",
        "Filter": "Salain",
        "Apply": "Mag-apply",
        "Clear": "Maaliwalas",
        "Name": "Pangalan",
        "Phone_Number": "Numero ng telepono",
        "Email": "Email",
        "Vip": "Vip",
        "companies": "kumpanya",
        "File": "file",
        "Number_successful_imports": "Bilang ng matagumpay na pag-import:",
        "Number_skipped": "Bilang ng nilaktawan:",
        "Number_duplicate_phone_numbers": "Bilang ng mga duplicate na numero ng telepono:",
        "Number_wrong_phone_numbers": "Bilang ng mga maling numero ng telepono:",
        "Corporate_Name": "Korporasyon",
        "Registered_From": "Nakarehistro Mula sa",
        "Registration_Date": "Petsa ng Pagpaparehistro",
        "Registration_date_from": "Petsa ng pagpaparehistro mula sa",
        "Registration_date_to": "Petsa ng pagpaparehistro sa",
        "IOS_Last_Login_Version": "IOS Huling-Login Bersyon",
        "Android_Last_Login_Version": "Bersyon ng Huling Pag-login ng Android",
        "Last_Active_Date": "Huling Aktibo na Petsa",
        "Verification": "Pagpapatunay",
        "Support_ID": "ID ng suporta",
        "Days_Since_Last_Active": "Mga Araw Mula Noong Huling Aktibo",
        "Completed_Bookings": "Mga Nakumpletong Booking",
        "Outstanding_amount": "Natitirang halaga",
        "Status": "Katayuan",
        "Actions": "Mga aksyon",
        "Action": "Aksyon",
        "Inactive": "Hindi aktibo",
        "Active": "Aktibo",
        "Edit": "I-edit",
        "View": "Tingnan",
        "ALERT_SELECT_ACTIVATE": "Mangyaring piliin ang customer na ia-activate.",
        "ALERT_SELECT_DEACTIVATE": "Mangyaring piliin ang customer na ide-deactivate.",
        "ALERT_SELECT_DELETE": "Mangyaring piliin ang customer na tatanggalin.",
        "CONFIRM_DELETE": "Sigurado ka bang gusto mong tanggalin ang account na ito? Maaaring mag-signup ang customer ng bagong profile na may walang laman na data pagkatapos alisin ang account.",
        "CONFIRM_DELETE_MULTI": "Sigurado ka bang gusto mong tanggalin ang mga customer na ito? Tanging ang mga customer na hindi aktibo at hindi rehistradong user sa pamamagitan ng app ang maaaring tanggalin.",
        "CONFIRM_DEACTIVATE_MULTI": "Gusto mo bang i-deactivate ang mga customer na ito?",
        "CONFIRM_ACTIVATE_MULTI": "Gusto mo bang i-activate ang mga customer na ito?",
        "CONFIRM_EXPORT_TO_EXCEL": "Sigurado ka bang gusto mong i-export ang lahat ng data bilang isang .xlsx file?",
        "Add_card_top_up_success": "Matagumpay na na-top up ang prepaid card",
        "Add_card_success": "Matagumpay na naidagdag ang card!",
        "Add_customer_success": "Matagumpay na nalikha ang bagong customer",
        "Update_customer_success": "Matagumpay na na-update ang customer",
        "Deleted_customer_success": "Matagumpay na natanggal ang customer",
        "Create_customer_fail": "Nabigong lumikha ng customer",
        "Update_customer_fail": "Nabigong i-update ang customer",
        "ERROR_EXISTED_PHONE": "Ang teleponong ito ay umiiral na sa system. Mangyaring maglagay ng isa pa",
        "ERROR_INPUT_FIRSTNAME": "Mangyaring ipasok ang unang pangalan.",
        "ERROR_INPUT_PHONE": "Mangyaring ipasok ang numero ng telepono.",
        "ERROR_INPUT_VALIDPHONE": "Mangyaring magpasok ng wastong numero ng telepono.",
        "ERROR_INPUT_VALIDEMAIL": "Mangyaring magpasok ng wastong email address.",
        "CONFIRM_DELETE_CARD": "Sigurado ka bang gusto mong tanggalin ang mga card na ito?",
        "First_name": "Pangalan",
        "Last_name": "Huling pangalan",
        "Phone_number": "Numero ng telepono",
        "Email_address": "Email address",
        "Notes": "Mga Tala",
        "Account": "Account",
        "Card_management": "Pamamahala ng card",
        "Home": "Bahay",
        "Affiliate": "Kaakibat",
        "SHOW_PERSONAL_CARD": "Ipakita ang personal na card",
        "ADD_PERSONAL_CARD": "Magdagdag ng personal na card",
        "SHOW_mDISPATCHER_CARD": "Ipakita ang card ng kasosyo",
        "ADD_mDISPATCHER_CARD": "Magdagdag ng partner card",
        "Personal_card": "Personal na card",
        "mDispatcher_card": "Card ng kasosyo",
        "Card_holder": "May hawak ng card",
        "Card_number": "Numero ng card",
        "Credit_type": "Uri ng kredito",
        "Credit_code": "Kodigo ng kredito",
        "Sms_verification": "Pagpapatunay ng SMS",
        "Sms_verification_placeholder": "ipasok ang verification code",
        "Expired_date": "Petsa ng pag-expire",
        "CVV": "CVV",
        "Address": "Address",
        "Country": "Bansa",
        "City": "lungsod",
        "State": "Estado",
        "Zip_code": "Zip code",
        "postal_code": "Kodigo ng postal",
        "Required_fields": "Mga kailangang punan",
        "Cancel": "Kanselahin",
        "Save": "I-save",
        "ERROR_INPUT_CARD_HOLDER": "Paki-input ang may hawak ng card",
        "ERROR_INPUT_CARD_NUMBER": "Mangyaring ipasok ang numero ng card",
        "ERROR_INPUT_EXPIRED_DATE": "Mangyaring ipasok ang petsa ng pag-expire",
        "ERROR_VAILD_EXPIRED_DATE": "Ang petsa ng pag-expire ay hindi wasto",
        "ERROR_INPUT_CVV": "Mangyaring ipasok ang CVV",
        "ERROR_INPUT_ADDRESS": "Mangyaring ipasok ang address",
        "ERROR_INPUT_CITY": "Mangyaring ipasok ang lungsod",
        "ERROR_INPUT_ZIPCODE": "Mangyaring ipasok ang zip code",
        "ERROR_INPUT_COUNTRY": "Mangyaring pumili ng bansa",
        "Info_edit_error": "Error!",
        "Gender": "Kasarian",
        "Select_Gender": "Pumili",
        "Select_Idtype": "Pumili ng uri ng id",
        "Male": "Lalaki",
        "Female": "Babae",
        "Other": "Iba pa",
        "Date_of_birth": "Araw ng kapanganakan",
        "Street_address": "Address ng kalye",
        "Select_Zone": "Piliin ang Zone",
        "ERROR_GET_GATEWAYS": "ERROR!!! Kumuha ng mga Gateway",
        "Require_email": "Mangyaring ipasok ang email bago magdagdag ng bagong card",
        "Require_lastName": "Pakilagay ang apelyido bago magdagdag ng bagong card",
        "Require_phone_number": "Mangyaring ipasok ang numero ng telepono ng manlalakbay bago mag-book gamit ang credit card",
        "IMPORT_CUSTOMER_SUCCESS": "matagumpay na mag-import ng mga customer",
        "No_card": "Walang nakitang card",
        "No_Support": "Kasalukuyang hindi sinusuportahan sa lugar na ito ang pagdaragdag ng bagong card",
        "Card_Management": "Pamamahala ng Card",
        "Emergency_contacts": "Mga contact sa emergency",
        "DETAIL_CUSTOMER": "Mga Detalye ng Customer",
        "Select_Country": "Pumili ng bansa",
        "Customer_ID": "ID# / Pambansang IC#",
        "Credit_balance": "Balanse ng credit",
        "required_email_payment": "Kinakailangan ang email ng customer. Mangyaring i-update ang profile upang magpatuloy.",
        "Yes": "Oo",
        "No": "Hindi",
        "WriteOffDebt": "Isulat ang utang",
        "selectPayment": "Mangyaring pumili ng paraan ng pagbabayad upang isara ang lahat ng booking na may natitirang bayad",
        "writeOffDebtSuccess": "Matagumpay na matanggal ang utang",
        "writeOffDebtNotes": "Tandaan: Ang write-off na aksyon na ito ay dapat lamang kumpirmahin pagkatapos mabayaran nang buo ang lahat ng natitirang halaga.",
        "totalCustomer": "Kabuuang mga customer",
        "Personal_Card": "Personal na card",
        "INFO_ADD_BALANCE_SUCCESS": "Matagumpay na na-update ang balanse ng pasahero",
        "INFO_UPDATE_POINT_SUCCESS": "Matagumpay na na-update ang punto ng pasahero",
        "currency": "Pera",
        "balance": "Balanse",
        "changeBalance": "Baguhin ang balanse",
        "change": "Baguhin",
        "WALLET_DEPOSIT": "Wallet",
        "AccessDenied": "Wala kang pahintulot na i-access ang modyul na ito!",
        "referral_code": "Referral code",
        "loginMethod": "Paraan ng pag-login",
        "searchCustomerPlaceholder": "Maghanap ng pangalan ng contact, telepono, email, korporasyon, support ID"
    },
    "importBookings": {
        "no": "Bilang",
        "status": "Katayuan",
        "pickupDate": "Petsa ng Pagkuha",
        "pickup": "Address ng Pickup",
        "dropoff": "Address ng Paghahatidan",
        "passenger": "pasahero",
        "phone": "Numero ng telepono",
        "seats": "Mga upuan",
        "luggages": "Mga bagahe",
        "rideSharing": "Sumakay-share",
        "flightNumber": "Numero ng Lipad",
        "notes": "Mga Tala",
        "externalId": "Panlabas na ID",
        "operatorNote": "Panloob na mga tala",
        "clientCaseMatter": "Paglalarawan ng biyahe",
        "chargeCode": "Trip code",
        "price": "Presyo",
        "payout": "Bayad",
        "paymentType": "Pagbabayad",
        "vehicleTypeRequest": "Uri ng kotse",
        "importBookings": "Mag-import ng mga booking",
        "corporation": "Korporasyon",
        "clickOrDropCsvFile": "I-click o drop.csv file",
        "importingFileForReview": "Ini-import ang file para sa pagsusuri...",
        "import": "Angkat",
        "submit": "Ipasa",
        "downloadTemplate": "I-download ang template",
        "learnMore": "Matuto pa",
        "total": "Kabuuan",
        "valid": "Wasto",
        "invalid": "Di-wasto",
        "failed": "Nabigo",
        "processing": "Pinoproseso",
        "success": "Tagumpay",
        "confirm": "Kumpirmahin",
        "confirmMessage": "lilikha ng mga order. Sigurado ka bang gusto mong magpatuloy?",
        "create": "Lumikha",
        "cancel": "Kanselahin",
        "close": "Isara",
        "leavingConfirmMessage": "Ang iyong gawa ay hindi nai-save! Sigurado ka bang gusto mong umalis?",
        "resultMessage": "Matagumpay na nagawa ang (mga) booking ng ${success}, nabigo ang ${failed}.",
        "limitExceededBookings": "Pinakamataas na laki ng pag-import ng file: 100 booking",
        "delivery": {
            "no": "#",
            "pickupDate": "Petsa ng pagkuha",
            "senderName": "Pangalan ng nagpadala",
            "senderPhone": "Telepono ng nagpadala",
            "senderMail": "Email ng nagpadala",
            "senderAddress": "Address ng nagpadala",
            "recipients": "Mga tatanggap",
            "senderDistrictOptional": "Distrito",
            "senderLocationDetails": "Mga detalye ng lokasyon",
            "recipientName": "Pangalan ng makakatanggap",
            "recipientPhone": "Telepono ng tatanggap",
            "recipientAddress": "Address ng tatanggap",
            "recipientDistrictOptional": "Distrito",
            "recipientLocationDetailsOptional": "Mga Detalye ng Lokasyon",
            "packageContent": "Nilalaman ng package",
            "orderNumber": "Order #",
            "instructions": "Mga tagubilin para sa Driver",
            "cod": "Halaga ng Item ng COD",
            "rideShare": "Sumakay-share",
            "paymentType": "Uri ng Pagbabayad",
            "carType": "Uri ng kotse",
            "recipientLocationDetails": "Mga detalye ng lokasyon",
            "operatorNote": "Panloob na mga tala",
            "rideSharing": "Batch na paghahatid"
        }
    },
    "merchant": {
        "INFO_ADD_BALANCE_SUCCESS": "Matagumpay na na-update ang balanse ng merchant",
        "ADD_MERCHANT_USER": "Magdagdag ng merchant account",
        "EDIT_MERCHANT_USER": "I-edit ang merchant account",
        "MERCHANT_USER_DETAILS": "Mga detalye ng merchant account",
        "CASH_WALLET": "Pondo ng cash",
        "CREDIT_WALLET": "Credit wallet",
        "ADD_MERCHANT": "Magdagdag ng mangangalakal",
        "ACCOUNT_INFO": "Impormasyon ng Account",
        "BILLING_ADDRESS": "Impormasyon sa Bangko",
        "user": {
            "fullName": "Gumagamit ng mangangalakal",
            "Phone_Number": "Numero ng telepono",
            "Email": "Email",
            "storeName": "Mangangalakal",
            "status": "Katayuan",
            "actions": "Aksyon",
            "First_name": "Pangalan",
            "Last_name": "Huling pangalan",
            "Select_store": "Pumili ng merchant",
            "accountHolder": "Pangalan ng may hawak ng account",
            "First_M_Last": "Una M. Huli",
            "accountNumber": "Numero ng account",
            "ibanNumber": "Numero ng IBAN",
            "bankName": "Pangalan ng bangko",
            "IDtype": "Uri ng ID",
            "IDnumber": "ID# / Pambansang IC#",
            "routingNumber": "Ruta/Transit/Numero ng sangay",
            "checkNumber": "Siguraduhing tama ang numero; tingnan ang bilang",
            "ssn": "SSN/NI",
            "sortCode": "Pagbukud-bukurin ang code",
            "transitNumber": "Numero ng transit",
            "institutionNumber": "Numero ng Institusyon",
            "birthDay": "Kaarawan",
            "address": "Address",
            "city": "lungsod",
            "state": "Estado",
            "postalCode": "Zipcode",
            "beneficiaryIDIC": "ID# / IC# ng benepisyaryo",
            "relationshipOtherName": "Relasyon sa iba?",
            "verificationDocumentFront": "Dokumento sa pagpapatunay (harap)",
            "verificationDocumentBack": "Dokumento sa pagpapatunay (likod)",
            "Verification_document_tooltip": "Mga katanggap-tanggap na form para sa pagkakakilanlan:\n  - Pasaporte\n  - Lisensiya sa pagmamaneho\n  - Resident permit ID\n  - Citizen Card\n  - ID card",
            "additionalDocumentFront": "Karagdagang dokumento (harap)",
            "additionalDocumentBack": "Karagdagang dokumento (likod)",
            "Additional_document_tooltip": "Mga katanggap-tanggap na paraan ng pag-verify ng address:\n  - Lisensiya sa pagmamaneho\n  - Utility bill\n  - Liham na ibinigay ng pamahalaan\n  - Pahayag mula sa isang institusyong pinansyal\n  - Entry ng Electoral Register",
            "please_select": "Pakisuyong pumili",
            "commission": "Komisyon",
            "ERROR_INPUT_VALIDPHONE": "Mangyaring magpasok ng wastong numero ng telepono.",
            "ERROR_EXISTED_PHONE": "Ang teleponong ito ay umiiral na sa system. Mangyaring maglagay ng isa pa",
            "Activate": "I-activate",
            "Deactivate": "I-deactivate",
            "ALERT_SELECT_ACTIVATE": "Mangyaring pumili ng user na ia-activate.",
            "ALERT_SELECT_DEACTIVATE": "Mangyaring pumili ng user na ide-deactivate.",
            "CONFIRM_ACTIVATE_MULTI": "Gusto mo bang i-activate ang mga user na ito?",
            "CONFIRM_DEACTIVATE_MULTI": "Gusto mo bang i-deactivate ang mga user na ito?",
            "RESET_PASSWORD": "Gusto mo bang i-reset ang password?",
            "CONFIRM_RESET_PASSWORD": "Gusto mo bang i-reset ang password?",
            "REMOVE_BANK_INFO": "Kumpirmahin ang pag-alis ng impormasyon sa bangko",
            "CONFIRM_REMOVE_BANK_INFO": "Gusto mo bang tanggalin ang impormasyon ng bangko?",
            "note_account_password_default": "Tandaan: Para sa bagong Merchant account, ang default na password ay \"12345678",
            "Cash_Balance": "Balanse ng pera",
            "Credit_Balance": "Balanse ng credit"
        },
        "Update_merchant_user_success": "Matagumpay na na-update ang gumagamit ng merchant",
        "Update_merchant_user_fail": "Nabigong i-update ang user ng merchant",
        "Create_merchant_user_success": "Matagumpay na nalikha ang bagong user ng merchant",
        "Create_merchant_user_fail": "Nabigong lumikha ng user ng merchant",
        "Update_merchant_user_status_success": "Matagumpay na na-update ang gumagamit ng merchant",
        "Update_merchant_user_status_fail": "Nabigong i-update ang user ng merchant",
        "Reset_password_merchant_user_success": "Matagumpay na i-reset ang password",
        "Reset_password_merchant_user_fail": "Nabigo ang pag-reset ng password",
        "Deleted_merchant_bank_info_success": "Matagumpay na alisin ang impormasyon ng bangko",
        "Deleted_merchant_bank_info_fail": "Nabigo ang pag-alis ng impormasyon sa bangko"
    },
    "table_header": {
        "Items_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "Search_here": "Maghanap dito",
        "Shown_Active": "%{start} - %{end} of %{total} na ipinakita",
        "Active": "%{active} Aktibo",
        "OF": "ng"
    },
    "driver": {
        "Driver": "Driver",
        "Add": "Idagdag",
        "addDriver": "Magdagdag ng drayber",
        "Detail": "Detalye",
        "detailDriver": "Mga Detalye ng Driver",
        "addNewVehicle": "Magdagdag ng Sasakyan",
        "serviceType": "Uri ng Serbisyo",
        "transport": "Transportasyon",
        "delivery": "Paghahatid",
        "stripeConnect": "Stripe Connect",
        "stripeConnectDes": "Magdagdag ng Stripe Connect account para sa mas madaling pagbabayad.",
        "bankAccount": "Impormasyon sa Bangko",
        "bankAccountDes": "Impormasyon sa bangko ng mga driver para sa paghawak ng mga bayad",
        "supplierComission": "Komisyon ng Supplier",
        "supplierComissionDes": "Set commissions the supplier earns for every complete order.",
        "fleetCommission": "Komisyon ng Fleet/Supplier",
        "fleetCommissionDes": "Itakda ang komisyon na kinikita ng fleet o supplier para sa bawat kumpletong order. Kung ang driver ay driver ng supplier, ang komisyon ay ibabawas mula sa kita ng supplier.",
        "operationZones": "Mga Lugar ng Operasyon",
        "operationZonesDes": "Mga sona na maaaring tumanggap ng mga trabaho ang mga supplier mula sa:",
        "notes": "Mga Tala",
        "notesDes": "Panloob na tala tungkol sa driver na ito:",
        "searchNotes": "Magdagdag ng mga tala para sa drayber",
        "marketplace": "Pamilihan",
        "marketplaceDes": "Bigyan ng kapangyarihan ang mga drayber na tumanggap ng mga trabahong nais nilang gawin.",
        "otherSettings": "Mga Ibang Setting",
        "topDriver": "TOP Driver",
        "topDriverDes": "Bigyang-priyoridad ang mga nangungunang performer gamit ang \"Top Driver\" na tag, tinitiyak na makakakuha sila ng mas maraming biyahe.",
        "walletTransferBetweenDriver": "Mga Paglipat ng Wallet sa Pagitan ng mga Driver",
        "walletTransferBetweenDriverDes": "Pahintulutan ang mga drayber na maglipat ng pondo nang direkta sa mga pitaka ng isa't isa, na nagpapadali sa madaling pamamahagi ng mga kredito ng mga lider ng koponan o mga embahador.",
        "rideSharing": "Pagbabahagi ng biyahe",
        "rideSharingDes": "Payagan ang mga drayber na magsagawa ng mga trabaho sa ride-sharing. Makipag-ugnayan sa iyong account manager para sa advanced na tampok na ito.",
        "individual_vehicle": "Indibidwal na sasakyan",
        "company_vehicle": "Sasakyan ng kumpanya",
        "ContactInfo": "Impormasyon sa Pakikipag-ugnayan",
        "name": "Pangalan",
        "expiryDate": "Petsa ng Pagka-expire",
        "action": "Aksyon",
        "editDocument": "Baguhin ang Dokumento",
        "documentToUpload": "Dokumento na i-upload",
        "addFiles": "I-click o i-drag ang file sa lugar na ito upang i-upload.",
        "fileSize": "Maximum na laki ng file 10 MB",
        "fileSizeDes": "Ang extension ng file ay dapat na .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip.",
        "removeOldFile": "Pakialis ang lumang file bago mag-upload ng bago.",
        "maxLengthFiles": "Pakilagay ang maximum na haba 1 file",
        "maxSizeFiles": "Mangyaring mag-upload ng file na mas mababa sa 10MB.",
        "typeFiles": "Mangyaring mag-upload ng file na uri .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip",
        "maxAvatarSizeFiles": "Mangyaring mag-upload ng avatar na mas mababa sa 8MB.",
        "IFSCCode": "IFSC Code",
        "Drivers": "Mga driver",
        "default": "Default",
        "customize": "Naangkop",
        "Activate": "I-activate",
        "Stripe_connect": "STRIPE CONNECT",
        "status_stripe": "Katayuan: {0}",
        "stripeConnectStatus": "Stripe connect",
        "stripeStatus": "Stripe status ng account",
        "Deactivate": "I-deactivate",
        "Delete": "Tanggalin",
        "acceptInDay": "Maaaring tanggapin ng driver ang maximum na reservation sa isang araw",
        "acceptATime": "Kabuuang bilang ng mga reservation na maaaring tanggapin ng isang driver sa isang pagkakataon",
        "Commission": "Itakda ang komisyon ng fleet",
        "Title_Commission": "Itakda ang komisyon ng fleet para sa lahat ng mga driver",
        "Confirm_Set_Commission": "Sigurado ka bang gusto mong itakda ang halaga ng komisyon na ito para sa lahat ng driver?",
        "Commission_Successfully": "Matagumpay na na-update ang komisyon ng driver",
        "Apply": "Mag-apply",
        "Type": "Uri",
        "Currency": "Pera",
        "View_Message": "Mensahe",
        "Send_Message": "Magpadala ng Mensahe",
        "Driver_Name": "Pangalan ng driver",
        "Driver_ID": "ID# / Pambansang IC#",
        "Phone_Number": "Numero ng telepono",
        "Driver_Type": "Uri ng Driver",
        "TOP": "ITAAS",
        "Company": "kumpanya",
        "City": "lungsod",
        "Driver_License_Number": "Numero ng Lisensya sa Pagmamaneho",
        "License_Plate": "Biển số xe",
        "Car_Type": "Uri ng kotse",
        "Zone": "Sona",
        "Registered_From": "Nakarehistro Mula sa",
        "Registration_Date": "Petsa ng Pagpaparehistro",
        "IOS_Last_Login_Version": "IOS Huling-Login Bersyon",
        "Android_Last_Login_Version": "Bersyon ng Huling Pag-login ng Android",
        "Last_Active_Date": "Huling Aktibo na Petsa",
        "Days_Since_Last_Active": "Mga Araw Mula Noong Huling Aktibo",
        "Completed_bookings": "Nakumpleto ang mga booking",
        "Status": "Katayuan",
        "Actions": "Mga aksyon",
        "Action": "Aksyon",
        "Inactive": "Hindi aktibo",
        "Active": "Aktibo",
        "Edit": "I-edit",
        "View": "Tingnan",
        "ALERT_SELECT_ACTIVATE": "Mangyaring piliin ang driver upang i-activate.",
        "ALERT_SELECT_DEACTIVATE": "Mangyaring piliin ang driver upang i-deactivate.",
        "ALERT_SELECT_DELETE": "Mangyaring piliin ang driver na tatanggalin.",
        "CONFIRM_DELETE": "Gusto mo bang tanggalin ang driver na ito?",
        "CONFIRM_DEACTIVATE_MULTI": "Sigurado ka bang gusto mong i-deactivate ang (mga) napiling driver? Idi-disable din ang kanilang (mga) konektadong hardware meter. Tanging ang (mga) driver na walang kasalukuyang biyahe o reserbasyon ang maaaring ma-deactivate.",
        "CONFIRM_ACTIVATE_MULTI": "Gusto mo bang i-activate ang mga driver na ito? Tanging ang (mga) driver na ganap na naka-setup para sa operasyon ang maaaring i-activate.",
        "CONFIRM_DELETE_MULTI": "Gusto mo bang tanggalin ang mga driver na ito? Tanging driver lamang sa hindi aktibong katayuan ang maaaring tanggalin.",
        "CONFIRM_REMOVE_BANKING_INFOR": "Sigurado ka bang gusto mong alisin ang impormasyon sa pagbabangko?",
        "REMOVE_BANKING_INFOR": "Alisin ang impormasyon sa pagbabangko",
        "ADD_DRIVER": "MAGDAGDAG NG DRIVER",
        "Avatar": "Avatar",
        "Individual_Driver": "Transportasyon - Sasakyan ng kumpanya",
        "Owner_Operator": "Transportasyon - Indibidwal na sasakyan",
        "deliveryCompany": "Paghahatid - Sasakyan ng kumpanya",
        "deliveryIndividual": "Paghahatid - Indibidwal na sasakyan",
        "CONTACT_INFO": "IMPORMASYON SA KONTAK",
        "Home_address": "Address ng bahay",
        "Username": "Username",
        "First_name": "Pangalan",
        "Last_name": "Huling pangalan",
        "Phone_number": "Numero ng telepono",
        "Email_address": "Email address",
        "Select_city": "Pumili ng lungsod",
        "State": "Estado",
        "Zip_code": "Zip code",
        "Date_of_birth": "Araw ng kapanganakan",
        "placeholderDate": "mm/dd/yyyy",
        "City_driver_want_to_drive": "Gustong magmaneho ng city driver",
        "Driver_license_number": "Numero ng lisensya sa pagmamaneho",
        "Driver_license_state": "Estado/Probinsya ng lisensya sa pagmamaneho",
        "Driver_license_expiry": "Pag-expire ng lisensya sa pagmamaneho",
        "FOR_INSPECTOR": "PARA SA INSPECTOR",
        "Document": "Dokumento",
        "Document_Id": "ID ng Dokumento",
        "Link": "Link",
        "Notes": "Mga Tala",
        "UPLOAD_DOCUMENT": "MAG-UPLOAD NG DOKUMENTO",
        "Click_here_to_download": "I-click upang i-download",
        "Click_here_to_view": "I-click upang tingnan",
        "EXTENSION_REQUIREMENT": "Ang extension ng file ay dapat na .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip at mas mababa sa 5Mb.",
        "Invalid_file": "Ang nilalaman ng file ay hindi wasto",
        "File_size_larger_than_5Mb": "Ang laki ng file ay dapat na mas malaki kaysa sa 5Mb",
        "BANK_ACCOUNT": "BANK ACCOUNT",
        "Name_of_bank": "Pangalan ng bangko",
        "Name_of_account": "Pangalan ng may hawak ng account",
        "First_M_Last": "Una M. Huli",
        "RTBnumber": "Ruta/Transit/Numero ng sangay",
        "bankName": "Pangalan ng bangko",
        "Select_a_bank": "Pumili ng bangko",
        "Account_number": "Numero ng account",
        "IBAN_number": "Numero ng IBAN",
        "Check_number": "Numero ng tseke",
        "Swift_code_number": "Numero ng Swift code",
        "SSNNI": "SSN/ NI",
        "sortCode": "Pagbukud-bukurin ang code",
        "Verification_document": "Dokumento sa pagpapatunay (harap)",
        "Additional_document": "Karagdagang dokumento (harap)",
        "Verification_document_back": "Dokumento sa pagpapatunay (likod)",
        "Additional_document_back": "Karagdagang dokumento (likod)",
        "others": "Iba",
        "signedW9Form": "Nilagdaan W-9 Form",
        "driverLicense": "Lisensiya sa pagmamaneho",
        "Verification_document_tooltip": "Mga katanggap-tanggap na form para sa pagkakakilanlan:\n  - Pasaporte\n  - Lisensiya sa pagmamaneho\n  - Resident permit ID\n  - Citizen Card\n  - ID card",
        "Additional_document_tootip": "Mga katanggap-tanggap na paraan ng pag-verify ng address:\n  - Lisensiya sa pagmamaneho\n  - Utility bill\n  - Liham na ibinigay ng pamahalaan\n  - Pahayag mula sa isang institusyong pinansyal\n  - Entry ng Electoral Register",
        "isBankAccountOwner": "Ikaw ba ang may-ari ng account na ito?",
        "yes": "Oo",
        "no": "Hindi",
        "beneficiary_name": "Pangalan ng Benepisyaryo",
        "beneficiary_idic": "ID/IC ng benepisyaryo",
        "relationship": "Relasyon",
        "select_relationship": "Pumili ng status ng relasyon",
        "spouse": "asawa",
        "daughterOrSon": "Anak na babae anak na lalaki",
        "brotherOrSister": "Kuya/Ate",
        "relative": "Kamag-anak",
        "friends": "Mga kaibigan",
        "other": "Iba pa",
        "relationshipOtherName": "Relasyon sa iba?",
        "OPERATION": "OPERASYON",
        "CAR_INSURANCE": "INSURANSYA NG SASAKYAN",
        "Policy_number": "Numero ng patakaran",
        "Effective_date": "Petsa ng bisa",
        "Expired_date": "Petsa ng pag-expire",
        "Select_company": "Pumili ng kumpanya",
        "All_company": "Lahat ng kumpanya",
        "All_Car_Type": "Lahat ng uri ng kotse",
        "Car": "kotse",
        "Existing_car": "Umiiral na sasakyan",
        "New_car": "Bagong sasakyan",
        "License_plate": "Biển số xe",
        "Select_license_plate": "Chọn Biển số xe",
        "Select_Car_Type": "Piliin ang Uri ng Kotse",
        "vehicleOwner": "Pangalan ng may-ari ng sasakyan",
        "Make": "Gawin",
        "Select_Car_Make": "Piliin ang Car Make",
        "Model": "Modelo",
        "Select_Car_Model": "Piliin ang Modelo ng Sasakyan",
        "Year": "taon",
        "Select_Year": "Piliin ang Taon",
        "Color": "Kulay",
        "Passengers": "pasahero",
        "Luggage": "Passengers",
        "License_expiry": "Pag-expire ng lisensya",
        "Shift": "Paglipat",
        "Select_Shift_Template": "Piliin ang Shift Template",
        "Fleet_commission": "Komisyon ng fleet (ulat)",
        "Company_commission": "Komisyon ng kumpanya (ulat)",
        "rideHailing": "Pagpapaalam sa Kalye",
        "intercity": "Intercity",
        "food": "Pagkain",
        "mart": "Mart",
        "streetSharing": "Pagbabahagi ng Kalye",
        "Shuttle": "Shuttle",
        "parcel": "Parcel",
        "driverInsurance": "Insurance sa Pagmamaneho",
        "Percentage": "Porsiyento",
        "Amount": "Halaga",
        "transaction": "Transaksyon",
        "Terminal_ID": "Terminal ID",
        "Auth_key": "Susi ng pagpapatotoo",
        "CREDIT_DEPOSIT": "Credit wallet",
        "Credit_Balance": "Balanse ng Credit",
        "Balance": "Balanse",
        "Change_balance": "Baguhin ang balanse",
        "Select_balance": "Pumili ng balanse",
        "Adjust_amount": "Ayusin ang halaga",
        "Adjust_value": "Ayusin ang halaga",
        "New_balance": "Bagong balanse",
        "New_point": "Bagong punto",
        "Enter_reason": "Ipasok ang dahilan",
        "ERROR_INPUT_BALANCE": "Mangyaring pumili ng balanse.",
        "ERROR_INPUT_AMOUNT": "Mangyaring ilagay ang halagang ito.",
        "ERROR_INPUT_REASON": "Pakilagay ang dahilan.",
        "ERROR_INPUT_VALID_AMOUNT": "Mangyaring magpasok ng halagang mas malaki sa o katumbas ng 0.",
        "INFO_ADD_BALANCE_SUCCESS": "Matagumpay na na-update ang balanse ng driver",
        "INFO_ADD_CASH_BALANCE_SUCCESS": "Matagumpay na na-update ang balanse ng cash ng driver",
        "Force_meter": "Puwersang metro",
        "Force_meter_tooltip": "Dapat na nakakonekta ang driver app sa metro bago gumana. Inilapat para sa mga metro ng Pulsar at Centrodyne",
        "ERROR_EXISTED_PHONE": "Ang teleponong ito ay umiiral na sa system. Mangyaring maglagay ng isa pa",
        "TOP_driver": "TOP na drayber",
        "Ride_sharing": "Pagbabahagi ng Sakay",
        "Note_password": "Tandaan: Para sa bagong driver account, ang default na password ay \"12345678",
        "Required_fields": "Mga kailangang punan",
        "Cancel": "Kanselahin",
        "Save": "I-save",
        "SaveAndInProgress": "I-save at Isinasagawa",
        "SaveAndDeactivate": "I-save at I-deactivate",
        "ERROR_REQUIRE_": "Mangyaring ipasok",
        "ERROR_INPUT_AVATAR": "Mangyaring mag-upload ng avatar.",
        "ERROR_INPUT_DRIVER_TYPE": "Mangyaring piliin ang uri ng driver.",
        "ERROR_INPUT_DOCUMENT": "Pakilagay",
        "ERROR_INPUT_USERNAME": "Mangyaring ipasok ang username.",
        "ERROR_INPUT_VALID_USERNAME": "Ang username ay maaari lamang maglaman ng mas mababang mga titik at numero at dapat ay nasa pagitan ng 3 at 20 character ang haba",
        "ERROR_INPUT_PHONE": "Mangyaring tumukoy ng wastong numero ng telepono.",
        "ERROR_INPUT_VALID_EMAIL": "Mangyaring maglagay ng wastong email.",
        "ERROR_INPUT_EMAIL": "Mangyaring mag-input ng email.",
        "ERROR_INPUT_FIRSTNAME": "Mangyaring ipasok ang unang pangalan.",
        "ERROR_INPUT_LASTNAME": "Mangyaring ipasok ang apelyido.",
        "ERROR_INPUT_ADDRESS": "Mangyaring ipasok ang address ng tahanan.",
        "ERROR_INPUT_CITY": "Mangyaring ipasok ang lungsod.",
        "ERROR_INPUT_STATE": "Mangyaring ilagay ang estado.",
        "ERROR_INPUT_ZIPCODE": "Mangyaring ipasok ang zipcode.",
        "ERROR_INPUT_BIRTHDAY": "Mangyaring ipasok ang kaarawan.",
        "ERROR_INPUT_NAME_OF_BANK": "Mangyaring ipasok ang pangalan ng bangko.",
        "ERROR_INPUT_NAME_OF_ACCOUNT": "Paki-input ang pangalan ng may-ari ng account.",
        "ERROR_INPUT_ROUTING_NUMBER": "Paki-input ang routing number.",
        "ERROR_INPUT_BANK_NAME": "Mangyaring pumili ng isang bangko.",
        "ERROR_INPUT_ACCOUNT_NUMBER": "Mangyaring maglagay ng account number",
        "ERROR_INPUT_CHECK_NUMBER": "Mangyaring ilagay ang check number.",
        "ERROR_INPUT_SSN": "Mangyaring ipasok ang SSN.",
        "ERROR_INPUT_DocumentId": "Mangyaring ipasok ang Document ID.",
        "ERROR_INPUT_SORTCODE": "Mangyaring ilagay ang sort code.",
        "ERROR_INPUT_COMPANY": "Mangyaring pumili ng kumpanyang isaaktibo.",
        "ERROR_INPUT_LICENSE_PLATE": "Mangyaring pumili ng plaka ng lisensya.",
        "ERROR_INPUT_ZONE": "Mangyaring piliin ang zone upang isaaktibo.",
        "ERROR_INPUT_SHIFT": "Mangyaring piliin ang shift para isaaktibo.",
        "ERROR_ACCOUNT_NUMBER_ONLY_NUMBERS": "Dapat itong maglaman lamang ng mga numero",
        "ERROR_SSN_ONLY_NUMBERS": "Dapat itong maglaman lamang ng mga numero",
        "ERROR_SSN_LENGTH": "Dapat na hindi bababa sa 4 na character ang SSN",
        "ERROR_COMMISSION_NUMBERS": "Mangyaring magpasok ng wastong numero",
        "INFO_DEACTIVAED_SUCCESS": "Matagumpay na na-deactivate ang driver.",
        "INFO_ACTIVAED_SUCCESS": "Matagumpay na na-activate ang driver.",
        "INFO_DEACTIVAED_SUCCESS_BUT_HARDWARE": "Ang driver ay na-deactivate ngunit ang integrated hardware meter ay hindi maaaring patayin para sa ilang mga hindi inaasahang dahilan.",
        "INFO_MULTIDEACTIVAED_SUCCESS": "Ang {0} napiling mga driver ay matagumpay na na-deactivate.",
        "INFO_MULTIDEACTIVAED_HARDWARE_SUCCESS": "Ang {0} napiling mga driver ay matagumpay na na-deactivate. {1} (mga) konektadong hardware meter ay hindi pinagana.",
        "INFO_MULTIDEACTIVAED_SUCCESS_BUT_HARDWARE": "Ang {0} napiling mga driver ay matagumpay na na-deactivate. {1} (mga) konektadong hardware meter ay hindi pinagana. Ang {2} ay hindi dahil sa ilang hindi inaasahang dahilan.",
        "INFO_MULTIACTIVAED_SUCCESS": "Ang {0} napiling mga driver ay matagumpay na na-activate.",
        "DRIVER_UPDATE_SUCCESS": "Matagumpay na na-update ang driver.",
        "DRIVER_CREATE_SUCCESS": "Ang impormasyon ng driver ay matagumpay na naidagdag",
        "Expiry_Date": "Petsa ng Pag-expire",
        "Case_number": "Numero ng kaso",
        "Export_to_csv": "I-export sa CSV",
        "CONFIRM_EXPORT_TO_CSV": "Sigurado ka bang gusto mong i-export ang lahat ng data sa ilalim ng .csv na format?",
        "Ride_sharing_tooltip": "Ang pagbabahagi ng pagsakay ay isang advanced na tampok, mangyaring makipag-ugnay sa aming Koponan ng suporta upang makakuha ng higit pang impormasyon",
        "In_Review": "Sa Pagsusuri",
        "Reset_password_success": "Matagumpay na i-reset ang password",
        "Topup_note": "(Pinapayagan na i-top up ang balanse ng iyong driver pagkatapos i-activate ang driver)",
        "cash_balance": "Balanse ng pera",
        "cash_wallet": "Cash wallet",
        "total_balance": "Kabuuang balanse",
        "total_cash_balance": "Kabuuang balanse ng cash",
        "total_credit_balance": "Kabuuang balanse ng kredito",
        "banking_status": "Katayuan sa pagbabangko",
        "bankingStatus": {
            "verified": "Na-verify",
            "not_verified": "Hindi napatunayan",
            "inComplete": "Hindi Kumpleto",
            "connected": "Ikonekta",
            "disconnected": "Naka-disconnect"
        },
        "INVALID_FILE_SIZE": "Ang laki ng file ay dapat na mas mababa sa 8Mb.",
        "totalDrivers": "Kabuuang Driver",
        "profileStatus": "Katayuan ng profile",
        "profile_completed": "Nakumpleto ang profile",
        "profile_incomplete": "Hindi kumpleto ang profile",
        "profile_inProgress": "Kasalukuyang ginagawa ang profile",
        "in_review_completed": "Sinusuri (nakumpleto ang profile)",
        "in_review_incomplete": "Sinusuri (hindi kumpleto ang profile)",
        "in_review_inProgress": "Nasa pagsusuri (profile in progress)",
        "CASH_WALLET_DEPOSIT": "Cash wallet",
        "payoutSelect": "Payout (isang inbox at email ang ipapadala sa driver pagkatapos ng payout)",
        "Confirm_update_cash_balance": "Baguhin ang Balanse ng Cash",
        "Confirm_update_cash_balance_msg": "Sigurado ka bang gusto mong baguhin ang balanse ng driver?",
        "cashBalance": "Balanse ng pera",
        "cashBalance_unavailable": "0.00",
        "cashBalance_active": "Aktibo",
        "cashBalance_negative": "Negatibo",
        "creditBalance": "Balanse ng credit",
        "ERROR_INPUT_DOCUMETID": "Mangyaring ipasok ang Document Id.",
        "ERROR_INPUT_EXPIRYDATE": "Pakilagay ang Petsa ng Pag-expire.",
        "driverType": "Uri ng Driver",
        "tooltip_in_review_completed": "Ipadala ang inbox sa mga driver na 'In review' na kumukumpleto sa kanilang profile.",
        "tooltip_in_review_incomplete": "Ipadala ang inbox sa mga driver na 'In review' na hindi pa nakumpleto ang kanilang profile.",
        "tooltip_in_review_inProgress": "Magpadala ng inbox sa mga driver na 'In review' na kumukumpleto ng kanilang profile ngunit nangangailangan ng karagdagang pag-verify.",
        "tooltip_active": "Ipadala ang inbox sa mga driver na 'Aktibo'.",
        "tooltip_inactive": "Magpadala ng inbox sa mga driver na muling na-activate ang account.",
        "active": "I-activate",
        "inactive": "I-deactivate",
        "inReviewInProgress": "Sa Pagsusuri",
        "Market_place": "Merkado",
        "Market_place_tooltip": "Bigyan ng kapangyarihan ang mga driver na pumili ng on-demand o mga pagpapareserba na tatanggapin",
        "selectDriverType": "Piliin ang uri ng driver",
        "PlsSelectDriverType": "Mangyaring piliin ang uri ng driver",
        "emergencyContacts": "Mga Kontak sa Emerhensiya",
        "switchVehicle": "Lumipat sa anumang sasakyan",
        "switchVehicleNote": "Payagan ang drayber na lumipat sa anumang sasakyan ng kanilang itinalagang kumpanya ng supplier.",
        "vehicleModel": "Modelo",
        "licensePlateNumber": "Plaka ng Sasakyan",
        "addVehicle": "Magdagdag ng Sasakyan",
        "newVehicle": "Bagong Sasakyan",
        "linkVehicle": "Link Sasakyan",
        "modal": "Modal",
        "selectVehicle": "Pumili ng Sasakyan",
        "selectVehicleNote": "Payagan ang drayber na pumili o magbago ng sasakyan para sa isang booking.",
        "Warning_change_company": "Babala: Ang muling pagtalaga sa drayber na ito sa ibang kumpanya ay mag-aalis ng koneksyon sa lahat ng kaugnay na sasakyan.",
        "searchDriverPlaceholder": "Maghanap ng pangalan, telepono, email, username, plaka",
        "please_select_a_name_of_bank": "Paki pili ng pangalan ng bangko"
    },
    "corporate": {
        "User_Name": "Username",
        "Edit_Balance": "I-edit ang Balanse",
        "Corporates": "Mga kumpanya",
        "Supplier": "Tagapagtustos",
        "CarTypes": "Mga Uri ng Sasakyan",
        "Add": "Idagdag",
        "Balance": "Balanse",
        "Activate": "I-activate",
        "Deactivate": "I-deactivate",
        "Delete": "Tanggalin",
        "Company_Name": "Pangalan ng Kumpanya",
        "Admin_Name": "Pangalan ng Admin",
        "Username": "Username",
        "Phone_Number": "Numero ng telepono",
        "importBooking": "May kakayahang mag-import ng mga booking",
        "Email": "Email",
        "Registered_From": "Nakarehistro Mula sa",
        "Registration_Date": "Petsa ng Pagpaparehistro",
        "Status": "Katayuan",
        "Actions": "Mga aksyon",
        "Action": "Aksyon",
        "Inactive": "Hindi aktibo",
        "Active": "Aktibo",
        "In_Review": "Sa Pagsusuri",
        "Edit": "I-edit",
        "View": "Tingnan",
        "ADD_CORPORATE_CARD": "Magdagdag ng corporate card",
        "selectCountry": "Pumili ng bansa",
        "CONFIRM_DELETE_CARD": "Sigurado ka bang gusto mong tanggalin ang mga card na ito?",
        "ALERT_SELECT_ACTIVATE": "Mangyaring pumili ng corporate na isaaktibo.",
        "ALERT_SELECT_DEACTIVATE": "Mangyaring pumili ng korporasyon upang i-deactivate.",
        "ALERT_SELECT_DELETE": "Mangyaring pumili ng kumpanyang tatanggalin.",
        "CONFIRM_DELETE": "Gusto mo bang tanggalin ang kumpanyang ito?",
        "CONFIRM_DELETE_USER": "Gusto mo bang tanggalin ang corp user na ito?",
        "CONFIRM_DEACTIVATE_MULTI": "Gusto mo bang i-deactivate ang mga korporasyong ito?",
        "CONFIRM_ACTIVATE_MULTI": "Gusto mo bang i-activate ang mga corporate na ito?",
        "CONFIRM_DELETE_MULTI": "Gusto mo bang tanggalin ang mga korporasyong ito?\n  ** Tanging mga corporate na hindi aktibo ang maaaring tanggalin.",
        "ERROR_INPUT_PHONE": "Mangyaring tumukoy ng wastong numero ng telepono.",
        "ERROR_INPUT_VALIDPHONE": "Mangyaring magpasok ng wastong numero ng telepono.",
        "ERROR_EXISTED_PHONE": "Ang teleponong ito ay umiiral na sa system. Mangyaring maglagay ng isa pa",
        "Account": "Account",
        "Corp_traveler": "Mga Gumagamit ng Corp",
        "Payment_methods": "Mga paraan ng pagbabayad",
        "Corp_operators": "Mga operator ng korporasyon",
        "Pricing": "Pagpepresyo",
        "COMPANY_INFORMATION": "Impormasyon ng kumpanya",
        "Company_name": "Pangalan ng kumpanya",
        "Company_ID": "Company ID (para sa pag-signup ng Corp Users)",
        "Company_address": "Address ng kumpanya",
        "Invoice_email": "Email ng invoice",
        "Confirmation_email": "Email ng kumpirmasyon",
        "colorCodeBooking": "Code ng kulay",
        "ADMIN_ACCOUNT": "Admin na account",
        "First_name": "Pangalan",
        "Last_name": "Huling pangalan",
        "Commission": "Komisyon",
        "commissionBooking": "Mag-apply ng komisyon para sa mga booking mula sa app/pwa",
        "Required_fields": "Mga kailangang punan",
        "Save": "I-save",
        "Cancel": "Kanselahin",
        "Reset_password": "I-reset ang password",
        "Employee_Name": "Pangalan",
        "Created_Date": "Petsa ng Paggawa",
        "Add_corporate_card": "Magdagdag ng corporate card",
        "Corp_Users": "Mga Gumagamit ng Corp",
        "Pricing_Default": "Template ng Corporate Rate",
        "Pricing_Discount": "Diskwento ayon sa porsyento (inilapat lamang para sa Mga Gumagamit ng Corp)",
        "Markup_By_Percent": "Mark-up ayon sa porsyento (inilapat para sa Mga User ng Corp lamang)",
        "Pricing_Discount_new": "Diskwento ayon sa porsyento",
        "Markup_By_Percent_new": "Mark-up ayon sa porsyento",
        "Pricing_Add_different_rates": "Magdagdag ng iba't ibang mga rate",
        "ERROR_INPUT_COMPANYNAME": "Pakilagay ang pangalan ng kumpanya.",
        "ERROR_INPUT_USERNAME": "Mangyaring ipasok ang username.",
        "ERROR_INPUT_FIRSTNAME": "Mangyaring ipasok ang unang pangalan.",
        "ERROR_INPUT_EMAIL": "Mangyaring mag-input ng email.",
        "ERROR_INPUT_VALID_EMAIL": "Mangyaring magpasok ng wastong email address.",
        "ERROR_INPUT_VALID_NUMBER": "Mangyaring magpasok ng wastong numero",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "Mangyaring magpasok ng halaga sa pagitan ng {0} at {1}.",
        "INFO_ADD_CORPORATE_SUCCESS": "Matagumpay na nalikha ang account na {0}. Pakisuri ang email {1} ​​para sa mga detalye ng kredensyal sa pag-log in.",
        "INFO_UPDATE_CORPORATE_SUCCESS": "Matagumpay na na-update ang impormasyon.",
        "INFO_UPDATE_PRICING_SUCCESS": "Matagumpay na na-update ang pagpepresyo",
        "INFO_RESET_PASSWORD_SUCCESS": "Matagumpay na na-reset ang account na {0}. Pakisuri ang email {1} ​​para sa mga detalye ng kredensyal sa pag-log in.",
        "COMFIRM_RESET_PASSWORD": "Gusto mo bang i-reset ang password?",
        "Traveler_signature": "Lagda ng manlalakbay",
        "Parcel_Delivery": "Paganahin ang paghahatid ng parsela",
        "Tracking_log": "Log ng pagsubaybay",
        "Rating": "Marka",
        "Email_address": "Email address",
        "Assistant_email": "Marka",
        "Corp_PO": "Corp PO",
        "Cost_centre": "Sentro ng gastos",
        "Corp_division": "Dibisyon ng korporasyon",
        "Corp_id": "Korporasyon id",
        "Department": "Kagawaran",
        "Manager_email": "Email ng manager",
        "Manager_name": "Pangalan ng manager",
        "Corporate_card": "Korporatibong kard",
        "Direct_invoicing": "Direktang pag-invoice",
        "Corporate_Prepaid": "Corporate Prepaid",
        "Cash": "Pera",
        "Car_Type_ID": "ID ng Uri ng Kotse",
        "App_Display_Name": "Display Name ng App",
        "Normal_Fare": "Regular",
        "Flat_Fare": "Pantay na Rate",
        "Hourly_Daily_Rate": "Oras-oras/ Araw-araw",
        "Delivery_Rate": "Paghahatid",
        "Assign_rate": "Magtalaga ng rate",
        "Zone": "Sona",
        "Rate": "Rate",
        "Zone_Rate": "Sona - Rate",
        "Please_select_rate": "Mangyaring pumili ng rate",
        "Paid_by": "Binayaran ni",
        "Enter_new_credit_card": "Maglagay ng bagong credit card",
        "TOP_UP": "TOP UP",
        "Top_up": "Magdagdag ng pondo",
        "Topup_amount": "Dami ng topup",
        "Currency": "Pera",
        "ERROR_INPUT_AMOUNT": "Mangyaring maglagay ng wastong halaga.",
        "VAT_number": "Numero ng VAT",
        "Gender": "Kasarian",
        "Select_Gender": "Pumili",
        "Male": "Lalaki",
        "Female": "Babae",
        "Date_of_birth": "Araw ng kapanganakan",
        "Street_address": "Address ng kalye",
        "City": "lungsod",
        "State": "Estado",
        "Zip_code": "Zip code",
        "Country": "Bansa",
        "adding_new_card": "Nagdaragdag ka ng bagong card para magamit ang serbisyo sa %{zoneName} area",
        "No_Support": "Kasalukuyang hindi sinusuportahan sa lugar na ito ang pagdaragdag ng bagong card",
        "Job_title": "Titulo sa trabaho",
        "required_phone_number_payment": "Kinakailangan ang numero ng telepono ng kumpanya. Mangyaring i-update ang profile upang magpatuloy.",
        "Yes": "Oo",
        "No": "Hindi",
        "AddCardBeforeTopup": "Walang nakitang credit card. Mangyaring magdagdag ng bagong card upang magpatuloy.",
        "flightNumber": "Numero ng flight",
        "Company_Type": "Uri ng kumpanya",
        "Standard": "Karaniwang korporasyon",
        "Airline": "Airline",
        "Branding": "Pagba-brand",
        "bgImage": "Larawan sa background (1600x900)",
        "logoImage": "Imahe ng Logo",
        "aliasTitle": "Parameter ng alias (URL).",
        "importChauffeurBooking": "May kakayahang mag-import ng mga booking sa transportasyon",
        "isCorporateVip": "Corporate VIP",
        "isCorporateVipToolTip": "Isaaktibo ang setting na ito upang awtomatikong bigyan ng VIP status ang lahat ng corporate travelers sa kanilang paglikha, maaari mo itong i-off para sa bawat indibidwal na gumagamit.",
        "qrTitle": "QR Web booking link",
        "qrNote": "Nandito ang iyong personalized na link para sa pag-book ng partner! I-display ito nang maliwanag sa mga bar, reception ng hotel, mga guest room, at sa iyong website—kahit saan na maaaring kailanganin ng iyong mga customer ang sakay o delivery. Isaalang-alang ang pagdidisenyo ng mga standee na may iyong natatanging QR code, na nagbibigay-daan sa mga customer para sa mabilis at madaling pag-scan upang i-book ang kanilang biyahe!",
        "PricingLegacy": "Pagpepresyo (Legacy)",
        "defaultTemplate": "Default na Template",
        "Select_Rate_Template": "Pumili ng Rate Template"
    },
    "airline": {
        "Airlines": "Mga airline",
        "Add": "Idagdag",
        "Activate": "I-activate",
        "Deactivate": "I-deactivate",
        "Delete": "Tanggalin",
        "Company_Name": "pangalan ng Kumpanya",
        "Admin_Name": "Pangalan ng Admin",
        "Username": "Username",
        "Phone_Number": "Numero ng telepono",
        "Email": "Email",
        "Registered_From": "Nakarehistro Mula sa",
        "Registration_Date": "Petsa ng Pagpaparehistro",
        "Status": "Katayuan",
        "Actions": "Mga aksyon",
        "Action": "Aksyon",
        "Inactive": "Hindi aktibo",
        "Active": "Aktibo",
        "In_Review": "Sa Pagsusuri",
        "Edit": "I-edit",
        "View": "Tingnan",
        "ADD_CORPORATE_CARD": "Magdagdag ng Airline card",
        "selectCountry": "Pumili ng bansa",
        "CONFIRM_DELETE_CARD": "Sigurado ka bang gusto mong tanggalin ang mga card na ito?",
        "ALERT_SELECT_ACTIVATE": "Mangyaring piliin ang Airline para i-activate.",
        "ALERT_SELECT_DEACTIVATE": "Mangyaring piliin ang Airline upang i-deactivate.",
        "ALERT_SELECT_DELETE": "Mangyaring piliin ang Airline na tatanggalin.",
        "CONFIRM_DELETE": "Gusto mo bang tanggalin ang Airline na ito?",
        "CONFIRM_DELETE_USER": "Gusto mo bang tanggalin ang user ng Airline na ito?",
        "CONFIRM_DEACTIVATE_MULTI": "Sigurado ka bang gusto mong i-deactivate ang kumpanyang ito?",
        "CONFIRM_ACTIVATE_MULTI": "Sigurado ka bang gusto mong gawing aktibo ang kumpanyang ito?",
        "CONFIRM_DELETE_MULTI": "Sigurado ka bang gusto mong tanggalin ang kumpanyang ito?\n  ** Tanging kumpanya na hindi aktibo ang maaaring tanggalin.",
        "ERROR_INPUT_PHONE": "Mangyaring tumukoy ng wastong numero ng telepono.",
        "ERROR_INPUT_VALIDPHONE": "Mangyaring magpasok ng wastong numero ng telepono.",
        "ERROR_EXISTED_PHONE": "Ang teleponong ito ay umiiral na sa system. Mangyaring maglagay ng isa pa",
        "Airline": "Airline",
        "Crew": "Tripulante",
        "Payment_methods": "Mga paraan ng pagbabayad",
        "Airline_operators": "Mga operator ng airline",
        "Pricing": "Pagpepresyo",
        "COMPANY_INFORMATION": "Impormasyon ng kumpanya",
        "Company_name": "Pangalan ng Kumpanya",
        "Company_ID": "ID ng kumpanya",
        "Company_address": "Address ng kumpanya",
        "Invoice_email": "Email ng invoice",
        "Confirmation_email": "Email ng kumpirmasyon",
        "colorCodeBooking": "Code ng kulay",
        "ADMIN_ACCOUNT": "Admin na account",
        "First_name": "Pangalan",
        "Last_name": "Huling pangalan",
        "Commission": "Komisyon",
        "Required_fields": "Mga kailangang punan",
        "Required_fields_crews": "Tandaan: Para sa bagong Crew account, ang default na password ay \"12345678",
        "Save": "I-save",
        "Cancel": "Kanselahin",
        "Reset_password": "I-reset ang password",
        "Crew_Name": "Tripulante",
        "Created_Date": "Petsa ng Paggawa",
        "Add_corporate_card": "Magdagdag ng airline card",
        "Corp_Users": "Mga operator",
        "Pricing_Default": "Default",
        "Pricing_Discount": "Diskwento ayon sa porsyento",
        "Markup_By_Percent": "Mark-up ayon sa porsyento",
        "Pricing_Add_different_rates": "Magdagdag ng iba't ibang mga rate",
        "ERROR_INPUT_COMPANYNAME": "Pakilagay ang pangalan ng kumpanya.",
        "ERROR_INPUT_USERNAME": "Mangyaring ipasok ang username.",
        "ERROR_INPUT_FIRSTNAME": "Mangyaring ipasok ang unang pangalan.",
        "ERROR_INPUT_EMAIL": "Mangyaring mag-input ng email.",
        "ERROR_INPUT_VALID_EMAIL": "Mangyaring magpasok ng wastong email address.",
        "ERROR_INPUT_VALID_NUMBER": "Mangyaring magpasok ng wastong numero",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "Mangyaring magpasok ng halaga sa pagitan ng {0} at {1}.",
        "INFO_ADD_CORPORATE_SUCCESS": "Matagumpay na nalikha ang account na {0}.",
        "INFO_UPDATE_CORPORATE_SUCCESS": "Matagumpay na na-update ang impormasyon.",
        "INFO_UPDATE_PRICING_SUCCESS": "Matagumpay na na-update ang pagpepresyo",
        "INFO_RESET_PASSWORD_SUCCESS": "Matagumpay na na-reset ang account na {0}.",
        "COMFIRM_RESET_PASSWORD": "Gusto mo bang i-reset ang password?",
        "Traveler_signature": "Lagda ng manlalakbay",
        "Tracking_log": "Log ng pagsubaybay",
        "Rating": "Marka",
        "Email_address": "Email address",
        "Assistant_email": "Email ng assistant",
        "Corp_PO": "Corp PO",
        "Cost_centre": "Sentro ng gastos",
        "Corp_division": "Dibisyon ng korporasyon",
        "Corp_id": "Korporasyon id",
        "Department": "Kagawaran",
        "Manager_email": "Email ng manager",
        "Manager_name": "Pangalan ng manager",
        "Corporate_card": "Kard ng airline",
        "Direct_invoicing": "Direktang pag-invoice",
        "Corporate_Prepaid": "Prepaid ng Airline",
        "Cash": "Salapi",
        "Car_Type_ID": "ID ng Uri ng Kotse",
        "App_Display_Name": "Display Name ng App",
        "Normal_Fare": "Regular",
        "Flat_Fare": "Pantay na Rate",
        "Hourly_Daily_Rate": "Oras-oras/ Araw-araw",
        "Delivery_Rate": "Paghahatid",
        "Assign_rate": "Magtalaga ng rate",
        "Zone": "Sona",
        "Rate": "Rate",
        "Zone_Rate": "Sona - Rate",
        "Please_select_rate": "Mangyaring pumili ng rate",
        "Paid_by": "Binayaran ni",
        "Enter_new_credit_card": "Maglagay ng bagong credit card",
        "TOP_UP": "TOP UP",
        "Top_up": "Magdagdag ng pondo",
        "Topup_amount": "Dami ng topup",
        "Currency": "Pera",
        "ERROR_INPUT_AMOUNT": "Mangyaring maglagay ng wastong halaga.",
        "VAT_number": "Numero ng VAT",
        "Gender": "Kasarian",
        "Select_Gender": "Pumili",
        "Male": "Lalaki",
        "Female": "Babae",
        "Date_of_birth": "Araw ng kapanganakan",
        "Street_address": "Address ng kalye",
        "City": "lungsod",
        "State": "Estado",
        "Zip_code": "Zip code",
        "Country": "Bansa",
        "adding_new_card": "Nagdaragdag ka ng bagong card para magamit ang serbisyo sa %{zoneName} area",
        "No_Support": "Kasalukuyang hindi sinusuportahan sa lugar na ito ang pagdaragdag ng bagong card",
        "Job_title": "Titulo sa trabaho",
        "required_phone_number_payment": "Kinakailangan ang numero ng telepono ng kumpanya. Mangyaring i-update ang profile upang magpatuloy.",
        "Yes": "Oo",
        "No": "Hindi",
        "AddCardBeforeTopup": "Walang nakitang credit card. Mangyaring magdagdag ng bagong card upang magpatuloy."
    },
    "message": {
        "Add": "Idagdag",
        "Delete": "Tanggalin",
        "Items_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "Search_here": "Maghanap dito",
        "Shown_Active": "{0} - {1} ng {2} ang ipinakita",
        "Date": "Petsa",
        "Subject": "Paksa",
        "To": "Upang",
        "Type": "Uri",
        "Result": "Resulta",
        "Actions": "Mga aksyon",
        "New_message": "Bagong mensahe",
        "MESSAGE_DETAILS": "Mga detalye ng mensahe",
        "All": "Lahat",
        "Company": "kumpanya",
        "Active": "Aktibo",
        "In_Active": "Hindi aktibo",
        "In_Review": "Sa Pagsusuri",
        "Send_to": "Ipadala sa",
        "All_drivers": "Lahat ng driver",
        "All_customers": "Lahat ng customer",
        "All_merchants": "Lahat ng mangangalakal",
        "Customized_driver": "Customized na driver",
        "Customized_customer": "Customized na customer",
        "Customized_merchant": "Customized na mangangalakal",
        "Receiver_list": "Listahan ng tatanggap",
        "Content": "Nilalaman",
        "Required_fields": "Mga kailangang punan",
        "Search_driver_name_driver_phone_number": "Hanapin ang pangalan ng driver, numero ng telepono ng driver",
        "Search_category_name": "Pangalan ng kategorya ng paghahanap",
        "Search_customer_name_customer_phone_number": "Hanapin ang pangalan ng customer, numero ng telepono ng customer",
        "Search_merchant_name_merchant_phone_number": "Hanapin ang pangalan ng customer, numero ng telepono ng customer",
        "Search_car_type": "Maghanap ng uri ng kotse",
        "Searching": "Naghahanap...",
        "No_results": "Walang resulta",
        "Send": "Ipadala",
        "Cancel": "Kanselahin",
        "SMS_failed_Inbox_succeeded": "Nabigo ang SMS, nagtagumpay ang Inbox",
        "Failed": "Nabigo",
        "Succeeded": "Nagtagumpay",
        "CONFIRM_DELETE": "Gusto mo bang tanggalin ang mensaheng ito?",
        "CONFIRM_DELETE_MULTI": "Gusto mo bang tanggalin ang mga mensaheng ito?",
        "ALERT_SELECT_DELETE": "Mangyaring piliin ang mensaheng tatanggalin.",
        "ERROR_INPUT_RECEIVERLIST": "Mangyaring pumili ng hindi bababa sa isang driver upang magpadala ng mensahe",
        "ERROR_INPUT_CUSTOMER_RECEIVERLIST": "Mangyaring pumili ng hindi bababa sa isang customer na magpapadala ng mensahe",
        "ERROR_INPUT_SUBJECT": "Mangyaring ipasok ang paksa",
        "ERROR_INPUT_CONTENT": "Mangyaring mag-input ng nilalaman",
        "ERROR_INPUT_LEAST_ONE_SUBJECT_CONTENT": "Mangyaring mag-set up ng hindi bababa sa isang wika upang magpatuloy",
        "ERROR_INPUT_SUBJECT_MULTI_LANGUAGE": "Mangyaring ipasok ang paksa para sa {0} wika",
        "ERROR_INPUT_CONTENT_MULTI_LANGUAGE": "Mangyaring ipasok ang paksa para sa {0} wika",
        "ERROR_INPUT_URL_MULTI_LANGUAGE": "Mangyaring ipasok ang URL para sa {0} wika",
        "ERROR_INPUT_TITLE_MULTI_LANGUAGE": "Mangyaring ipasok ang pamagat para sa {0} wika",
        "ERROR_INPUT_BODY_MULTI_LANGUAGE": "Paki-input ang katawan para sa {0} wika",
        "import_fail_success_driver": "Matagumpay na na-import ang %{success} (mga) driver, nabigo ang %{fail}.",
        "import_fail_success_passenger": "Matagumpay na na-import ang %{success} (mga) customer, nabigo ang %{fail}.",
        "import_fail_success_merchant": "Matagumpay na na-import ang %{success} (mga) merchant, nabigo ang %{fail}.",
        "CONFIRM_SEND_SUCCESS": "Ang iyong mensahe ay naipadala na. Maaaring tumagal ito ng ilang minuto. Mangyaring maghintay habang pinoproseso ng system ang iyong kahilingan.",
        "Load_message_and_sms_fail": "Naganap ang mga error habang naglo-load ng mga detalye ng mensahe at SMS",
        "Update_message_and_sms_fail": "Naganap ang mga error habang ina-update ang mga detalye ng mensahe at SMS",
        "Update_message_and_sms_success": "Matagumpay na na-update ang mga detalye ng mensahe at SMS",
        "Driver_List": "Listahan ng Driver",
        "Car_Type_List": "Listahan ng uri ng kotse",
        "Search_vehicle_type_name": "Pangalan ng Uri ng Sasakyan sa Paghahanap",
        "ALERT_PROCESSING_DELETE": "Pinoproseso ang iyong kahilingan. Maaaring tumagal ito ng ilang segundo",
        "Customer": "Kustomer",
        "Driver": "Driver",
        "StatusOfCustomer": "Katayuan ng customer",
        "StatusOfDriver": "Katayuan ng driver",
        "StatusOfMerchant": "Katayuan ng mangangalakal",
        "SendTo": "Ipadala sa",
        "DownloadReceiverList": "I-download ang listahan ng tatanggap",
        "warningInputChangeOver": "Mayroong relatibong pagbabago na higit sa 20% sa pagitan ng 2 kamakailang input. Mangyaring isaalang-alang!",
        "NoteDownloadReveverList": "Pagkalipas ng 1 buwan, idi-disable ang pag-download ng listahan ng mga receiver.",
        "Load_voip_fail": "Naganap ang mga error habang nilo-load ang mga detalye ng VOIP.",
        "Update_voip_success": "Matagumpay na na-update ang mga detalye ng VOIP.",
        "Update_voip_fail": "Naganap ang mga error habang ina-update ang mga detalye ng VOIP.",
        "expiryDate": "Ipadala sa bagong user hanggang",
        "expiryDate_placeholder": "Petsa ng Pag-expire (mm/dd/yyyy)",
        "NA": "Wala",
        "PleaseSelectStatusOfDriver": "Mangyaring piliin ang katayuan ng driver",
        "versionApp": "Bersyon ng App",
        "platform": "Plataporma",
        "contentType": "Uri ng nilalaman",
        "url": "URL",
        "title": "Pamagat",
        "contentId": "ContentId",
        "body": "Katawan",
        "image_notification": "Imahe",
        "platformItem": {
            "all": "Lahat",
            "iOS": "iOS",
            "android": "Android"
        },
        "comparisonVersionApp": {
            "is": "Ay",
            "is_not": "Ay hindi",
            "is_one_of": "Ay isa sa",
            "is_not_one_of": "Ay hindi isa sa",
            "greater_or_equal": "Mas malaki o katumbas",
            "less_or_equal": "Mas kaunti o katumbas"
        },
        "contentTypeItem": {
            "html": "HTML",
            "link": "Link"
        },
        "Please_input": "Kinakailangan ang field na ito"
    },
    "fleetInfo": {
        "Fleet_name": "Pangalan ng fleet",
        "Phone_number": "Numero ng telepono",
        "Email_address": "Email address",
        "Country": "Bansa",
        "Time_zone": "Time zone",
        "Address": "Address",
        "Website": "Website",
        "Currency": "Pera",
        "Distance_unit": "Unit ng distansya",
        "Load_fleet_info_fail": "Naganap ang mga error habang nilo-load ang impormasyon ng fleet"
    },
    "surchargePolicy": {
        "Surchage_Policy": "Patakaran sa Surcharge",
        "SurgePolicy": "Patakaran sa Surge",
        "surgeType": "Uri ng Surge",
        "bookingTimeCoverage": "Takdang Oras ng Pag-book",
        "Delete_surcharge": "Sigurado ka bang nais mong tanggalin ang napiling karagdagang bayad?",
        "Delete_surcharge_item": "Sigurado ka bang nais mong tanggalin ang napiling surcharge item?",
        "Delete_surcharge_item_success": "Ang surcharge ay matagumpay na na-deactivate",
        "Delete_surcharge_item_fail": "Nangyari ang mga pagkakamali habang pinapatay ang surcharge item",
        "linkNewPolicy": "Ikonekta ang bagong patakaran",
        "Link": "Link",
        "ViewPolicy": "Tingnan ang Patakaran",
        "Unlink": "Alisin ang link",
        "Create_Surcharge_Item_success": "Matagumpay na nalikha ang item na may karagdagang bayad",
        "Create_Surcharge_Item_fail": "Nangyari ang mga pagkakamali habang nililikha ang item ng surcharge",
        "Update_Surcharge_Item_success": "Na-update nang matagumpay ang item ng surcharge",
        "Update_Surcharge_Item_fail": "Nangyari ang mga pagkakamali habang ina-update ang item ng surcharge",
        "single": "Isang Araw",
        "yearly": "Taunan",
        "weekly": "Araw ng linggo",
        "Please_select_at_least_one_day": "Pakisuyong pumili ng hindi bababa sa isang araw",
        "Booking_lead_time": "Oras ng Pag-book",
        "Start_date_must_be_before_end_date": "The start date must be before the end date"
    },
    "penaltyPolicy": {
        "penaltyPolicy": "Patakaran sa Parusa",
        "Reservation": "Rekado",
        "onDemand": "On-demand",
        "noShow": "Walang Pagpapakita",
        "driverNoShow": "Walang dumating na driver",
        "freeCancellation": "Libre ang pagkansela ng buffer",
        "fieldExclusions": "Kasamang mga Patlang",
        "penaltyActive": "Ikansela ang Tagal ng Antas - bago ang oras ng pagkuha",
        "penaltyType": "Uri ng Parusa",
        "Compensation": "Kompensasyon ng Supplier/Driver",
        "Create_penalty_success": "Matagumpay na nalikha ang template ng parusa",
        "Create_penalty_fail": "Nangyari ang mga error habang gumagawa ng template ng parusa",
        "Update_penalty_success": "Ang template ng parusa ay matagumpay na na-update",
        "Update_penalty_fail": "Ang mga pagkakamali ay nangyari habang ina-update ang template ng parusa",
        "confirmDelete": "Kumpirmahin ang Tanggalin",
        "confirmDeleteContent": "Sigurado ka bang nais mong tanggalin ang patakaran sa parusa na ito? Ang pagtanggal sa patakarang ito ay mag-uugnay mula sa lahat ng mga rate ng booking.",
        "Delete_success": "Matagumpay na na-delete ang template ng parusa",
        "Delete_fail": "Nangyari ang mga error habang binubura ang penalty template",
        "payoutPolicy": "Patakaran sa Pagbabayad",
        "commission": "Persyento ng Parusa sa Customer",
        "commissionPayout": "Persentasyon ng Bayad sa Supplier",
        "fixAmount": "Dami",
        "amount": "Dami",
        "amount_driver": "Dami",
        "percent": "Percent",
        "percent_driver": "Persentaheng nakabatay sa pamasahe",
        "basedOnPayout_driver": "Persentaheng batay sa Bayad",
        "percentPayout": "% ng Bayad",
        "percentFare": "% ng Pamasahe",
        "penaltyFee": "Bayad sa Kanselasyon",
        "commissionType": "Uri ng Kompensasyon",
        "commissionFee": "Kompensasyon",
        "tax": "Buwis",
        "techFee": "Bayad sa Teknolohiya",
        "minute": "minuto",
        "hour": "oras",
        "setDefaultSuccess": "Matagumpay na naitakda ang default na patakaran sa parusa",
        "setDefaultFail": "Ang mga error ay nangyari habang nagtatakda ng default na patakaran sa parusa."
    },
    "rateTemplates": {
        "Rate_Templates": "Mga Template ng Rate",
        "newRate": "Bagong Template ng Rate",
        "placeHolderName": "Ilagay ang Pangalan ng Rate Template",
        "Assign_Rate": "Rate ng Pag-assign",
        "carTypeName": "Uri ng Sasakyan",
        "appDisplayName": "App Display Name",
        "assign_rate_success": "Ang uri ng sasakyan ay matagumpay na naitalaga ng rate",
        "assign_rate_fail": "Nangyari ang mga error habang nag-aassign ng rate",
        "confirmDeleteTitle": "Kumpirmahin ang Tanggalin",
        "confirmDelete": "Sigurado ka bang nais mong tanggalin ang template na ito? Ang pagtanggal sa template na ito ay aalisin ang koneksyon mula sa lahat ng mga kasosyo/korporasyon na nakakabit dito.",
        "setDefaultSuccess": "Ang default na template ng rate ay matagumpay na naitakda",
        "setDefaultFail": "Ang mga error ay nangyari habang nagse-set ng default rate template",
        "Delete_rate_template_success": "Matagumpay na natanggal ang template ng rate",
        "Delete_rate_template_fail": "Nangyari ang mga pagkakamali habang binubura ang rate template",
        "setDefault": "Itakda bilang Default",
        "Regular": "Regular na rate",
        "Sharing": "Rate ng Paghahati sa Kalsada",
        "Flat": "Patag na Bayad",
        "Hourly": "Oras/ Araw",
        "Delete_default": "Kung susubukan mong tanggalin ang default na template, hindi natin dapat pahintulutan hangga't hindi sila nagtatakda ng ibang default na rate."
    },
    "supplierPlan": {
        "Supplier_Plan": "Plano ng Supplier",
        "rateTemplate": "Rate Schema",
        "rateTemplateNote": "ang pagkalkula ng pamasahe na ginamit upang tukuyin ang halagang binayaran sa drayber o tagapagbigay.",
        "percent": "Komisyon ng Pangkalahatang Sasakyan",
        "percentNote": "ang porsyento na sinisingil ng fleet sa bawat booking.",
        "amount": "Naayos na Halaga",
        "amountNote": "ang halaga na ibinabawas ng fleet para sa bawat booking.",
        "supplierPenaltyId": "Patakaran sa Parusa ng Supplier",
        "payoutType": "Uri",
        "Select_penalty_policy": "Pumili ng Patakaran sa Parusa",
        "Select_corporate": "Pumili ng Korporasyon",
        "Select_supplier_plan": "Pumili ng Supplier Plan",
        "Create_supplier_plan_success": "Matagumpay na nalikha ang plano ng supplier",
        "Create_supplier_plan_fail": "Ang mga pagkakamali ay nangyari habang gumagawa ng plano ng supplier",
        "Update_supplier_plan_success": "Na-update nang matagumpay ang plano ng supplier",
        "Update_supplier_plan_fail": "Nangyari ang mga error habang ina-update ang plano ng supplier",
        "Payout_Plan": "Plano ng Bayad",
        "Payout_Plan_note": "I-set up kung magkano ang babayaran sa supplier.",
        "default": "Default",
        "custom": "Pasadyang Plano",
        "cannotSetPayout": "Di maitatag ang plano ng bayad para sa drayber ng panlabas na kasosyo."
    },
    "stopSales": {
        "stopSales": "Huminto sa Benta",
        "confirm_delete": "Sigurado ka bang nais mong tanggalin ang patakarang ito?",
        "Create_stop_sales_success": "Matagumpay na nalikha ang stop sales",
        "Create_stop_sales_fail": "Nangyari ang mga pagkakamali habang gumagawa ng stop sales",
        "Update_stop_sales_success": "Ang pag-update ng stop sales ay matagumpay na naisagawa.",
        "Update_stop_sales_fail": "Nangyari ang mga pagkakamali habang ina-update ang stop sales",
        "Delete_success": "Matagumpay na natanggal ang stop sales",
        "Delete_fail": "Nangyari ang mga error habang binubura ang stop sales",
        "allVehicle": "Lahat ng Sasakyan",
        "allZone": "All Zone"
    },
    "generalSetting": {
        "alertNotifications": {
            "title": "Mga abiso ng alerto",
            "emails": "Mga Email",
            "emailsPlaceholder": "Ilagay ang email",
            "slack": "Slack Channel (Mga Tagubilin)",
            "slackPlaceholder": "Slack POST URL",
            "discord": "Discord Channel (Mga Tagubilin)",
            "discordPlaceholder": "Pasukin ang Discord Channel",
            "telegram": "Telegram Channel (Mga Tagubilin)",
            "telegramPlaceholder": "Pasukin ang Telegram Channel"
        },
        "showFare": {
            "title": "Ipakita ang pamasahe sa driver",
            "totalFare": "Kabuuang pamasahe",
            "estimateGross": "Tantyahin ang kabuuang kita"
        },
        "carHailing": "Street Hailing",
        "regular": "Regular",
        "cancelTimeout": "Awtomatikong kanselahin ang mga timeout na booking",
        "allowStripePaymentLink": "Payagan ang pagbuo ng link ng pagbabayad ng Stripe",
        "flat": "patag",
        "techFee": "Tech fee bawat transaksyon",
        "customizeLogo": "I-customize ang logo ng dashboard",
        "logo": "Logo",
        "customerApp": "App ng Customer",
        "hourly": "Oras-oras",
        "shuttle": "Shuttle",
        "parcel": "Parcel",
        "freeCancelTime": "Mga libreng oras ng pagkansela bawat araw",
        "AM": "AM",
        "PM": "PM",
        "RUSH_HOUR": "Patong na singil",
        "Name": "Pangalan",
        "Date": "Petsa",
        "Mon": "Mon",
        "Tue": "Tue",
        "Wed": "Wed",
        "Thu": "Huwebes",
        "Fri": "Biyernes",
        "Sat": "Sabado",
        "Sun": "Araw",
        "Time_range": "Saklaw ng oras",
        "From": "Mula sa",
        "To": "Upang",
        "Rush_hour_time_calculation": "Pagkalkula ng oras ng surcharge",
        "Rush_hour_surcharge": "Patong na singil",
        "Required_fields": "Mga kailangang punan",
        "Save": "I-save",
        "Cancel": "Kanselahin",
        "MDISPATCHER_CANCELLATION": "Pagkansela ng Pax / Partner / Web booking",
        "Book_now": "Mag-book na",
        "MDISPATCHER_CANCELLATION_TOOLTIP": "Pagkansela ng Pax / Partner / Web booking",
        "Book_now_toolTip": "Nalalapat ang bayad sa pagkansela kung ang mga on-demand na booking ay nakansela sa loob",
        "Book_later_toolTip": "Nalalapat ang bayad sa pagkansela kung ang isang reserbasyon ay nakansela bago ang oras ng pagkuha",
        "Drv_Book_now_toolTip": "Nalalapat ang bayad sa pagkansela kung ang mga on-demand na booking ay nakansela sa loob ng itinakdang oras, mula sa oras ng pagtanggap",
        "Drv_Book_later_toolTip": "Applicable ang cancellation fee kung makansela ang mga advance booking sa loob ng nakatakdang oras, bago ang inaasahang oras ng pick-up",
        "Free_cancel": "Libreng tagal ng pagkansela",
        "Hide_cancel_btn": "Itago ang button na kanselahin pagkatapos ng mga nakatakdang oras",
        "Driver_cancellation": "Pagkansela ng driver",
        "Time_day": "Mga oras bawat araw",
        "Duration": "Tagal",
        "Times": "Mga oras",
        "Book_later": "Mag-book mamaya",
        "Intercity": "Intercity",
        "Intercity_tooltip": "Applicable ang cancellation fee kung ang isang intercity booking ay nakansela sa loob ng itinakdang oras, bago ang oras ng pickup.",
        "MDISPATCHER_NO_SHOW": "Walang Palabas",
        "AIRPORT_FEE": "Bayad sa paliparan",
        "From_airport": "Mula sa airport",
        "To_airport": "Sa airport",
        "MEET_DRIVER": "Kilalanin ang driver",
        "On_curb": "Sa gilid ng bangketa",
        "Meet_Greet": "Pagkikita at Pagbati",
        "Add": "Idagdag",
        "Edit": "I-edit",
        "DELETE_SURCHARGE": "Tanggalin ang surcharge",
        "DELETE_SERVICE": "Tanggalin ang serbisyo",
        "CHANGE_APPLY_SERVICE_FEES": "Baguhin ang paglalapat ng mga bayarin sa serbisyo",
        "DELETE_CONFIRM": "Sigurado ka bang gusto mong tanggalin ang item na ito?",
        "DELETE_SURCHARGE_CONFIRM": "Sigurado ka bang gusto mong tanggalin ang napiling surcharge?",
        "DELETE_ADDITIONAL_SERVICES_CONFIRM": "Sigurado ka bang gusto mong tanggalin ang napiling serbisyo?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_CUSTOM": "Sigurado ka bang gusto mong mag-apply ng iba't ibang mga bayarin para sa mga seperated zone?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_ALL": "Sigurado ka bang gusto mong ilapat ang parehong mga bayarin para sa lahat ng mga zone?",
        "EDIT_SERVICE_FEES": "I-edit ang mga bayarin sa serbisyo",
        "EDIT_SERVICE_FEES_CONFIRM": "Sigurado ka bang gusto mong umalis nang hindi nagse-save ng mga setting para sa %{currentZone}?",
        "HEAVY_TRAFFIC": "Matinding trapiko",
        "Heavy_traffic_surcharge": "Matinding traffic surcharge",
        "TOLL_FEE": "Bayad sa toll",
        "parkingFee": "Bayad sa paradahan",
        "gasFee": "Bayad sa gas",
        "OTHER_FEES": "Iba pang bayad",
        "Can_edit": "Marunong mag edit",
        "Can_add_note": "May kakayahang magdagdag ng tala",
        "Other_fees_amount": "Iba pang halaga ng bayad",
        "TAX": "Buwis",
        "Tax_surcharge": "dagdag na singil sa buwis",
        "TIP": "Tip",
        "Default_tip": "Default na tip",
        "RESERVATION_REMINDER": "Paalala sa pagpapareserba",
        "Driver_app_SMS_alert_before": "Driver app - SMS at alerto dati",
        "notifyWhenDriverFailStartTrip": "Ipagbigay-alam sa operator kung ang drayber ay nabigong simulan ang biyahe bago ang oras ng pickup",
        "notifyWhenDriverFailStartTripTooltip": "Ang mga notification ay ipapakita sa seksyon ng mga notification ng platform. Maaari mo ring i-configure ang mga alerto na ipapadala sa pamamagitan ng email, Slack, Discord, o Telegram para sa napapanahong mga update.",
        "notifyPaxBeforeQuote": "Notify passenger before quote expiration time",
        "Pax_app_alert_before": "Pax app - alerto dati",
        "Confirm_driver_info_via_email_before": "Magpadala ng email / sms booking confirmation sa customer bago",
        "Confirm_driver_info_via_email_before_hint": "Magpapadala ang system ng kumpirmasyon sa booking sa customer batay sa iyong itinakdang oras, bago ang oras ng pagkuha.",
        "Show_request_tab_on_driver_app": "Ipakita ang tab na 'Kahilingan' sa driver app",
        "Show_preferred_tab_on_driver_app": "Ipakita ang tab na 'Preferred' sa driver app",
        "Sound_notification": "Tunog na notification",
        "Advance_information": "Paunang impormasyon ng mga gumagamit ng kumpanya",
        "Load_general_fail": "Naganap ang mga error habang naglo-load ng pangkalahatang setting",
        "Update_general_success": "Matagumpay na na-update ang pangkalahatang setting",
        "Update_general_fail": "Matagumpay na na-update ang pangkalahatang setting",
        "Time_over_lap": "Ang mga hanay ng oras ay hindi dapat mag-overlap sa bawat isa",
        "Allow_passenger_to_register_as_corp_traveler": "Pahintulutan ang pasahero na magparehistro bilang mga gumagamit ng corp",
        "Not_Allow_Make_Booking_Without_Assign_Fare": "Huwag ipakita ang uri ng kotse sa PWA at App kung walang itinalagang pamasahe (v4.6.60 at mas mataas)",
        "Not_Allow_show_car_type_on_cc": "Huwag ipakita ang uri ng sasakyan sa CC kung walang itinalagang pamasahe",
        "Disable_Direct_Invoicing_Receipt_Email": "Huwag paganahin ang email ng resibo ng direktang pag-invoice",
        "Additional_services": "Karagdagang serbisyo",
        "Edit_additional_services": "I-edit ang Mga Karagdagang Serbisyo",
        "Service_Fee_By_Currencies": "Kabayaran sa serbisyo",
        "Service_type": "Uri ng Serbisyo",
        "Optional": "Opsyonal",
        "Compulsory": "Obligatoryo",
        "Vehicle_type": "Uri ng Sasakyan",
        "Adding_additional_service_success": "Matagumpay na nalikha ang bagong serbisyo",
        "Update_additional_service_success": "Matagumpay na na-update ang serbisyo",
        "Delete_additional_service_success": "Matagumpay na natanggal ang serbisyo",
        "Adding_additional_service_fail": "Nabigong magdagdag ng Serbisyo",
        "Update_additional_service_fail": "Nabigong i-update ang serbisyo",
        "Other_settings": "Iba pang mga setting",
        "Operator_assign_error": "Nagkaroon ng mga error sa pagtatalaga ng operator",
        "Create_surcharge_success": "Matagumpay na nalikha ang bagong surcharge",
        "Update_surcharge_success": "Matagumpay na na-update ang surcharge",
        "Delete_surcharge_success": "Matagumpay na natanggal ang surcharge",
        "Create_surcharge_fail": "Nabigong muling ibigay ang surcharge",
        "Update_surcharge_fail": "Nabigong i-update ang surcharge",
        "Delete_surcharge_fail": "Nabigong tanggalin ang surcharge",
        "Get_surcharge_detail_fail": "Nabigong makuha ang detalye ng surcharge",
        "Repeat": "Ulitin",
        "DayOfWeek": "Araw sa isang linggo",
        "SingleDay": "Isang araw",
        "Yearly": "Taon-taon",
        "Backup_phone_number": "Numero ng backup",
        "Backup_phone_number_hint": "Direkta sa numerong ito kapag ang driver at pasahero ay wala sa mga operation zone",
        "Apply_countdown_clock": "Ilapat ang countdown na orasan",
        "No_show_duration_tooltip": "I-set up ang oras para ipakita ang No Show button pagkatapos i-tap ng driver ang Arrived button sa Driver App",
        "Limit_radius": "Limitahan ang radius",
        "Limit_radius_tooltip": "Maaaring mag-ulat ang driver ng booking bilang no-show sa loob ng radius na ito",
        "Limit_radius_arrive_pickup": "Maaaring dumating ang driver ng limit radius at mag-pick up para sa transport booking",
        "Booking_validation": "Mga pagpapatunay ng booking",
        "Invalid_period_of_time": "Di-wastong yugto ng panahon",
        "hide_Provider_Filter_From_Corporate_Board": "Itago ang filter ng provider mula sa corporate board",
        "customer_email_is_optional": "Ang email ng customer ay opsyonal sa pampasaherong app",
        "disable_hourly_rate": "I-disable ang oras-oras na rate kapag available ang parehong oras-oras at flat rate",
        "customer_gender_is_compulsory": "Ang kasarian ng customer ay sapilitan sa pampasaherong app",
        "SHOW_MAP_STATUS": "Ipakita ang katayuan ng mapa",
        "Pay_to": "Magbayad sa",
        "EMERGENCY_SOS": "Emergency S.O.S",
        "customer_address_is_compulsory": "Ang address ng customer ay sapilitan sa pampasaherong app",
        "customer_id_is_compulsory": "Ang Customer's ID# / National IC# ay sapilitan sa pampasaherong app",
        "allowPassengerToUploadDocument": "Payagan ang pasahero na mag-upload ng ID# / National IC# na dokumento",
        "compulsoryNationalIcDocumentInPaxApp": "Ang Customer's ID# / National IC# na dokumento ay sapilitan sa Pax app",
        "doNotAllowAddDriverWhenNationalIdDuplicated": "Huwag payagan ang operator na magdagdag ng driver kapag nadoble ang national ID",
        "forceCustomerToUseLiveLocation": "Pilitin ang customer na gumamit ng Live na Lokasyon",
        "disableMarketPlace": "Huwag paganahin ang Market Place para sa mga bagong driver",
        "dontShowSecondStageImmediately": "Itago ang stage 2 signup",
        "dontAddCarMM": "Huwag payagan ang Driver na magdagdag ng bagong tatak/modelo ng sasakyan",
        "dontEditCapability": "Do not allow Driver to edit Driver Capability",
        "compulsoryCarInsurance": "Ang seguro sa kotse ng driver ay sapilitan",
        "marketPlace": "Lugar ng Pamilihan",
        "Enable": "Paganahin",
        "Disable": "Huwag paganahin",
        "showTotalFareWithoutPromotionOnDriverApp": "Ipakita ang kabuuang pamasahe nang walang promosyon sa Driver app",
        "showTotalFareWithoutPromotionOnDriverApp_hint": "- Transportasyon: ilapat ang setting na ito bago magbayad ang driver. <br/> - Paghahatid at Intercity: ilapat ang setting na ito bago magsimulang magtrabaho ang driver.",
        "hideFareOnPaxAppForAllCorporateBookings": "Itago ang pamasahe sa Pax app para sa lahat ng corporate booking",
        "hidePaxNameAvatarOnDispatchScreen": "Tago ang impormasyon ng customer sa Driver app bago magsimula ang biyahe",
        "showFullCustomerNameOnDriverApp": "Ipakita ang buong pangalan ng customer sa Driver app",
        "hideDriverLogoutBtn": "Itago ang Driver logout button sa Driver app",
        "showMeetAndGreetButtonForEveryBooking": "Ipakita ang Meet & Greet na button para sa bawat booking",
        "showEcontract": "Ipakita ang E-Contract na pindutan",
        "isShowConfirmationCode": "Ipakita ang code ng kumpirmasyon ng booking",
        "showIncidentReportButton": "Ipakita ang Insidente na pindutan",
        "inReviewStatus": "Status ng pagsusuri",
        "inReviewStatusTooltip": "Minamarkahan ang booking bilang “Nasa pagsusuri.” Mananatiling aktibo ang biyahe hanggang isara ito ng operator.",
        "incidentBtnDrvApp": "Ipakita ang button na “Insidente” sa Driver app",
        "incidentBtnDrvAppTooltip": "Nagdagdag ng isang button sa mga aktibong biyahe para sa mga drayber upang iulat ang mga insidente, na maaaring suriin at isara ng operator.",
        "fareChangeTolerance": "Tolerance sa pagbabago ng pamasahe",
        "fareChangeToleranceTooltip": "Ang mga pagbabago sa pamasahe na higit sa % na ito ay nangangailangan ng manu-manong pag-apruba ng operator.",
        "groupManifest": "Manifesto ng Grupo",
        "JobOrderedBy": "Trabaho na inutos ng",
        "optional": "Opsyonal",
        "pickupTime": "Oras ng Pagkuha",
        "route": "Ruta",
        "settings": "Mga setting",
        "Default_value": "Default na halaga",
        "limitTopupAmount": {
            "valueByCurrencies": "Dami ng babala",
            "minimumByCurrencies": "Minimum na halaga ng top up",
            "maximumByCurrencies": "Pinakamataas na halaga ng top up",
            "title": "Minimum at Maximum na halaga ng Top up"
        },
        "driverApp": "Driver App",
        "passengerApp": "App ng Pasahero",
        "Default_Topup_Values": "Default na Mga Halaga ng Top up",
        "service_fees": "Mga Bayarin sa Serbisyo",
        "commission_fleet": "Default na Fleet Commission",
        "apply_all": "Ang parehong para sa lahat ng mga zone ng operasyon",
        "apply_custom_zone": "Naiiba sa pagitan ng lahat ng mga zone ng operasyon",
        "apply": "Mag-apply",
        "tollFeeDriverCanInput": "Limitahan ang halaga na mai-input ng driver",
        "unlimited": "Walang limitasyon",
        "limited": "Limitado",
        "sameFee": "Parehong bayad",
        "customizedAirportfee": "Pasadyang bayad sa paliparan",
        "noteAirportFeeModal": "Tandaan: Ang bayad sa paliparan ay inilalapat lamang para sa mga paliparan na nasa listahan.",
        "intercity_schedule_trip_time_range": "Upang matiyak ang magkakasunod na pagkakasunud-sunod ng oras ng pag-book, pakitiyak na ang hanay ng oras ng mga ginustong/hiling na mga biyahe ay mas malaki kaysa sa mga iskedyul ng mga biyahe",
        "airportFee": {
            "tooltipApply": "Ang default na bayad sa paliparan ay ilalapat para sa bawat biyahe mula / papunta sa paliparan bilang default. Kung ang bayad sa paliparan ay na-customize, ang bagong bayad ay ilalapat para sa lugar na iyon.",
            "titleSearchAiportZone": "Mangyaring hanapin ang iyong airport at idagdag ang iyong bayad",
            "airport": "Paliparan",
            "currency": "Pera",
            "fromAirportFee": "Mula sa bayad sa paliparan",
            "toAirportFee": "Sa bayad sa airport",
            "action": "Mga aksyon"
        },
        "Yes": "Oo",
        "No": "Hindi",
        "tipPaymentMethod": "Available ang paraan ng pagbabayad para sa customer na magbigay ng tip sa kanyang driver pagkatapos ng order",
        "allowPaxUpdateTip": "Payagan ang pasahero na i-update ang porsyento ng tip habang nasa biyahe",
        "tipDefaultValues": "Mga default na halaga para sa tip pagkatapos ng biyahe",
        "creadit": "Credit card (Personal na card / Corporate na card)",
        "wallet": "Pitaka",
        "tnGeWallet": "TnG eWallet",
        "vippseWallet": "Vipps",
        "DurationRegularBooking": "Tagal (para sa mga regular na booking)",
        "googlePay": "Google Pay",
        "applePay": "Apple Pay",
        "DurationRegularBookingToolTip": "Ipapakita ang \"No show\" na button pagkatapos na i-tap ng driver ang \"Arrived\" na button sa Driver app.",
        "noShowCountDown": {
            "customizedNoShow": "Pag-customize para sa mga partikular na lokasyon (hal. airport...)",
            "customizedNoShowTitle": "Ilapat ang tagal ng hindi pagsipot na count down para sa mga partikular na lokasyon (hal. airport...)"
        },
        "maxWaitTime": "Max na karagdagang oras ng paghihintay",
        "maxWaitTimeToolTip": "Ito ang pinakamataas na karagdagang oras ng paghihintay na sisingilin sa customer. Mayroon kang kakayahang i-customize ang bayad bawat minuto sa iyong mga setting ng rate.",
        "maxWaitTimePlaceholder": "Pinakamataas na oras ng paghihintay para sa singil",
        "HEAT_MAP": "Mapa ng init",
        "heatMap": {
            "defaultMode": "Default na mode",
            "radius": "Radyus",
            "intensity": "Intensidad",
            "opacity": "Opacity",
            "requestedBookings": "Hiniling na mga booking",
            "activePassengers": "Mga aktibong pasahero",
            "completedBookings": "Nakumpleto ang mga booking",
            "timeoutBookings": "Mag-time out sa mga booking",
            "tooltipRadius": "Ang radius ng impluwensya para sa bawat punto ng data, sa mga pixel.",
            "tooltipIntensity": "Ang maximum na intensity ng heatmap.",
            "tooltipOpacity": "Ang opacity ng heatmap, na ipinahayag bilang isang numero sa pagitan ng 0 at 1."
        },
        "schedule_trip": "Mag-iskedyul ng paglalakbay",
        "driver_starts_trip_before_set_time": "Nagsisimula ang biyahe ng driver bago ang itinakdang oras",
        "request_trip": "Humiling ng biyahe",
        "preferred_trip": "Ginustong paglalakbay",
        "time_range": "Saklaw ng oras para sa kahilingan at gustong biyahe",
        "working_time": "Oras ng trabaho",
        "hour": "oras",
        "hours": "oras",
        "minutes": "minuto",
        "indicate_pickup_time_in_advance_to_customer": "Ipahiwatig ang oras ng pagkuha nang maaga sa customer.",
        "customers_can_select_start_time_and_request_intercity_trip": "Maaaring pumili ang mga customer ng oras ng pagsisimula at humiling ng intercity trip. Ang mga driver ay maaari ring lumikha ng kanilang ginustong biyahe gamit ang kanilang sariling iskedyul. Halimbawa: ang isang hanay ng oras na 1 oras ay magbibigay-daan sa mga customer at driver na gumawa ng intercity trip na magsisimula sa 8:00 am - 9:00 am, 9:00 am - 10:00 am, o 10:00 am - 11:00 am .",
        "this_setting_limits_customers_to_create_request_trip_within_working_hours_only": "Nililimitahan ng setting na ito ang mga customer na gumawa ng kahilingang biyahe sa loob ng mga oras ng trabaho lamang.",
        "face_mask_verify": "Pag-verify ng face mask",
        "faceMask_allZones": "Lahat ng zone",
        "faceMask_customized": "Customized na zone",
        "turn_on_verify": "I-on ang pag-verify",
        "force_to_wear_face_mask": "Piliting magsuot ng face mask",
        "time_range_to_verify": "Huwag i-verify muli sa loob",
        "customizedFaceMaskZone": "Customized na pag-verify ng face mask",
        "zoneOperation": "Operation Zone",
        "FaceMaskCustomized": "Naangkop",
        "time": "oras",
        "day": "araw",
        "days": "Mga Araw",
        "allow_driver_to_skip_verification_after": "Payagan ang driver na laktawan ang pag-verify pagkatapos",
        "driver_need_to_verify": "Kapag kailangang i-verify ng driver",
        "open_app": "Buksan ang app",
        "start_reservation": "Simulan ang pagpapareserba",
        "choose_at_least_one": "Dapat kang pumili ng hindi bababa sa isang aksyon upang magpatuloy.",
        "face_mask_customized_fail": "Dapat kang pumili ng hindi bababa sa isang aksyon upang magpatuloy ({0}).",
        "vehicleAgeLimit": "Limitasyon sa edad ng sasakyan",
        "vehicleAgeLimit_years": "taon",
        "founderFund_firstBooking": "Founder's Fund: unang booking lang",
        "distance_diversity": "Pagkakaiba-iba ng distansya",
        "Add_Surcharge_Distance": "Idagdag",
        "from": "Mula sa",
        "to": "Upang",
        "surchargeValue": "Patong na singil",
        "actions": "Aksyon",
        "please_enter_distance_range_valid": "Di-wasto ang distansyang %{name}!",
        "please_enter_distance_to": "Pakilagay ang distansya \"To",
        "please_enter_surchargeValue": "Pakilagay ang distansyang \"Surcharge\" para sa hanay ng distansya %{name}",
        "please_enter_surchargeValue_is_number": "Pakipasok ang wastong numerong \"Surcharge\" para sa hanay ng distansya %{name}",
        "Update_service_fee_success": "Matagumpay na na-update ang mga bayarin sa serbisyo",
        "Update_service_fee_fail": "Naganap ang mga error habang ina-update ang mga bayarin sa serbisyo",
        "Update_fleet_commission_success": "Matagumpay na na-update ang default na fleet commision",
        "Update_fleet_commission_fail": "Naganap ang mga error habang ina-update ang default na komisyon ng fleet",
        "RESERVATION_POLICY": "Patakaran sa pagpapareserba",
        "default_expected_pickup_time": "Default na inaasahang oras ng pagkuha",
        "default_expected_pickup_time_hint": "Ang default na halaga na inaasahan mong darating ang isang driver mula sa oras ng pagkuha.",
        "same_original_pickup_time": "Pareho sa orihinal na oras ng pagkuha",
        "quarter_before": "15 min bago",
        "half_before": "30 min bago",
        "quarter_after": "15 min pagkatapos",
        "half_after": "30 min pagkatapos",
        "custom": "Pasadya",
        "min_before": "min bago",
        "min_after": "min pagkatapos",
        "TransactionFee": "Bayad sa transaksyon",
        "creditCardPercent": "Kard ng kredito/ prepaid",
        "directBilling": "Direktang pagsingil",
        "externalCard": "External Card",
        "zoneIds": "Mga Lokasyon",
        "vehicles": "Mga Sasakyan",
        "default_expected_pickup_time_airport": "Default na inaasahang oras ng pickup (Pagdating sa Paliparan)",
        "expectedPickupTooltip": "Kung may ibinigay na numero ng flight, ang default na buffer na ito ay ilalapat upang awtomatikong kalkulahin ang oras ng pickup. Ito ay nalalapat lamang sa mga booking na ginawa sa pamamagitan ng admin dashboard."
    },
    "social": {
        "pax_app": "app ng pasahero",
        "driver_app": "Aplikasyon ng drayber",
        "default": "Default",
        "customized": "Naayon",
        "html": "HTML",
        "about": "Tungkol sa",
        "email": "Suporta sa email",
        "enablePhone": "Numero ng telepono",
        "phone": "",
        "policy": "I-link ang Patakaran sa Privacy",
        "termOfUse": "I-link ang Mga Tuntunin ng Paggamit",
        "site": "Website",
        "logoDriverIOS": "Logo - IOS",
        "logoDriverAndroid": "Logo - Android",
        "htmlUrl": "HTML na file",
        "Update_fail": "Naganap ang mga error habang nag-a-update ng social",
        "Update_success": "Matagumpay na na-update ang social"
    },
    "user": {
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "Search_here": "Maghanap dito",
        "show_pages": "{0} - {1} ng {2} ang ipinakita",
        "Username": "Username",
        "Name": "Pangalan",
        "Phone_number": "Numero ng telepono",
        "Email": "Email",
        "Permission": "Pahintulot",
        "Status": "Katayuan",
        "Actions": "Mga aksyon",
        "Active": "Aktibo",
        "Inactive": "Hindi aktibo",
        "Edit": "I-edit",
        "Deactivate": "I-deactivate",
        "Delete": "Tanggalin",
        "Add": "Idagdag",
        "ADD_USER": "Idagdag ang gumagamit",
        "First_name": "Pangalan",
        "Last_name": "Huling pangalan",
        "AgendId": "Gumagamit #",
        "Email_address": "Email address",
        "Address": "Address",
        "Required_fields": "Mga kailangang punan",
        "Save": "I-save",
        "Cancel": "Kanselahin",
        "EDIT_USER": "I-edit ang user",
        "Yes": "Oo",
        "DELETE_USER": "Tanggalin ang user",
        "DETAIL_USER": "Detalye ng gumagamit",
        "DELETE_CONFIRM": "Sigurado ka bang gusto mong tanggalin ang napiling user?",
        "Update_user_fail": "Naganap ang mga error habang ina-update ang user",
        "Update_user_success": "Matagumpay na na-update ang user",
        "Create_user_fail": "Naganap ang mga error habang gumagawa ng user",
        "Create_user_success": "Matagumpay na nalikha ang account na {0}. Pakisuri ang email {1} ​​para sa mga detalye ng kredensyal sa pag-log in.",
        "Load_user_fail": "Naganap ang mga error habang nilo-load ang user",
        "Update_user_status_fail": "Naganap ang mga error habang ina-update ang status ng user",
        "Delete_user_fail": "Naganap ang mga error habang tinatanggal ang user",
        "Delete_user_success": "Matagumpay na natanggal ang user",
        "CONFIRM_RESET_PASSWORD": "Gusto mo bang i-reset ang password?",
        "RESET_PASSWORD": "Gusto mo bang i-reset ang password?",
        "Reset_password": "I-reset ang password",
        "Select_permission": "Piliin ang Pahintulot",
        "Reset_password_success": "Matagumpay na i-reset ang password"
    },
    "report": {
        "query": {
            "errorMessage": {
                "bookFrom": "Mangyaring pumili ng booking mula sa",
                "paymentMethod": "Mangyaring pumili ng paraan ng pagbabayad",
                "bookingType": "Mangyaring pumili ng uri ng booking",
                "ratingType": "Mangyaring pumili ng uri ng rating",
                "stars": "Mangyaring pumili ng uri ng rating",
                "type": "Uri",
                "transactionType": "Mangyaring pumili ng uri ng transaksyon",
                "serviceType": "Mangyaring pumili ng uri ng serbisyo",
                "rideService": "Mangyaring pumili ng serbisyo sa pagsakay",
                "invalidEmail": "Mangyaring magpasok ng wastong email address."
            },
            "search": {
                "driverReferalPax": "Hanapin: Pangalan ng Driver, Numero ng Telepono",
                "passengerRefersPassengers": "Hanapin: Pangalan ng Customer, Numero ng Telepono",
                "driverReferalPaxDetail": "Hanapin: Pangalan ng Pasahero",
                "bookingDetails": "Search: Booking ID, Operator, Customer phone, Customer name, Driver name, Mã tài xế, License plate, Queuing area, Note, Trip, Support ID",
                "financial": "Hanapin: Pangalan ng driver, Telepono",
                "completedTime": "Nakumpletong Oras",
                "collectedTime": "Nakolektang Oras",
                "financialDriver": "Hanapin: Booking ID, Driver name, ID# / National IC#",
                "carActivity": "Hanapin: License plate",
                "affiliation": "Maghanap: Booking ID",
                "prepaidTopUp": "Paghahanap: Pangalan ng kumpanya, Top up ID, Transaction ID",
                "operatorLogs": "Paghahanap: Pangalan ng operator, Pangalan ng gumagamit, Paglalarawan",
                "corporate": "Maghanap: Booking ID, Pangalan ng Driver, Mga Korporatibong Gumagamit, Usapin ng Kliyente, Kodigo ng Singil",
                "bookingLogs": "Maghanap: Booking ID, Pangalan ng Customer, Support ID, Pangalan ng Driver, ID# / National IC#",
                "rating": "Maghanap: Booking ID, Customer phone, Customer name, Plate number",
                "mDispatcher": "Maghanap: Booking ID, pangalan ng kasosyo",
                "totalAdjustment": "Maghanap: Booking ID",
                "incidentCancellation": "Maghanap: Booking ID, Customer phone, Support Id, Customer name",
                "acceptanceCancellationRate": "Paghahanap: Pangalan ng driver, numero ng telepono",
                "revenueDriver": "Hanapin: Pangalan ng driver",
                "dailyDriver": "Maghanap: Telepono ng driver, Pangalan ng driver, ID# / Pambansang IC#",
                "dailyCar": "Hanapin: License plate, Pahintulot",
                "dailyDriverCar": "Search: Driver phone, Driver name, Mã tài xế, License plate",
                "driverLoginStatus": "Search: Driver phone, Driver name, Mã tài xế, License plate",
                "bookingSummary": "Paghahanap: Pangalan ng operator, User name, Booking ID",
                "creditWallet": "Paghahanap: Pangalan ng kumpanya, Pangalan ng Driver, Booking ID, Transaction ID, Operator",
                "cashWallet": "Paghahanap: Pangalan ng kumpanya, Pangalan ng Driver, Booking ID, Numero ng telepono",
                "SupplierWallet": "Maghanap: Pangalan ng kumpanya, Booking ID",
                "settlement": "Hanapin: Pangalan ng driver, ID# / Pambansang IC#",
                "driverRating": "Maghanap: Booking ID, Customer phone, Customer name, Plate number, Support ID",
                "driverWithdrawal": "Pangalan ng driver, Telepono, Kumpanya, Transaction ID, Reference #",
                "penaltyCompensation": "Hanapin: Booking ID, Pangalan ng Driver, Pangalan ng Pasahero",
                "incompletePayment": "Maghanap: Booking ID, Support ID, Pangalan ng Customer",
                "passengerWallet": "Maghanap: Booking ID, Transaction ID, Pangalan ng Customer",
                "driverDeposit": "Hanapin: Pangalan ng kumpanya, Pangalan ng Driver, Booking ID, Operator",
                "refund": "Maghanap: Booking ID, Trip Id, Support ID, Pangalan ng customer",
                "driverRefersCustomerBookings": "Paghahanap: Referral code, Support ID",
                "driverHistory": "Paghahanap: Payout ID",
                "merchantHistory": "Paghahanap: Payout ID",
                "firstWillWin": "Maghanap: pangalan ng customer, telepono ng customer, customer ID",
                "firstWillWinDriver": "Maghanap: pangalan ng driver, telepono ng driver, username",
                "merchant": "Hanapin: tindahan",
                "merchantCashTransactionHistory": "Maghanap: Booking ID, Transaction ID, Pangalan ng Merchant",
                "merchantCreditTransactionHistory": "Maghanap: Booking ID, Transaction ID, Pangalan ng Merchant",
                "deleteAccountRequest": "Hanapin: Telepono",
                "affiliationPayoutHistory": "Paghahanap: Payout ID",
                "thirdPartyBooking": "Maghanap: Booking Id, External Id"
            },
            "common": {
                "all": "Lahat"
            },
            "today": "Ngayong araw",
            "sendDownloadLink": "Email Address ng Tatanggap",
            "generaltingYourExcel": "Pakitandaan, maaaring magtagal ang pagbuo ng iyong excel file. I-email namin ito sa iyo sa sandaling handa na ito.",
            "messageSuccess": "Kasalukuyang isinasagawa ang file. Makakatanggap ka ng email kapag handa na. Subaybayan ang pag-unlad o direktang mag-download mula sa Mga Ulat/Kasaysayan sa Pag-export",
            "thisMonth": "Sa buwang ito",
            "lastMonth": "Noong nakaraang buwan",
            "past30Days": "Nakalipas na 30 araw",
            "thisYear": "Ngayong taon",
            "custom": "Pasadya",
            "customize": "I-customize",
            "thisWeek": "Ngayong linggo",
            "past7Days": "Huling 7 Araw",
            "weekly": "Linggu-linggo",
            "monthly": "Buwan-buwan",
            "allTime": "Lahat ng oras",
            "tomorrow": "Bukas",
            "nextWeek": "Susunod na linggo",
            "lastWeek": "Nakaraang linggo",
            "nextMonth": "Susunod na buwan",
            "next7Day": "Susunod na 7 Araw",
            "yesterday": "Kahapon",
            "fromDate": "Mula sa petsa",
            "toDate": "Hanggang ngayon",
            "driver": "Driver: %{name}",
            "customer": "Pangalan ng Customer}",
            "referralCode": "Referral Code: %{name}",
            "referer": "Nag-refer: %{name}",
            "referee": "Tagahatol: %{name}",
            "usedPromoCode": "Promosyon: %{name}",
            "voucherCode": "Code: %{name}",
            "city": "lungsod",
            "company": "kumpanya",
            "company_report": "Pangalan ng Kumpanya}",
            "companySupplier_report": "Tagapagtustos/Kumpanya: %{name}",
            "supplier_report": "Tagapagtustos: %{name}",
            "corporate_report": "Korporasyon: %{name}",
            "campaign_report": "Kampanya: %{name}",
            "operator": "Operator",
            "farmType": "Uri ng sakahan",
            "carLicensePlate": "Plat ng lisensya ng sasakyan: %{name}",
            "settlementType": "Uri",
            "bookingService": "Uri ng network",
            "payoutOption": "Opsyon sa pagbabayad",
            "currency": "Pera",
            "bookingFrom": "Pagbu-book mula sa",
            "Provider": "Tagapagbigay",
            "thirdPartyAction": "Aksyon",
            "paymentMethod": "Paraan ng pagbabayad",
            "paymentStatus": "Katayuan ng pagbabayad",
            "bookingType": "Uri ng booking",
            "adjustPrice": "Ayusin ang Presyo",
            "intercityRoute": "Intercity na ruta",
            "ratingType": "Uri ng rating",
            "stars": "Marka",
            "driverRating": "Rating ng driver",
            "vehicleRating": "Rating ng sasakyan",
            "mDispatcherType": "Uri ng kasosyo",
            "mDispatcher": "Pangalan ng kasosyo",
            "campaign": "Kampanya",
            "promocode": "Promo code",
            "canceledBy": "Kinansela ni",
            "timezone": "Timezone",
            "month": "buwan",
            "year": "taon",
            "view": "Tingnan",
            "action": "Aksyon",
            "status": "Katayuan",
            "module": "Modul",
            "driverType": "Uri",
            "vehicleType": "Uri ng kotse",
            "serviceType": "Uri ng serbisyo",
            "expireDate": "Petsa ng pag-expire",
            "rideSharing": "Pagbabahagi ng pagsakay",
            "rideService": "Serbisyo sa pagsakay",
            "transactionType": "Uri ng Transaksyon",
            "completeFromCC": "Kumpleto mula sa CC",
            "withDrawalTransactionType": "Uri ng Transaksyon",
            "bookingStatus": "Katayuan ng booking",
            "withdrawalStatus": "Katayuan",
            "originalStatus": "Katayuan ng orihinal na pagbabayad",
            "currentStatus": "Kasalukuyang katayuan ng pagbabayad",
            "tip": "Tip",
            "type": "Uri",
            "userType": "Uri ng user",
            "eventType": "Uri ng kaganapan",
            "eventState": "Katayuan ng kaganapan",
            "eventName": "Pangalan ng pangyayari",
            "merchantType": "Uri ng mangangalakal",
            "merchantService": "Serbisyong mangangalakal",
            "storeName": "Tindahan",
            "merchant": "Mangangalakal",
            "event": "Pangalan ng kaganapan: %{name}",
            "store": "Pangalan ng tindahan: %{name}",
            "selectedMerchant": "Mangangalakal: %{name}",
            "associatedApps": "Mga nauugnay na app",
            "settlement": "Pag-aayos",
            "rideServiceItem": {
                "all": "Lahat",
                "regulation": "Regulasyon",
                "rideSharing": "Pagbabahagi ng Sakay"
            },
            "actionItem": {
                "all": "Lahat",
                "login": "Mag log in",
                "logout": "Mag-logout",
                "bookIn": "Magagamit",
                "bookOff": "Hindi magagamit",
                "deny": "Tanggihan",
                "ignore": "Huwag pansinin",
                "accept": "Tanggapin",
                "startTrip": "Papunta na ako",
                "updateBooking": "Update",
                "arrive": "Dumating",
                "pickup": "Pulutin",
                "drop": "Ilaglag",
                "complete": "Kumpleto",
                "noShow": "Walang Palabas",
                "driverNoShow": "Walang dumating na driver",
                "rqJob": "Nagpapadala",
                "cancel": "Kanselahin"
            },
            "loginStatusItem": {
                "all": "Lahat",
                "online": "Naglo-log in",
                "offline": "Hindi naka-log in"
            },
            "payoutType": "Uri ng pagbabayad",
            "affiliationPayoutTypeItem": {
                "auto": "Awtomatikong pagbabayad",
                "manual": "Manu-manong pagbabayad"
            },
            "affiliationSettlementItem": {
                "payable": "Mababayaran",
                "receivable": "Matatanggap"
            },
            "affiliationPaymentMethod": {
                "online": "Online",
                "directInvoicing": "Direktang pag-invoice"
            },
            "payoutPaymentStatusItem": {
                "paid": "Binayaran",
                "pending": "Nakabinbin"
            },
            "farmTypeItem": {
                "all": "Lahat",
                "farmIn": "Magsasaka sa",
                "farmOut": "Ilipat sa iba",
                "roaming": "Roaming",
                "affiliationOwner": "May-ari ng kaakibat",
                "farmInAndAffiliationOwner": "Farm in at kaakibat na may-ari",
                "farmOutAndAffiliationOwner": "Farm out at kaakibat na may-ari"
            },
            "settlementDriverTypeItem": {
                "all": "Lahat ng driver",
                "individual": "Company Car"
            },
            "shortTrip": {
                "all": "Lahat",
                "shortTrip": "Maikling biyahe",
                "nonShortTrip": "Hindi maikling biyahe"
            },
            "paymentMethodItem": {
                "B2BTerminal": "B2BTerminal",
                "webBooking": "Pagbu-book sa web",
                "pendingPayment": "Nakabinbing bayad",
                "all": "Lahat",
                "cash": "Pera",
                "cashBySender": "Cash ng nagpadala",
                "cashByRecipient": "Cash ng tatanggap",
                "personalCard": "Personal na card",
                "corporateCard": "Korporatibong card",
                "qrCodePayment": "Pagbabayad ng QR code",
                "directBilling": "Direktang pag-invoice",
                "externalCard": "Panlabas na card",
                "mDispatcherCard": "Card ng kasosyo",
                "corporatePrepaid": "Korporatibong prepaid",
                "canceled": "Kinansela",
                "noShow": "Walang Palabas",
                "driverNoShow": "Hindi dumating ang drayber",
                "incident": "Insidente",
                "fleetCard": "Panlabas na card",
                "applePay": "Apple Pay",
                "creditCardExternal": "Kard ng kredito",
                "paxWallet": "Pitaka",
                "tngeWallet": "TnG eWallet",
                "vippseWallet": "Vipps",
                "zainCash": "ZainCash",
                "xendit": "Xendit",
                "exAlipay": "Alipay",
                "FIB": "FIB",
                "SantimPay": "SantimPay",
                "gCash": "GCash",
                "completedWithoutService": "Nakumpleto nang walang driver",
                "BankOfGeorgia": "Bangko ng Georgia",
                "partialCompleted": "Bahagyang Nakumpleto",
                "failed": "Nabigo",
                "googlePay": "Google Pay",
                "paymentLink": "Link sa Pagbabayad",
                "easyPaisa": "Easy Paisa",
                "jazzCash": "Jazz Cash",
                "samsung_pay": "Samsung Pay",
                "kakao_pay": "Kakao Pay",
                "naver_pay": "Naver Pay",
                "wechat_pay": "WeChat Pay",
                "alipay": "Alipay",
                "paynow": "PayNow",
                "grabpay": "GrabPay",
                "cashapp": "Cash App Pay"
            },
            "paymentStatusItem": {
                "all": "Lahat",
                "fullPayment": "Buong bayad",
                "partialPayment": "Paunang bayad",
                "pendingPayment": "Nakabinbing bayad",
                "partialRefund": "Bahagyang refund",
                "fullRefund": "Buong refund"
            },
            "companySettlementTypeItem": {
                "all": "Lahat",
                "fleetOweCompany": "Fleet na may utang na kumpanya",
                "companyOweFleet": "Ang kumpanya ay may utang na armada"
            },
            "bookingStatusItem": {
                "all": "Lahat",
                "completed": "Nakumpleto",
                "incident": "Insidente",
                "paxNoShow": "Walang pasok si Pax",
                "driverNoShow": "Walang palabas ang driver",
                "rejected": "Tinanggihan",
                "canceledByTimeOut": "Kinansela ng timeout",
                "canceledByTimeOutRejected": "Kinansela ng timeout (tinanggihan)",
                "canceledByBookingBoard": "Kinansela ng booking board",
                "canceledByCustomer": "Kinansela ng customer",
                "canceledBySupplier": "Kinansela ng supplier"
            },
            "bookingFromItem": {
                "all": "Lahat",
                "paxApp": "Pax app",
                "mDispatcher": "Kasosyo",
                "kiosk": "Kiosk",
                "cc": "Sentro ng Utos",
                "webBooking": "Pagbu-book sa web",
                "carHailing": "Pagpapa-arkila ng sasakyan",
                "streetSharing": "pagbabahagi ng kalye",
                "dashboard": "Board ng reserbasyon",
                "corp": "Booking board (CTM)",
                "dmc": "Board ng Booking (DMC)",
                "Boost_web_link": "Pag-book ng boBoost web linkard"
            },
            "thirdPartyActionItem": {
                "all": "Lahat",
                "searched": "Hinanap",
                "allocated": "Inilaan",
                "updated": "Na-update",
                "cancelled": "Kinansela"
            },
            "bookingTypeItem": {
                "batchDelivery": "Batch Delivery",
                "all": "Lahat",
                "now": "Ngayon (Transport)",
                "reservation": "Pagpapareserba (Transportasyon)",
                "intercity": "Intercity",
                "delivery": "Paghahatid",
                "shuttle": "Shuttle"
            },
            "adjustPrices": {
                "all": "Lahat",
                "normalPrice": "Normal na presyo",
                "addonPrice": "Presyo ng addon"
            },
            "bookingServiceItem": {
                "all": "Lahat",
                "roaming": "Roaming",
                "homeFleet": "Ilipat sa iba",
                "localBooking": "Sa loob ng bahay",
                "farmIn": "Magsasaka sa",
                "farmInAndAffiliationOwner": "Farm in at may-ari ng kaakibat",
                "provideService": "Magsasaka sa"
            },
            "ratingTypeItem": {
                "all": "Lahat",
                "like": "Gaya ng",
                "dislike": "hindi gusto"
            },
            "starsItem": {
                "all": "Lahat",
                "star1": "1 Bituin",
                "star2": "2 Bituin",
                "star3": "3 Bituin",
                "star4": "4 Bituin",
                "star5": "5 Bituin"
            },
            "incidentCanceledTypes": {
                "all": "Lahat",
                "incident": "Insidente",
                "canceled": "Kinansela"
            },
            "canceledByItem": {
                "all": "Lahat",
                "CorpAD": "Admin ng Kumpanya",
                "passenger": "pasahero",
                "driver": "Driver",
                "merchant": "Mangangalakal",
                "CC": "CC",
                "mDispatcher": "Kasosyo",
                "Partner": "Kasosyo",
                "webBooking": "Pagbu-book sa web",
                "timeout": "Timeout"
            },
            "incidentStatusItem": {
                "RESOLVED": "Nakalutas",
                "DISPUTED": "Pinagtatalunan"
            },
            "bookingSummaryActionItem": {
                "all": "Lahat",
                "create": "Lumikha",
                "update": "Update",
                "cancel": "Kanselahin",
                "complete": "Kumpleto",
                "incident": "Insidente"
            },
            "transactionTypeItem": {
                "DriverFees": "Driver Fees",
                "bookingAdjustment": "Pag-aayos ng Booking",
                "bankAccount": "Inilipat sa bank account",
                "sentToCustomer": "Ipadala sa customer",
                "receivedFromDriver": "Natanggap mula sa driver",
                "sentToDriver": "Ipinadala sa driver",
                "creditWallet": "Inilipat sa credit wallet",
                "netEarning": "Net na Kita",
                "referralEarning": "Referral na Kita",
                "all": "Lahat",
                "topUp": "Magdagdag ng pondo",
                "editBalance": "I-edit ang balanse",
                "bookingDeduction": "Pagbawas sa booking",
                "bookingPromo": "Promosyon ng booking",
                "topUpGCash": "Mag-top up sa GCash",
                "cashWallet": "Cash wallet",
                "topUpMOLPay": "Mag-top up sa pamamagitan ng Razer Pay",
                "topUpQRIS": "Mag-top up gamit ang QRIS",
                "topUpZainCash": "Mag-top up sa pamamagitan ng ZainCash",
                "topUpXendit": "Magdagdag ng pondo sa pamamagitan ng Xendit",
                "topUpalipayExternal": "Mag-top up gamit ang Alipay",
                "topUpFIB": "Magdagdag ng pondo sa pamamagitan ng FIB",
                "topUpSantimPay": "Magdagdag ng pondo sa pamamagitan ng SantimPay",
                "topUpTelebirr": "Top up sa pamamagitan ng Telebirr",
                "topUpKsher": "Top up ni Ksher",
                "topUpWallet": "Top up ng {0}",
                "TnG": "Top up ng TnG",
                "credit": "Mag-top up gamit ang credit card",
                "ride": "Sumakay",
                "tipAfterCompleted": "Tip pagkatapos ng biyahe",
                "debtWriteOff": "Pagtanggal ng utang",
                "refund": "Refund",
                "excessOffsetAmount": "Labis na Cash Credit",
                "excessDeductionAmount": "Labis na Cash Debit",
                "cashExcess": "Labis na Cash Debit",
                "gateway": "Mag-top up mula sa gateway",
                "driverTopUpForPax": "Labis na Cash Debit",
                "updatedBalance": "Na-update na balanse",
                "partialEarning": "Kumita",
                "payout": "Bayad",
                "payoutManual": "Manual ng pagbabayad",
                "payoutDriver": "Bayad",
                "itemValue": "Mga halaga ng item",
                "redeemVoucher": "I-redeem ang code #",
                "topUpReferrer": "Gantimpala ng referral",
                "driverInsurance": "Insurance sa Pagmamaneho",
                "cancellationPenalty": "Parusa sa Pagkansela",
                "WingBank": "Mga paglilipat sa Wingbank account",
                "customerDebt": "Utang ng Customer",
                "googlePay": "Mag-top up sa pamamagitan ng Google Pay",
                "applePay": "Mag-top up sa pamamagitan ng Apple Pay",
                "samsung_pay": "Mag-top up gamit ang Samsung Pay",
                "kakao_pay": "Mag-top up gamit ang Kakao Pay",
                "naver_pay": "Mag-top up gamit ang Naver Pay",
                "wechat_pay": "Magdagdag ng pondo sa pamamagitan ng WeChat Pay",
                "alipay": "Magdagdag ng pondo sa pamamagitan ng Alipay",
                "paynow": "Mag-top up sa pamamagitan ng PayNow",
                "grabpay": "Mag-top up gamit ang GrabPay",
                "cashapp": "Magdagdag gamit ang Cash App Pay",
                "merchantCommission": "Komisyon ng mangangalakal",
                "eWallet": "Nilipat sa panlabas na e-wallet",
                "reversed": "Naibalik ang pag-withdraw",
                "driverNoShow": "Driver na hindi nagpakita",
                "noShowPenalty": "Driver na hindi nagpakita",
                "bookingEarning": "Netong Kita"
            },
            "moduleItem": {
                "all": "Lahat",
                "bookings": "Mga booking",
                "customers": "Mga customer",
                "dispatch": "Pagpapadala",
                "general": "Heneral",
                "promotion": "Promosyon",
                "quest": "Paghanap",
                "rate": "Rate",
                "car": "kotse",
                "city": "lungsod",
                "company": "kumpanya",
                "drivers": "Mga driver",
                "driverSettlement": "Pag-aayos ng driver",
                "login": "Mag log in",
                "logout": "Mag-logout",
                "mDispatcher": "Kasosyo",
                "mDispatcherType": "Uri ng kasosyo",
                "operation": "Operasyon",
                "partners": "Mga kasosyo",
                "permission": "Pahintulot",
                "queuingArea": "Lugar ng pila",
                "report": "Ulat",
                "shift": "Paglipat",
                "user": "Gumagamit",
                "voiceSms": "Boses at SMS",
                "intercityZone": "Sona (intercity)",
                "Payout": "Bayad",
                "code#": "Kodigo #",
                "ApiManagement": "Pamamahala ng API"
            },
            "serviceTypeItem": {
                "all": "Lahat",
                "oneWay": "Isang daanan",
                "fromAirport": "Mula sa airport",
                "toAirport": "Sa airport",
                "hourly": "Oras-oras/araw-araw",
                "roundTrip": "Papunta at pabalik",
                "fromAirportHourlyDaily": "Mula sa paliparan - oras-oras/araw-araw",
                "fromAirportRoundTrip": "Mula sa airport - round trip",
                "toAirportHourlyDaily": "Sa airport - oras-oras/araw-araw",
                "toAirportRoundTrip": "Papunta sa airport - round trip"
            },
            "merchantTransactionTypeItem": {
                "all": "Lahat",
                "editBalance": "I-edit ang balanse",
                "payout": "Bayad",
                "earning": "Kumita",
                "itemValue": "Halaga ng item",
                "orderDeduction": "Pagbawas ng order"
            },
            "withdrawalTransactionType": {
                "WingBank": "Inilipat sa Wingbank account",
                "bankAccount": "Inilipat sa bank account",
                "cashWallet": "Inilipat sa cash wallet",
                "creditWallet": "Inilipat sa credit wallet"
            },
            "payoutDriver": {
                "driversHaveBankAccount": "May bank account ang mga driver",
                "driversDontHaveBankAccount": "Walang bank account ang mga driver",
                "payoutEndTime": "Oras ng pagtatapos ng pagbabayad",
                "driverHaveInvalidBankAccount": "Ang mga driver ay may di-wastong bank account"
            },
            "payoutMerchant": {
                "HaveBankAccount": "May bank account ang mga merchant",
                "DontHaveBankAccount": "Walang bank account ang mga merchant",
                "HaveInvalidBankAccount": "May di-wastong bank account ang mga merchant",
                "payoutEndTime": "Oras ng pagtatapos ng pagbabayad"
            }
        },
        "error": {
            "23005": "Para sa pagganap ng system maaari mo lamang tingnan ang mga ulat sa %{interval} %{unitLabel}, mangyaring ayusin ang iyong hanay ng petsa"
        },
        "result": {
            "idPermitType": "Uri ng ID",
            "noResultFound": "Walang natagpuang resulta",
            "page": "Pahina",
            "itemsPerPage": "Mga item bawat pahina",
            "showPages": "Ipinapakita ang %{from} - %{to} ng %{total}",
            "exportToExcel": "I-export sa excel",
            "exportToCSV": "I-export sa csv",
            "exportToPaymentFile": "I-export sa file ng pagbabayad",
            "pay": "Magbayad",
            "paySelected": "Pinili ang bayad",
            "payAll": "Bayaran lahat",
            "invalidBankAccount": "Di-wastong bank account",
            "validBankAccount": "Wastong bank account",
            "bookingDetails": {
                "customerAdjustmentsFee": "Pag-aayos ng Customer",
                "supplierDriverAdjustmentsFee": "Pag-aayos ng Supplier/Driver",
                "supplierPayout": "Bayad sa supplier",
                "driverPayout": "Bayad sa drayber",
                "profit": "Kita",
                "successSendMessage": "ang iyong mensahe ay naipadala na",
                "packageName": "Pangalan ng package",
                "transactionId": "ID ng Transaksyon",
                "proofOfFailure": "Patunay ng Pagkabigo",
                "recipientsNumber": "Bilang ng tatanggap",
                "recipientsInfo": "Impormasyon ng tatanggap",
                "creditTransactionFee": "Mga bayarin sa credit card",
                "carTypeRequest": "Hiniling na cartype",
                "bookingId": "# ng booking",
                "bookingStatus": "Katayuan ng booking",
                "tripId": "# ng biyahe",
                "bookFrom": "Pagbu-book mula sa",
                "bookingService": "Uri ng network",
                "bookingType": "Uri ng booking",
                "serviceType": "Uri ng serbisyo",
                "operator": "Operator",
                "customerPhone": "Numero ng telepono ng pasahero",
                "customerName": "Pangalan ng pasahero",
                "customerIdNumber": "Passenger ID# / IC#",
                "corpDivision": "Dibisyon",
                "corpDept": "Dept",
                "chargeCode": "Code ng pagsingil",
                "tripDescription": "Paglalarawan ng biyahe",
                "rideSharing": "Pagbabahagi ng Sakay",
                "queueName": "Lugar ng pila",
                "bookingTime": "Oras ng paglikha",
                "pickupTime": "Oras ng pagkuha",
                "expectedPickupTime": "Inaasahang Oras ng Pagkuha",
                "dispatchTime": "oras ng pag aalis",
                "onBoardTime": "Oras ng sakay",
                "droppedOffTime": "Oras ng pagbaba",
                "onBoardDuration": "Ang tagal ng sakay",
                "dispatch": "Paghahatid #",
                "completedTime": "Nakumpletong Oras",
                "driverName": "Pangalan ng driver",
                "driverIdPermit": "ID# / Pambansang IC#",
                "driverLicenseNumber": "Numero ng lisensya sa pagmamaneho",
                "companyName": "kumpanya",
                "carType": "Uri ng kotse",
                "licensePlate": "Plaka ng sasakyan",
                "intercityRoute": "Intercity na ruta",
                "pickupLocation": "Lokasyon ng pickup",
                "geoPickup": "Ang lokasyon ng pickup ay lat/mahaba",
                "extraDestination": "Mga karagdagang destinasyon",
                "originDestination": "Orihinal na destinasyon",
                "originEstDistance": "Orihinal na tinatayang distansya",
                "destination": "Tunay na destinasyon",
                "geoDestination": "Aktwal na destinasyon lat/long",
                "pickupFrom": "Lokasyon ng pickup mula sa",
                "distanceTour": "distansya ng P.O.B",
                "internalNotes": "Panloob na mga tala",
                "notes": "Mga Tala",
                "basicFareCalculator": "Pangunahing calculator ng pamasahe",
                "basicFare": "Pangunahing pamasahe",
                "editFare": "I-edit ang pangunahing pamasahe",
                "oldBasicFare": "Lumang pangunahing pamasahe",
                "airportFee": "Bayad sa paliparan",
                "meetDriver": "Kilalanin ang driver",
                "rushHour": "Patong na singil",
                "surchargeParameter": "Dynamic na surcharge",
                "dynamicFare": "Dynamic na pamasahe",
                "heavyTraffic": "Matinding trapiko",
                "tollFee": "Bayad daan",
                "parkingFee": "Bayad sa paradahan",
                "gasFee": "Bayad sa gas",
                "otherFees": "Iba pang bayad",
                "subtotal": "Subtotal",
                "subTotalFF": "Subtotal na FF",
                "techFee": "bayad sa tech",
                "serviceFee": "Karagdagang serbisyo",
                "fleetServiceFee": "Mga serbisyo ng fleet",
                "bookingFee": "Bayad sa pagpapareserba",
                "salesTax": "Buwis sa pagbebenta",
                "tipAmt": "Tip halaga",
                "promoCode": "Promo code",
                "promoAmt": "Promo halaga",
                "requestedTotalAmount": "OTA Price",
                "total": "Kabuuang amt",
                "totalNotRounded": "ROUND (Kabuuang amt)",
                "actualReceived": "Aktwal na natanggap",
                "differenceAmt": "Pagkakaiba (natanggap)",
                "customerDebt": "Utang ng Customer",
                "markupDifference": "Pagkakaiba ng markup",
                "receivedWhenDropOff": "Natanggap kapag bumaba",
                "refundAmount": "Halaga ng refund",
                "requestedPaymentMethod": "Hiniling na paraan ng pagbabayad",
                "paidBy": "Binayaran ni",
                "splitPayment": "Hati sa bayad",
                "paidByWallet": "Binayaran ng wallet",
                "paidByOtherMethod": "Binabayaran ng ibang paraan",
                "cashReceived": "Natanggap ang cash",
                "transferredChangeByWallet": "Maglipat ng pagbabago sa pamamagitan ng wallet",
                "returnedChangeByCash": "Ibalik ang pagbabago sa pamamagitan ng cash",
                "instructions": "Mga tagubilin",
                "additionalServiceName": "Pangalan",
                "additionalServiceValue": "Halaga",
                "sendReceiptHeader": "Header",
                "sendReceipt": "Magpadala ng resibo",
                "send": "Ipadala",
                "cancel": "Kanselahin",
                "sentReceiptSuccess": "Matagumpay na naipadala ang resibo",
                "sentReceiptFailed": "Ang resibo ay hindi maipadala sa ngayon. Pakisubukang muli.",
                "coRider": "Kasama sa pagsakay",
                "coriderName": "Pangalan",
                "stopAddress": "Karagdagang destinasyon",
                "stopGeo": "Lat/long",
                "addonPrice": "Customer ayusin ang presyo",
                "oldSubTotal": "Subtotal bago ayusin",
                "view_good_receipt": "Resibo ng mga kalakal",
                "view_delivery_receipt": "Larawan ng paghahatid",
                "view": "Tingnan",
                "tipAfterCompletedDetails": "Inilipat: {0}{1}; Bayad sa transaksyon: {0}{2}",
                "fleetMarkup": "Kita",
                "editedDriverEarning": "Na-edit na kita ng driver",
                "driverEarning": "Kumita ng driver",
                "supplierAmount": "Kita ng supplier",
                "currencyISO": "Salapi",
                "pickUpZoneName": "Lugar ng pickup",
                "dynamicFactor": "Dinamiko na pamasahe (salik)",
                "supplierEarning": "Kita ng supplier",
                "passengerName": "Pangalan ng pasahero",
                "totalPayout": "Kabuuang bayad",
                "numberOfTrips": "Bilang ng mga biyahe",
                "psgLocation": "Lokasyon ng pasahero (lat/long)",
                "psgIp": "IP ng Pasahero",
                "DeviceImei": "Device IMEI",
                "otaDiscount": 'OTA Discount',
            },
            "financial": {
                "supplierPayout": "Bayad sa supplier",
                "driverPayout": "Bayad sa driver",
                "profit": "Kita",
                "currencyISO": "Salapi",
                "supplierAmount": "Kita ng supplier",
                "driverEarning": "Kita ng drayber",
                "supplierEarning": "Kita ng supplier",
                "passengerName": "Pangalan ng pasahero",
                "totalPayout": "Kabuuang bayad",
                "numberOfTrips": "Bilang ng mga biyahe",
                "driverName": "Pangalan ng driver",
                "driverPhone": "Numero ng telepono",
                "driverUserName": "Username",
                "companyName": "kumpanya",
                "bookingList": "Listahan ng booking",
                "totalFare": "Kabuuang pamasahe na walang promo",
                "netEarning": "Net na kita",
                "showBookingList": "Ipakita",
                "referralEarning": "Kumita ng referral",
                "totalEarningNet": "Kabuuang kita (net)",
                "totalEarningNetTooltip": "Pera na kinita mo pagkatapos ibalik ang lahat ng bayarin sa fleet. Kabuuang kita (net) = Net na kita + Tip pagkatapos ng biyahe",
                "totalEarningNetTooltipRefferal": "Pera na kinita mo pagkatapos ibalik ang lahat ng bayarin sa fleet. Kabuuang kita (net) = Referal na kita + Net na kita + Tip pagkatapos ng biyahe",
                "totalEarningGross": "Kabuuang kita (gross)",
                "totalEarning": "Kabuuang kita",
                "totalEarningGrossTooltip": "Pera na kinita mo mula sa pag-book ng pamasahe at mga tip. Kabuuang kita (gross) = Gross na kita + Tip pagkatapos ng biyahe",
                "totalEarningGrossTooltipRefferal": "Pera na kinita mo sa pag-book ng pamasahe at tip. Kabuuang kita (gross) = Referal na kita + Gross na kita + Tip pagkatapos ng biyahe",
                "note": "Tandaan",
                "shortTrip": "Maikling biyahe",
                "deduction": "Pagbawas",
                "totalDriverEarning": "Kabuuang kita ng drayber",
                "totalDriverEarningTooltip": "Kabilang ang mga booking na may parehong online at offline na pagbabayad",
                "totalDriverPayout": "Kabuuang bayad sa drayber",
                "totalDriverPayoutTooltip": "Hindi kasama ang mga booking na may cash o offline na pagbabayad."
            },
            "financialDriver": {
                "supplierAmount": "Komisyon ng supplier",
                "payoutType": "Uri ng pagbabayad",
                "date": "Petsa",
                "driverTipAfterCompleted": "Tip pagkatapos ng biyahe",
                "bookingId": "Booking ID",
                "paidBy": "Binayaran ni",
                "bookFrom": "Pagbu-book mula sa",
                "bookingType": "Uri ng booking",
                "companyName": "kumpanya",
                "driverName": "Driver",
                "driverIdPermit": "ID# / Pambansang IC#",
                "totalFare": "Kabuuang pamasahe nang walang promo",
                "subtotal": "Subtotal",
                "airportFee": "Bayad sa paliparan",
                "meetDriver": "Kilalanin ang driver",
                "tollFee": "Bayad sa toll",
                "parkingFee": "Bayad sa paradahan",
                "gasFee": "Bayad sa gas",
                "rushHour": "Oras ng rush",
                "transactionFee": "Bayad sa transaksyon",
                "techFee": "bayad sa tech",
                "salesTax": "Buwis sa pagbebenta",
                "tipAmt": "Tip halaga",
                "bookingFee": "Bayad sa pagpapareserba",
                "commission": "Komisyon",
                "deduction": "Pagbawas",
                "promoAmt": "Promo amt",
                "ridePayment": "Pagbabayad sa pagsakay",
                "driverTax": "Buwis sa pagmamaneho",
                "grossEarning": "Kabuuang kita",
                "driverDeduction": "Pagbawas ng driver",
                "netEarning": "Net na Kita",
                "payToDriver": "Magbayad sa driver",
                "payToFleet": "Magbayad sa fleet",
                "totalNotRounded": "ROUND (Kabuuang amt)",
                "fleetServiceFee": "Mga bayarin sa serbisyo ng fleet",
                "editedDriverEarning": "Na-edit na kita ng driver",
                "stripeFee": "Bayad ng Stripe",
                "currencyISO": "Salapi"
            },
            "financialCompany": {
                "companyName": "kumpanya",
                "homeFleetNetEarning": "Home fleet Net Kita",
                "affiliateNetEarning": "Affiliate Net Kita",
                "totalNetEarning": "Total Driver Net Kita",
                "status": "Katayuan",
                "companyAmount": "Kita ng kumpanya",
                "numberOfTrips": "Bilang ng mga biyahe"
            },
            "companySettlement": {
                "companyName": "kumpanya",
                "pendingSettlement": "Nakabinbing settlement",
                "viewDetails": "Tingnan ang mga detalye",
                "settlementType": "Uri"
            },
            "companySettlementDetails": {
                "bookId": "Booking ID",
                "dateTime": "Oras ng petsa",
                "originalPaymentStatus": "Katayuan ng orihinal na pagbabayad",
                "subTotal": "Subtotal",
                "fleetAmount": "Dami ng fleet",
                "driverAmount": "Ang dami ng driver",
                "companyAmount": "Ang halaga ng kumpanya",
                "companyOweFleet": "Ang kumpanya ay may utang na armada",
                "fleetOweCompany": "Fleet na may utang na kumpanya",
                "notes": "Mga Tala"
            },
            "financialProfit": {
                "profit": "Kita",
                "bookingId": "# ng booking",
                "subTotal": "Subtotal",
                "subTotalFF": "Subtotal na FF",
                "fleetCommission": "Komisyon ng fleet",
                "techFee": "bayad sa tech",
                "promotion": "Promosyon",
                "markupDifference": "Pagkakaiba ng markup",
                "Profit": "Kita",
                "currency": "Pera",
                "fleetServiceFee": "Serbisyo ng fleet (fleet take)",
                "fleetServiceFeeTooltip": "Ang halaga ng fleet ay kumukuha ng komisyon mula sa mga bayarin sa serbisyo"
            },
            "promotion": {
                "date": "Petsa",
                "promoCode": "Promo code",
                "users": "Mga gumagamit",
                "uses": "Mga gamit",
                "checked": "Sinuri",
                "applied": "Inilapat",
                "totalPromoAmount": "Kabuuang halaga ng promo",
                "totalReceipt": "Kabuuang resibo",
                "numberOfUsers": "Bilang ng mga gumagamit",
                "numberOfPromoCodeAppliance": "Bilang ng promo code appliance",
                "numberOfSuccessfulBookings": "Bilang ng mga matagumpay na booking",
                "numberOfCompletedBookings": "Bilang ng mga nakumpletong booking",
                "numberOfCompletedUsers": "Bilang ng mga nakumpletong user",
                "numberOfUsersApplyPromotion": "Bilang ng mga gumagamit na nag-aplay ng promosyon",
                "numberOfUsersApplyPromotionAndCompleteBooking": "Bilang ng mga user na nag-apply ng promosyon at kumpletong booking",
                "numberOfPromoCodeApplianceTooltip": "Bilang ng promo code appliance ng lahat ng user",
                "numberOfSuccessfulBookingsTooltip": "Bilang ng mga booking na matagumpay na nagawa gamit ang promotion code",
                "numberOfCompletedBookingsTooltip": "Bilang ng mga nakumpletong booking na naglapat ng promotion code"
            },
            "export": {
                "createdDate": "Petsa",
                "sessionName": "Pangalan ng Sesyon",
                "download": "I-download",
                "delete": "Tanggalin",
                "percent": "Porsiyento",
                "status": "Katayuan",
                "name": "Pangalan ng module"
            },
            "redeemed": {
                "date": "Petsa",
                "code": "Code",
                "customers": "Mga customer",
                "phone": "Numero ng telepono",
                "value": "Halaga",
                "currency": "Pera",
                "campaignName": "Kampanya"
            },
            "carActivity": {
                "plateNumber": "plaka ng sasakyan",
                "vehicleType": "Uri ng kotse",
                "companyName": "kumpanya",
                "day1st": "ika-1",
                "day2nd": "ikalawa",
                "day3rd": "ika-3",
                "day4th": "ika-4",
                "day5th": "ika-5",
                "day6th": "ika-6",
                "day7th": "ika-7",
                "day8th": "ika-8",
                "day9th": "ika-9",
                "day10th": "ika-10",
                "day11th": "ika-11",
                "day12th": "ika-12",
                "day13th": "ika-13",
                "day14th": "ika-14",
                "day15th": "ika-15",
                "day16th": "ika-16",
                "day17th": "ika-17",
                "day18th": "ika-18",
                "day19th": "ika-19",
                "day20th": "ika-20",
                "day21st": "ika-21",
                "day22nd": "ikalawang pu't dalawa",
                "day23rd": "ika-23",
                "day24th": "ika-24",
                "day25th": "ika-25",
                "day26th": "ika-26",
                "day27th": "ika-27",
                "day28th": "ika-28",
                "day29th": "ika-29",
                "day30th": "ika-30",
                "day31st": "ika-31",
                "operationDays": "Mga araw ng operasyon",
                "activeCars": "Kabuuang aktibong sasakyan:"
            },
            "carActivityLogsTitle": "Mga log",
            "carActivityLogs": {
                "licensePlate": "Plaka ng sasakyan",
                "companyName": "kumpanya",
                "bookingId": "Booking ID",
                "driverName": "Pangalan ng driver",
                "driverIDNumber": "ID# / Pambansang IC#",
                "date": "Tinanggap na oras",
                "bookFrom": "Pagbu-book mula sa"
            },
            "affiliation": {
                "date": "Oras ng pagkuha",
                "bookingId": "Booking ID",
                "bookingType": "Uri ng booking",
                "homeFleet": "Pangunahing hukbo",
                "providerFleet": "Fleet ng provider",
                "driver": "Driver",
                "passenger": "pasahero",
                "paidBy": "Binayaran ni",
                "airportFee": "Bayad sa paliparan",
                "meetDriver": "Kilalanin ang driver",
                "rushHour": "Patong na singil",
                "tollFee": "Bayad sa toll",
                "parkingFee": "Bayad sa paradahan",
                "gasFee": "Bayad sa gas",
                "heavyTraffic": "Matinding trapiko",
                "otherFees": "Iba pang bayad",
                "provider": "Tagapagtustos",
                "basicFareProvider": "Tagapagbigay ng batayang taripa",
                "subTotalProvider": "Sub kabuuang provider",
                "techFeeProvider": "Tagabigay ng bayad sa teknolohiya",
                "bookingFeeProvider": "Tagabigay ng bayad sa booking",
                "taxValueProvider": "Tagabigay ng halaga ng buwis",
                "tipProvider": "Tagabigay ng tip",
                "totalFareProvider": "Kabuuang tagapagbigay ng pamasahe",
                "basicFare": "Pangunahing pamasahe",
                "subtotal": "Subtotal",
                "techFee": "bayad sa tech",
                "bookingFee": "Bayad sa pagpapareserba",
                "tax": "Buwis",
                "tip": "Tip",
                "totalFare": "Kabuuang pamasahe",
                "payoutInLocalCurrency": "Sumakay sa kita sa lokal na pera",
                "payoutInUSD": "Kumita ng ride sa USD",
                "fleetCommInUSD": "Fleet comm sa USD",
                "bookingFeeInUSD": "Bayad sa booking sa USD",
                "totalPayoutInUSD": "Kabuuang payout sa USD",
                "subTotal": "Subtotal",
                "bookingStatus": "Katayuan ng booking",
                "vehicle": "Sasakyan",
                "customerPhone": "Numero ng telepono ng customer",
                "driverPhone": "Numero ng telepono ng driver",
                "total": "Kabuuan",
                "totalInUSD": "Kabuuang pamasahe (USD)",
                "supplierPayout": "Pagbabayad ng supplier",
                "supplierPayoutInUSD": "Payout ng supplier (USD)",
                "buyerPayout": "Komisyon ng mamimili",
                "buyerPayoutInUSD": "Komisyon (USD)",
                "buyerCommission": "Komisyon",
                "buyerCommissionInUSD": "Komisyon (USD)",
                "receivableInUSD": "Matatanggap (USD)",
                "payableInUSD": "Bayarin (USD)",
                "fleetMarkupInUSD": "Kita (USD)",
                "paymentMethod": "Paraan ng Pagbayad",
                "paymentStatus": "Katayuan ng pagbabayad"
            },
            "prepaidTopUp": {
                "date": "Petsa at oras",
                "topUpId": "Magdagdag ng pondo sa ID",
                "transactionId": "ID ng Transaksyon",
                "name": "Pangalan",
                "company": "kumpanya",
                "paidBy": "Binayaran ni",
                "amount": "Halaga",
                "newAmount": "Bagong balanse",
                "transactionType": "Uri ng transaksyon"
            },
            "operatorLogs": {
                "date": "Petsa",
                "operator": "Operator",
                "username": "Username",
                "module": "Modul",
                "description": "Paglalarawan"
            },
            "corporate": {
                "date": "Petsa",
                "bookingId": "Booking ID",
                "operatorName": "Operator ng korporasyon",
                "corporateName": "kumpanya",
                "corpTraveler": "Mga Gumagamit ng Corp",
                "travelerSignature": "Lagda ng manlalakbay",
                "corpId": "Korporasyon id",
                "corpDivision": "Dibisyon ng korporasyon",
                "costCentre": "Sentro ng gastos",
                "corpPO": "Corp PO",
                "managerName": "Pangalan ng manager",
                "managerEmail": "Email ng manager",
                "title": "Pamagat",
                "department": "Kagawaran",
                "clientCaseMatter": "Usapin sa kaso ng kliyente / Paglalarawan ng biyahe",
                "chargeCode": "Code ng singil / Code ng biyahe",
                "driverName": "Driver",
                "pickupLocation": "Lokasyon ng pickup",
                "destination": "Patutunguhan",
                "total": "Kabuuang amt",
                "subtotal": "Subtotal",
                "subTotalFF": "Subtotal FF",
                "commission": "Komisyon",
                "commissionBooking": "Mag-apply ng komisyon para sa mga booking mula sa app/pwa",
                "paidBy": "Binayaran ni",
                "statusDisplay": "Katayuan",
                "flightNumber": "Numero ng flight"
            },
            "bookingLogs": {
                "bookingId": "Booking ID",
                "bookingService": "Uri ng network",
                "bookingType": "Uri ng booking",
                "driverName": "Driver",
                "driverIdPermit": "ID# / Pambansang IC#",
                "customerName": "pasahero",
                "pickupTime": "Oras ng pagkuha",
                "onBoardTime": "Oras ng sakay",
                "droppedOffTime": "Oras ng pagbaba",
                "pickupLocation": "Lokasyon ng pickup",
                "destination": "Patutunguhan",
                "dispatchHistory": "Kasaysayan ng pagpapadala",
                "otwDistance": "O.T.W ang layo",
                "distanceTour": "distansya ng P.O.B",
                "duration": "Ang tagal ng P.O.B",
                "paidBy": "Binayaran ni",
                "bookFrom": "Pagbu-book Mula sa",
                "map": "Mapa",
                "showDispatchHistory": "Ipakita",
                "showMap": "Ipakita",
                "paymentActivities": "Mga aktibidad sa pagbabayad"
            },
            "rating": {
                "date": "Petsa",
                "bookingId": "Booking ID",
                "driverName": "Driver",
                "driverIdPermit": "ID# / Pambansang IC#",
                "customerName": "Pangalan ng Customer",
                "customerPhone": "Telepono ng customer",
                "like": "Gaya ng",
                "dislike": "hindi gusto",
                "notes": "Magkomento",
                "stars": "Marka",
                "vehicleRating": "Rating ng Sasakyan",
                "driverRating": "Rating ng Driver",
                "plateNumber": "Numero ng Plaka"
            },
            "mDispatcher": {
                "date": "Petsa",
                "bookingId": "Booking ID",
                "mDispatcherName": "Pangalan ng kasosyo",
                "mDispatcherType": "Uri ng kasosyo",
                "subtotal": "Subtotal",
                "commission": "Komisyon",
                "paidBy": "Binayaran ni"
            },
            "totalAdjustment": {
                "date": "Petsa",
                "bookingId": "Booking ID",
                "oldAmount": "Kabuuan",
                "type": "Uri",
                "markupDifference": "Pagkakaiba ng markup",
                "newAmount": "Na-edit ang kabuuan/Markup",
                "username": "Operator",
                "reason": "Dahilan"
            },
            "incidentCancellation": {
                "date": "Petsa",
                "bookingId": "Booking ID",
                "customerName": "Pangalan ng Customer",
                "customerPhone": "Telepono ng customer",
                "bookFrom": "Pagbu-book mula sa",
                "canceledBy": "Kinansela ni",
                "type": "Uri",
                "reason": "Dahilan",
                "reasonCode": {
                    "0": "Nakahanap ako ng isa pang opsyon sa paglalakbay",
                    "1": "Masyadong malayo ang driver",
                    "2": "Maling lokasyon ang pinasok ko",
                    "3": "Naghintay ako ng sobrang tagal",
                    "4": "Hiniling ng driver na kanselahin",
                    "5": "Binago ko ang aking mga plano",
                    "6": "Nais kong magpalit ng lokasyon",
                    "101": "Karamihan o lahat ng mga item ay hindi magagamit",
                    "102": "Masyado kaming abala ngayon",
                    "103": "Sarado na kami ngayon",
                    "104": "Malapit na kaming magsara"
                },
                "canceller": "Tagapagpawalang-bisa",
                "incidentStatus": "Katayuan ng insidente"
            },
            "acceptanceCancellationRate": {
                "companyId": "Company Id",
                "driverId": "Driver Id",
                "driverName": "Pangalan ng driver",
                "phoneNumber": "Numero ng telepono",
                "company": "kumpanya",
                "acceptanceRate": "Rate ng pagtanggap",
                "cancellationRate": "Rate ng pagkansela",
                "rating": "Marka"
            },
            "revenueFleet": {
                "date": "Petsa",
                "fareRevenue": "Kita sa pamasahe",
                "trip": "Biyahe",
                "avgFareTrip": "Avg na pamasahe/biyahe",
                "drivers": "# Mga driver",
                "avgTripPerDriver": "Avg na biyahe/driver",
                "dispatcher": "# Tagapaghatid"
            },
            "revenueDriver": {
                "date": "Petsa",
                "driverName": "Driver",
                "fareRevenue": "Kita sa pamasahe",
                "trip": "# Biyahe",
                "avgFareTrip": "Avg na pamasahe/biyahe"
            },
            "revenueMonthly": {
                "month": "buwan",
                "trip": "Tapos na mga biyahe",
                "subtotal": "Subtotal",
                "tipAmt": "Tip",
                "techFee": "bayad sa tech",
                "salesTax": "Buwis",
                "partnerCommission": "Komisyon ng kasosyo/ ODD",
                "totalFare": "Kabuuang pamasahe nang walang promo",
                "netEarning": "Net na Kita",
                "fleetServiceFee": "Mga bayarin sa serbisyo ng fleet"
            },
            "dailyDriver": {
                "driverName": "Driver",
                "driverIDPermit": "ID# / Pambansang IC#",
                "driverPhone": "Telepono",
                "companyName": "kumpanya",
                "workingHoursOnline": "Online (oras)",
                "workingHoursAvailable": "Available (oras)",
                "driverWorkingHours": "Oras ng trabaho ng driver",
                "distance": "Layo ng nilakbay ng driver",
                "CC_activity": "Aktibidad ng CC",
                "fare_summary": "Aktibidad ng CC",
                "workingHoursNotAvailable": "Hindi available (mga oras)",
                "workingHoursPob": "P.O.B (mga oras)",
                "workingHoursPobToolTip": "Tagal ng sakay ng pasahero",
                "workingHoursAccepted": "Tinatanggap",
                "workingHoursReject": "Tanggihan",
                "workingHoursIgnore": "Huwag pansinin",
                "workingHoursCancel": "Kanselahin",
                "completedTripsTotal": "Kabuuan",
                "completedTripsCc": "Mula sa CC",
                "completedTripsCarHailing": "Mula sa car-hailing",
                "completedTripsStreetSharing": "Mula sa Street Sharing",
                "completedTripsPaxApp": "Mula sa pax app",
                "completedTripsWebBooking": "Mula sa web booking",
                "completedTripsMDispatcher": "Mula sa partner",
                "completedTripsKiosk": "Mula sa Kiosk",
                "completedTripsApi": "Mula sa API",
                "ccActivityDispatchedTrips": "Mga pinadalang biyahe",
                "ccActivityAccepted": "Tinanggap",
                "ccActivityReject": "Tanggihan",
                "ccActivityIgnore": "Huwag pansinin",
                "ccActivityCancelByPassenger": "Kinansela ng pasahero",
                "ccActivityCancelByDriver": "Kinansela ng driver",
                "ccActivityCancelByCc": "Kinansela ni CC",
                "ccActivityCancelByAPI": "Kinansela ng API",
                "ccActivityNoShow": "Walang Palabas",
                "fareSummaryTotalCash": "Salapi",
                "fareSummaryTotalCreditCard": "Kard ng kredito",
                "fareSummaryTotalExternalCard": "Panlabas na card",
                "fareSummaryTotalPaxWallet": "Pitaka",
                "fareSummaryTotalDirectBilling": "Drect na pag-invoice",
                "fareSummaryTotalQrCode": "QR code",
                "fareSummaryTotalPrePaid": "Corporate Prepaid",
                "fareSummaryTotalApplePay": "Apple Pay",
                "fareSummaryTotalTngeWallet": "TNG eWallet",
                "fareSummaryTotalVippseWallet": "Vipps",
                "fareSummaryTotal": "Kabuuan",
                "ratingNotes": "Bilang ng mga tala",
                "ratingDislike": "Bilang ng Hindi gusto",
                "ratingLike": "Bilang ng gusto",
                "fareDetailsBasicFare": "Pangunahing pamasahe",
                "fareDetailsAirportFee": "Bayad sa paliparan",
                "fareDetailsRushHour": "Patong na singil",
                "fareDetailsHeavyTraffic": "Matinding trapiko",
                "fareDetailsOtherFees": "Iba pang bayad",
                "fareDetailsSubTotal": "Subtotal",
                "fareDetailsSubTotalFF": "Subtotal FF",
                "fareDetailsTechFee": "bayad sa tech",
                "fareDetailsBookingFee": "Bayad sa pagpapareserba",
                "fareDetailsSalesTax": "Buwis sa pagbebenta",
                "fareDetailsTip": "Halaga ng tip",
                "fareDetailsPromoAmount": "Promo amt",
                "fareDetailsTotalAmt": "Kabuuang amt",
                "availableDistance": "Magagamit",
                "otwDistance": "O.T.W",
                "otwDistanceToolTip": "Sa layo ng daan",
                "pobDistance": "P.O.B",
                "pobDistanceToolTip": "Distansya ng pasahero sa board",
                "ratingStars1": "No. 1 bituin",
                "ratingStars2": "No. 2 bituin",
                "ratingStars3": "No. 3 bituin",
                "ratingStars4": "No. 4 na bituin",
                "ratingStars5": "No. 5 na bituin",
                "ratingAvg": "Katamtaman",
                "ssnNumber": "SSN #",
                "driverEmail": "Email address",
                "driverAddress": "Address ng bahay",
                "fareDetailsAddonPrice": "Customer ayusin ang presyo",
                "fareDetailsOldSubTotal": "Subtotal bago ayusin"
            },
            "dailyCar": {
                "carInfo": "Impormasyon ng sasakyan",
                "fareDetails": "Mga detalye ng pamasahe",
                "completedTrips": "Mga nakumpletong biyahe",
                "carInfoCompanyName": "kumpanya",
                "carInfoPermission": "Pahintulot",
                "carInfoVehiclePlateNumber": "Plaka ng sasakyan",
                "carInfoVhcId": "# ng sasakyan",
                "carInfoCarType": "Uri ng kotse",
                "completedTripsTotal": "Kabuuan",
                "completedTripsCc": "Mula sa CC",
                "completedTripsCarHailing": "Mula sa car-hailing",
                "completedTripsStreetSharing": "Mula sa Street Sharing",
                "completedTripsPaxApp": "Mula sa pax app",
                "completedTripsWebBooking": "Mula sa web booking",
                "completedTripsMDispatcher": "Mula sa partner",
                "completedTripsKiosk": "Mula sa Kiosk",
                "completedTripsAPI": "Mula sa API",
                "fareDetailsBasicFare": "Pangunahing pamasahe",
                "fareDetailsAirportFee": "Bayad sa paliparan",
                "fareDetailsMeetDriver": "Kilalanin ang driver",
                "fareDetailsRushHour": "Patong na singil",
                "fareDetailsHeavyTraffic": "Matinding trapiko",
                "fareDetailsTollFee": "Bayad sa toll",
                "fareDetailsParkingFee": "Bayad sa paradahan",
                "fareDetailsGasFee": "Bayad sa gas",
                "fareDetailsOtherFees": "Iba pang bayad",
                "fareDetailsSubTotal": "Subtotal",
                "fareDetailsSubTotalFF": "Subtotal FF",
                "fareDetailsTechFee": "bayad sa tech",
                "fareDetailsBookingFee": "Bayad sa pagpapareserba",
                "fareDetailsSalesTax": "Buwis sa pagbebenta",
                "fareDetailsTip": "Tip",
                "fareDetailsPromoAmount": "halaga ng promo",
                "fareDetailsTotalAmt": "Kabuuang amt",
                "fareDetailsAddonPrice": "Customer ayusin ang presyo",
                "fareDetailsOldSubTotal": "Subtotal bago ayusin"
            },
            "dailyDriverCar": {
                "driverInfo": "Impormasyon ng driver",
                "driverName": "Pangalan ng driver",
                "driverIDPermit": "ID# / Pambansang IC#",
                "driverPhone": "Numero ng telepono",
                "companyName": "kumpanya",
                "actionInfo": "Mga aksyon",
                "date": "Petsa",
                "action": "Aksyon",
                "bookingId": "Booking ID",
                "carInfo": "Impormasyon ng sasakyan",
                "permission": "Pahintulot",
                "licensePlate": "Plaka ng sasakyan",
                "carId": "# ng sasakyan",
                "carType": "Uri ng kotse"
            },
            "driverLoginStatus": {
                "driver": "Driver",
                "driverIdPermit": "ID# / Pambansang IC#",
                "phone": "Numero ng telepono",
                "username": "Username",
                "company": "kumpanya",
                "carType": "Uri ng kotse",
                "licensePlate": "Plaka",
                "status": "Katayuan"
            },
            "bookingSummary": {
                "date": "Petsa",
                "operator": "Operator",
                "username": "Username",
                "action": "Aksyon",
                "bookingId": "Booking ID"
            },
            "cashWallet": {
                "bankAccount": "Inilipat sa bank account",
                "creditWallet": "Inilipat sa credit wallet",
                "tipAfterCompleted": "Tip Pagkatapos Nakumpleto",
                "netEarning": "Net na Kita",
                "referralEarning": "Referral na Kita",
                "receiverAccount": "Receiver Account",
                "dateAndTime": "Petsa at oras",
                "driverName": "Pangalan ng driver",
                "phoneNumber": "Numero ng telepono",
                "userName": "Username",
                "company": "kumpanya",
                "type": "Uri",
                "bookingId": "# ng booking",
                "operator": "Operator",
                "reason": "Dahilan",
                "amount": "Halaga",
                "newAmount": "Bagong balanse",
                "currency": "Pera",
                "topUpGCashReason": "Top up sa Gcash",
                "topUpReason": "Mag-top up mula sa credit card *{0}",
                "cashWalletReason": "Mag-top up mula sa Cash Wallet",
                "topUpMOLPayReason": "Razer Pay [ {0} ]",
                "chargedAmount": "halaga ng singil",
                "differentPercent": "Diskwento / Dagdag na singil (%)",
                "operatorName": "Operator",
                "sendPayout": "Aksyon",
                "sendPayoutTitle": "Muling ipadala ang email ng payout",
                "payoutReason": "{0} (Bayad {1} {2})"
            },
            "creditWallet": {
                "receiverType": "Uri ng Tatanggap",
                "receiverName": "Pangalan ng Makatatanggap",
                "receiverPhone": "Numero ng telepono ng tatanggap",
                "senderPhone": "Numero ng telepono ng nagpadala",
                "senderName": "Pangalan ng nagpadala",
                "sentToCustomer": "Ipadala sa customer",
                "sentToDriver": "Ipadala sa driver",
                "dateAndTime": "Petsa at oras",
                "driverName": "Pangalan ng driver",
                "phoneNumber": "Numero ng telepono",
                "userName": "Username",
                "company": "kumpanya",
                "type": "Uri",
                "bookingId": "# ng booking",
                "operator": "Operator",
                "reason": "Dahilan",
                "amount": "Halaga",
                "newAmount": "Bagong balanse",
                "currency": "Pera",
                "transactionId": "ID ng Transaksyon",
                "topUpGCashReason": "Top up sa Gcash",
                "topUpReason": "Mag-top up mula sa credit card *{0}",
                "cashWalletReason": "Mag-top up mula sa Cash Wallet",
                "topUpMOLPayReason": "Razer Pay [ {0} ]",
                "topUpWalletReason": "{0} [ {1} ]",
                "chargedAmount": "halaga ng singil",
                "differentPercent": "Diskwento / Dagdag na singil (%)",
                "cashExcessReason": "Dapat magbayad ang customer ng {0}; Natanggap ang pera {1}",
                "referralEarningReason": "Nakumpleto ng customer na {0} {1} ang unang booking {2}",
                "referralEarningReason_2": "Nakumpleto ng customer na {0} {1} ang pag-book {2}",
                "insurance": "Insurance sa pagmamaneho"
            },
            "passengerWallet": {
                "dateTime": "Petsa at oras",
                "customerName": "Pangalan ng Customer",
                "phoneNumber": "Numero ng telepono",
                "type": "Uri",
                "bookingId": "# ng booking",
                "changedAmount": "Binago ang halaga",
                "amount": "Binago ang halaga",
                "newBalance": "Bagong balanse",
                "currency": "Pera",
                "transactionId": "ID ng Transaksyon",
                "Note": "Tandaan",
                "credit": "Topup sa pamamagitan ng credit card *{0}",
                "TnG": "Topup ng TnG #{0}",
                "MOLPay": "Mag-top up mula sa [RazerPay - #{0}]",
                "gatewayName": "Top up mula sa [{0} - #{1}]",
                "cashExcess": "Ang customer ay dapat magbayad ng {0}, Cash na ibinigay {1}",
                "editBalance": "I-edit ang Balanse",
                "ride": "Sumakay",
                "topUp": "Magdagdag ng pondo",
                "topUpReferee": "Referral na reward ({0})",
                "topUpReferrer": "Bagong referee (#{0}): {1} ({2})"
            },
            "recipientsInfo": {
                "order": "Bilang",
                "orderId": "Order #",
                "name": "Pangalan ng makakatanggap",
                "phone": "Telepono ng tatanggap #",
                "address": "Address ng tatanggap",
                "deliveryFee": "Bayad sa paghahatid",
                "ItemValue": "Halaga ng Item (COD)",
                "status": "Katayuan",
                "Performer": "Tagapagganap",
                "Reason": "Dahilan",
                "proofOfFailure": "Patunay ng kabiguan",
                "referenceNumber": "Numero ng Sanggunian"
            },
            "dispatchHistory": {
                "performer": "Tagapagganap",
                "name": "Pangalan",
                "action": "Aksyon",
                "date": "Petsa",
                "location": "Lokasyon ng driver",
                "estimate": "Pagtatantya ng lokasyon ng sasakyan-sa-pickup",
                "passenger": "Customer",
                "detachVehicle": "Alisin ang Sasakyan",
                "assignVehicle": "Italaga ang Sasakyan"
            },
            "payToDriver": {
                "driverName": "Driver",
                "totalUnsettledTransactions": "Kabuuang hindi maayos na mga transaksyon",
                "totalUnsettledAmount": "Kabuuang hindi naayos na halaga",
                "actions": "Aksyon",
                "pay": "Magbayad",
                "remove": "Alisin",
                "clearSuccess": "Matagumpay na na-clear ang kita ng napiling driver.",
                "clearFailed": "Nabigong i-clear ang data ng kita ng driver. Pakisubukang muli.",
                "selectDriver": {
                    "title": "",
                    "body": "Mangyaring pumili ng driver na babayaran.",
                    "buttonTitle": "Sige"
                },
                "confirmClear": {
                    "title": "",
                    "body": "Sigurado ka bang gusto mong i-clear ang data ng kita ng driver na ito? Ang gawaing ito ay hindi pwedeng baguhin.",
                    "buttonTitle": "Oo",
                    "closeButtonText": "Hindi"
                },
                "confirmPay": {
                    "body": "Sigurado ka bang gusto mong magbayad sa (mga) napiling driver?",
                    "buttonTitle": "Oo",
                    "closeButtonText": "Hindi"
                },
                "paymentSuccessfully": "Matagumpay na naayos ang mga pagbabayad sa (mga) driver",
                "ProcessPayout": "Proseso ng Bayad"
            },
            "customerQuest": {
                "name": "Pangalan",
                "phoneNumber": "Numero ng telepono",
                "supportId": "ID ng suporta",
                "ranking": "Pagraranggo",
                "points": "Mga puntos",
                "numberOfReservation": "Bilang ng reserbasyon",
                "driver": "Driver",
                "customer": "Kustomer",
                "firstWillWin": "Unang mananalo",
                "firstWillWinLuckyDraw": "Una ang mananalo (lucky draw)",
                "largestWillWin": "Pinakamalaki ang mananalo (leaderboard)",
                "qualified": "Kwalipikadong",
                "notQualified": "Hindi qualified",
                "userName": "Pangalan ng gumagamit",
                "completedDate": "Nakumpleto ang petsa",
                "isQualified": "Katayuan",
                "ticket": "Ticket",
                "numOfComplete": "Bilang ng natapos",
                "bookingDistance": "distansya ng P.O.B",
                "numberOfIntercity": "Bilang ng intercity",
                "numberOfDelivery": "Bilang ng paghahatid",
                "pleaseSelectEventName": "Mangyaring piliin ang pangalan ng kaganapan.",
                "numberOfQualifiedSetting": "Bilang ng mga kwalipikado (setting):",
                "numberOfActualQualified": "Bilang ng aktwal na kwalipikado:",
                "driverRating": "Rating ng Driver",
                "acceptanceRating": "Rating ng Pagtanggap",
                "cancellationRating": "Rating ng Pagkansela",
                "period": "Panahon:"
            },
            "payoutToDriver": {
                "IFSCCode": "IFSC Code",
                "payoutID": "Payout ID",
                "driverName": "Driver",
                "driverPhone": "Numero ng telepono",
                "companyName": "kumpanya",
                "period": "Panahon:",
                "driverId": "ID# / Pambansang IC#",
                "cashWalletBalance": "Balanse ng cash wallet",
                "creditBalance": "Balanseng kredito",
                "holdAmount": "Hawak ang halaga",
                "minPayout": "Min na bayad",
                "enterMinimumPayoutAmount": "Ipasok ang pinakamababang halaga ng payout",
                "payoutAmount": "Halaga ng bayad",
                "payoutDate": "Petsa ng pagbabayad",
                "actions": "Aksyon",
                "pay": "Magbayad",
                "remove": "Alisin",
                "payoutEndTime": "Oras ng pagtatapos ng pagbabayad",
                "clearSuccess": "Matagumpay na na-clear ang kita ng napiling driver.",
                "clearFailed": "Nabigong i-clear ang data ng kita ng driver. Pakisubukang muli.",
                "amountKeepInDriverCashWallet": "Halagang itago sa Cash Wallet ng driver",
                "selectDriver": {
                    "title": "pamagat",
                    "body": "Mangyaring pumili ng driver na babayaran.",
                    "buttonTitle": "OK"
                },
                "confirmClear": {
                    "title": "",
                    "body": "Sigurado ka bang gusto mong i-clear ang data ng kita ng driver na ito? Ang gawaing ito ay hindi pwedeng baguhin.",
                    "buttonTitle": "Oo",
                    "closeButtonText": "Hindi"
                },
                "confirmPay": {
                    "body": "Sigurado ka bang gusto mong magbayad sa (mga) napiling driver? <br> - Bilang ng mga driver: <b>%{drivers}</b> <br> - Min payout out para sa bawat driver: %{currency} <b>%{min}</b> <br> - Hold halaga: %{currency}<b> %{hold}</b> <br> - Kabuuang payout: %{currency} <b>%{total}</b>",
                    "buttonTitle": "Oo",
                    "closeButtonText": "Hindi"
                },
                "paymentSuccessfully": "Matagumpay na naayos ang mga pagbabayad sa (mga) driver",
                "paymentCompleted": "Nakumpleto ang pagbabayad: <br> - Matagumpay na magbayad: %{success} <br> - Nabigo: %{failed} <br> - Matagumpay na kabuuang payout: %{currency} %{total}",
                "noteSelectDrivers": "Tandaan: piliin ang mga driver na may bank account na babayaran.",
                "sendPayout": "Magpadala ng matagumpay na notification ng payout sa email address",
                "accountNumber": "Numero ng account",
                "iBanNumber": "Numero ng IBAN",
                "accountHoldName": "Pangalan ng may hawak ng account",
                "bankName": "Pangalan ng bangko",
                "selelctedDriverHasBeenPaid": "Nabayaran na ang (mga) napiling driver",
                "selelctedDriverHasBeenFailed": "Nabigo ang (mga) napiling driver",
                "selelctedDriverHasBeenUpdateAsInvalid": "Na-update ang napiling (mga) driver bilang 'Di-wastong bank account'",
                "selelctedDriverHasBeenUpdateAsValid": "Na-update ang napiling (mga) driver bilang 'Valid na bank account'",
                "isBankAccountOwner": "Ang benepisyaryo ay katulad ng driver",
                "isBankAccountOwner_true": "Oo",
                "isBankAccountOwner_false": "Hindi",
                "beneficiaryIDIC": "ID# / IC# ng benepisyaryo",
                "bankRelationship": "Relasyon",
                "bankRelationship_1": "asawa",
                "bankRelationship_2": "Anak na babae anak na lalaki",
                "bankRelationship_3": "Kuya/Ate",
                "bankRelationship_4": "Kamag-anak",
                "bankRelationship_5": "Mga kaibigan",
                "bankRelationship_6": "Iba pa: {0}",
                "bankStatus": "Katayuan ng Bangko",
                "emailStatement": "Email Pahayag",
                "viewStatement": "Tingnan ang Pahayag",
                "downloadStatement": "I-download bilang PDF",
                "emailStatementSuccess": "Matagumpay na naipadala ang pahayag sa email",
                "NumberDriver": "Numero ng Driver",
                "NumberSupplier": "Numero ng Supplier",
                "sendMailPayout": "Magpadala ng matagumpay na abiso ng pagbabayad sa sumusunod na email address:",
                "confirmPayoutTitle": "Sigurado ka bang gusto mong magbayad sa mga napiling gumagamit?",
                "phoneOfBank": "Telepono ng Bangko"
            },
            "payoutToMerchant": {
                "payoutId": "ID ng Bayad",
                "merchantName": "Pangalan ng Merchant",
                "phone": "Numero ng telepono",
                "accountNumber": "Numero ng account",
                "iBanNumber": "Numero ng IBAN",
                "bankAccountHolder": "Pangalan ng may hawak ng account",
                "bankName": "Pangalan ng bangko",
                "pendingAmount": "Nakabinbing halaga",
                "payoutAmount": "Halaga ng bayad",
                "payoutDate": "Petsa ng pagbabayad",
                "holdAmount": "Hawak ang halaga",
                "minPayout": "Min na bayad",
                "selelctedMerchantHasBeenPaid": "Nabayaran na ang (mga) napiling merchant",
                "selelctedMerchantHasBeenFailed": "Nabayaran na ang (mga) napiling merchant",
                "pay": "Magbayad",
                "selectMerchant": {
                    "title": "Babala",
                    "body": "Mangyaring pumili ng merchant na babayaran.",
                    "buttonTitle": "Sige"
                },
                "confirmPay": {
                    "body": "Sigurado ka bang gusto mong magbayad sa napiling (mga) merchant? <br> - Bilang ng mga merchant: <b>%{merchants}</b> <br> - Min payout out para sa bawat driver: %{currency} <b>%{min}</b> <br> - Hold halaga: %{currency}<b> %{hold}</b> <br> - Kabuuang payout: %{currency} <b>%{total}</b>",
                    "buttonTitle": "Oo",
                    "closeButtonText": "Hindi"
                },
                "sendPayout": "Magpadala ng matagumpay na notification ng payout sa email address",
                "HasBeenUpdateAsInvalid": "Na-update ang napiling (mga) merchant bilang 'Di-wastong bank account'",
                "HasBeenUpdateAsValid": "Na-update ang napiling (mga) merchant bilang 'Valid na bank account'"
            },
            "payoutSupplier": {
                "selelctedSupplierHasBeenUpdateAsValid": "Ang napiling supplier(s) ay na-update bilang 'Bumabalid na bank account'",
                "selelctedSupplierHasBeenUpdateAsInvalid": "Ang napiling supplier(s) ay na-update bilang 'Di-wastong bank account'",
                "selelctedSupplierHasBeenFailed": "Nabigo ang napiling supplier(s)",
                "selelctedSupplierHasBeenPaid": "Nabayaran na ang napiling supplier(s)",
                "confirmPay": {
                    "body": "Sigurado ka bang nais mong magbayad sa napiling supplier(s)? <br> - Bilang ng supplier: <b>%{drivers}</b> <br> - Minimum na bayad para sa bawat supplier: %{currency} <b>%{min}</b>  <br> - Halaga ng hawak: %{currency}<b> %{hold}</b> <br> - Kabuuang bayad: %{currency} <b>%{total}</b>",
                    "buttonTitle": "Oo",
                    "closeButtonText": "Hindi"
                },
                "agentName": "Pangalan ng ahente",
                "walletBalance": "Balanseng wallet",
                "newAmount": "Bagong Halaga"
            },
            "settlementHistory": {
                "date": "Petsa",
                "driverName": "Pangalan ng driver",
                "dateRange": "Saklaw ng petsa",
                "totalTransaction": "Kabuuang naayos na mga transaksyon",
                "paidAmount": "Kabuuang naayos na halaga"
            },
            "settlement": {
                "driverName": "Drayber",
                "driverIdPermit": "ID# / Pambansang IC#",
                "totalBookings": "Kabuuang booking",
                "total": "Kabuuang amt",
                "approved": "Naaprubahan",
                "acct": "ACCT",
                "gross": "BRUTO",
                "percent": 0.03,
                "net": "NET"
            },
            "documentExpiry": {
                "driverName": "Pangalan ng driver",
                "driverPhone": "Telepono ng driver",
                "company": "kumpanya",
                "documentName": "Pangalan ng dokumento",
                "expiredDate": "Petsa ng pag-expire",
                "status": "Katayuan",
                "statusStr": {
                    "NA": "Wala",
                    "expired": "Nag-expire na",
                    "active": "Aktibo",
                    "expireSoon": "Malapit nang mag-expire"
                }
            },
            "referralDetail": {
                "bookingId": "Aklat #",
                "completedDate": "Nakumpletong Oras",
                "paidBy": "Binayaran ni",
                "bookFrom": "Pagbu-book mula sa",
                "driverName": "Pangalan ng driver",
                "driverIdPermit": "ID# / Pambansang IC#",
                "companyName": "kumpanya",
                "Passenger": "pasahero",
                "Customer": "Customer",
                "subtotal": "Subtotal",
                "subTotalFF": "Subtotal na FF",
                "subtotalWithPromo": "Subtotal na may promosyon",
                "referralEarning": "Referral na Kita",
                "Amount": "Halaga",
                "Note": "Tandaan",
                "Currency": "Pera",
                "PercentOfSubTotal": "{0}% ng subtotal",
                "max": "max {0}",
                "referrerInfo": "Tinutukoy ng driver ang customer",
                "phoneReferral": "Telepono ng driver #",
                "driverNumber": "ID# / Pambansang IC#",
                "referralCode": "Referral code",
                "reference": "Reference"
            },
            "referralHistory": {
                "driverName": "Pangalan ng driver",
                "phoneNumber": "Numero ng telepono",
                "companyName": "kumpanya",
                "referralCode": "Referral code",
                "commission": "Kabuuang komisyon",
                "expectedReferralEarning": "Asahan ang kita ng referral",
                "activePaxTooltip": "Ang mga pasaherong nag-redeem ng referral code mula sa driver na may kahit isang booking ay matagumpay na nagawa.",
                "referredPaxTooltip": "Mga pasaherong nag-redeem ng referral code mula sa driver ngunit hindi pa nakakagawa ng anumang booking.",
                "activePax": "Kabuuang mga aktibong customer",
                "referredPax": "Kabuuang tinukoy na mga customer",
                "detailFields": {
                    "passengerId": "ID ng pasahero",
                    "passengerName": "Pangalan ng Customer",
                    "firstBookingDate": "Unang nakumpletong petsa ng booking",
                    "firstBookingDateGMT": "Unang nakumpletong petsa ng booking (GMT)",
                    "passengerPhone": "Telepono ng customer",
                    "appliedDate": "Petsa ng pag-refer",
                    "referredByDriver": "Tinukoy ng driver",
                    "driverPhone": "Numero ng telepono ng driver",
                    "referralCode": "Referral code"
                },
                "showDetail": "Ipakita",
                "detail": "Detalye"
            },
            "paxReferralHistory": {
                "customerName": "Pangalan ng Customer",
                "phoneNumber": "Numero ng telepono",
                "referralCode": "Referral code",
                "commission": "Kabuuang komisyon",
                "activePaxTooltip": "Ang mga pasaherong na-redeem ang referral code na may kahit isang booking ay matagumpay na nagawa.",
                "referredPaxTooltip": "Mga pasaherong na-redeem ang referral code ngunit hindi pa nakakagawa ng anumang booking.",
                "activePax": "Kabuuang mga aktibong customer",
                "referredPax": "Kabuuang tinukoy na mga customer",
                "detailFields": {
                    "passengerId": "ID ng pasahero",
                    "passengerName": "Pangalan ng pasahero",
                    "firstBookingDate": "Unang nakumpletong petsa ng booking",
                    "firstBookingDateGMT": "Unang nakumpletong petsa ng booking (GMT)"
                },
                "showDetail": "Ipakita",
                "detail": "Detalye"
            },
            "driverRefersDriver": {
                "companyName": "kumpanya",
                "phoneNumber": "Numero ng telepono",
                "username": "Username",
                "referralCode": "Referral code",
                "referrer": "Referrer",
                "numberOfReferees": "Bilang ng mga referee",
                "activeReferees": "Mga aktibong referee",
                "referee": "Tagahatol",
                "refereePhone": "Numero ng telepono ng referee",
                "refereeUsername": "username ng referee",
                "referredDate": "Petsa ng pagtukoy",
                "activatedDate": "Na-activate na petsa",
                "referrerByDriver": "Referrer",
                "referrerPhone": "Numero ng telepono ng referrer",
                "referralStatus": "Katayuan ng referral",
                "lifeTimeBookings": "Mga life time booking",
                "inReview": "Sa pagsusuri",
                "activated": "Na-activate"
            },
            "driverWithdrawal": {
                "transferToEWallet": "Nilipat sa panlabas na e-wallet *{0}",
                "channelCode": "Kodigo ng channel",
                "channelName": "Pangalan ng channel",
                "reversed": "Baligtad",
                "currentBalanceTooltip": "Ang kasalukuyang balanse ng cash wallet ng driver bago ang kahilingan sa pag-withdraw",
                "paymentTime": "Oras ng pagbabayad",
                "requestTime": "Oras ng kahilingan",
                "referenceId": "Sanggunian #",
                "transactionId": "ID ng Transaksyon",
                "description": "Paglalarawan",
                "transferAmount": "halaga ng paglipat",
                "currency": "Pera",
                "approved": "Naprubahan",
                "rejected": "Tinanggihan",
                "failed": "Nabigo",
                "reason": "Dahilan"
            },
            "penaltyCompensation": {
                "penaltyAmount": "Parusa",
                "totalCollect": "Kailangang magbayad sa lokal na pera",
                "totalCollectInUSD": "Kailangang magbayad sa USD",
                "compensationAmount": "Magbayad",
                "compensationAmountInUSD": "Bayaran (USD)",
                "penaltyReason": "Dahilan ng Parusa",
                "estimatedPrice": "Tinatayang presyo",
                "estimatedPriceInUSD": "Tinantyang presyo (USD)",
                "penaltyAmountInUSD": "Parusa (USD)",
                "amount": "Halaga",
                "amountInUSD": "Halaga (USD)"
            },
            "imcompletePayment": {
                "bookingId": "Booking ID",
                "bookFrom": "Pagbu-book mula sa",
                "bookingTime": "Petsa/Oras na Pag-book",
                "completedTime": "Pangalan ng Customer",
                "customerName": "Pangalan ng Customer",
                "requestedPaymentMethod": "Hiniling na paraan ng pagbabayad",
                "originalPaymentStatus": "Katayuan ng orihinal na pagbabayad",
                "currentPaymentStatus": "Kasalukuyang katayuan ng pagbabayad",
                "updatedDateTime": "Petsa/Oras na nakolekta ang Balanse",
                "totalAmt": "Kabuuang amt",
                "originalOutstandingAmount": "Orihinal na natitirang halaga",
                "currentOutstandingAmount": "Kasalukuyang natitirang halaga",
                "outstandingAmountPaidBy": "Natitirang halaga na kinokolekta ng",
                "writeOffDebtMethod": "Natitirang halaga na kinokolekta ng",
                "reason": "Dahilan",
                "customerPhone": "Numero ng telepono",
                "amountCollected": "Halagang nakolekta",
                "partialPaymentAmount": "Bahagyang bayad kapag bumaba"
            },
            "driverDeposit": {
                "dateAndTime": "Petsa at oras",
                "userName": "Username",
                "type": "Uri",
                "newAmount": "Bagong balanse",
                "topUpGCashReason": "Mag-top up gamit ang Gcash",
                "topUpReason": "Mag-top up mula sa credit card *{0}",
                "cashWalletReason": "Mag-top up mula sa Cash Wallet",
                "topUpMOLPayReason": "Razer Pay [ {0} ]"
            },
            "refund": {
                "fullRefund": "Buong refund",
                "partialRefund": "Bahagyang refund",
                "tripId": "Trip ID",
                "route": "Ruta",
                "refundAmount": "halaga ng refund",
                "refundTime": "Oras ng refund",
                "paymentStatus": "Katayuan ng pagbabayad"
            },
            "merchant": {
                "store": "Tindahan",
                "name": "Pangalan",
                "phoneNumber": "Numero ng telepono",
                "bookingId": "# ng booking",
                "totalOrders": "Kabuuang mga order",
                "completedOrders": "Nakumpleto ang mga order",
                "canceledOrders": "Kinansela ang mga order",
                "incidentOrders": "Insidente",
                "revenue": "Kita",
                "commission": "Komisyon",
                "earning": "Kumita",
                "food": "Pagkain",
                "mart": "Mart",
                "preferredMerchant": "Ginustong mangangalakal",
                "regularMerchant": "Regular na mangangalakal",
                "companyName": "Kumpanya"
            },
            "merchantCashTransactionHistory": {
                "companyName": "Kumpanya",
                "dateTime": "Petsa at oras",
                "merchantUserName": "Gumagamit ng mangangalakal",
                "merchantUserPhone": "Numero ng telepono",
                "merchantUserEmail": "Email",
                "merchantName": "Mangangalakal",
                "transactionType": "Uri",
                "bookId": "# ng booking",
                "transactionId": "ID ng Transaksyon",
                "operatorName": "Operator",
                "reason": "Dahilan",
                "amount": "Halaga",
                "newBalance": "Bagong balanse",
                "currencyISO": "Pera"
            },
            "merchantCreditTransactionHistory": {
                "dateTime": "Petsa at oras",
                "merchantUserName": "Gumagamit ng mangangalakal",
                "merchantUserPhone": "Numero ng telepono",
                "merchantUserEmail": "Email",
                "merchantName": "Mangangalakal",
                "transactionType": "Uri",
                "bookId": "# ng booking",
                "transactionId": "ID ng Transaksyon",
                "operatorName": "Operator",
                "reason": "Dahilan",
                "amount": "Halaga",
                "newBalance": "Bagong balanse",
                "currencyISO": "Pera"
            },
            "deleteAccountRequest": {
                "date": "Petsa",
                "phone": "Telepono",
                "username": "Username",
                "supportId": "ID ng suporta",
                "requestFrom": "Kahilingan mula sa",
                "associatedApps": "Mga nauugnay na app",
                "reason": "Dahilan"
            },
            "affiliationPayoutHistory": {
                "payoutId": "Payment ID",
                "dateTime": "Petsa at oras",
                "payoutType": "Uri",
                "accountHolderName": "Pangalan ng may hawak ng account",
                "bankName": "Pangalan ng bangko",
                "accountNumber": "Numero ng account",
                "totalPayout": "Kabuuang bayad (USD)",
                "viewDetails": "Tingnan ang mga detalye",
                "notes": "Tala",
                "bookId": "# ng booking",
                "transactionType": "Uri ng transaksyon",
                "transactionId": "Transaction Id (awtomatikong paglilipat)",
                "settlement": "Pag-aayos",
                "paymentMethod": "Uri",
                "networkType": "Uri ng network"
            },
            "thirdPartyBooking": {
                "date": "Petsa",
                "bookingId": "Booking ID",
                "externalId": "Panlabas na ID",
                "psgPhone": "Numero ng telepono",
                "psgName": "Pangalan ng pasahero",
                "pickupLocation": "Lokasyon ng pickup",
                "pickupLocationLatLong": "Ang lokasyon ng pickup ay lat/mahaba",
                "dropoffLocation": "Lokasyon ng dropoff",
                "dropoffLocationLatLong": "Ang lokasyon ng dropoff ay lat/mahaba",
                "pickupTime": "Oras ng pagkuha",
                "numOfPassenger": "Bilang ng pasahero",
                "action": "Aksyon"
            },
            "external": "Panlabas na Tagapagtustos",
            "inHouse": "Supplier na In-house",
            "negative": "Negatibo",
            "positive": "Positibo",
            "supplierType": "Uri ng Tagapagtustos",
            "supplierCompany": "Tagapagtustos/Kompanya",
            "invalidOrNoBank": "Walang bisa",
            "BankInfo": "Impormasyon sa Bangko",
            "BankStatusConnect": "Katayuan ng Gateway",
            "payManually": "Magbayad nang Manu-mano",
            "payViaGateway": "Magbayad sa pamamagitan ng %{gateway}",
            "payConfirmModal_manual": "Manwal na Kumpirmasyon ng Pagbabayad",
            "payConfirmModal_manual_note": "Naghahanda ka nang magproseso ng <b>manwal na pagbabayad</b> sa napiling %{type}. Ito ay mag-a-update sa balanse ng pitaka ng bawat %{type} at lilikha ng ulat ng pagbabayad para sa pagproseso ng bangko.",
            "payConfirmModal_auto": "Awtomatikong Kumpirmasyon ng Bayad",
            "payConfirmModal_auto_note": "Ikaw ay malapit nang magproseso ng <b>awtomatikong pagbabayad</b> sa napiling %{type} sa pamamagitan ng <b>%{gateway}</b>. Ang mga pagbabayad ay ipapadala nang direkta sa kanilang nakarehistrong mga bank account.",
            "Eligible": "Karapat-dapat para sa awtomatikong pagbabayad",
            "EligibleNote": "Tanging %{value} na mga supplier ang kwalipikado para sa auto payout. Pakisuri at i-update ang mga detalye ng bank account para sa natitirang mga supplier."
        }
    },
    "zoneSetting": {
        "Add": "Idagdag",
        "Import": "Angkat",
        "Name": "Pangalan",
        "Status": "Katayuan",
        "Active": "Aktibo",
        "Inactive": "Hindi aktibo",
        "Deactivate": "I-deactivate",
        "Activate": "I-activate",
        "Delete": "Tanggalin",
        "Cancel": "Kanselahin",
        "Input_zone_name": "Pangalan ng zone ng input",
        "Save_zone": "I-save ang zone",
        "Clear_draw": "Malinaw na draw",
        "Edit": "I-edit",
        "Delete_zone_success": "Matagumpay na natanggal ang Zone",
        "Delete_zone_fail": "Naganap ang mga error habang tinatanggal ang zone",
        "Update_zone_fail": "Naganap ang mga error habang ina-update ang zone",
        "Update_zone_success": "Matagumpay na na-update ang Zone hase",
        "Create_zone_fail": "Naganap ang mga error habang gumagawa ng zone",
        "Create_zone_success": "Matagumpay na nalikha ang bagong zone",
        "Draw_zone": "Mangyaring gumuhit ng zone sa mapa",
        "Import_zones_successful": "Matagumpay ang mga import zone",
        "Import_zones_fail": "Nabigong mag-import ng mga zone",
        "DELETE_ZONE": "Tanggalin ang Zone",
        "ZONE_CONFIRM": "Sigurado ka bang gusto mong tanggalin ang napiling zone ?",
        "Name_zone_required": "Pangalan at Sona ang kailangan!",
        "Select_file": "Pumili ng file",
        "No": "Hindi",
        "Yes": "Oo",
        "Import_zones_intercity_successful": "Matagumpay na na-import ang [{0}] (mga) zone, nabigo ang [{1}].",
        "Import_zones_intercity_successful_failed": "Matagumpay na na-import ang [{0}] (mga) zone, nabigo ang [{1}].",
        "Flat_zone": "Patag na sona",
        "Json_file": "Json file",
        "Import_zones": "Mga zone ng pag-import",
        "timezone": "Time Zone"
    },
    "companySetting": {
        "DELETE_COMPANY": "Tanggalin ang kumpanya",
        "DELETE_CONFIRM": "Gusto mo bang tanggalin ang kumpanya?",
        "DETAIL_COMPANY": "Detalye ng kumpanya",
        "commissionValue": "Komisyon ng kumpanya",
        "connectStatus": "Stripe Connect",
        "connectStripe": "Kumonekta",
        "stripeConnectId": "Stripe account ID",
        "loginStripe": "Dashboard",
        "disconnectStripe": "Idiskonekta",
        "Yes": "Oo",
        "No": "Hindi",
        "Cancel": "Kanselahin",
        "EDIT_COMPANY": "I-EDIT ANG SUPPLIER NG COMPANY",
        "ADD_COMPANY": "ADD COMPANY SUPPLIER",
        "Name": "Pangalan",
        "Required_fields": "Mga kailangang punan",
        "Save": "I-save",
        "Actions": "Aksyon",
        "Edit": "I-edit",
        "Add": "Idagdag",
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "show_pages": "{0} - {1} ng {2} ang ipinakita",
        "Create_company_success": "Matagumpay na nalikha ang bagong kumpanya",
        "Create_company_fail": "Naganap ang mga error habang gumagawa ng kumpanya",
        "Update_company_success": "Ang kumpanya ay matagumpay na na-update",
        "Update_company_fail": "Naganap ang mga error habang ina-update ang kumpanya",
        "Load_company_fail": "Naganap ang mga error habang nilo-load ang kumpanya",
        "Delete_company_success": "Matagumpay na natanggal ang kumpanya",
        "Delete_company_fail": "Naganap ang mga error habang tinatanggal ang kumpanya",
        "hideFare": "Laging itago ang pamasahe",
        "Broadcast_orders": "I-broadcast ang lahat ng mga utos",
        "paymentMethodsApply": "Suportahan ang paraan ng pagbabayad",
        "emailsNotification": "Mga Abiso ng Email",
        "CopySignUpLink": "Kopyahin ang link ng pag-sign up",
        "operationZone": "Operasyon na Lugar",
        "delayBroadcast": "Ipakita ang order pagkatapos",
        "releaseTime": "Oras ng Paglabas",
        "advanceBookingVisibility": "Pagkakita ng maagang pag-book",
        "advanceBookingVisibilityTooltip": "Itakda ang bilang ng mga araw bago ang petsa ng pagkuha na makikita ng supplier ang booking. Tinitiyak nito na ang mga booking ay naipapasa sa mga driver sa tamang oras, batay sa bawat supplier."
    },
    "dispatchSetting": {
        "Cut_off_time_range": "Pagputol ng oras ng booking pagkatapos ng oras",
        "Cut_off_time_range_tooltip": "Kung ang cutoff window ay 10PM - 6AM, maari pa ring mag-book ang mga customer bago mag-10PM para sa mga pickup pagkatapos ng 10PM. Gayunpaman, kung ang kasalukuyang oras ay nasa loob ng 10PM - 6AM, ang pinakamadaling pickup na pinapayagan ay pagkatapos ng 6AM + lead time.",
        "GENERAL": "Heneral",
        "Offer_interval": "Interval ng alok (driver)",
        "Offer_interval_merchant": "Agwat ng alok (merchant)",
        "Offer_interval_merchant_toolTip": "Pinakamataas na oras para sa isang merchant na tumanggap ng isang order",
        "Offer_interval_toolTip": "Pinakamataas na oras para sa isang driver na tumanggap ng booking",
        "soundMarketplace": "Tunog",
        "sound": "Tunog",
        "Auto_re_dispatch_interval_toolTip": "Oras ng pahinga sa pagitan ng 2 round ng pagpapadala",
        "Maximum_auto_dispatch_duration_toolTip": "Pinakamataas na oras ng pagpapadala ng booking sa mga driver",
        "Seconds": "Mga segundo",
        "Auto_re_dispatch_interval": "Auto re-dispatch na agwat",
        "Maximum_auto_dispatch_duration": "Pinakamataas na tagal ng auto-dispatch",
        "Time_out": "Panahon ng pahinga",
        "mins": "minuto",
        "minTimeBeforeReservation": "Huwag payagan ang Driver na magsimula ng reserbasyon bago ang oras ng pagkuha",
        "IN_ADVANCE": "SA MAAGA",
        "Assign_reservation_to_driver": "Magtalaga ng reserbasyon sa driver",
        "Dispatcher_confirms_job_for_driver": "Kinukumpirma ng dispatcher ang trabaho para sa driver",
        "Dispatcher_confirms_job_for_offline_driver": "Kinukumpirma ng dispatcher ang pagpapareserba para sa offline na driver",
        "Broadcast_orders": "Ibroadcast ang mga utos sa lahat ng kumpanya",
        "Broadcast_orders_tooltip_1": "Isangga ang setting na ito kung nais mo lamang na i-broadcast ang lahat ng biyahe sa lahat ng supplier ng kumpanya. Tandaan na kailangan mong i-enable ang broadcast mode sa bawat profile ng kumpanya.",
        "Minimum_book_ahead": "Minimum na libro sa unahan",
        "Maximum_book_ahead": "Maximum na aklat sa unahan - isang order",
        "Maximum_period_recurring_oders_fleet": "Pinakamataas na panahon para sa mga umuulit na order (fleet operator)",
        "Maximum_period_recurring_oders_corp": "Pinakamataas na panahon para sa mga umuulit na order (corporate)",
        "Day": "Araw",
        "Week": "Linggo",
        "Month": "buwan",
        "hrs": "oras",
        "Driver_cancellation_duration": "Tagal ng pagkansela ng driver",
        "Mins": "minuto",
        "Maximum_Day": "Maaaring tanggapin ng driver ang maximum na reservation sa isang araw.",
        "Maximum_Accept_Reservation": "Kabuuang bilang ng mga reservation na maaaring tanggapin ng isang driver sa isang pagkakataon.",
        "jobRTDriver": "Oras ng pagpapalabas ng trabaho sa drayber (bago ang pickup)",
        "jobRTDriverDes": "Itakda kung kailan magiging visible ang trabaho sa itinalagang driver sa kanilang app bago ang oras ng pickup. - halimbawa, 24 na oras bago ang pickup.",
        "Local_notification_before": "Lokal na abiso bago",
        "Dispatch_mode": "Mode ng pagpapadala",
        "Manual": "Manwal",
        "Immediate_auto_dispatch": "Agarang awtomatikong pagpapadala",
        "Delayed_auto_dispatch": "Naantala ang auto-dispatch",
        "Auto_dispatch_before_pickup_time": "Auto dispatch bago ang oras ng pickup",
        "Auto_Reassign_Before_Pickup_Time": "Awtomatikong muling itatalaga bago ang oras ng pagkuha",
        "Auto_Reassign_Before_Pickup_Time_Tooltip": "Awtomatikong nire-reassign ang trabaho kung ang nakatalagang drayber ay hindi nagsimula ng biyahe X minuto bago ang oras ng pickup. Tandaan: Ito ay nalalapat lamang sa mga drayber ng in-house supplier.",
        "Required_fields": "Mga kailangang punan",
        "Shuttle": "SHUTTLE",
        "Shuttle_Dispatch_mode": "Mode ng pagpapadala",
        "Dispatch_setting_Shuttle_Dispatch_mode_tooltip": "- Manual mode: Ise-save ang reservation at mananatili sa Cue ng iyong Command Center sa ilalim ng status na \"Nakabinbin\" kapag nagawa na ang reservation. Pagkatapos mag-click sa \"I-update ang booking\" sa detalye ng booking, ipapadala ang reserbasyon sa iyong mga nakatalagang driver o sa lahat ng mga driver kung sakaling walang magtalaga ng driver. Isasama ito sa kalendaryo ng driver device at magiging available ang paalala. <br>- Delayed mode:Ise-save ang reservation at mananatili sa Cue ng iyong Command Center sa ilalim ng status na “Pending” kapag nagawa na ang reservation. Awtomatikong ipapadala ang reserbasyon bago ang \"halaga ng oras sa \"Proseso nang maaga\" mula sa oras ng pag-pick up sa nakatalagang driver o sa pinakamalapit na available kung sakaling walang magtalaga ng driver. <br>- Agad na auto-dispatch mode: Awtomatikong ipapadala ang reserbasyon sa lahat ng driver kapag nagawa na ang reservation. Isasama ito sa kalendaryo ng driver device at magiging available ang paalala.",
        "Save": "I-save",
        "Process_in_advance": "Proseso nang maaga",
        "Save_dispatch_success": "Ang dispatch ay matagumpay na na-update",
        "Save_dispatch_fail": "Nagkaroon ng mga error noong ina-update ang dispatch",
        "Dispatch_setting_general_tooltip": "Mag-apply sa booking on demand, booking nang maaga nang may naantalang auto-dispatch",
        "Dispatch_setting_Assign_reservation_to_driver_tooltip": "Ang reserbasyon ay awtomatikong itinalaga at tinatanggap para sa driver kapag pinagana ang opsyong ito",
        "Dispatch_setting_Driver_cancellation_duration_tooltip": "Ang tagal ay mula sa oras kung kailan kinansela ng oras ng pagkuha sa driver ang booking",
        "Dispatch_setting_Dispatch_mode_tooltip": "- Manual mode: Ise-save ang reservation at mananatili sa Cue ng iyong Command Center sa ilalim ng status na \"Nakabinbin\" kapag nagawa na ang reservation. Pagkatapos mag-click sa \"I-update ang booking\" sa detalye ng booking, ipapadala ang reserbasyon sa iyong mga nakatalagang driver o sa lahat ng mga driver kung sakaling walang magtalaga ng driver. Isasama ito sa kalendaryo ng driver device at magiging available ang paalala. <br>- Delayed mode:Ise-save ang reservation at mananatili sa Cue ng iyong Command Center sa ilalim ng status na “Pending” kapag nagawa na ang reservation. Awtomatikong ipapadala ang reserbasyon bago ang \"halaga ng oras sa \"Proseso nang maaga\" mula sa oras ng pag-pick up sa nakatalagang driver o sa pinakamalapit na available kung sakaling walang magtalaga ng driver. <br>- Agad na auto-dispatch mode: Awtomatikong ipapadala ang reserbasyon sa lahat ng driver kapag nagawa na ang reservation. Isasama ito sa kalendaryo ng driver device at magiging available ang paalala.",
        "Notification_nearby_drivers_before_pickup_time": "Abisuhan ang mga kalapit na driver bago ang oras ng pickup",
        "Dispatch_setting_Maximum_Day_tooltip": "Ito ay para limitahan ang mga driver na magkaroon ng masyadong maraming reservation sa parehong araw. Naaangkop para sa Marketplace at Intercity.",
        "Maximum_Accept_Reservation_tooltip": "Ang bilang ng mga tinatanggap na reservation ng driver ay hindi maaaring lumampas sa numerong ito. Nililimitahan nito ang driver mula sa pagtanggap ng masyadong marami sa isang pagkakataon. Naaangkop para sa Marketplace at Intercity.",
        "Notification_nearby_drivers_before_pickup_time_tooltip": "Kung ang reserbasyon ng isang customer ay hindi tinanggap ng sinumang driver bago ang itinakdang oras, bago ang oras ng pickup, aabisuhan ng system ang mga driver sa malapit. Sana ay ma-prompt sila nito na tingnan ang marketplace para tanggapin ang booking.",
        "marketPlace": "PAMILIHAN",
        "howFarDriverSeeBookingMarketplace": "Gaano kalayo ang nakikita ng driver na mga booking sa marketplace",
        "shortNoticeOrder": "Maikling paunawa ng order",
        "shortNoticeOrderTooltip": "Itakda ang oras para sa mga booking na ituturing na agarang at makikita ng lahat ng antas agad."
    },
    "voiceSMSSetting": {
        "ACCOUNT_SETTINGS": "Mga setting ng account",
        "Account_SID": "Account SID",
        "Auth_Token": "Auth Token",
        "Application_ID": "Application ID",
        "SMS_number_1": "SMS numero 1",
        "SMS_number_2": "SMS numero 2",
        "SMS_SETTINGS": "MGA SETTING ng SMS",
        "MASKED_PHONE_SETTINGS": "MGA SETTING NA MAY MASAKITANG TELEPONO",
        "SMS_MARKETING_SETTINGS": "MGA SETTING NG SMS MARKETING",
        "Phone_number": "Numero ng telepono",
        "Save": "I-save",
        "voiceSMS": "TWILIO",
        "DRIVER_APP": "Driver App",
        "PASSENGER_APP": "App ng Pasahero",
        "allowDriverToCallCC": "Payagan ang Driver na tumawag sa Helpdesk sa pamamagitan ng:",
        "allowDriverToCallHelpdesk": "Payagan ang Driver na tumawag sa Helpdesk sa pamamagitan ng:",
        "allowDriverToCallPassenger": "Pahintulutan ang Driver na tumawag sa Pasahero sa pamamagitan ng:",
        "allowPassengerToCallCC": "Pahintulutan ang Pasahero na tumawag sa Helpdesk sa pamamagitan ng:",
        "allowPassengerToCallHelpdesk": "Pahintulutan ang Pasahero na tumawag sa Helpdesk sa pamamagitan ng:",
        "allowPassengerToCallDriver": "Pahintulutan ang Pasahero na tumawag sa Driver sa pamamagitan ng:",
        "voip": "VOIP",
        "mobile": "Mobile",
        "bookingSMS": "Template ng mensahe",
        "bookingSMSTemplate": {
            "name": "Pangalan",
            "content": "Nilalaman",
            "action": "Aksyon",
            "DELETE": "Tanggalin ang template ng Mensahe",
            "DELETE_CONFIRM": "Sigurado ka bang gusto mong tanggalin ang napiling template ng Mensahe?",
            "EDIT": "I-edit ang template ng Mensahe",
            "ADD": "Magdagdag ng template ng Mensahe",
            "DETAIL": "Template ng Detalye ng Mensahe",
            "Update_success": "Matagumpay na na-update ang template ng mensahe",
            "Create_success": "Matagumpay na nalikha ang template ng mensahe",
            "Delete_success": "Matagumpay na natanggal ang template ng mensahe",
            "Delete_fail": "Naganap ang mga error habang tinatanggal ang template ng Mensahe",
            "Load_fail": "Naganap ang mga error habang nilo-load ang template ng Mensahe",
            "Update_fail": "Naganap ang mga error habang ina-update ang template ng Mensahe",
            "Create_fail": "Naganap ang mga error habang gumagawa ng template ng Mensahe"
        },
        "bookingSMSModal": {
            "title": "Magdagdag ng template ng SMS",
            "save": "I-save",
            "cancel": "Kanselahin",
            "titleMessage": "Magpadala ng Mensahe",
            "template": "Template",
            "phoneNumber": "Numero ng telepono",
            "content": "Nilalaman",
            "messageType": "Uri ng mensahe",
            "inbox": "Inbox",
            "sms": "SMS",
            "sendTo": "Ipinadala sa",
            "passenger": "pasahero",
            "driver": "Driver"
        }
    },
    "regularSetting": {
        "extraWaitTimeTooltip": "Fee to compensate the driver when he has to wait additional time for the customer till they are onboard.",
        "fareWaitTimeLater": "Taripa bawat minuto (Reserbasyon)",
        "fareWaitTimeNow": "Taripa bawat minuto (Ngayon)",
        "transport": "Transportasyon",
        "delivery": "Paghahatid",
        "Fer_Stop": "Fee fer itigil",
        "First_Stop": "Bayad para sa unang paghinto",
        "Each_Stop": "Bayad para sa bawat dagdag na paghinto",
        "Name": "Pangalan",
        "Pay_to_driver_Cash": "Magbayad sa driver (Cash booking)",
        "Last_Update": "Huling Update",
        "Status": "Katayuan",
        "Required_fields": "Mga kailangang punan",
        "Yes": "Oo",
        "No": "Hindi",
        "Cancel": "Kanselahin",
        "Save": "I-save",
        "Actions": "Aksyon",
        "Edit": "I-edit",
        "Add": "Idagdag",
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "show_pages": "{0} - {1} ng {2} ang ipinakita",
        "DELETE_CONFIRM": "Gusto mo bang tanggalin?",
        "ADD_REGULAR_RATE": "Magdagdag ng regular na rate",
        "EDIT_REGULAR_RATE": "I-edit ang regular na rate",
        "DETAIL_REGULAR_RATE": "Detalye ng regular na rate",
        "DELETE_REGULAR_RATE": "Tanggalin ang regular na rate",
        "Delete_confirm_regular_rate": "Gusto mo bang tanggalin ang item na ito?",
        "STARTING": "Nagsisimula",
        "Starting_Now": "Simula ngayon)",
        "Starting_Reservation": "Simula (Pagpapareserba)",
        "FIRST_DISTANCE_FEE": "Bayad sa unang distansya",
        "First_distance_fee": "Unang distansya",
        "From": "Mula sa",
        "To": "Upang",
        "Fee_for_first_distance": "Bayad para sa unang distansya",
        "SECOND_DISTANCE_FEE": "Bayad sa pangalawang distansya",
        "Second_distance_fee": "Pangalawang distansya",
        "AFTER_SECOND_DISTANCE": "Pagkatapos ng pangalawang distansya",
        "Fee_after_second_distance": "Bayad pagkatapos ng pangalawang distansya",
        "PER_MINUTE": "Bawat minuto",
        "Fee_per_minute": "Pamasahe kada minuto",
        "mi": "mi",
        "hour": "oras",
        "MINIMUM": "pinakamababa",
        "Minimum_Now": "Minimum (Ngayon)",
        "Minimum_Reservation": "Minimum (Reserbasyon)",
        "PAX_MDISPATCHER_CANCELLATION": "Pagkansela ng pax/partner",
        "On_demand": "Pagkansela ng pax/partner - On demand",
        "Penalty": "Halaga ng parusa",
        "In_advance": "Pagkansela ng pax/partner - In advance",
        "PAX_MDISPATCHER_NO_SHOW": "Hindi sumipot ang Pax/ partner",
        "Driver_cancel_demand": "Patakaran sa pagkansela ng driver - on demand",
        "Driver_cancel_advance": "Patakaran sa pagkansela ng driver - nang maaga",
        "Assign_car_type": "Magtalaga ng uri ng kotse",
        "Select_car_type": "Pumili ng uri ng kotse",
        "Active": "Aktibo",
        "Inactive": "Hindi aktibo",
        "Deactivate": "I-deactivate",
        "DELETE_FLATE_RATE": "Tanggalin ang flate rate",
        "Delete_confirm_flat_rate": "Gusto mo bang tanggalin ang item na ito?",
        "EDIT_FLAT_RATE": "I-edit ang flat rate",
        "ADD_FLAT_RATE": "Magdagdag ng flat rate",
        "DELETE_FLAT_RATE": "Tanggalin ang flat rate",
        "DELETE_HOURLY_RATE": "Tanggalin ang oras-oras/araw-araw na rate",
        "Delete_confirm_hour_rate": "Gusto mo bang tanggalin ang item na ito?",
        "EDIT_HOURLY_RATE": "I-edit ang oras-oras/ araw-araw na rate",
        "ADD_HOURLY_RATE": "Magdagdag ng oras-oras/ araw-araw na rate",
        "DELETE_FLAT_ROUTE": "Tanggalin ang patag na ruta",
        "DELETE_ROUTE_CONFIRM": "Sigurado ka bang tatanggalin ang ruta?",
        "EDIT_ROUTE": "I-edit ang ruta",
        "ADD_ROUTE": "Magdagdag ng ruta",
        "Route_name": "Pangalan ng ruta",
        "Route_type": "Uri ng Ruta",
        "Zone_to_zone": "Zone sa zone",
        "Zipcode_to_zipcode": "Zipcode sa zipcode",
        "First_location": "Unang lokasyon",
        "Second_location": "Pangalawang lokasyon",
        "First_location_zip_note": "*Mga Tala: Maaari kang magpasok ng maraming zip code nang sabay-sabay sa pamamagitan ng paggamit ng simbolo na ','. Para sa magkakasunod na code, mangyaring gumamit ng simbolo na '->' sa halip na mag-input ng isa-isa ( hal: 90001 -> 90099, 90101, 90102, 90103, 90174, 90185)",
        "Second_location_zip_note": "*Mga Tala: Maaari kang magpasok ng maraming zip code nang sabay-sabay sa pamamagitan ng paggamit ng simbolo na ','. Para sa magkakasunod na code, mangyaring gumamit ng simbolo na '->' sa halip na mag-input ng isa-isa ( hal: 90001 -> 90099, 90101, 90102, 90103, 90174, 90185)",
        "SINGLE_TRIP_SETUP": "Pag-setup ng solong biyahe",
        "Route_1": "Ruta 1 (Unang lokasyon -> Pangalawang lokasyon)",
        "Route_2": "Ruta 2 (Ikalawang lokasyon -> Unang lokasyon)",
        "Limitation": "Limitasyon",
        "Unlimited": "Walang limitasyon",
        "Limited": "Limitado",
        "Time_coverage": "Saklaw ng oras",
        "Extra_time": "Sobrang oras",
        "ROUND_TRIP_SETUP": "Round trip setup",
        "Round_trip": "Papunta at pabalik",
        "ROUTES": "ROUTES",
        "Route_1_Fare": "Pamasahe sa Ruta 1",
        "Route_2_Fare": "Pamasahe sa Ruta 2",
        "Round_Trip_Fare": "Pamasahe ng Pabalik",
        "Select_a_zone": "Pumili ng zone",
        "minute": "minuto",
        "VIEW_REGULAR_RATE": "Tingnan ang detalye regular na rate",
        "VIEW_FLAT_RATE": "Tingnan ang flat rate",
        "VIEW_HOURLY_RATE": "Tingnan ang oras-oras na rate",
        "HOURLY_PACKAGE_RATE": "Oras na rate ng package",
        "Package_name": "Pangalan ng package",
        "Package_duration": "Tagal ng package",
        "PackageId": "Package ID",
        "Base_rate": "Batayang rate",
        "Distance_coverage": "Saklaw ng distansya",
        "Extra_duration": "Dagdag tagal",
        "Extra_distance": "Dagdag na distansya",
        "DELETE_HOURLY_PACKAGE": "Tanggalin ang oras-oras na pakete",
        "DELETE_PACKAGE_CONFIRM": "Gusto mo bang tanggalin ang rate ng package?",
        "EDIT_PACKAGE": "I-edit ang package",
        "VIEW_PACKAGE": "Tingnan ang detalye ng package",
        "ADD_PACKAGE": "Magdagdag ng pakete",
        "Fee_per_extra_duration": "Bayad sa bawat dagdag na tagal",
        "Fee_per_extra_distance": "Bayad sa bawat dagdag na distansya",
        "hours": "(mga) oras",
        "days": "Mga Araw",
        "Update_flat_rate_success": "Matagumpay na na-update ang flat rate",
        "Update_flat_rate_fail": "Naganap ang mga error habang ina-update ang flat rate",
        "Created_flat_rate_success": "Matagumpay na nalikha ang flat rate",
        "Created_flat_rate_fail": "Naganap ang mga error habang gumagawa ng flat rate",
        "Update_flat_rate_route_success": "Matagumpay na na-update ang ruta ng flat rate",
        "Update_flat_rate_route_fail": "Naganap ang mga error habang ina-update ang flat rate na ruta",
        "Created_flat_rate_route_success": "Matagumpay na nagawa ang flat rate na ruta",
        "Created_flat_rate_route_fail": "Naganap ang mga error habang gumagawa ng flat rate na ruta",
        "Loading_flat_rate_fail": "Naganap ang mga error habang nilo-load ang detalye ng flat rate",
        "Delete_flat_rate_route_fail": "Naganap ang mga error habang tinatanggal ang flat rate na ruta",
        "Delete_flat_rate_success": "Matagumpay na natanggal ang flat rate",
        "Delete_flat_rate_fail": "Naganap ang mga error habang tinatanggal ang flat rate",
        "Update_intercity_rate_success": "Matagumpay na na-update ang intercity rate",
        "Update_intercity_rate_fail": "Naganap ang mga error habang ina-update ang rate ng intercity",
        "Created_intercity_rate_success": "Matagumpay na nagawa ang intercity rate",
        "Created_intercity_rate_fail": "Naganap ang mga error habang gumagawa ng intercity rate",
        "Update_intercity_rate_route_success": "Matagumpay na na-update ang ruta ng intercity rate",
        "Update_intercity_rate_route_fail": "Naganap ang mga error habang ina-update ang ruta ng intercity rate",
        "Created_intercity_rate_route_success": "Matagumpay na nalikha ang ruta ng intercity rate",
        "Created_intercity_rate_route_fail": "Naganap ang mga error habang gumagawa ng intercity rate na ruta",
        "Loading_intercity_rate_fail": "Naganap ang mga error habang nilo-load ang detalye ng intercity rate",
        "Delete_intercity_rate_route_fail": "Naganap ang mga error habang tinatanggal ang ruta ng intercity rate",
        "Delete_intercity_rate_success": "Matagumpay na natanggal ang intercity rate",
        "Delete_intercity_rate_fail": "Naganap ang mga error habang tinatanggal ang rate ng intercity",
        "Update_regular_rate_success": "Matagumpay na na-update ang regular na rate",
        "Update_regular_rate_fail": "Naganap ang mga error habang ina-update ang regular na rate",
        "Create_regular_rate_success": "Matagumpay na nalikha ang regular na rate",
        "Create_regular_rate_fail": "Naganap ang mga error habang gumagawa ng regular na rate",
        "Update_hourly_rate_success": "Matagumpay na na-update ang oras-oras na rate",
        "Update_hourly_rate_fail": "Naganap ang mga error habang ina-update ang oras-oras na rate",
        "Create_hourly_rate_success": "Matagumpay na nalikha ang oras-oras na rate",
        "Create_hourly_rate_fail": "Naganap ang mga error habang gumagawa ng oras-oras na rate",
        "Update_hourly_rate_package_success": "Matagumpay na na-update ang package ng oras-oras na rate",
        "Update_hourly_rate_package_fail": "Naganap ang mga error habang ina-update ang package ng oras-oras na rate",
        "Create_hourly_rate_package_success": "Matagumpay na nalikha ang package ng oras-oras na rate",
        "Create_hourly_rate_package_fail": "Ang mga error ay nangyari habang gumagawa ng hourly rate package",
        "Load_hourly_rate_fail": "Naganap ang mga error habang naglo-load ng mga detalye ng oras-oras na rate",
        "Update_hourly_status": "Naganap ang mga error habang ina-update ang status ng oras-oras na rate",
        "Delete_hourly_fail": "Naganap ang mga error habang tinatanggal ang oras-oras na rate",
        "Delete_hourly_success": "Matagumpay na natanggal ang oras-oras na rate",
        "Loading_regular_rate_fail": "Naganap ang mga error habang naglo-load ng regular na rate",
        "Update_regular_status_fail": "Naganap ang mga error habang ina-update ang status ng regular na rate",
        "Delete_regular_rate_success": "Matagumpay na natanggal ang regular na rate",
        "Delete_regular_rate_fail": "Naganap ang mga error habang tinatanggal ang regular na rate",
        "Please_go_to_Car_Type_settings": "Upang ilapat ang rate na ito sa anumang uri ng kotse, mangyaring pumunta sa Mga Setting > Kotse > Uri ng Kotse.",
        "Car_type_filter": "Filter ng Uri ng Kotse",
        "Delete_package_error": "Nagkaroon ng error noong tinatanggal ang package!",
        "Pax_mDispatcher_cancellation_tooltip": "Inilapat ang patakaran sa pagkansela para sa mga pasahero",
        "Penalty_tooltip": "Ang halaga ng customer ay sisingilin. Bilang karagdagan sa multa maaari kang magdagdag ng buwis o tech fee.",
        "Pax_mDispatcher_no_show_tooltip": "No show policy na inilapat para sa mga pasahero. Sisingilin ang bayad na ito kung ita-tap ng mga driver ang \"No show\" kapag hindi nila nakita ang mga pasahero sa lokasyon ng pickup.",
        "detail_route": "Detalye ng ruta",
        "detail_package": "Detalye ng Package",
        "THIRD_DISTANCE_FEE": "Bayad sa ikatlong distansya",
        "AFTER_DISTANCE_FEE": "Pagkatapos ng third distance fee",
        "Loading_delivery_rate_fail": "Naganap ang mga error habang nilo-load ang detalye ng rate ng paghahatid",
        "Update_delivery_rate_fail": "Naganap ang mga error habang ina-update ang rate ng paghahatid",
        "Update_delivery_rate_success": "Ang rate ng paghahatid ay matagumpay na na-update",
        "Created_delivery_rate_success": "Matagumpay na nalikha ang rate ng paghahatid",
        "Created_delivery_rate_fail": "Naganap ang mga error habang gumagawa ng rate ng paghahatid",
        "Starting_fee": "Panimulang bayad",
        "First_distance": "Unang distansya",
        "Second_distance": "Pangalawang distansya",
        "Third_distance": "Pangatlong distansya",
        "Fee_for_second_distance": "Bayad para sa pangalawang distansya",
        "Fee_for_third_distance": "Bayad para sa ikatlong distansya",
        "Fee_after_third_distance": "Bayad pagkatapos ng ikatlong distansya",
        "Assign_rate_to_car_type": "I-assign ang rate sa cartype",
        "car_type": "Uri ng sasakyan",
        "PRICE_ADJUSTABLE": "Maaaring ayusin ang presyo",
        "Amount_Step": "Naiaangkop na presyo",
        "Tax": "Buwis",
        "TechFee": "Bayad sa teknolohiya",
        "Pay_to_driver": "Pay to driver",
        "Pay_to_driver_tooltip": "Mga opsyon para sa kompensasyon ng mga driver:\n - Tiyak na halaga: Isang tiyak na halaga na matatanggap ng driver.\n - Komisyon: Itinakdang komisyon ng driver na ilalapat sa halaga ng parusa.",
        "Fix_amount": "Dami",
        "Commission": "Komisyon",
        "fareFlat": "Patas na pamasahe",
        "flatRoute": "Patag na ruta",
        "Mode": "Mode",
        "speedThresholdKM": "Hangganan ng bilis (km/h)",
        "speedThresholdMI": "Hangganan ng bilis (mi/h)",
        "timeAndMileage": "Oras at milyahe",
        "timeOrMileage": "Oras o milyahe",
        "perDistanceKM": "Sa bawat kilometro",
        "perDistanceMI": "Bawat milya",
        "perTime": "Bawat minuto",
        "regularRates": "Regular na Rate",
        "newRate": "Bagong Rate",
        "enterName": "Ilagay ang Pangalan ng Rate",
        "actualMode": "Aktwal na pamasahe",
        "estimatedMode": "Sinipi na pamasahe",
        "feePerStop": "Bayad sa Bawat Karagdagang Hintuan",
        "extraWaitTime": "Karagdagang oras ng paghihintay",
        "startingFee": "Nagsisimula",
        "minimumFee": "Minimum",
        "minAppend": "/min",
        "kmAppend": "/km",
        "miAppend": "/mi",
        "kmhrAppend": "km/h",
        "mihrAppend": "mi/h",
        "feePerKm": "Bawat kilometro",
        "feePerMi": "Sa bawat milya",
        "feeSpeedThreshold": "Hangganan ng bilis",
        "serviceType": "Uri ng Serbisyo",
        "fareMode": "Pormula",
        "calculationMode": "Mode ng Pagkalkula",
        "timeChangeMode": "Mode ng Singil sa Oras",
        "minimum_Percent_Adjust": "Minimum % mula sa tinatayang pamasahe",
        "maximum_Percent_Adjust": "Maximum % mula sa tinatayang pamasahe",
        "AllowAdjustPrice": "Payagan ang Customer na Ayusin ang Presyo",
        "Calculation": "Kalkulasyon",
        "distanceTier": "Antas ng Distansya",
        "perKm": "Bayad bawat km",
        "perMi": "Bayad bawat mi",
        "flatFee": "Patag na Bayad",
        "defaultRate": "Default Rate",
        "timeRange": "Hanay ng Oras",
        "bookingType": "Uri ng Pagbu-book",
        "rateDetail": "Detalye ng Rate",
        "subRate": "Sub Rate",
        "specialRates": "Espesyal na Rate",
        "surcharge": "Karagdagang bayad",
        "penalty": "Parusa",
        "basedOriginMode": "Batay sa orihinal na oras ng pagkuha",
        "basedDriverMode": "Batay sa oras ng pagkuha ng drayber",
        "hourlyRate": "Rate ng Oras",
        "flat_Fare": "Patag na Bayad",
        "flatFeeOption": "Patag na bayad",
        "fareModeTooltip": "Ang oras o milyahe ay naaangkop lamang sa mga rate ng customer, hindi ito magiging naaangkop para sa rate ng bayad ng supplier/drayber.",
        "cloneRate": "Clone Rate",
        "rateName": "Pangalan ng Rate",
        "Infinity": "Walang Hanggan",
        "Fee": "Bayad",
        "headerTile": "Ilagay ang pamagat ng header",
        "enterFooter": "Ilagay ang pamagat ng footer",
        "invoiceNo": "Numero ng Invoice",
        "paidOn": "Binayaran Sa",
        "amountPaid": "Halagang Bayad",
        "isFeePerSeatActive": "Singil bawat pasahero",
        "minSeat": "Minimum na bilang ng mga pasahero",
        "minSeatTooltip": "Ito ang pinakamababang bilang ng mga upuan na dapat singilin para sa isang booking.",
        "dropOffZoneIds": "Mga Lugar ng Pagbaba",
        "applyGeniusDiscount": "Booking.com: Mag-apply ng Genius Discount(5%)"
    },
    "flatRateSettings": {
        "flatZoneNote": "Ang mga zone na nilikha mo dito ay ginagamit lamang upang itakda ang iyong mga flat rate."
    },
    "deliverySetting": {
        "Name": "Pangalan",
        "Last_Update": "Huling Update",
        "Status": "Katayuan",
        "Actions": "Aksyon"
    },
    "sharingSetting": {
        "EDIT_RATE": "I-edit ang rate ng pagbabahagi ng kalye",
        "ADD_RATE": "Magdagdag ng rate sa pagbabahagi ng kalsada",
        "VIEW_RATE": "Tingnan ang rate ng pagbabahagi ng kalye",
        "Name": "Pangalan",
        "startingFee": "Simulang pamasahe",
        "minimumFee": "Minimum na pamasahe",
        "Update_streetSharing_rate_fail": "Ang mga pagkakamali ay nangyari habang ina-update ang rate ng pagbabahagi ng kalye",
        "Update_streetSharing_rate_success": "Ang rate ng pagbabahagi ng kalsada ay matagumpay na na-update",
        "Created_streetSharing_rate_success": "Ang rate ng pagbabahagi ng kalye ay matagumpay na nalikha",
        "Created_streetSharing_rate_fail": "Nangyari ang mga error habang gumagawa ng street sharing rate",
        "Loading_streetSharing_rate_fail": "Nangyari ang mga error habang naglo-load ng detalye ng rate ng street sharing",
        "Delete_streetSharing_rate_success": "Matagumpay na na-delete ang rate ng street sharing",
        "Delete_streetSharing_rate_fail": "Nangyari ang mga error habang binubura ang rate ng street sharing",
        "Delete_streetSharing_rate": "Burahin ang rate ng pagbabahagi ng kalye",
        "Assign_Car": "Magtalaga ng uri ng sasakyan"
    },
    "carTypeSetting": {
        "ID": "Cartype ID",
        "newService": "Bagong Serbisyo",
        "editService": "Isedit ang Serbisyo",
        "serviceInfo": "Impormasyon ng Serbisyo",
        "name": "Pangalan",
        "namePH": "Pangalan ng uri ng sasakyan",
        "enterNumber": "Maglagay ng numero",
        "appDisplayName": "App display name",
        "shortDescription": "Maikling paglalarawan",
        "maxPassengers": "Max na pasahero",
        "maxLuggage": "Max na bagahe",
        "vehiclePhoto": "Mga Larawan ng Sasakyan",
        "iconShowList": "Ikon na ipapakita sa listahan",
        "imageShowWeb": "Larawan na ipapakita sa web",
        "carPinOnMap": "Car PIN sa mapa",
        "recommendedSize": "Inirerekomendang sukat:",
        "serviceSetting": "Mga Setting ng Serbisyo",
        "serviceType": "Uri ng serbisyo",
        "reservation": "Rekober",
        "onDemand": "On-demand",
        "destinationSetting": "Pagtatakda ng destinasyon",
        "requireDestination": "Kailangan ng patutunguhan",
        "extraDestination": "Karagdagang destinasyon",
        "calculatorFareMode": "Kalkulahin ang paraan ng pamasahe",
        "hideDestinationOnDemand": "On-demand",
        "meteredFare": "Sinusukat na pamasahe",
        "quotedFare": "Sinipi na pamasahe",
        "availableZones": "Available Zones",
        "dispatchAssociation": "Samahan ng Dispatch",
        "Save": "I-save",
        "Edit": "Isagawa",
        "Cancel": "Ikansela",
        "validateName": "Pakisulat ang pangalan",
        "validateAppDisplayName": "Please input app display name",
        "validateSelectImage": "Pakis chọn ang isang imahe",
        "updateSuccess": "Matagumpay na na-update",
        "createSuccess": "Matagumpay na nalikha",
        "failApi": "May nangyaring mali!",
        "validateRequire": "Pakispecify ang bilang ng pasahero at suriin muli ang bagahe."
    },
    "carSetting": {
        "Details": "Mga Detalye",
        "vehicleInfo": "Impormasyon ng Sasakyan",
        "Documents": "Mga Dokumento",
        "vehicle": "Sasakyan",
        "addVehicle": "Magdagdag ng Sasakyan",
        "detailVehicle": "Mga Detalye ng Sasakyan",
        "additionalVehicleTitle": "Karagdagang Impormasyon sa Sasakyan",
        "Phone_Number_Tooltip": "Maglagay ng tiyak na numero ng telepono para sa sasakyan para sa paggamit ng customer. Kung hindi ito ibinigay, ang mga tawag ay mapupunta sa personal na numero ng driver. Mainam ito para sa mga supplier na nag-eequip ng mga sasakyan ng mga nakalaang telepono para sa pakikipag-ugnayan.",
        "discardChange": "Iwaksi ang mga pagbabago",
        "model_name_is_required": "Kailangan ang pangalan ng modelo",
        "DELETE_CAR": "Burahin ang sasakyan",
        "DELETE_CONFIRM": "Gusto mo bang tanggalin ang napiling sasakyan?",
        "Yes": "Oo",
        "Cancel": "Kanselahin",
        "EDIT_CAR": "Baguhin ang sasakyan",
        "CREATE_CAR": "Lumikha ng sasakyan",
        "Plate_Number": "Numero ng Plaka",
        "Car_Type": "Uri ng kotse",
        "Select_car_type": "Pumili ng uri ng sasakyan",
        "Make": "Gumawa",
        "Select_car_make": "Pumili ng tatak ng sasakyan",
        "Model": "Modelo",
        "Select_a_car_model": "Pumili ng modelo ng sasakyan",
        "Year": "Taon ng Produksyon",
        "Select_year": "Pumili ng taon",
        "Hardware_Meter": "Hardware Meter",
        "VIN": "Numero ng pagkakakilanlan ng sasakyan (VIN)",
        "Company": "kumpanya",
        "Select_company": "Pumili ng kumpanya",
        "Max_Passengers": "Max na Pasahero",
        "Max_Luggage": "Max Luggage",
        "Color": "Kulay",
        "License_expiry": "Pagtatapos ng lisensya",
        "Required_fields": "Mga kinakailangang patlang",
        "Save": "I-save",
        "Add": "Idagdag",
        "Car_Model": "Modelo ng Sasakyan",
        "Created_Date": "Petsang Nilikha",
        "Status": "Katayuan",
        "Actions": "Aksyon",
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "show_pages": "{0} - {1} ng {2} na ipinapakita",
        "Active": "Aktibo",
        "activeVehicle": "Aktibong sasakyan",
        "Inactive": "Hindi aktibo",
        "Edit": "I-edit",
        "Deactivate": "Idiskonekta",
        "Activate": "Isaaktibo",
        "Delete": "Tanggalin",
        "Name": "Pangalan",
        "MODEL_LIST": "Listahan ng modelo",
        "Model_Name": "Pangalan ng modelo",
        "Add_Model": "Magdagdag ng modelo",
        "DELETE_CAR_MODEL": "Burahin ang modelo ng sasakyan",
        "DELETE_CONFIRM_MODEL": "Gusto mo bang tanggalin ang modelo ng sasakyan?",
        "DELETE_CAR_MAKE": "Burahin ang tatak ng sasakyan",
        "DELETE_CONFIRM_CAR_MAKE": "Gusto mo bang tanggalin ang brand ng sasakyang ito?",
        "EDIT_CAR_MAKE": "I-edit ang tatak ng sasakyan",
        "CREATE_CAR_MAKE": "Magdagdag ng tatak ng sasakyan",
        "Assign_Rate": "Assign Rate",
        "ASSIGN_RATE": "Magtalaga ng rate",
        "Car_type_ID": "ID ng uri ng sasakyan",
        "App_Display_Name": "App Display Name",
        "Affiliate_car_type": "Uri ng Sasakyan ng Affiliate",
        "Regular_rate": "Regular na rate",
        "Zone": "Zone",
        "Rate": "Rate",
        "Zone_Rate": "Sona - Rate",
        "Flat_Fare": "Patag na Bayad",
        "Flat_Delivery": "Patag na paghahatid",
        "Select_flat_rate": "Pumili ng nakatakdang halaga",
        "Hourly_daily_rate": "Oras/ Araw",
        "Dispatch_To": "Ipapadala Sa",
        "Normal_Fare": "Regular",
        "Upload_an_image": "I-upload ang isang larawan",
        "DETAIL_CAR": "Paglilinis ng sasakyan",
        "DELETE_MULTI_CAR": "Burahin ang napiling mga sasakyan",
        "DELETE_MULTI_CAR_CONFIRM": "Gusto mo bang tanggalin ang mga sasakyang ito? Tanging mga sasakyan lamang na nasa inactive status ang maaaring tanggalin?",
        "DETAIL_CAR_MAKE": "Brand ng Sasakyan",
        "Car_Make": "Marca ng Sasakyan",
        "Create_car_success": "Matagumpay na nalikha ang bagong sasakyan",
        "Update_car_success": "Ang sasakyang ito ay matagumpay na na-update.",
        "Update_car_fail": "Nangyari ang mga error habang ina-update ang sasakyan",
        "Create_car_fail": "Ang mga error ay nangyari habang gumagawa ng sasakyan",
        "Load_car_fail": "Nangyari ang mga error habang naglo-load ng kotse",
        "Delete_car_fail": "Nagkaroon ng mga error habang binubura ang sasakyan",
        "Delete_car_success": "Matagumpay na na-delete ang sasakyan",
        "Change_cars_status_success": "Ang lahat ng estado ng sasakyan ay matagumpay na nabago",
        "Change_cars_status_fail": "Ang mga pagkakamali ay nangyari habang binabago ang mga estado ng sasakyan.",
        "Delete_cars_success": "Lahat ng napiling sasakyan ay matagumpay na na-delete.",
        "Delete_cars_fail": "Ang mga error ay nangyari habang nagbubura ng mga sasakyan",
        "Update_car_type_success": "Ang uri ng sasakyan ay matagumpay na na-update",
        "Update_car_type_fail": "Nangyari ang mga error habang ina-update ang uri ng sasakyan",
        "Load_car_type_details_fail": "Hindi ma-load ang mga detalye ng uri ng sasakyan",
        "Update_car_make_fail": "Nangyari ang mga error habang ina-update ang tatak ng sasakyan",
        "Update_car_make_success": "Ang tatak ng sasakyan ay matagumpay na na-update",
        "Create_car_make_fail": "Nagkaroon ng mga error habang gumagawa ng tatak ng sasakyan",
        "Create_car_make_success": "Matagumpay na nalikha ang bagong tatak ng sasakyan",
        "Update_car_model_fail": "Nangyari ang mga error habang ina-update ang modelo ng kotse",
        "Update_car_model_success": "Ang modelo ng sasakyan ay na-update nang matagumpay.",
        "Create_car_model_fail": "Nangyari ang mga error habang gumagawa ng modelo ng kotse",
        "Create_car_model_success": "Ang bagong modelo ng sasakyan ay matagumpay na nalikha",
        "Loading_car_model_fail": "Nangyari ang mga error habang naglo-load ng modelo ng sasakyan",
        "Delete_car_make_success": "Matagumpay na na-delete ang tatak ng sasakyan",
        "Delete_cat_make_fail": "Nagkaroon ng mga error habang binubura ang tatak ng sasakyan",
        "Delete_regular_rate_success": "Matagumpay na natanggal ang Regular na rate",
        "Delete_regular_rate_fail": "Burahin ang error sa Regular rate",
        "Update_status_error": "Error sa pag-update ng status",
        "Case_number": "Numero ng kaso",
        "Phone_Number": "Numero ng telepono",
        "ERROR_INPUT_VALIDPHONE": "Pakisok ang wastong numero ng telepono.",
        "Car_type_filter": "Filter ng uri ng sasakyan",
        "No": "Hindi",
        "Intercity_Rate": "Intercity Rate",
        "Select_intercity_rate": "Pumili ng intercity rate",
        "Delivery_Rate": "Rate ng Paghahatid",
        "Select_delivery_rate": "Pumili ng rate ng paghahatid",
        "vehicleOwner": "Pangalan ng may-ari ng sasakyan",
        "EDIT_CAR_COLOR": "I-edit ang kulay ng sasakyan",
        "DETAIL_CAR_COLOR": "Detalye ng kulay ng sasakyan",
        "CREATE_CAR_COLOR": "Magdagdag ng kulay ng kotse",
        "Car_Color": "Kulay ng sasakyan",
        "Update_car_color_fail": "Nangyari ang mga error habang ina-update ang kulay ng sasakyan.",
        "Update_car_color_success": "Ang kulay ng sasakyan ay matagumpay na na-update.",
        "Create_car_color_fail": "Nangyari ang mga error habang nililikha ang kulay ng kotse.",
        "Create_car_color_success": "Bagong kulay ng kotse ay matagumpay na nalikha",
        "Delete_car_color_success": "Matagumpay na na-delete ang kulay ng sasakyan.",
        "Delete_car_color_fail": "Nangyari ang mga error habang tinatanggal ang kulay ng sasakyan.",
        "DELETE_CAR_COLOR": "Burahin ang kulay ng sasakyan",
        "DELETE_CONFIRM_CAR_COLOR": "Gusto mo bang tanggalin ang kulay ng sasakyang ito?",
        "sharing_Rate": "Rate ng Paghahati sa Kalye",
        "bookingAffiliate": "Uri ng sasakyan ng Affiliate Booking.com",
        "streetSharing": "Pagbabahagi ng Kalye",
        "colorCode": "Kulay ng code",
        "selectColorCode": "Pumili ng kulay na code"
    },
    "operationSetting": {
        "Driver": "Driver",
        "Search_driver_name": "Hanapin ang pangalan ng drayber",
        "Company": "kumpanya",
        "License_plate": "Plaka ng sasakyan",
        "Select_license_plate": "Pumili ng plaka ng sasakyan",
        "Shift": "Shift",
        "Zone": "Zone",
        "Required_fields": "Mga kinakailangang patlang",
        "Save": "I-save",
        "No": "Bilang",
        "Car_Type": "Uri ng kotse",
        "Plate_Number": "Numero ng Plaka",
        "Unassign": "Alisin ang takdang gawain",
        "Please_choose_driver": "Pakisuyong pumili ng drayber.",
        "Please_choose_company": "Pakisuyong pumili ng kumpanya.",
        "Please_license_plate": "Pakisuyong pumili ng plaka.",
        "Please_choose_shift": "Pakisuyong pumili ng shift.",
        "Please_choose_zone": "Pakisuyong pumili ng sona.",
        "CONFIRM_UNASSIGN": "Gusto mo bang alisin ang pagkaka-assign sa drayber na ito?",
        "Assign_success": "Ang operasyon ay matagumpay na naitalaga",
        "Unassign_success": "Matagumpay na naalis ang driver."
    },
    "paymentMethod": {
        "cash": "Pera",
        "easyPaisa": "Easy Paisa",
        "jazzCash": "Jazz Cash",
        "cashBySender": "Cash ng nagpadala",
        "cashByRecipient": "Cash ng tumanggap",
        "personalCard": "Personal na card",
        "corporateCard": "Korporatibong kard",
        "qrCodePayment": "QR code na bayad",
        "directBilling": "Direktang Pagsingil",
        "externalCard": "Panlabas na kard",
        "mDispatcherCard": "Kard ng kasosyo",
        "corporatePrepaid": "Korporatibong prepaid",
        "fleetCard": "Panlabas na kard",
        "applePay": "Apple Pay",
        "creditExternalCard": "Kard ng kredito",
        "googlePay": "Google Pay",
        "wallet": "Wallet",
        "BankOfGeorgia": "Bank Of Georgia",
        "tnGeWalletlet": "TnG eWallet",
        "paymentMethod_1": "Pera",
        "paymentMethod_2": "Personal na card",
        "paymentMethod_3": "Kard ng kasosyo",
        "paymentMethod_4": "Korporatibong kard",
        "paymentMethod_5": "Direktang Pagsingil",
        "paymentMethod_6": "Panlabas na kard",
        "paymentMethod_7": "Korporatibong prepaid",
        "paymentMethod_8": "QR code na pagbabayad",
        "paymentMethod_9": "Apple Pay",
        "paymentMethod_11": "Airpay",
        "paymentMethod_12": "Kard ng kredito",
        "paymentMethod_13": "Wallet",
        "paymentMethod_14": "TnG eWallet",
        "paymentMethod_16": "Cash ng nagpadala",
        "paymentMethod_17": "Cash ng tumanggap",
        "paymentMethod_19": "Boost eWallet",
        "paymentMethod_20": "Vipps",
        "paymentMethod_21": "ZainCash",
        "paymentMethod_23": "Google Pay",
        "paymentMethod_25": "Easy Paisa",
        "paymentMethod_27": "Samsung Pay",
        "paymentMethod_28": "Kakao Pay",
        "paymentMethod_29": "Naver Pay",
        "paymentMethod_30": "WeChat Pay",
        "paymentMethod_31": "Alipay",
        "paymentMethod_32": "PayNow",
        "paymentMethod_33": "GrabPay",
        "paymentMethod_34": "Cash App Pay",
        "vippseWallet": "Vipps",
        "paymentMethod_credit": "Personal na card",
        "paymentMethod_razerPay": "RazerPay",
        "paymentMethod_gCash": "GCash",
        "paymentMethod_zainCash": "ZainCash",
        "paymentMethod_xenDit": "Xendit",
        "paymentMethod_alipayExternal": "Alipay",
        "paymentMethod_FIB": "FIB",
        "paymentMethod_SantimPay": "SantimPay",
        "paymentMethod_ksher": "Ksher",
        "paymentMethod_paydunya": "PayDunya",
        "paymentMethod_fawry": "Fawry",
        "paymentMethod_BankOfGeorgia": "Bank Of Georgia",
        "paymentLink": "Link ng bayad",
        "paymentMethod_xendit": "Xendit",
        "paymentMethod_easyPaisa": "Easy Paisa",
        "paymentMethod_jazzCash": "Jazz Cash",
        "paymentMethod_flooz": "Flooz",
        "paymentMethod_tmoney": "Tmoney",
        "paymentMethod_samsung_pay": "Samsung Pay",
        "paymentMethod_kakao_pay": "Kakao Pay",
        "paymentMethod_naver_pay": "Naver Pay",
        "paymentMethod_wechat_pay": "WeChat Pay",
        "paymentMethod_alipay": "Alipay",
        "paymentMethod_paynow": "PayNow",
        "paymentMethod_grabpay": "GrabPay",
        "paymentMethod_cashapp": "Cash App Pay"
    },
    "changePassword": {
        "Change_password": "Palitan ang password",
        "Current_password": "Kasalukuyang password",
        "New_password": "Bagong password",
        "Confirm_password": "Kumpirmahin ang password",
        "ERROR_INPUT_PASSWORD": "Pakilagay ang password",
        "ERROR_INPUT_VALID_PASSWORD": "Ang password ay dapat magkaroon ng hindi bababa sa 8 na karakter, isang numerong digit at isang espesyal na karakter.",
        "ERROR_INPUT_MATCH_PASSWORD": "Hindi nagtutugma ang password. Pakisubukan muli.",
        "Save": "I-save",
        "Cancel": "Kanselahin"
    },
    "userProfile": {
        "My_account": "Ang aking account",
        "Username": "Username",
        "First_name": "Unang Pangalan",
        "Last_name": "Huling pangalan",
        "Phone_number": "Numero ng telepono",
        "Email_address": "Email address",
        "Address": "Address",
        "Save": "I-save",
        "Edit_profile": "I-edit ang profile",
        "Change_password": "Palitan ang password",
        "ERROR_INPUT_USERNAME": "Pakisok ang username.",
        "ERROR_INPUT_FIRSTNAME": "Pakisulat ang unang pangalan.",
        "ERROR_INPUT_VALID_EMAIL": "Pakisok ang wastong email.",
        "Required_fields": "Mga kinakailangang patlang"
    },
    "General": {
        "widgetChat": "Support / Chat",
        "searchQueuingDriver": "Maghanap: Pangalan ng Driver, Numero ng Telepono",
        "search": "Maghanap",
        "User": "User",
        "My_Account": "Ang Aking Account",
        "Product_Discovery": "Pagtuklas ng Produkto",
        "Sign_out": "Mag-sign out",
        "My_site": "Ang aking site",
        "Command_center": "Sentro ng Utos",
        "Notifications": "Mga Abiso",
        "Show_all": "Ipakita Lahat",
        "SOS_Notifications": "SOS Abiso",
        "You_dont_have_any_message": "Wala kang anumang mensahe",
        "Mon": "Mon",
        "Tue": "Tue",
        "Wed": "Wed",
        "Thu": "Huwebes",
        "Fri": "Fri",
        "Sat": "Sabado",
        "Sun": "Araw",
        "Now": "Ngayon",
        "NowComplete": "Ngayon (Tunay na Oras ng Pagkuha)",
        "hrs": "oras",
        "patmentMethod_1": "Salapi",
        "patmentMethod_2": "Personal na card",
        "patmentMethod_3": "Kard ng kasosyo",
        "patmentMethod_4": "Corporate Card",
        "patmentMethod_5": "Direktang pagsingil",
        "patmentMethod_6": "Panlabas na kard",
        "patmentMethod_7": "Corporate Prepaid",
        "patmentMethod_8": "QR Code",
        "patmentMethod_9": "Apple Pay",
        "patmentMethod_10": "Apple Pay",
        "patmentMethod_12": "Credit card",
        "patmentMethod_13": "Wallet",
        "patmentMethod_14": "TnG eWallet",
        "patmentMethod_16": "Cash ng nagpadala",
        "patmentMethod_17": "Cash ng tumanggap",
        "patmentMethod_19": "Palakasin",
        "patmentMethod_20": "Vipps",
        "patmentMethod_23": "Google Pay",
        "patmentMethod_24": "Link ng Bayad",
        "patmentMethod_25": "Easy Paisa",
        "patmentMethod_26": "Jazz Cash",
        "patmentMethod_27": "Samsung Pay",
        "patmentMethod_28": "Kakao Pay",
        "patmentMethod_29": "Naver Pay",
        "patmentMethod_30": "WeChat Pay",
        "patmentMethod_31": "Alipay",
        "patmentMethod_32": "PayNow",
        "patmentMethod_33": "GrabPay",
        "patmentMethod_34": "Cash App Pay",
        "patmentMethod_ZainCash": "ZainCash",
        "patmentMethod_Xendit": "Xendit",
        "patmentMethod_FIB": "FIB",
        "patmentMethod_SantimPay": "SantimPay",
        "patmentMethod_GCash": "GCash",
        "patmentMethod_cash": "Pera",
        "patmentMethod_credit": "Personal na card",
        "patmentMethod_mDispatcher": "Partner card",
        "patmentMethod_corpCredit": "Corporate Card",
        "patmentMethod_directBilling": "Direct invoicing",
        "patmentMethod_fleetCard": "Panlabas na kard",
        "patmentMethod_prepaid": "Corporate Prepaid",
        "patmentMethod_QRCode": "QR Code",
        "patmentMethod_applePay": "Apple Pay",
        "patmentMethod_easyPaisa": "Easy Paisa",
        "patmentMethod_jazzCash": "Jazz Cash",
        "patmentMethod_prePaid": "Corporate Prepaid",
        "patmentMethod_GooglePay": "Google Pay",
        "patmentMethod_creditCardExternal": "Credit card",
        "patmentMethod_exXendit": "QRIS",
        "patmentMethod_PaxWallet": "Wallet",
        "patmentMethod_TnGeWallet": "TnG eWallet",
        "patmentMethod_boosteWallet": "Palakasin",
        "patmentMethod_Vipps": "Vipps",
        "patmentMethod_exZainCash": "ZainCash",
        "patmentMethod_exGCash": "GCash",
        "patmentMethod_exPayTM": "PayTM",
        "patmentMethod_exFlooz": "Flooz",
        "patmentMethod_exTmoney": "Tmoney",
        "patmentMethod_exTelebirr": "GCash",
        "paymentMethod_exzainCash": "ZainCash",
        "paymentMethod_exXendit": "Xendit",
        "paymentMethod_exalipay": "Alipay",
        "paymentMethod_exFIB": "FIB",
        "paymentMethod_exSantimPay": "SantimPay",
        "patmentMethod_exKsher": "Ksher",
        "paymentMethod_paydunya": "PayDunya",
        "paymentMethod_exfawry": "Fawry",
        "patmentMethod_exBankOfGeorgia": "Bank Of Georgia",
        "patmentMethod_exPayDunya": "PayDunya",
        "patmentMethod_21": "ZainCash",
        "patmentMethod_paymentLink": "Link ng Bayad",
        "patmentMethod_card": "Personal na card",
        "patmentMethod_corporateCard": "Korporatibong kard",
        "patmentMethod_paxWallet": "Pitaka",
        "patmentMethod_externalWallet": "Panlabas na Wallet",
        "patmentMethod_googlePay": "Google Pay",
        "patmentMethod_manual": "Manwal",
        "patmentMethod_samsung_pay": "Samsung Pay",
        "patmentMethod_kakao_pay": "Kakao Pay",
        "patmentMethod_naver_pay": "Naver Pay",
        "patmentMethod_wechat_pay": "WeChat Pay",
        "patmentMethod_alipay": "Alipay",
        "patmentMethod_paynow": "PayNow",
        "patmentMethod_grabpay": "GrabPay",
        "patmentMethod_cashapp": "Cash App Pay",
        "patmentMethod_online": "Kard/Online na Bayad",
        "patmentMethod_check": "Suriin",
        "patmentMethod_wire": "Kable",
        "patmentMethod_digitalWallet": "Digital Wallet",
        "patmentMethod_bankTransfer": "Paglipat ng Pondo",
        "patmentMethod_offlineMethod": "Offline na Bayad",
        "patmentAirlineMethod_5": "Direct invoicing",
        "patmentAirlineMethod_4": "Kard ng Airline",
        "patmentAirlineMethod_7": "Prepaid ng Airline",
        "Name": "Pangalan",
        "Delete": "Tanggalin",
        "App_SOS_dialog_form_message_1": "{0} Emergency SOS!",
        "App_SOS_dialog_form_message_2": "Kailangan ko ng tulong sa",
        "App_SOS_dialog_form_message_3": "Pag-book: {0}, Driver: {1}, Pasahero: {2}, Plaka: {3} ({4})",
        "mins": "minuto",
        "Credit_Card": "Kard ng kredito",
        "ALL": "Lahat",
        "NotFound": "Hindi mahanap ang pahinang iyong hiniling.",
        "ServerError": "May nangyaring mali",
        "AccessDenied": "Wala kang pahintulot na ma-access ang module na ito!",
        "Retry": "Subukan muli",
        "Can_not_get_data": "Hindi makakuha ng data"
    },
    "shiftSettings": {
        "Add": "Idagdag",
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "Name": "Pangalan",
        "Time_Range": "Hanay ng Oras",
        "Actions": "Aksyon",
        "show_pages": "{0} - {1} ng {2} na ipinakita",
        "Edit": "Isagawa ang pagbabago",
        "Delete": "Tanggalin",
        "EDIT_SHIFT_SETTING": "I-edit ang setting ng shift",
        "ADD_SHIFT_SETTING": "Magdagdag ng setting ng shift",
        "DETAIL_SHIFT_SETTING": "Pag-set ng detalye ng shift",
        "DELETE_SHIFT_SETTING": "Burahin ang setting ng shift",
        "Delete_confirm_shift_setting": "Gusto mo bang tanggalin ang item na ito?",
        "Required_fields": "Mga kinakailangang patlang",
        "Save": "I-save",
        "Cancel": "Kanselahin",
        "From": "Mula",
        "To": "Sa",
        "Edit_shift_template": "Baguhin ang Template ng Shift",
        "Add_shift_template": "Magdagdag ng Shift Template",
        "Detail_shift_template": "Template ng Detalye ng Shift",
        "Delete_shift_template": "Burahin ang Shift Template",
        "Delete_confirm_shift_template": "Gusto mo bang tanggalin ang item na ito?",
        "Working_time": "Oras ng Trabaho",
        "Create_shift_settings_success": "Bagong setting ng shift ay matagumpay na nalikha",
        "Create_shift_settings_fail": "Nangyari ang mga error habang gumagawa ng shift setting",
        "Update_shift_settings_success": "Na-update nang matagumpay ang setting ng shift",
        "Update_shift_settings_fail": "Ang mga error ay nangyari habang ina-update ang setting ng shift",
        "Delete_shift_settings_success": "Matagumpay na na-delete ang setting ng shift",
        "Delete_shift_settings_fail": "Nangyari ang mga error habang binubura ang setting ng shift",
        "Create_shift_template_success": "Matagumpay na nalikha ang bagong template ng shift",
        "Create_shift_template_fail": "Nangyari ang mga error habang gumagawa ng shift template",
        "Update_shift_template_success": "Na-update nang matagumpay ang template ng shift",
        "Update_shift_template_fail": "Nangyari ang mga error habang ina-update ang shift template",
        "Delete_shift_template_success": "Nabura nang matagumpay ang template ng shift",
        "Delete_shift_template_fail": "Nangyari ang mga error habang binubura ang shift template",
        "Yes": "Oo",
        "No": "Hindi"
    },
    "promotionSettings": {
        "Detail_campaign": "Detalye ng Kampanya",
        "Edit_campaign": "Baguhin ang Kampanya",
        "Add_campaign": "Magdagdag ng Kampanya",
        "Delete_campaign": "Burahin ang Kampanya",
        "Delete_confirm_campaign": "Gusto mo bang tanggalin ang napiling kampanya?",
        "Add": "Idagdag",
        "Corporate_list": "Listahan ng korporasyon",
        "permittedCorporate": "Pinapayagang listahan ng mga korporasyon",
        "CorporateCustomers": "Mga Kliyenteng Korporasyon",
        "auto_add_corporate": "Awtomatikong idagdag sa listahan ng promosyon ng Corporate User",
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "Name": "Pangalan",
        "Actions": "Aksyon",
        "Private": "Pribado",
        "show_pages": "{0} - {1} ng {2} na ipinakita",
        "Edit": "Isagawa",
        "Delete": "Tanggalin",
        "Send_to_inbox": "Ipadala sa inbox",
        "Save": "I-save",
        "Duplicate": "Duplicate",
        "Cancel": "Kanselahin",
        "Required_fields": "Mga kinakailangang patlang",
        "Promotion_code": "Promosyon Kodigo",
        "Promotion_type": "Uri ng Promosyon",
        "Campaign": "Kampanya",
        "Type": "Uri",
        "Value": "Halaga",
        "keepMinFee": "Ang kabuuang pamasahe pagkatapos ng promo ay dapat mas mataas kaysa sa minimum na pamasahe.",
        "Zone": "Mga Zone",
        "paymentMethodsApply": "Mga paraan ng pagbabayad",
        "schedules": "Mga Iskedyul",
        "minimumEstFareApply": "Minimum na tinatayang kabuuang pamasahe upang ilapat ang code",
        "quantityLimitPerYear": "Pinakamataas na gamit/user/taon",
        "termAndCondition": "Mga Tuntunin at Kundisyon",
        "Valid_from": "Valido Mula",
        "Valid_to": "Valido Hanggang",
        "Total_uses_user": "Kabuuang Paggamit/Gumagamit",
        "Released_quantity": "Naipadalang Dami",
        "Number_of_sending_inbox": "Bilang ng Pagpapadala ng Inbox",
        "Status": "Katayuan",
        "Activate": "Isagawa",
        "Deactivate": "Idiskonekta",
        "Add_promotion_code": "Magdagdag ng Promotion Code",
        "Edit_promotion_code": "I-edit ang Promotion Code",
        "Detail_promotion_code": "Detalye ng Kodigo ng Promosyon",
        "Delete_promotion_code": "Burahin ang Promo Code",
        "Delete_confirm_promotion_code": "Gusto mo bang tanggalin ang napiling promotion code?",
        "New_customer": "Mga bagong customer",
        "Budget_per_user": "Budget/user (para sa buong panahon ng promosyon)",
        "Budget_per_user_day": "Budget/gumagamit/araw",
        "Budget_per_user_month": "Budget/user/buwan",
        "Budget_per_user_year": "Budget/user/year",
        "Unlimited": "Walang hanggan",
        "Limited": "Limitado",
        "Total_uses_per_user": "Pinakamataas na gamit/user (para sa buong panahon ng promosyon)",
        "Send_an_in_box_automatically_to_new_customers": "Magpadala ng inbox nang awtomatiko sa mga bagong customer",
        "Notes": "Mga Tala",
        "Public": "Publiko",
        "Create_campaign_success": "Matagumpay na nalikha ang bagong kampanya",
        "Create_campaign_fail": "Ang mga error ay nangyari habang gumagawa ng kampanya",
        "Update_campaign_success": "Ang kampanya ay matagumpay na na-update",
        "Update_campaign_fail": "Ang mga error ay nangyari habang ina-update ang kampanya",
        "Delete_campaign_success": "Matagumpay na na-delete ang kampanya",
        "Delete_campaign_fail": "Nangyari ang mga error habang binubura ang kampanya",
        "Loading_campaign_fail": "Ang mga error ay nangyari habang naglo-load ng kampanya",
        "Update_campaign_status_success": "Ang katayuan ng kampanya ay na-update nang matagumpay",
        "Update_campaign_status_fail": "Ang mga error ay nangyari habang ina-update ang katayuan ng kampanya",
        "Loading_promotion_code_fail": "Nangyari ang mga error habang naglo-load ng promotion code",
        "Select_campaign": "Pumili ng Kampanya",
        "Create_promotion_code_success": "Bagong code ng promosyon ang matagumpay na nalikha",
        "Create_promotion_code_fail": "Ang mga error ay nangyari habang gumagawa ng promotion code",
        "Update_promotion_code_status_success": "Ang katayuan ng promotion code ay na-update nang matagumpay",
        "Update_promotion_code_status_fail": "Ang mga error ay nangyari habang ina-update ang katayuan ng promotion code",
        "Delete_promotion_code_confirmation": "Gusto mo bang burahin ang mga code ng promosyon na ito?",
        "Just_delete_inactive": "** Tanging ang mga promotion code na nasa inactive status lamang ang maaaring tanggalin.",
        "Send_inbox_confirmation": "Sigurado ka bang nais mong ipadala ang promo code na ito sa inbox ng pasahero?",
        "Send_inbox_success": "Ang promotion code ay naipadala nang matagumpay.",
        "Send_inbox_fail": "Nabigo ang pagpapadala ng promotion code. Pakisubukan muli!",
        "Confirmation": "Kumpirmasyon",
        "Delete_promotion_codes_success": "Ang promotion code ay matagumpay na na-delete",
        "Delete_promotion_codes_fail": "Nangyari ang mga pagkakamali habang binubura ang promotion code",
        "Delete_multiple_promotion_codes_success": "Ang mga promotion code ay matagumpay na na-delete.",
        "Delete_multiple_promotion_codes_fail": "Ang mga pagkakamali ay nangyari habang binubura ang mga promotion code",
        "Delete_promotion_code_success": "Matagumpay na natanggal ang promotion code",
        "Delete_promotion_code_fail": "Nangyari ang mga error habang binubura ang promotion code",
        "Update_multiple_promotion_code_status_success": "Ang mga katayuan ng promotion code ay na-update nang matagumpay.",
        "Update_multiple_promotion_code_status_fail": "Nangyari ang mga error habang binubura ang mga katayuan ng promo code",
        "Search_here": "Maghanap dito",
        "Please_input_campaign_name": "Pakisulat ang pangalan ng kampanya",
        "Please_input_promotion_code": "Pakisok ang promotion code",
        "Please_input_promotion_code_at_least_4_characters": "Pakisok ang hindi bababa sa 4 na karakter.",
        "Please_select_campaign": "Pakisuyong pumili ng kampanya",
        "Please_input_value": "Pakilagay ang halaga",
        "Please_select_date": "Pakisuyong pumili ng petsa",
        "Please_add_schedules": "Pakidagdag ang iskedyul",
        "Please_add_corporate": "Pakidagdag ang corporate",
        "Please_choose_at_least_one_customer": "Pakisuyong pumili ng hindi bababa sa isang customer.",
        "This_campaign_name_has_been_existing_on_the_system_Please_input_another_one": "Ang pangalang kampanya na ito ay umiiral na sa sistema. Mangyaring mag-input ng iba.",
        "This_promotion_code_has_been_existing_on_the_system_Please_input_another_one": "Ang promo code na ito ay umiiral na sa sistema. Mangyaring mag-input ng iba.",
        "Invalid_file": "Di wasto ang nilalaman ng file",
        "File_size_larger_than_5Mb": "Ang laki ng file ay mas malaki sa 5Mb",
        "Import_promotions_success": "Matagumpay na na-import ang file",
        "Import_Promotions": "Mag-import ng File",
        "Number_successful_imports": "Mga inangkat na item",
        "Number_skipped": "Palampasin ang mga item",
        "File": "File",
        "Phone_Numbers": "numero ng telepono",
        "Import_Promotion_code_success": "Ang promotion code <b>{0}</b> ay matagumpay na na-import",
        "Import_Promotion_code_fail": "Ang promotion code <b>{0}</b> ay nabigong ma-import. Pakisubukan muli.",
        "Customer_type": "Uri ng customer",
        "All": "Lahat",
        "Referred_customers": "Mga inirekomendang customer",
        "Common_customers": "Karaniwang mga customer",
        "Operation_zone": "Mga sona ng operasyon",
        "totalUsesLimitPerDay": "Pinakamataas na paggamit/bawat gumagamit/araw",
        "quantityLimitPerDay": "Pinakamataas na dami/araw",
        "quantityLimitPerMonth": "Maximum na dami/gumagamit/buwan",
        "applyVerifiedCustomers": "Mag-apply para sa mga napatunayang customer mula sa Malaysia lamang",
        "applyWhenBudgetLimit": "Maaaring ilapat ng gumagamit ang code hanggang sa maubos ang limitasyon ng badyet.",
        "applyVerifiedCustomersTooltip": "Ang promosyon na ito ay naaangkop lamang para sa mga Malaysian na may napatunayan na pambansang ID at na-upload ang kanilang ID card sa sistema.",
        "valueLimitPerUse": "Maximum na halaga/paggamit (Mag-apply para sa app v48 at pataas)",
        "Promotion_Services": "Serbisyo",
        "transport": "Transportasyon",
        "shuttle": "Shuttle",
        "parcel": "Parcel",
        "food": "Pagkain",
        "mart": "Mart",
        "intercity": "Intercity",
        "addSchedule": "Magdagdag ng Iskedyul",
        "editSchedule": "Baguhin ang Iskedyul",
        "date": "Petsa",
        "Time_range": "Hanay ng oras",
        "startTime": "Oras ng pagsisimula",
        "endTime": "Oras ng pagtatapos",
        "applyForOtherDays": "Mag-apply para sa ibang mga araw",
        "scheduleTimeOverlap": "Huwag mag-overlap ang oras ng iskedyul sa isa't isa.",
        "schedule_startDate_greater_than_endDate": "Ang petsa ng pagsisimula ay mas malaki kaysa sa petsa ng pagtatapos",
        "scheduleTimeDuplicate": "Huwag magdoble ang oras ng iskedyul sa isa't isa.",
        "promoIcon": "Icon ng promo",
        "bannerImage": "Larawan ng banner",
        "Upload_an_image": "I-upload ang isang larawan",
        "Click_here_to_view": "Mag-click dito upang tingnan."
    },
    "quest_event": {
        "name": "Pangalan",
        "userType": "Uri ng Gumagamit",
        "carType": "Uri ng kotse",
        "operationZones": "Zonang operasyon",
        "type": "Uri ng Kaganapan",
        "isLuckyDraw": "Paligsahan ng Suwerte",
        "start_date": "Petsa ng Pagsisimula",
        "end_date": "Petsa ng Pagtatapos",
        "numOfQualify": "Bilang ng mga Kwalipikado",
        "event_progress": "Pag-unlad ng Kaganapan",
        "isActive": "Katayuan",
        "Actions": "Aksyon",
        "passenger": "Customer",
        "driver": "Driver",
        "first_will_win": "Ang unang makakapanalo",
        "largest_will_win": "Pinakamalaki ang mananalo (leaderboard)",
        "not_start": "Hindi magsimula",
        "active": "Aktibo",
        "closed": "Sarado",
        "event_details": "Detalye ng Quest",
        "add_event": "Magdagdag ng Quest",
        "limited": "Limitado",
        "unlimited": "Walang Hanggan",
        "eventImage": "Larawan ng Kaganapan",
        "sharedImage": "Shared Image",
        "qualifiedImage": "Qualified Image",
        "expiredImage": "Nawawalang Imahe",
        "luckyDrawImage": "Lucky Draw Image",
        "Upload_an_image": "I-upload ang isang imahe",
        "Required_Image": "Mga Extension ng Imahe (.jpg, .png, .gif)",
        "ok": "OK",
        "eventId": "Event ID",
        "passengerMetric": {
            "booking_distance": "Distansya ng booking",
            "booking_time": "Oras ng pag-book",
            "booking_amount_spent": "Halaga ng booking na ginastos",
            "num_of_ondemand": "Bilang ng on-demand",
            "num_of_reservation": "Bilang ng reserbasyon",
            "num_of_intercity": "Bilang ng intercity",
            "num_of_delivery": "Bilang ng paghahatid",
            "num_of_referral": "Bilang ng referral",
            "num_of_sharing": "Bilang ng pagbabahagi",
            "topup_wallet_amount": "Dagdagan ang halaga ng wallet",
            "num_of_complete_wallet": "Bilang ng kumpletong booking (wallet)",
            "num_of_complete_booking_by_referee": "Bilang ng kumpletong booking (ng referee)",
            "number_of_complete_booking": "Bilang ng kumpletong booking",
            "number_of_food_mart": "Bilang ng pagkain / mart"
        },
        "driverMetric": {
            "booking_distance": "Distansya ng trabaho",
            "booking_time": "Oras ng trabaho",
            "num_of_referral": "Bilang ng referral",
            "num_of_complete": "Bilang ng kumpletong booking (natatanging customer)",
            "num_of_referral_driver": "Bilang ng referral (driver)",
            "num_of_accept": "Bilang ng tinanggap na booking",
            "num_of_receive": "Bilang ng natanggap na booking",
            "num_of_cancel": "Bilang ng pagkansela ng booking ng driver",
            "sum_of_rating": "Kabuuang bilang ng bituin sa rating",
            "total_rating": "Kabuuang bilang ng mga oras ng pag-rate",
            "earnings_amount": "Halaga ng Kita",
            "num_of_complete_wallet": "Bilang ng kumpletong booking (wallet)",
            "num_of_complete_booking_by_referee": "Bilang ng kumpletong booking (ng referee)",
            "available_time": "Oras sa online"
        },
        "Click_here_to_view": "Mag-click dito upang tingnan.",
        "view": "Mag-click dito upang tingnan.",
        "metricType": "Uri",
        "task": "Gawain",
        "value": "Halaga",
        "quantity": "Dami",
        "quests_list": "Mga Misyon",
        "rankImages": "Ranggo ng imahe (punto)",
        "qualifiedPrizeOrder": "Mga Kwalipikadong Gantimpala",
        "luckyDrawPrizeOrder": "Mga Premyo ng Lucky Draw",
        "reward": "Item",
        "from": "Mula",
        "to": "Sa",
        "image": "Larawan",
        "Add_Prize": "Idagdag",
        "bannerText": "Teksto ng banner",
        "buttonText": "Teksto ng buton",
        "bannerLink": "Link ng banner",
        "shortLink": "Maikling link",
        "buttonLinkDesktop": "Button link (Desktop)",
        "buttonLinkAndroid": "Button link (Android)",
        "buttonLinkiOS": "Link ng button (iOS)",
        "termsURL": "Link ng Mga Tuntunin at Kundisyon",
        "metadataTitle": "Pamagat ng metadata",
        "metadataDescription": "Paglalarawan ng metadata",
        "isDarkMode": "Madilim na Mode",
        "isActive_details": "Aktibo",
        "Required_fields": "Mga kinakailangang patlang",
        "change": "Pagbabago",
        "Please_input_name": "Pakisulat ang pangalan",
        "Please_select_date": "Pakisuyong pumili ng petsa",
        "endDate_invalid": "Di wasto ang Petsa ng Pagtatapos",
        "startDate_greater_than_endDate": "Ang petsa ng pagsisimula ay mas malaki kaysa sa petsa ng pagtatapos",
        "Please_input_termsURL": "Pakilagay ang Link ng Mga Tuntunin at Kundisyon",
        "Please_input_metadataTitle": "Pakisok ang pamagat ng metadata",
        "Please_input_metadataDescription": "Pakilagay ang paglalarawan ng metadata",
        "Please_input_bannerText": "Pakisok ang teksto ng banner",
        "Please_input_buttonText": "Pakilagay ang teksto ng pindutan",
        "Please_input_bannerLink": "Pakilagay ang link ng banner",
        "Please_input_shortLink": "Pakilagay ang maikling link",
        "Please_input_buttonLinkDesktop": "Pakilagay ang link ng button (Desktop)",
        "Please_input_buttonLinkAndroid": "Pakilagay ang link ng button (Android)",
        "Please_input_buttonLinkiOS": "Pakilagay ang link ng button (iOS)",
        "the_range_1_to_5": "Pakilagay ang halaga sa saklaw na 1 hanggang 5 para sa %{name}!",
        "the_range_1_to_100": "Pakilagay ang halaga sa saklaw na 1 hanggang 100 para sa %{name}!",
        "task_is_empty": "Pakisok ang gawain para kay %{name}!",
        "task_limit_50_characters": "Ang maximum na haba ng gawain ay 50 karakter para sa %{name}!",
        "please_input_points": "Pakilagay ang mga puntos para sa %{name}!",
        "please_input_value": "Pakisok ang halaga para sa %{name}!",
        "value_is_invalid": "%{name}, ang halaga ay dapat isang numero",
        "please_upload_image": "Pakisama ang larawan para sa item %{name}!",
        "rank_invalid": "Ang ranggo %{name} ay hindi wasto!",
        "rank_invalid_to": "Ang Ranggo na \"To\" ay dapat isang numero",
        "deepLink": "Deeplink",
        "point_per_task": "Point bawat gawain",
        "points": "Mga puntos",
        "points_per_some_think": "Mga puntos bawat %{unit}",
        "criterias": "Kriteriya (opsyonal)",
        "criterias_list": "Kriteriya",
        "criteriaType": "Uri",
        "criteriaValue": "Halaga",
        "acceptance_rating": "Rating ng Pagtanggap (higit sa o katumbas ng)",
        "cancellation_rating": "Rating ng Kanselasyon (mas mababa o katumbas)",
        "driver_rating": "Rating ng Driver (higit sa o katumbas ng)",
        "please_upload_image_rank": "Pakilagay ang larawan para sa ranggo %{name}!",
        "Update_event_success": "Ang Quest ay matagumpay na na-update",
        "Update_event_fail": "Ang mga error ay nangyari habang ina-update ang quest",
        "Create_event_success": "Bagong misyon ang matagumpay na nalikha",
        "Create_event_fail": "Ang mga error ay nangyari habang gumagawa ng quest",
        "suspend_list": "Listahan ng Suspendido"
    },
    "voucherSettings": {
        "Search_here": "Maghanap dito",
        "Voucher_code": "Maghanap dito",
        "Campaign": "Kampanya",
        "Type": "Uri",
        "Value": "Halaga",
        "Valid_from": "Valid From",
        "Valid_to": "Balido Hanggang",
        "isActive": "Katayuan",
        "Activate": "Isagawa",
        "Deactivate": "Idiskonekta",
        "Actions": "Aksyon",
        "Active": "Aktibo",
        "Inactive": "Hindi aktibo",
        "redeemed": "Nakapagligtas",
        "expired": "Nawalang bisa",
        "Add_Voucher_code": "Magdagdag ng code",
        "Add": "Idagdag",
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "Name": "Pangalan",
        "show_pages": "{0} - {1} ng {2} na ipinakita",
        "Edit": "I-edit",
        "Delete": "Tanggalin",
        "Save": "I-save",
        "Duplicate": "Duplicate",
        "Cancel": "Kanselahin",
        "Required_fields": "Mga kinakailangang patlang",
        "Detail_voucher_code": "Detalye ng Voucher Code",
        "Delete_voucher_code": "Burahin ang Voucher Code",
        "Confirmation": "Kumpirmasyon",
        "Delete_confirm_voucher_code": "Gusto mo bang tanggalin ang napiling voucher code?",
        "Delete_voucher_code_confirmation": "Gusto mo bang tanggalin ang mga voucher code na ito?",
        "Just_delete_inactive": "** Tanging ang voucher code na nasa hindi aktibong estado ang maaaring tanggalin.",
        "Loading_voucher_code_fail": "Ang mga error ay nangyari habang naglo-load ng voucher code",
        "Select_campaign": "Pumili ng Kampanya",
        "Create_voucher_code_success": "Bagong voucher code ang matagumpay na nalikha",
        "Create_voucher_code_fail": "Ang mga error ay nangyari habang gumagawa ng voucher code",
        "Update_voucher_code_status_success": "Ang katayuan ng voucher code ay na-update nang matagumpay",
        "Update_voucher_code_status_fail": "Ang mga error ay nangyari habang ina-update ang katayuan ng voucher code",
        "Delete_voucher_codes_success": "Matagumpay na na-delete ang voucher code",
        "Delete_voucher_codes_fail": "Nangyari ang mga error habang binubura ang voucher code",
        "Delete_multiple_voucher_codes_success": "Ang mga voucher code ay matagumpay na na-delete",
        "Delete_multiple_voucher_codes_fail": "Nangyari ang mga error habang binubura ang mga voucher code",
        "Delete_voucher_code_success": "Matagumpay na na-delete ang voucher code.",
        "Delete_voucher_code_fail": "Nagkaroon ng mga error habang binubura ang voucher code",
        "Update_multiple_voucher_code_status_success": "Ang mga katayuan ng voucher code ay na-update nang matagumpay.",
        "Update_multiple_voucher_code_status_fail": "Ang mga error ay nangyari habang binubura ang mga katayuan ng voucher code",
        "Please_input_voucher_code": "Pakisok ang voucher code",
        "Please_input_voucher_code_at_least_4_characters": "Pakisok ang hindi bababa sa 4 na karakter.",
        "Please_select_campaign": "Pakisuyong pumili ng kampanya",
        "Please_input_value": "Pakilagay ang halaga",
        "Please_select_date": "Pakisuyong pumili ng petsa",
        "Invalid_file": "Ang nilalaman ng file ay hindi wasto",
        "File_size_larger_than_5Mb": "Ang laki ng file ay mas malaki sa 5Mb",
        "Import_vouchers_success": "Matagumpay na na-import ang file",
        "Import_vouchers": "Mag-import ng File",
        "Number_successful_imports": "Mga inangkat na item",
        "Number_skipped": "Palampasin ang mga item",
        "File": "File",
        "Phone_Numbers": "numero ng telepono",
        "Import_voucher_code_success": "Ang voucher code <b>{0}</b> ay matagumpay na na-import.",
        "Import_voucher_code_fail": "Ang voucher code <b>{0}</b> ay nabigong ma-import. Pakisubukan muli.",
        "All": "Lahat"
    },
    "pointConfig": {
        "point_config": "Point config",
        "Convert_spent_amount_to_points": "I-convert ang ginastos na halaga sa mga puntos",
        "Convert_topup_amount_to_points": "I-convert ang halaga ng topup sa mga puntos",
        "Redeem_points_to_voucher": "I-redeem ang mga puntos sa voucher",
        "others": "Iba",
        "Online_Payment": "Online na pagbabayad",
        "transport": "Transportasyon",
        "parcel": "Parcel",
        "food": "Pagkain",
        "mart": "Mart",
        "delivery": "Paghahatid",
        "intercity": "Intercity",
        "applyCash": "Mag-apply para sa pera",
        "point": "Point",
        "vourcherName": "Pangalan",
        "pointsToRedeem": "Mga puntos na maaring ipalit",
        "vourcherValue": "Halaga ng voucher",
        "validTime": "Valido na oras",
        "month": "Buwan(buwan)",
        "day": "Mga Araw",
        "termAndCondition": "Mga Tuntunin at Kundisyon",
        "Actions": "Aksyon",
        "add_voucher": "Idagdag",
        "instructionURL": "Link ng tagubilin",
        "displayName": "Ipakita ang pangalan sa super app",
        "isActive": "aktibo",
        "EDIT_VOUCHER": "I-update ang Voucher",
        "DETAIL_VOUCHER": "Mga Detalye ng Voucher",
        "CREATE_VOUCHER": "Magdagdag ng Voucher",
        "update_successfully": "Ang setting ng point config ay matagumpay na na-update",
        "Create_voucher_successfully": "Ang bagong voucher ay matagumpay na nalikha",
        "Create_voucher_fail": "Nagkaroon ng mga error habang gumagawa ng voucher",
        "Update_voucher_successfully": "Ang voucher ay na-update nang matagumpay",
        "Update_voucher_fail": "Nangyari ang mga error habang ina-update ang voucher",
        "Delete_voucher_successfully": "Matagumpay na na-delete ang voucher",
        "Delete_voucher_fail": "Nangyari ang mga pagkakamali habang binubura ang voucher",
        "Confirmation": "Kumpirmasyon",
        "Delete_voucher_confirmation": "Gusto mo bang tanggalin ang voucher na ito?",
        "Please_enter_value_least_one": "Kailangan ang rate ng conversion! Itakda ang ginastos na halaga o halaga ng pagdagdag upang magpatuloy.",
        "Please_enter_value_is_number_spentAmount": "Pakisok ang wastong halaga sa serbisyo ng \"Convert spent amount\" \"{0}\".",
        "Please_enter_value_is_number_topUp": "Pakisok ang wastong halaga sa \"Convert topup amount\" na pamamaraan \"{0}\"."
    },
    "resetPassword": {
        "New_Password": "Bagong Password",
        "New_Comfirm_Password": "Bagong Kumpirmahin ang Password",
        "Save": "I-save",
        "INFO_SUCCESS": "Isang link para sa pag-reset ng password ang naipadala sa iyong email.",
        "TOKEN_EXPIRED": "Ang iyong reset password token ay nag-expire na.",
        "Back_To_Login_Page": "Bumalik sa Pahina ng Pag-login"
    },
    "permission": {
        "editBooking": "Baguhin ang mga booking ng farm-out",
        "companyOperator": "Operator ng Kumpanya",
        "Third_Party_Integration_Booking": "3rd party Integration (Booking.com)",
        "Third_Party_Integration_HolidayTaxis": "3rd party Integration (HolidayTaxis)",
        "supplierPermission": "Pagpahintulot ng supplier",
        "Hint_edit_booking": "Payagan ang mga kumpanya/supplier na i-edit ang mga booking na ibinigay ng may-ari ng fleet.",
        "View": "Tingnan",
        "Actions": "Aksyon",
        "EditFare": "Baguhin ang Pasahe",
        "EditDriverEarning": "Baguhin ang Kita ng Driver",
        "EditTotal": "I-edit ang Kabuuan",
        "ImportBookings": "Mag-import ng mga Booking sa Transportasyon",
        "ImportDeliveryBookings": "Pag-import ng mga Booking sa Paghahatid",
        "ShowFare": "Ipakita ang Pamasahe",
        "delete_permission": "Burahin ang Pahintulot",
        "DELETE_CONFIRM": "Sigurado ka bang nais mong tanggalin ang napiling pahintulot!",
        "Yes": "Oo",
        "No": "Hindi",
        "Cancel": "Kanselahin",
        "DRIVERS": "DRAYBER",
        "Driver_list": "Listahan ng mga Driver",
        "Enter_to_search": "Mag-enter upang maghanap",
        "Permitted_driver_list": "Listahan ng mga pinapayagang drayber",
        "Save": "I-save",
        "CAR": "BIYAHE",
        "Car_list": "Listahan ng mga sasakyan",
        "Permitted_car_list": "Listahan ng mga pinahintulutang sasakyan",
        "Edit_permission": "Karapatan sa pag-edit",
        "Add_permission": "Magdagdag ng pahintulot",
        "Detail_permission": "Detalyadong pahintulot",
        "Name": "Pangalan",
        "Driver_Car": "Driver/Sasakyan",
        "All": "Lahat",
        "Company": "kumpanya",
        "By_specific": "Sa tiyak",
        "Drivers": "Mga drayber",
        "Cars": "Mga Sasakyan",
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "show_pages": "{0} - {1} ng {2} na ipinapakita",
        "Delete": "Tanggalin",
        "Edit": "Isagawa",
        "Status": "Katayuan",
        "Action": "Aksyon",
        "Inactive": "Hindi aktibo",
        "Active": "aktibo",
        "Update_status_error": "Error sa pag-update ng status",
        "All_tooltip": "Lahat ng driver(s) ay ipapakita sa Map, Cue, Drivers, Operation at Reports. Lahat ng car(s) ay ipapakita sa Car mgmt.",
        "Company_tooltip": "Ang mga pinapayagang driver sa kumpanyang ito ay ipapakita sa Map, Cue, Drivers, Operation at Reports. Ang mga pinapayagang sasakyan sa kumpanyang ito ay ipapakita sa Car mgmt.",
        "By_specific_tooltip": "Ang mga pinapayagang driver sa listahang ito ay ipapakita sa Drivers, Operation. Ang mga pinapayagang sasakyan sa listahang ito ay ipapakita sa Car mgmt.",
        "Full_permissions": "Buong pahintulot",
        "Balance": "Palitan ang Balanse",
        "ChangeBalance": "Palitan ang Balanse ng Kredito",
        "ChangeCashBalance": "Baguhin ang Cash Balance",
        "TotalBalance": "Kabuuang Balanse",
        "WriteOffDebt": "Isulat ang Utang",
        "topupPaxWallet": "Palitan ang Balanse",
        "SeFleetCommission": "Itakda ang komisyon ng fleet (lahat ng driver)",
        "EditFleetCommission": "I-edit ang komisyon ng fleet",
        "EditBalance": "Baguhin ang Balanse",
        "ViewHeatMap": "Tingnan ang Heat Map",
        "Delete_permission_success": "Ang pahintulot ay matagumpay na natanggal",
        "Delete_permission_fail": "Nangyari ang mga error habang nagbubura ng pahintulot",
        "Create_permission_fail": "Nangyari ang mga error habang lumilikha ng bagong pahintulot",
        "Create_permission_success": "Bagong pahintulot ang matagumpay na nalikha",
        "Update_permission_fail": "Ang mga error ay nangyari habang ina-update ang pahintulot",
        "Update_permission_success": "Ang pahintulot ay na-update nang matagumpay",
        "No_action_selected": "Pakisuyong lagyan ng tsek ang kahit isang aksyon sa listahan ng aksyon",
        "Required_fields": "Mga kinakailangang patlang",
        "sendSMS": "Magpadala ng Mensahe (SMS)",
        "sendInbox": "Magpadala ng Mensahe (Inbox)",
        "PayToDriver": "Tingnan ang 'Bayad sa Driver'",
        "PayoutHistory": "Tingnan ang 'Kasaysayan ng Bayad'",
        "Pay": "Bayad na drayber",
        "ActivateDriver": "Isaaktibo ang Driver",
        "Export": "I-export",
        "Export_csv": "I-export ang .csv",
        "Street-sharing_rate": "Rate ng pagbabahagi sa kalye"
    },
    "thirdPartySettings": {
        "category": "Kategorya",
        "Not_over_limit_subs": "Hindi ka makakagawa ng higit sa 10 sub-locations.",
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "show_pages": "{0} - {1} ng {2} na ipinakita",
        "Delete": "Tanggalin",
        "Edit": "Isagawa ang pagbabago",
        "Status": "Katayuan",
        "Actions": "Aksyon",
        "Action": "Aksyon",
        "Inactive": "Hindi aktibo",
        "Active": "Aktibo",
        "website": "Website",
        "Check_Google_Address": "Suriin ang address ng Google mula sa latitude at longitude",
        "Delete_Category_success": "Matagumpay na na-delete ang kategorya",
        "Delete_category_fail": "Nangyari ang mga error habang binubura ang kategorya",
        "availableTime": "Magagamit na oras",
        "Please_choose_at_least_one_category": "Pakisuyong pumili ng hindi bababa sa isang kategorya",
        "Please_input_category_name": "Pakisulat ang pangalan ng kategorya",
        "Create_category_success": "Ang kategorya ay matagumpay na nalikha",
        "Create_category_fail": "Nangyari ang mga error habang lumilikha ng kategorya",
        "Update_third_party_success": "Ang lokasyon ay na-update nang matagumpay",
        "Update_category_fail": "Nangyari ang mga error habang ina-update ang kategorya",
        "All_Category": "Lahat ng kategorya",
        "Delete_Category": "Isang edit na kategorya",
        "Edit_Category": "Baguhin ang kategorya",
        "Add_Category": "Magdagdag ng kategorya",
        "Add_Third_Party_location": "Magdagdag ng Lokasyon ng Ikatlong Partido",
        "Add": "Idagdag",
        "Edit_Third_Party_location": "Baguhin ang Lokasyon ng Ikatlong Partido",
        "Location_Not_Found": "Hindi natagpuan ang lokasyon",
        "Create_third_party_success": "Matagumpay na nalikha ang lokasyon",
        "Create_third_party_fail": "Nangyari ang mga error habang gumagawa ng lokasyon",
        "Update_third_party_fail": "Ang mga error ay nangyari habang ina-update ang lokasyon",
        "Alias": "Alias",
        "Address": "Address",
        "Latitude": "Latitud",
        "Longitude": "Longitude",
        "Please_input_address": "Pakilagay ang address",
        "Please_input_name": "Pakisok ang pangalan ng lokasyon",
        "Please_input_latitude": "Pakisok ang latitude",
        "Please_input_longitude": "Pakisok ang longitude",
        "Save": "I-save",
        "Cancel": "Kanselahin",
        "Required_fields": "Mga kinakailangang patlang",
        "Last_update": "Huling Update",
        "Username": "Username",
        "locationType": "Uri ng Lokasyon",
        "single": "Isang lokasyon",
        "multiple": "Maramihang lokasyon",
        "AddMore": "Magdagdag pa",
        "locationList": "Listahan ng mga lokasyon",
        "instructionLink": "Link ng Instruksyon",
        "location": "Lokasyon",
        "checkOnMap": "Suriin sa mapa",
        "Remove": "Alisin",
        "all": "Lahat",
        "PU": "Pickup",
        "DO": "Drop off",
        "namePlaceholder": "e.g. terminal 1",
        "instructionLinkPlaceholder": "Html na pahina na may kumpletong tagubilin",
        "instructionLinkTooltip": "Pakilagay ang isang link para sa pahina ng tagubilin. Maaaring sundan ng pasahero ang tagubilin sa link na ito upang mahanap ang lokasyon ng pickup.",
        "longitudePlaceholder": 108.1837969,
        "latitudePlaceholder": 16.0393381,
        "Error_message_lat_in_range": "Ang latitude ay dapat nasa pagitan ng -90.0 at 90.0",
        "Error_message_lng_in_range": "Ang longitude ay dapat nasa pagitan ng -180.0 at 180.0.",
        "Delete_third_party_success": "Matagumpay na natanggal ang lokasyon",
        "Delete_third_party_fail": "Nagkaroon ng mga error habang tinatanggal ang lokasyon",
        "Delete_location": "Burahin ang lokasyon",
        "Note_guide": "Tandaan: kapag naghahanap sa mapa, ang iyong lokasyon ay mabilis na mamarkahan ng isang pin.",
        "PostalCode": "Postal Code",
        "meetZonesTooltip": "Meeting Zone: Itinatakda ang lugar na kinabibilangan ng lahat ng itinalagang punto ng pulong. Kapaki-pakinabang para sa mga lokasyon tulad ng mga paliparan kung saan ang mga tiyak na lugar ng pickup at drop-off ay kailangang malinaw na matukoy.",
        "instructions": "Mga Tagubilin sa Pagkuha",
        "pickupMode": "Uri ng Pickup",
        "tripSegment": "Segmento ng Paglalakbay",
        "buildingLevel": "Antas ng Gusali",
        "instructionType": "Uri ng Instruksyon",
        "instructionUrl": "Instruction URL",
        "instructionImage": "Mga Larawan ng Instruksyon",
        "imageInstructions": "Mga Tagubilin sa Pagkuha ng Imahe",
        "addMultipleInstructions": "Magdagdag ng maraming tagubilin sa pickup.",
        "maximum3Images": "Maximum na 3 larawan.",
        "image": "Larawan",
        "uploadImage": "I-upload ang isang larawan",
        "description": "Paglalarawan",
        "descriptionPlaceholder": "Ang pangalan ng lugar ng pagpupulong.",
        "altText": "Alt Text",
        "altTextPlaceholder": "Ang pangalan ng lugar ng pagpupulong.",
        "addImage": "Magdagdag ng Larawan",
        "imageCount": "Bilang ng Imahe",
        "viewEditImages": "Tingnan/I-edit ang mga Imahe",
        "addMeetingZone": "Magdagdag ng Meeting zone"
    },
    "city": {
        "DELETE_CITY": "Burahin ang lungsod",
        "DELETE_CONFIRM": "Sigurado ka bang nais mong burahin ang napiling lungsod?",
        "Yes": "Oo",
        "No": "Hindi",
        "Cancel": "Kanselahin",
        "EDIT_CITY": "Isedit ang lungsod",
        "ADD_CITY": "Magdagdag ng Lungsod",
        "Name": "Pangalan",
        "Required_fields": "Mga kinakailangang patlang",
        "Save": "I-save",
        "Add": "Idagdag",
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "show_pages": "{0} - {1} ng {2} na ipinakita",
        "Delete": "Tanggalin",
        "Edit": "I-edit",
        "DETAIL_CITY": "Detail ng lungsod",
        "Update_city_success": "Ang lungsod ay matagumpay na na-update",
        "Create_city_success": "Bagong lungsod ay matagumpay na nalikha",
        "Delete_city_success": "Ang lungsod ay matagumpay na natanggal",
        "cityName": "Pangalan ng lungsod",
        "Service": "Serbisyo",
        "serviceTransportation": "Transportasyon",
        "serviceAssistant": "Katulong",
        "serviceDelivery": "Paghahatid",
        "isShowDriverSignUp": "Ipakita sa pag-sign up ng provider",
        "note_isShowDriverSignUp": "(Mag-apply para sa bagong signup module mula 4.6.46 pataas)"
    },
    "blockPassenger": {
        "Imei": "IMEI",
        "EditImei": "Baguhin ang Block IMEI",
        "AddImei": "Magdagdag ng Block IMEI",
        "DetailImei": "Detail Block IMEI",
        "Update_Imei_success": "Ang Block IMEI ay matagumpay na na-update",
        "Update_Imei_Fail": "Ang mga error ay nangyari habang ina-update ang Block IMEI",
        "Create_Imei_success": "Bagong Block IMEI ay matagumpay na nalikha",
        "Create_Imei_Fail": "Ang mga error ay nangyari habang nililikha ang Block IMEI",
        "Delete_Imei_success": "Ang Block IMEI ay matagumpay na natanggal",
        "Delete_Imei_fail": "Nangyari ang mga error habang binubura ang Block IMEI",
        "DELETE_IMEI": "Burahin ang Block IMEI",
        "DELETE_CONFIRM": "Sigurado ka bang nais mong tanggalin ang napiling Block IMEI?"
    },
    "jobTab": {
        "DELETE_JOBTAB": "Burahin ang Tab ng Mga Trabaho",
        "DELETE_CONFIRM": "Sigurado ka bang nais mong tanggalin ang napiling Jobs Tab?",
        "Yes": "Oo",
        "No": "Hindi",
        "Cancel": "Kanselahin",
        "EDIT_JOBTAB": "Edit Job Tab",
        "ADD_JOBTAB": "Magdagdag ng Tab ng Trabaho",
        "Name": "Pangalan",
        "Required_fields": "Mga kinakailangang patlang",
        "Save": "I-save",
        "Add": "Idagdag",
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "show_pages": "{0} - {1} ng {2} na ipinapakita",
        "Delete": "Tanggalin",
        "Edit": "Isagawa ang pagbabago",
        "DETAIL_JOBTAB": "Detalye ng Mga Trabaho Tab",
        "Update_JOBTAB_success": "Ang Jobs Tab ay matagumpay na na-update",
        "Create_JOBTAB_success": "Matagumpay na nalikha ang bagong tab ng mga trabaho",
        "Delete_JOBTAB_success": "Ang Jobs Tab ay matagumpay na natanggal",
        "JOBTABName": "Pangalan ng Tab ng Mga Trabaho",
        "jobsLink": "Link"
    },
    "driverNote": {
        "name": "Nota ng drayber",
        "DELETE": "Burahin ang Tala ng Driver",
        "DELETE_CONFIRM": "Sigurado ka bang nais mong tanggalin ang napiling Driver Note?",
        "EDIT": "Baguhin ang Tala ng Driver",
        "ADD": "Magdagdag ng Tala ng Driver",
        "DETAIL": "Detalyadong Tala ng Driver",
        "Update_success": "Ang Tala ng Driver ay matagumpay na na-update",
        "Create_success": "Matagumpay na nalikha ang Bagong Tala ng Driver",
        "Delete_success": "Ang Tala ng Driver ay matagumpay na natanggal",
        "Delete_fail": "Nagkaroon ng mga error habang binubura ang tala ng driver",
        "Load_fail": "Nangyari ang mga error habang naglo-load ng driver note",
        "Update_fail": "Nangyari ang mga error habang ina-update ang tala ng driver",
        "Create_fail": "Ang mga error ay nangyari habang gumagawa ng tala ng drayber"
    },
    "flightIntegration": {
        "Username": "Username",
        "provider": "Tagapagbigay ng Flight",
        "Key": "API Key",
        "apiKeys": "API Keys",
        "apiId": "API Id",
        "Save": "I-save",
        "Update_flight_integration_success": "Ang pagsasama ng flight ay matagumpay na na-update",
        "Update_flight_integration_fail": "Ang mga error ay nangyari habang ina-update ang flight integration"
    },
    "smsIntegration": {
        "provider": "Tagapagbigay ng SMS",
        "apiToken": "API Token",
        "subAccountId": "Sub Account ID",
        "senderIdSource": "Sender ID (pinagmulan):",
        "apiKey": "API Key",
        "username": "Username",
        "shortCode": "Maikling Kodigo",
        "key": "Susi",
        "webService": "Serbisyo sa web",
        "bearerToken": "Bearer token",
        "keyId": "Key ID",
        "email": "Email",
        "appKey": "Susi ng app",
        "sender": "Nagpadala",
        "password": "Password",
        "maskedPhone": "Nakatagong numero ng telepono",
        "senderId": "Sender ID",
        "webservice": "Serbisyo ng web",
        "brandname": "Pangalan ng tatak",
        "appSecret": "Lihim ng app",
        "consumerKey": "Suskey ng mamimili",
        "requestUrl": "Request Url",
        "authId": "Auth ID",
        "authToken": "Auth Token",
        "authKey": "Auth Key",
        "templateId": "Template Id",
        "templateKey": "Key ng Template",
        "phloId": "PHLO ID",
        "dlcNumber": "10DLC Numero",
        "app_key": "Susi ng app",
        "api_key": "API key",
        "accountSID": "Account SID",
        "applicationId": "Application ID",
        "phoneNumber": "Numero ng SMS 1",
        "phoneNumber2": "SMS numero 2",
        "SenderID_1": "SenderID 1",
        "SenderID_2": "SenderID 2",
        "smsMarketingNumber": "Numero ng telepono para sa SMS marketing",
        "updateSMSSuccess": "The sms integration has been updated successfully",
        "Deleted_success": "Ang SMS ay matagumpay na na-delete.",
        "receiverCountries": "Bansa ng Tumanggap",
        "error": {
            "ERROR_CREATE": "Nangyari ang mga error habang lumilikha ng sms",
            "COUNTRY_EXISTED": "Umiiral na ang bansa sa sistema",
            "ERROR_DELETE": "Nabigong tanggalin ang SMS",
            "ERROR_UPDATE": "Nabigong i-update ang SMS"
        },
        "identifierId": "Identifier ID"
    },
    "mDispatcher": {
        "mDispatchers": "Mga Kasosyo",
        "Active": "aktibo",
        "Inactive": "Hindi aktibo",
        "Deactivate": "Idiskonekta",
        "Activate": "Isaaktibo",
        "Delete": "Tanggalin",
        "Save": "I-save",
        "Edit": "I-edit",
        "ADD_MDISPATCHER": "Magdagdag ng kasosyo",
        "EDIT_MDISPATCHER": "Baguhin ang kasosyo",
        "Phone_number": "Numero ng telepono",
        "first_name": "Pangalan",
        "last_name": "Huling pangalan",
        "email": "Email",
        "address": "Address",
        "mDispatcher_type": "Uri ng kasosyo",
        "mDispatcher_type_toolTip": "Upang magdagdag ng higit pang uri ng kasosyo, mangyaring pumunta sa Mga Setting > Uri ng Kasosyo",
        "queuing_area_toolTip": "Para magdagdag ng higit pang mga lugar ng pag-aantay, mangyaring pumunta sa menu ng Lugar ng Pag-aantay.",
        "mDispatcher": "Kabartner",
        "card_management": "Pamahalaan ng Kard",
        "Select_mDispatcher_type": "Pumili ng Uri ng Kasosyo",
        "Amount": "Dami",
        "Percent": "Percent",
        "Yes": "Oo",
        "Required_fields": "Mga kinakailangang patlang",
        "Cancel": "Kanselahin",
        "commission_type": "Uri ng Komisyon",
        "commission_value": "Halaga ng Komisyon",
        "Name": "Pangalan",
        "Phone_Number": "Numero ng telepono",
        "queuing_area": "Lugar ng Paghihintay",
        "mdispatcher_type": "Uri ng Kasosyo",
        "registered_from": "Nirehistro Mula",
        "registration_date": "Petsa ng Pagpaparehistro",
        "status": "Katayuan",
        "actions": "Mga aksyon",
        "Select_queue_area": "Pumili ng lugar ng pila",
        "for_new_mDipatcher_account_password_default_is_password": "Para sa bagong partner account, ang default na password ay \"12345678\"",
        "Create_mDispatcher_success": "Bagong kasosyo ay matagumpay na nalikha",
        "Create_mDispatcher_fail": "Ang mga error ay nangyari habang nililikha ang kasosyo",
        "Load_mDispatcher_fail": "Ang mga error ay nangyari habang naglo-load ng kasosyo",
        "Update_mDispatcher_success": "Ang kasosyo ay matagumpay na na-update",
        "Update_mDispatcher_fail": "Ang mga error ay nangyari habang ina-update ang kasosyo",
        "Update_mDispatcher_status_success": "Ang katayuan ng kasosyo ay matagumpay na na-update",
        "Update_mDispatcher_status_fail": "Nangyari ang mga error habang ina-update ang katayuan ng kasosyo",
        "Update_mDispatcher_statuses_success": "Na-update nang matagumpay ang mga katayuan ng kasosyo",
        "Update_mDispatcher_statuses_fail": "Nangyari ang mga pagkakamali habang ina-update ang mga katayuan ng kasosyo.",
        "Delete_mDispatcher_success": "Matagumpay na natanggal ang partner",
        "Delete_mDispatcher_fail": "Nagkaroon ng mga error habang binubura ang kasosyo",
        "Delete_mDispatchers_success": "Matagumpay na na-delete ang mga kasosyo",
        "Delete_mDispatchers_fail": "Ang mga error ay nangyari habang binubura ang mga kasosyo",
        "Do_you_want_to_delete_these_mDipatchers": "Gusto mo bang tanggalin ang mga kasosyo na ito?",
        "Only_mDistcher_in_the_inactive_status_can_be_deleted": "***Tanging ang mDistcher na nasa inactive status lamang ang maaaring tanggalin",
        "No_card": "Walang nahanap na card",
        "Reset_Password": "I-reset ang Password",
        "Reset_password_success": "Matagumpay na na-reset ang password ng partner",
        "Reset_password_fail": "Ang mga error ay nangyari habang nire-reset ang password ng mga kasosyo",
        "Do_you_want_to_reset_password": "Gusto mo bang i-reset ang password?",
        "ERROR_EXISTED_PHONE": "Ang teleponong ito ay umiiral na sa sistema. Mangyaring mag-input ng iba.",
        "ERROR_INPUT_VALIDPHONE": "Pakisok ang isang wastong numero ng telepono.",
        "Partner_detail": "Mga detalye ng kasosyo",
        "ALERT_SELECT_ACTIVATE": "Pakisuyong pumili ng mga kasosyo upang i-activate.",
        "ALERT_SELECT_DEACTIVATE": "Pakisuyong pumili ng mga kasosyo upang i-deactivate.",
        "CONFIRM_DEACTIVATE_MULTI": "Gusto mo bang i-deactivate ang mga kasosyo na ito?",
        "CONFIRM_ACTIVATE_MULTI": "Gusto mo bang i-activate ang mga kasosyo na ito?",
        "ERROR_COMMISSION_NUMBERS": "Pakisok ang isang wastong numero",
        "No_Support": "Ang pagdaragdag ng bagong card ay kasalukuyang hindi suportado sa lugar na ito.",
        "Add": "Idagdag",
        "Default_zone": "Default na sona",
        "required_email_payment": "Kailangan ang email ng partner. Mangyaring i-update ang profile upang magpatuloy.",
        "titleGuestQR": "Partner Guest-QR Link",
        "questQRContent": "Nandito ang iyong personalized na link para sa partner booking! I-display ito nang maliwanag sa mga bar, reception ng hotel, mga kwarto ng bisita, at sa iyong website—saanman maaaring kailanganin ng iyong mga customer ang sakay o delivery. Isaalang-alang ang pagdidisenyo ng mga standee na may iyong natatanging QR code, na nagbibigay-daan sa mga customer para sa mabilis at madaling pag-scan upang i-book ang kanilang biyahe!",
        "View_Guest_QR": "Tingnan ang Guest QR"
    },
    "mDispatcherType": {
        "Name": "Pangalan",
        "Required_fields": "Mga kinakailangang patlang",
        "Save": "I-save",
        "Cancel": "Kanselahin",
        "No": "Hindi",
        "Add": "Idagdag",
        "Show_per_page": "Mga item bawat pahina",
        "Page": "Pahina",
        "show_pages": "{0} - {1} ng {2} na ipinakita",
        "Delete": "Tanggalin",
        "Edit": "I-edit",
        "DELETE_MDISPATCHER_TYPE": "Burahin ang Uri ng Kasosyo",
        "DELETE_CONFIRM": "Sigurado ka bang burahin ang uri ng kasosyo?",
        "Yes": "Oo",
        "EDIT_MDISPATCHER_TYPE": "Baguhin ang Uri ng Kasosyo",
        "ADD_MDISPATCHER_TYPE": "Magdagdag ng Uri ng Kasosyo",
        "DETAIL_MDISPATCHER_TYPE": "Detalye ng Uri ng Kasosyo",
        "Actions": "Mga aksyon",
        "Delete_mDispatcherType_success": "Matagumpay na na-delete ang Partner Type",
        "Delete_mDispatcherType_fail": "Nagkaroon ng mga error habang binubura ang uri ng kasosyo",
        "Load_mDispatcherType_fail": "Nangyari ang mga error habang naglo-load ng uri ng mga kasosyo",
        "Create_mDispatcherType_success": "Matagumpay na nalikha ang Bagong Uri ng Kasosyo",
        "Create_mDispatcherType_fail": "Nangyari ang mga error habang lumilikha ng uri ng mga kasosyo",
        "Update_mDispatcherType_success": "Ang Uri ng Kasosyo ay matagumpay na na-update",
        "Update_mDispatcherType_fail": "Nangyari ang mga error habang ina-update ang uri ng mga kasosyo"
    },
    "queuingArea": {
        "queuing_area_info": "Impormasyon sa lugar ng pila",
        "queuingDrivers": "Mga aktibong drayber",
        "Name": "Pangalan",
        "Required_fields": "Mga kinakailangang patlang",
        "Save": "I-save",
        "Cancel": "Kanselahin",
        "Yes": "Oo",
        "No": "Hindi",
        "Add": "Idagdag",
        "Show_per_page": "Mga item bawat pahina",
        "Enter_to_search": "Mag-enter upang maghanap",
        "Page": "Pahina",
        "show_pages": "{0} - {1} ng {2} na ipinakita",
        "Delete": "Tanggalin",
        "Edit": "Isagawa",
        "Active": "Aktibo",
        "Inactive": "Hindi aktibo",
        "Deactivate": "Idiskonekta",
        "Activate": "Isagawa",
        "drivers": {
            "order": "Order",
            "Driver_name": "Pangalan ng driver",
            "Phone_Number": "Numero ng telepono",
            "driverLicenseNumber": "Plaka ng sasakyan",
            "Car_Type": "Uri ng kotse",
            "checkInTime": "Oras ng pag-check in",
            "duration": "Tagal",
            "timestampScore": "Timestamp Score",
            "changeOrderDriver": "Pagbabago ng order",
            "detailOrderDriver": "Order ng driver",
            "Yes": "Oo",
            "No": "Hindi",
            "insert": "Ipasok",
            "refresh": "Mag-refresh",
            "insertDriver": "Ipasok ang isang driver sa pila",
            "orderDriver": "Order #",
            "reason": "Dahilan",
            "removeDriver": "Alisin ang Driver mula sa Queue",
            "removeDriverConfirm": "Gusto mo bang alisin ang drayber na ito mula sa pila?",
            "driverNotStay": "Ang drayber na ito ay hindi nananatili sa loob ng lugar ng pila. Pakisubukan muli mamaya.",
            "overOrder": "Ang order # ay hindi maaaring lumampas sa kabuuang bilang ng mga drayber sa pila.",
            "noDriverFound": "Walang nahanap na drayber",
            "driverUpdateErrRs": "Walang driver sa lugar ng pila. Pakisubukan muli mamaya.",
            "orderUpdateErrRs": "Ang order # ay hindi maaaring lumampas sa kabuuang bilang ng mga drayber sa pila.",
            "removeDriverSuccess": "Ang drayber ay matagumpay na naalis mula sa lugar ng pila.",
            "removeDriverFail": "Isang error ang nangyari habang inaalis ang driver mula sa lugar ng pila.",
            "operationInsertFailRs": "Walang driver o hindi ito available.",
            "versionInsertFailRs": "Upang magamit ang tampok na ito, kailangan ng drayber na i-upgrade ang kanyang driver app sa pinakabagong bersyon.",
            "queueInsertFailRs": "Walang pila o ang drayber ay hindi nasa lugar ng pila. Pakisubukan muli mamaya.",
            "vehicleInsertFailRs": "Hindi sinusuportahan ng pila ang uri ng sasakyan ng drayber.",
            "orderInsertFailRs": "Ang order # ay hindi maaaring mas mataas kaysa sa kabuuang bilang ng mga drayber sa pila.",
            "positionInsertFailRs": "Nagkaroon ng error habang nag-iinsert ng driver sa lugar ng queue.",
            "insertDriverSuccess": "Ang driver ay matagumpay na naipasok sa lugar ng pila.",
            "changeOrderSuccess": "Ang posisyon ng drayber ay matagumpay na nabago.",
            "insertDriverFail": "Nagkaroon ng error habang nag-iinsert ng driver mula sa queue area.",
            "changeOrderFail": "Nagkaroon ng error habang binabago ang posisyon ng drayber mula sa lugar ng pila.",
            "selectToInsert": "Maghanap: Pangalan ng driver, Numero ng telepono",
            "updateBy": "Na-update ng operator",
            "changeOrder": "Pagbabago ng order",
            "remove": "Alisin"
        },
        "keepDriverPlaceCancelNoShow": "I-save ang lugar ng drayber kapag ang booking ay kinansela / walang pagdating",
        "keepDriverPlaceUnavailable": "Iwanan ang puwesto ng drayber kapag hindi available ang drayber",
        "range": "Hanay ng pila",
        "queueRangeTooltip": "Ganito ang makikita ng mga driver sa kanilang numero ng posisyon sa pila sa driver app. Halimbawa:\n  - Kung itatakda ang saklaw ng pila sa 1: makikita ng mga driver ang kanilang posisyon sa pila bilang isang solong numero: 1, 2, 3, 4, atbp.\n  - Kung itatakda ang saklaw ng pila sa 5: makikita ng mga driver ang kanilang posisyon sa pila bilang isang saklaw: 1-5, 6-10, 11-15, 16-20, atbp.\n  - Kung itatakda ang saklaw ng pila sa 10: makikita ng mga driver ang kanilang posisyon sa pila bilang isang saklaw: 1-10, 11-20, 21-30, 31-40, atbp.",
        "queueCanceledTooltip": "- Kapag ang pasahero ay nagkansela o hindi nagpakita, mananatili ang drayber sa pinakamataas na posisyon kung ang drayber ay babalik sa pila sa loob ng itinakdang oras.  \n- Ang posisyon ng drayber ay itatakdang mataas na prayoridad kung ang drayber ay babalik sa pila sa loob ng itinakdang oras pagkatapos makumpleto ang isang maikling biyahe na booking.",
        "DELETE_QUEUING_AREA": "Burahin ang Queuing Area",
        "DELETE_CONFIRM": "Gusto mo bang tanggalin ang Queuing Area?",
        "EDIT_QUEUING_AREA": "Baguhin ang Lugar ng Paghihintay",
        "ADD_QUEUING_AREA": "Magdagdag ng Lugar ng Paghihintay",
        "DETAIL_QUEUING_AREA": "Detalye ng lugar ng pag-queue",
        "Queuing_area": "Lugar ng paghihintay",
        "Address": "Address",
        "Enter_a_location": "Maglagay ng lokasyon",
        "Entered_Address_is_incorrect": "Hindi matukoy ng sistema ang iyong lokasyon. Mangyaring gamitin ang inirekomendang address.",
        "Not_supported_zone": "Ang lugar ng pila na ito ay hindi nasa suportadong sona",
        "Active_mDispatcher_list": "Listahan ng mga aktibong kasosyo",
        "Queue_list": "Listahan ng pila",
        "Allow_radius": "Payagan ang radius",
        "Min_drivers_required": "# Min na Kinakailangang Drayber",
        "Open_queuing_area": "Bukas na lugar ng pag-queue",
        "Auto_dispatch": "Awtomatikong pagpapadala sa mga drayber sa pila (hindi kinakailangan ang paggamit ng Partner app)",
        "Active_car_list": "Listahan ng mga aktibong sasakyan",
        "mDispatcher": "Kasosyo",
        "Google_Address": "Google Address",
        "Status": "Katayuan",
        "Update_status_error": "Error sa pag-update ng katayuan",
        "driver_checkin_area": "Saradong lugar para sa pag-check in ng mga drayber",
        "EDIT_POLYGONS": "Baguhin ang mga polygon",
        "pax_pickup_area": "Lugar ng pagkuha ng pasahero",
        "pickup_area": "Pick-up area",
        "your_chosen_polygon": "Ang napili mong polygon",
        "other_queues": "Ibang pila",
        "operation_zones": "Mga lugar ng operasyon",
        "delete_pickup_area_confirm": "Sigurado ka bang nais mong tanggalin ang lugar na ito para sa pick-up?",
        "delete_pickup_area": "Burahin ang lugar ng pagkuha",
        "please_choose_driver_check_in_area": "Pakiusap, pumili ng lugar ng pag-check-in ng driver.",
        "please_choose_pick_up_area": "Pakisuyong pumili ng lugar ng pagkuha.",
        "Load_queuing_area_fail": "Nangyari ang mga error habang naglo-load ng lugar ng pag-queue",
        "Create_queuingArea_success": "Matagumpay na nalikha ang lugar ng pag-queue.",
        "Update_queuingArea_success": "Ang lugar ng pag-uunahan ay matagumpay na na-update",
        "Delete_queuingArea_success": "Matagumpay na na-delete ang lugar ng pagkuha.",
        "Delete_queuingArea_fail": "Nangyari ang mga error habang binubura ang lugar ng pag-queue",
        "Create_queuingArea_fail": "Nangyari ang mga error habang nililikha ang lugar ng pag-queue",
        "Load_queuingArea_fail": "Nangyari ang mga error habang naglo-load ng lugar ng pag-queue",
        "Update_queuingArea_fail": "Nangyari ang mga error habang ina-update ang lugar ng pag-queue"
    },
    "appBanner": {
        "Save": "I-save",
        "Pax_app": "Pax app",
        "Apply_to": "Mag-apply sa",
        "Please_select_view": "Pakis chọn ang view",
        "Select_Type": "Pakis chọn ang uri ng banner",
        "Home_view": "Tahanan na tanawin",
        "Other_view": "Ibang tanawin",
        "Banner_1": "Banner #1",
        "Upload_an_image": "Walang napiling larawan",
        "Action": "Aksyon",
        "NA": "Wala",
        "Link_to_website": "Link sa website",
        "Make_a_call": "Magbigay ng tawag",
        "Send_an_email": "Magpadala ng email",
        "Banner_2": "Banner #2",
        "Banner_3": "Banner #3",
        "Driver_app": "Aplikasyon ng drayber",
        "pax": "Aplikasyon ng Pasahero",
        "driver": "Driver app",
        "merchant": "Merchant app",
        "Name": "Pangalan",
        "viewType": "Uri",
        "status": "Katayuan",
        "image": "Larawan",
        "html": "HTML",
        "Delete_Banner": "Burahin ang banner",
        "Delete_confirm_banner": "Sigurado ka bang nais mong tanggalin ang napiling banner?",
        "Delete_banner_success": "Matagumpay na na-delete ang banner",
        "Delete_banner_fail": "Nangyari ang mga pagkakamali habang binubura ang banner",
        "edit_banner": "I-edit ang Banner",
        "detail_banner": "Detail Banner",
        "create_banner": "Magdagdag ng Banner",
        "note_1": "*  Ang file extension ay dapat na .jpg, .jpeg, .png, .gif at mas mababa sa %{limit}MB.",
        "note_2": "* Ang mga larawan ay dapat may 16:9 na aspeto.",
        "note_3": "* Ibang mga pananaw kabilang ang Inbox, I-refer ang kaibigan, Resibo, Aking booking, Promo code, Magdagdag ng Credit card/Mga Paraan ng Pagbabayad, Profile, Naghihintay para sa proseso/Kinumpirmang reserbasyon, Nakumpletong pananaw.",
        "Update_app_banner_success": "Na-update nang matagumpay ang banner ng app",
        "Update_app_banner_fail": "Nabigong i-update ang banner ng app!",
        "Create_app_banner_success": "Matagumpay na nalikha ang banner ng app",
        "Create_app_banner_fail": "Nabigong likhain ang banner ng app!",
        "Note": "Mangyaring gamitin ang file sa .png format (transparent na background, sukat 400:200px) para sa mas magandang pagganap ng app.",
        "Limit_size_upload": "Ang laki ng file ay dapat mas mababa sa 8Mb.",
        "display_duration": "Tagal ng pagpapakita",
        "playback_settings": "Mga setting ng pag-playback",
        "display_banner_again_after": "Ipakita muli ang mga banner pagkatapos ng",
        "stop_display_banner_after": "Huminto sa pagpapakita ng banner pagkatapos",
        "enable_playback": "Payagan ang pag-playback",
        "Update_playback_success": "Ang mga setting ng playback ay na-update nang matagumpay",
        "Update_playback_fail": "Nabigong i-update ang mga setting ng playback!",
        "language": "Wika",
        "single": "Isang Wika",
        "multi": "Maraming Wika",
        "es-ES": "Espanyol",
        "en-US": "English",
        "fr-FR": "Pranses",
        "id-ID": "Wikang Indonesian",
        "vi-VN": "Biyetnames",
        "ur-PK": "Urdu",
        "ms-MY": "Malaysia",
        "ar-AR": "Arabic",
        "nb-NO": "Norwegian",
        "en-GB": "Ingles (United Kingdom)",
        "am-ET": "Amhariko",
        "ro-RO": "Romanian",
        "version": "Bersyon ng App",
        "comparisonVersionApp": {
            "is": "Is",
            "is_not": "Hindi",
            "is_one_of": "Isa sa",
            "is_not_one_of": "Hindi isa sa",
            "greater_or_equal": "Mas malaki o katumbas",
            "less_or_equal": "Mas mababa o katumbas"
        },
        "platform": "Plataporma",
        "platformItem": {
            "all": "Lahat",
            "iOS": "iOS",
            "android": "Android"
        },
        "userStatus": "Katayuan ng gumagamit",
        "Active": "Aktibo",
        "Inactive": "Hindi aktibo",
        "in_review_completed": "Sa pagsusuri (kumpletong profile)",
        "in_review_incomplete": "Sa pagsusuri (hindi kumpleto ang profile)",
        "in_review_inProgress": "Sa pagsusuri (profile na nasa proseso)",
        "zones": "Mga Zone"
    },
    "reservation": {
        "name": "Rekord",
        "company": "kumpanya",
        "carType": "Uri ng kotse",
        "licensePlate": "Plaka: %{name}",
        "driver": "Driver: %{name}",
        "showAllDrivers": "Ipakita ang Lahat ng Driver",
        "available": "Available",
        "reserved": "Nakareserba",
        "search_holder": "Kumpanya, Pangalan ng Driver, Uri ng Sasakyan, Plaka",
        "all": "Lahat",
        "today": "Ngayon",
        "thisWeek": "Ngayong Linggo",
        "day": "Araw-araw",
        "week": "Tu weekly",
        "bookingID": "Booking ID",
        "tripId": "Trip ID",
        "pickupTime": "Oras ng pagkuha",
        "pickupLocation": "Lokasyon ng pickup",
        "monday": "Lunes",
        "tuesday": "Martes",
        "wednesday": "Merkules",
        "thursday": "Huwebes",
        "friday": "Biyernes",
        "saturday": "Sabado",
        "sunday": "Linggo",
        "overlapped": "Nagsalubong",
        "noData": "Walang natagpuang datos.",
        "bookingDetails": "Mga Detalye ng Reservation",
        "reservedHint": "Ang mga booking ng reserbasyon ay nakumpirma",
        "availableHint": "Walang anumang nakumpirmang reserbasyon.",
        "overlappedHint": "Dalawa o higit pang nakumpirmang reserbasyon ang nag-o-overlap"
    },
    "dashboard": {
        "API": "API",
        "cc": "CC",
        "dmc": "Board ng booking",
        "streetSharing": "Street-Sharing",
        "kiosk": "Kiosk",
        "mDispatcher": "Kasosyo",
        "paxApp": "Pax App",
        "webBooking": "Web Booking",
        "carHailing": "Car-Hailing",
        "acceptance": "Tanggapin",
        "booking_com": "Booking.com",
        "completed": "Nakumpleto",
        "noShow": "Walang Pagpapakita",
        "driverNoShow": "Driver na hindi nagpakita",
        "canceled": "Nakansela",
        "incident": "Insidente",
        "rate1": "1 Bituin",
        "rate2": "2 Bituin",
        "rate3": "3 Bituin",
        "rate4": "4 Bituin",
        "rate5": "5 Bituin",
        "Export_to_Excel": "I-export sa Excel",
        "Profit": "Kita",
        "day_change": "Araw-araw na pagbabago",
        "week_change": "Taunang pagbabago",
        "month_change": "Buwanang pagbabago",
        "Booking_requests": "Mga kahilingan sa pag-book",
        "Complete_bookings": "Nakumpletong mga booking",
        "New_customers": "Mga bagong customer",
        "Booking_dashboard": "Board ng booking",
        "others": "Mga iba",
        "Revenue_booking": " Kita at Natapos na Booking",
        "Profit_finish_booking": "Profit at Natapos na Booking",
        "Booking_request": "Request ng booking",
        "Finished_booking": "Nakumpleto ang pag-book",
        "failed": "Nabigo",
        "partialCompleted": "Bahagyang Nakumpleto",
        "Finished_booking_char_header": "Nakumpleto ang booking ({0})",
        "Bookings": "Mga Booking ({0})",
        "Ratings": "Mga Rating ({0})",
        "Daily": "Araw-araw",
        "Weekly": "Lingguhan",
        "Monthly": "Buwanang",
        "Total_customer": "Kabuuang customer {0}",
        "ProfitToolTips": "Ang kita ng pera ng fleet pagkatapos ibawas ang lahat ng gastos",
        "RevenueToolTips": "Ang perang natatanggap ng fleet sa aktwal na napiling panahon, kabilang ang promosyon, bawas para sa mga driver, buwis, atbp.",
        "ProfitChangeToolTips": "Ang porsyento ng pagbabago sa kita ng fleet kumpara sa nakaraang panahon",
        "BookingRequestsToolTips": "Kabuuang bilang ng mga on-demand na booking at reserbasyon na nilikha sa loob ng napiling panahon",
        "PercentageOfAcceptanceToolTips": "Ang porsyento ng tinanggap na mga booking sa napiling panahon",
        "BookingChangeHint": "Ang porsyento ng pagbabago sa mga nilikhang booking kumpara sa nakaraang panahon",
        "CompletedBookingHint": "Kabuuang bilang ng mga on-demand na booking at reserbasyon na natapos sa loob ng napiling panahon",
        "PercentageOfSatisfactionHint": "Ang porsyento ng kasiyahan sa napiling panahon",
        "CompleteBookingDailyChangeHint": "Ang porsyento ng pagbabago sa natapos na mga booking kumpara sa nakaraang panahon",
        "NewCustomersHint": "Kabuuang bilang ng mga bagong customer na nakarehistro sa napiling panahon",
        "CustomerChangeHint": "Ang bilang at porsyento ng pagbabago sa mga customer kumpara sa nakaraang panahon",
        "TotalCustomer": "Kabuuang bilang ng mga customer sa sistema",
        "ProfitAndFinishedBookingHint": "Profit at natapos na mga booking ng fleet sa napiling panahon",
        "BookingRequestHint": "Kabuuang bilang ng mga on-demand na booking at reservation na nilikha sa loob ng napiling panahon",
        "FinishedBookingChartsHint": "Kabuuang bilang ng mga on-demand na booking at reserbasyon na isinara sa loob ng napiling panahon, kabilang ang pagkansela, hindi pagdating, insidente, at natapos.",
        "Customer_count": "{0} bilang ng customer",
        "Revenue": "Kita"
    },
    "referral": {
        "first_package": "1st package (i.e ang unang natapos na booking ng Pax)",
        "driver_refers_to_pax": "Nag-refer ng customer ang driver",
        "driver_will_get": "Makakakuha ang driver",
        "money": "Pera",
        "amount": "Dami",
        "percent": "Percent",
        "settlement": "Komisyon (% ng subtotal na halaga ng bawat natapos na booking)",
        "pax_will_get": "Makakakuha si Pax",
        "promotion_code": "Kodigo ng Promosyon",
        "select_a_promotion": "Pumili ng code ng promosyon",
        "maximum": "Maximum",
        "second_package": "ikalawang pakete",
        "from": "Mula",
        "to": "Sa",
        "After_2nd_package": "Pagkatapos ng 2nd package",
        "from_end_value_of_above_package": "Mula sa halaga ng huling nabanggit na pakete + 1",
        "Expiration_date": "Petsa ng pag-expire",
        "Never": "Hindi kailanman",
        "Customized_date": "Naangkop na petsa",
        "limited": "Limitado",
        "unlimited": "Walang Hanggan",
        "Valid_from": "Valid From",
        "Valid_to": "Valido hanggang",
        "Invitation_limit": "Limitasyon ng tagahatol/drayber",
        "Status": "Katayuan",
        "Active": "Aktibo",
        "Inactive": "Hindi aktibo",
        "note": "* Pakitandaan na kapag ang kampanya ay aktibo na, ang anumang pag-update sa halaga ng gantimpala ay makakaapekto lamang sa mga bagong customer.",
        "Required_fields": "Mga kinakailangang patlang",
        "refferal_update_successfully": "Ang mga setting ng referral ay matagumpay na na-update",
        "distributeIncentiveToDriver": "Ibigay ang insentibo sa drayber",
        "Immediate": "Agad",
        "Periodic": "Panahon (Mano-mano)",
        "Period": "Panahon",
        "startDate": "Petsa ng pagsisimula",
        "nextDistributionDate": "Susunod na petsa ng pamamahagi",
        "oneMonth": "1 buwan",
        "threeMonth": "3 buwan",
        "sixMonth": "6 na buwan",
        "passenger_refers_to_pax": "Customer ay nagre-refer ng customer",
        "referer_will_get": "Makakakuha ang Referer",
        "referee_will_get": "Makakakuha ang referee",
        "promo": "Promosyon",
        "Pax_invitation_limit": "Limitasyon ng imbitasyon/gumagamit",
        "promoPaidBy": "Promosyon na binayaran ng",
        "fleet": "Fleet",
        "driver": "Driver",
        "promoCode": "Code ng promosyon",
        "isSendInbox": "Magpadala ng inbox",
        "isDefaultCode": "Awtomatikong ilapat sa app",
        "autoApplyOnWeb": "Auto apply sa web",
        "isDefaultCode_hint": "Idagdag ang promotion code sa listahan ng customer at awtomatikong ilapat sa booking kapag lumikha ng order ang customer.",
        "Actions": "Mga aksyon",
        "add_promoCode": "Idagdag",
        "Send_an_in_box_automatically_to_new_customers": "Magpadala ng inbox sa customer",
        "set_default_promo_code": "Awtomatikong ilapat sa app",
        "EDIT_PROMO_CODE": "I-edit ang promo code",
        "DETAIL_PROMO_CODE": "Mga detalye ng promo code",
        "CREATE_PROMO_CODE": "Lumikha ng promo code",
        "DELETE_PROMO_CODE": "Burahin ang code ng promosyon",
        "DELETE_CONFIRM_PROMO_CODE": "Gusto mo bang tanggalin ang promo code na ito?",
        "ERROR_INPUT_SOURCE": "Pakisuyong pumili ng hindi bababa sa isa."
    },
    "upload_document": {
        "NO_FILE_CHOSEN": "Walang napiling file",
        "Limit_size_upload": "Ang laki ng file ay lumampas sa pinapayagang limitasyon na {0}Mb."
    },
    "payment_info": {
        "member_since": "Kasapi mula noong",
        "package_name": "Pangalan ng pakete",
        "last_payment": "Huling bayad",
        "credit_card": "Kard ng kredito",
        "last_digits": "Huling 4 na digit",
        "default": "Default",
        "add_new_card": "Magdagdag ng bagong card",
        "history": "Kasaysayan",
        "transaction_date": "Petsa ng transaksyon",
        "transaction_id": "ID ng Transaksyon",
        "billing_cycle": "Ikot ng pagsingil",
        "amount": "Dami",
        "payment_history": "Kasaysayan ng pagsingil",
        "card_information": "Impormasyon ng card",
        "card_holder": "Tagahawak ng kard",
        "card_number": "Numero ng card",
        "expiration_date": "Petsa ng pag-expire",
        "cvv": "CVV"
    },
    "search_by": {
        "group_id": "Group ID",
        "booking_id": "# ng booking",
        "recurring_id": "Ulit-ulit na #",
        "ExternalID": "Panlabas #",
        "tripId": "Biyahe #",
        "driver_name": "Pangalan ng driver",
        "driver_phone_number": "Numero ng telepono ng drayber",
        "license_plate": "Plaka ng sasakyan",
        "vehicle": "Sasakyan",
        "operator": "Operator",
        "passenger_email": "Email ng pasahero",
        "passenger_name": "Pangalan ng pasahero",
        "passenger_phone_number": "Numero ng telepono ng pasahero",
        "destination": "Patutunguhan",
        "pick_up": "Pick-up",
        "flight_number": "Lipad #",
        "book_from": "Pagbu-book mula sa",
        "note": "Tala",
        "email": "Email",
        "phone": "Telepono"
    },
    "withdrawal": {
        "transferToEWallet": "Nilipat sa panlabas na e-wallet *{0}",
        "channelCode": "Kodigo ng channel",
        "channelName": "Pangalan ng channel",
        "reversed": "Baligtad",
        "requestTime": "Oras ng kahilingan",
        "referenceId": "Sanggunian #",
        "driverName": "Pangalan ng driver",
        "phoneNumber": "Numero ng telepono",
        "company": "kumpanya",
        "description": "Paglalarawan",
        "requestAmount": "Halaga ng kahilingan",
        "transferAmount": "Halaga ng paglilipat",
        "currentBalance": "Kasalukuyang balanse",
        "currency": "Pera",
        "action": "Aksyon",
        "approve": "Aprubahan",
        "reject": "Tanggihan",
        "transferToBankAccount": "Nilipat sa bank account *{0}",
        "transferToWingBank": "Nilipat sa Wing bank ID *{0}",
        "transferToCreditWallet": "Nilipat sa credit wallet",
        "reason": "Dahilan",
        "search": "Pangalan ng drayber, telepono, kumpanya, transaction ID, reference #",
        "message": {
            "approve": "Sigurado ka bang nais mong bayaran ang drayber na ito ng halagang {0}?",
            "approveMulti": "Sigurado ka bang nais mong bayaran ang napiling driver(s)?",
            "approveSuccess": "Ang napiling kahilingan ay nabayaran na",
            "approveFail": "Ang napiling kahilingan ay hindi matagumpay. Pakisubukan muli.",
            "approveMultiSuccess": "{0} sa {1} napiling kahilingan ang nabayaran na.",
            "approveMultiFail": "{0} sa {1} napiling kahilingan ay hindi matagumpay. Pakisubukan muli.",
            "buttonConfirmTitle": "Oo",
            "closeButtonText": "Hindi",
            "pleaseInputReason": "Pakisulat ang dahilan",
            "rejectSuccess": "Nireject ang kahilingan ng drayber",
            "rejectFail": "Bigong tanggihan ang napiling kahilingan"
        },
        "getDataFailure": "Hindi makakuha ng data",
        "rejectRequest": "Tanggihan ang kahilingan"
    },
    "dynamicSurcharge": {
        "operationZone": "Zonang operasyon",
        "activeSurcharge": "Aktibong surcharge",
        "surcharge": "Patong na singil",
        "surchargeName": "Pangalan ng karagdagang bayad",
        "parameter": "Parameter (hal. 1.x)",
        "pickupPoint": "Lugar ng pagkuha",
        "dropOffPoint": "Zonang ibababa",
        "delete_surcharge_success": "Matagumpay na na-delete ang surcharge",
        "delete_surcharge_fail": "Nagkaroon ng mga error habang binubura ang surcharge",
        "update_surcharge_fail": "Nangyari ang mga error habang ina-update ang surcharge",
        "update_surcharge_success": "Na-update nang matagumpay ang surcharge",
        "create_surcharge_fail": "Nangyari ang mga pagkakamali habang gumagawa ng surcharge",
        "create_surcharge_success": "Matagumpay na nalikha ang surcharge.",
        "active_surcharge_fail": "Ang mga error ay nangyari habang nag-aaktibo ng surcharge",
        "active_surcharge_success": "Ang surcharge ay matagumpay na na-activate",
        "deactive_surcharge_fail": "Nangyari ang mga error habang pinapatay ang surcharge",
        "deactive_surcharge_success": "Ang surcharge ay matagumpay na na-deactivate",
        "delete_surcharge": "Burahin ang dagdag na bayad",
        "delete_confirm_message": "Sigurado ka bang nais mong tanggalin ang napiling karagdagang bayad?",
        "note": "*Tandaan: ito ang kung gaano karaming beses ang iyong pangunahing pamasahe ay imumultiply. Halimbawa: ang pamasahe na $20 ay magiging $30 kapag ang parameter ay nasa 1.5x."
    },
    "dynamicFare": {
        "operationZone": "Zonang operasyon",
        "activeFare": "Aktibong pamasahe",
        "fare": "Pamasahe",
        "fareName": "Pangalan ng pasahe",
        "factor": "Paramihin sa salik",
        "fix_amount": "Dami",
        "parameter": "Parameter (hal. 1.x)",
        "delete_fare_success": "Matagumpay na na-delete ang fare",
        "delete_fare_fail": "Ang mga error ay nangyari habang tinatanggal ang pamasahe",
        "update_fare_fail": "Nangyari ang mga error habang ina-update ang pamasahe",
        "update_fare_success": "Na-update nang matagumpay ang pamasahe",
        "create_fare_fail": "Nangyari ang mga error habang gumagawa ng pamasahe",
        "create_fare_success": "Ang pamasahe ay matagumpay na nalikha",
        "active_fare_fail": "Ang mga error ay nangyari habang ina-activate ang pamasahe",
        "active_fare_success": "Ang pasahe ay matagumpay na na-activate",
        "deactive_fare_fail": "Nangyari ang mga error habang pinapatay ang taripa",
        "deactive_fare_success": "Ang pamasahe ay matagumpay na na-deactivate",
        "delete_fare": "Burahin ang pamasahe",
        "delete_confirm_message": "Sigurado ka bang nais mong tanggalin ang napiling pamasahe?",
        "note": "*Tandaan: ito ang magiging multiplier ng iyong pangunahing pamasahe. Halimbawa: ang pamasahe na $20 ay magiging $30 kapag ang parameter ay nasa 1.5x.",
        "note_amount": "*Nota: ito ang halaga na idaragdag sa iyong pangunahing pamasahe. Halimbawa: ang pamasahe na $20 ay magiging $25 kapag ang nakatakdang halaga ay $5."
    },
    "notifications": {
        "search": "Hanapin ang booking ID, external ID",
        "searchProviderName": "Pangalan ng tagapagbigay ng serbisyo sa paghahanap",
        "statusItem": {
            "all": " lahat ng abiso",
            "canceledByDriver": "Transport - Kinansela ng Driver",
            "canceledByPartner": "Affiliate - Nakansela ng kasosyo",
            "reservationReminder": "Paalaala sa reserbasyon",
            "localPending": "Local - Naghihintay",
            "reservationIsNotStarted": "Hindi pa nagsimula ang reserbasyon",
            "partnerRequestsCars": "Mga kotse ng kahilingan ng kasosyo",
            "timeout": "Timeout",
            "noShow": "Affiliate - Walang pagdalo",
            "driverNoShow": "Walang dumating na drayber",
            "affiliatePending": "Affiliate - Naka-pending",
            "affiliatePaymentFailed": "Nabigong Bayaran ang Affiliate",
            "affiliateTimeout": "Affiliate Timeout",
            "flightApi": "Flight API",
            "DebtWriteOff": "Pagsusulat ng utang",
            "driverCancelTrip": "Intercity - Kinansela ng Driver",
            "minimumSeatRequired": "Minimum na kinakailangang upuan",
            "newFarmInJobFrom3rd": "Booking.com - Bagong booking",
            "canceledJobBy3rd": "Booking.com - Nakansela",
            "updatedJobBy3rd": "Booking.com - Na-update",
            "incidentJobBy3rd": "Booking.com - Insidente",
            "newFarmInJobFromHolidayTaxis": "HolidayTaxis - Bagong booking",
            "canceledJobByHolidayTaxis": "HolidayTaxis - Nakansela",
            "updatedJobByHolidayTaxis": "HolidayTaxis - Na-update",
            "newFarmInJobFromKarhoo": "Karhoo - Bagong booking",
            "canceledJobByKarhoo": "Karhoo - Nakansela",
            "updatedJobByKarhoo": "Karhoo - Na-update",
            "newFarmInJobFromHoppa": "Hoppa - Bagong booking",
            "canceledJobByHoppa": "Hoppa - Nakansela",
            "updatedJobByHoppa": "Hoppa - Na-update",
            "newFarmInJobFromKlook": "Klook - Bagong reserbasyon",
            "canceledJobByKlook": "Klook - Kanselado",
            "updatedJobByKlook": "Klook - Na-update",
            "newFarmInJobFromTransferZ": "TransferZ - Bagong booking",
            "canceledJobByTransferZ": "TransferZ - Kanselado",
            "updatedJobByTransferZ": "TransferZ - Na-update",
            "incidentReport": "Insidente",
            "incidentAutoReport": "Kailangan ng pagsusuri"
        },
        "sos": {
            "sosSearch": "Maghanap ng booking ID, pangalan ng pax, pangalan ng driver",
            "statusItem": {
                "all": "Lahat",
                "driver": "Mga Driver",
                "passenger": "pasahero",
                "crew": "Tripulante"
            }
        }
    },
    "smartData": {
        "No": "Bilang",
        "driverName": "Pangalan",
        "phone": "Telepono",
        "rating": "Rating",
        "completed": "Nakumpleto",
        "noShow": "Hindi nagpakita",
        "driverNoShow": "Walang dumating na driver",
        "incident": "Insidente",
        "canceled": "Kinansela ng drayber",
        "accepted": "Tinatanggap",
        "reject": "Tanggihan",
        "ignore": "Balewalain",
        "earning": "Kita",
        "query": {
            "top20": "Nangungunang 20",
            "top50": "Nangungunang 50",
            "top100": "Nangungunang 100",
            "bottom20": "Ika-20 sa ilalim",
            "bottom50": "Pinakamababang 50",
            "bottom100": "Ibabang 100"
        },
        "status": {
            "canceled": "Kinansela ng drayber",
            "noShow": "Hindi nagpakita",
            "driverNoShow": "Walang dumating na driver",
            "incident": "Insidente",
            "completed": "Nakumpleto",
            "earning": "Kita",
            "reject": "Tanggihan",
            "ignore": "Balewalain",
            "accepted": "Tinatanggap"
        }
    },
    "Reject": "Walang Pagpapakita",
    "Do not allow Driver to start reservat": "Pagkakaugnay",
    "intercityRate": {
        "Delete_intercity_rate": "Burahin ang intercity rate",
        "edit_intercity_rate": "Baguhin ang intercity rate",
        "view_intercity_rate": "Tingnan ang intercity rate",
        "add_intercity_rate": "Magdagdag ng intercity rate",
        "Delete_confirm_intercity_rate": "Gusto mo bang tanggalin ang item na ito?",
        "Update_intercity_rate_success": "Ang intercity rate ay matagumpay na na-update",
        "Update_intercity_rate_fail": "Nangyari ang mga error habang ina-update ang intercity rate",
        "Created_intercity_rate_success": "Ang intercity rate ay matagumpay na nalikha",
        "Created_intercity_rate_fail": "Nangyari ang mga error habang gumagawa ng intercity rate",
        "Update_intercity_rate_route_success": "Ang ruta ng intercity rate ay matagumpay na na-update",
        "Update_intercity_rate_route_fail": "Ang mga pagkakamali ay nangyari habang ina-update ang intercity route",
        "Created_intercity_rate_route_success": "Matagumpay na nalikha ang intercity rate route",
        "Created_intercity_rate_route_fail": "Nangyari ang mga error habang gumagawa ng intercity route",
        "Loading_intercity_rate_fail": "Nangyari ang mga error habang naglo-load ng detalye ng intercity rate",
        "Delete_intercity_rate_route_fail": "Nangyari ang mga error habang binubura ang intercity rate route",
        "Delete_intercity_rate_success": "Ang intercity rate ay matagumpay na natanggal",
        "Delete_intercity_rate_fail": "Ang mga error ay nangyari habang tinatanggal ang intercity rate"
    },
    "intercityRoute": {
        "alias": "Alias",
        "routeNameHint": "Upang baguhin ang pangalan ng ruta, mangyaring pumunta sa Mga Setting > Zone > Intercity at baguhin ang pangalan ng mga city zone nang naaayon.",
        "pricePerSeat": "Presyo bawat upuan (hindi kasama ang buwis)",
        "distance": "Distansya",
        "duration": "Tagal",
        "cancellationPenalty": "Halaga ng parusa bawat upuan",
        "noShow": "Pax/partner na hindi nagpakita",
        "penalty": "Halaga ng parusa bawat upuan",
        "no_show_tooltip": "Ang halagang sisingilin sa customer bawat upuan. Bilang karagdagan sa multa, magbabayad ang customer ng buwis o tech fee kung naaangkop.",
        "firstLocation": "Unang lokasyon",
        "secondLocation": "Pangalawang lokasyon",
        "routeOneSetup": "I-set up ang ruta 1",
        "routetwoSetup": "I-set up ang ruta 2",
        "schedules": "Mga Iskedyul",
        "date": "Petsa",
        "time": "Oras",
        "editSchedule": "Baguhin ang iskedyul",
        "addSchedule": "Magdagdag ng iskedyul",
        "requestTimeEnable": "Payagan ang customer na itakda ang oras ng kahilingan",
        "extraFee": "Karagdagang bayad",
        "hideRouteEnable": "itago ang rutang ito",
        "timeRange": "Saklaw ng oras",
        "workingTime": "Oras ng trabaho",
        "applyForOtherDays": "Mag-apply para sa ibang mga araw",
        "limitSeatLuggage": "Limitasyon sa upuan / bagahe",
        "warningMinimumSeats": "Minimum na kinakailangang upuan",
        "warningMinimumSeatsHint": "Minimum na bilang ng mga upuan na kinakailangan upang maganap ang isang biyahe",
        "allowStartLessMinRequiredSeats": "Driver na simulan ang biyahe kahit walang minimum na kinakailangang upuan",
        "allowStartLessMinRequiredSeatsHint": "Payagan ang driver na simulan ang biyahe kahit na ang hinihinging bilang ng mga upuan ay mas mababa sa minimum na kinakailangang upuan.",
        "freeLuggagePerSeat": "Libre na bagahe bawat upuan",
        "freeLuggagePerSeatHint": "Bilang ng libreng bagahe na kasama sa bawat upuan",
        "allowToAddExtraLuggage": "Magdagdag ng karagdagang bagahe",
        "allowToAddExtraLuggageHint": "Payagan ang Pasahero na magdagdag ng karagdagang bagahe",
        "feePerExtraLuggage": "Bayad sa bawat dagdag na bagahe",
        "Delete_intercity_route": "Burahin ang intercity route",
        "Delete_confirm_intercity_route": "Gusto mo bang tanggalin ang rutang ito?",
        "Update_intercity_route_fail": "Ang mga error ay nangyari habang ina-update ang intercity route",
        "Update_intercity_route_success": "Ang ruta ng intercity ay matagumpay na na-update",
        "created_intercity_route_success": "Ang ruta ng intercity ay matagumpay na nalikha",
        "created_intercity_route_fail": "Nangyari ang mga pagkakamali habang lumilikha ng ruta sa pagitan ng mga lungsod.",
        "Delete_intercity_route_success": "Ang ruta ng intercity ay matagumpay na natanggal",
        "Delete_intercity_route_fail": "Nangyari ang mga pagkakamali habang binubura ang ruta sa pagitan ng mga lungsod",
        "penalty_less_than_or_equal_to_price": "Pakisok ang isang halaga na mas mababa o katumbas ng halaga bawat upuan.",
        "scheduleTimeOverlap": "Huwag mag-overlap ang iskedyul ng oras sa isa't isa.",
        "allows_adding_extra": "Pinapayagan ang pagdagdag ng karagdagang singil kapag humiling ang customer ng oras na hindi naka-iskedyul ng fleet.",
        "this_is_to_limit_users": "Ito ay upang limitahan ang mga gumagamit (i.e. customer, driver, operator) mula sa paglikha ng bagong booking o biyahe sa rutang ito. Ang mga umiiral na booking o biyahe ay mananatiling nakalaan."
    },
    "dayOfWeek": {
        "0": "Linggo",
        "1": "Lunes",
        "2": "Martes",
        "3": "Merkules",
        "4": "Huwebes",
        "5": "Biyernes",
        "6": "Sabado"
    },
    "intercityBooking": {
        "route": "Ruta",
        "departureDate": "Petsa ng pag-alis",
        "departureTime": "Oras ng pag-alis",
        "Departure": "Pag-alis",
        "Arrival": "Pagdating",
        "RefundFare": "Refund ng pamasahe",
        "intercityZoneNote": "Ang mga zone na nilikha mo dito ay ginagamit lamang para sa pag-set up ng iyong mga intercity rate.",
        "zoneNameHint": "Pakisiguraduhing maikli at malinaw ang pangalan ng iyong zone upang madali itong mahanap at mapili ng iyong mga customer.",
        "zoneUploadNote_2": "* Inirerekomenda na ang resolusyon ng larawan ay 1095x360 at ang laki ng file ay mas mababa sa 5MB.",
        "Complete_booking": "Kompletuhin ang Pag-book",
        "ConfirmCancel": "Kumpirmahin ang pagkansela"
    },
    "deliveryRate": {
        "Delete_delivery_rate": "Burahin ang rate ng paghahatid",
        "edit_delivery_rate": "Baguhin ang rate ng paghahatid",
        "view_delivery_rate": "Tingnan ang rate ng paghahatid",
        "add_delivery_rate": "Magdagdag ng rate ng paghahatid",
        "Delete_confirm_delivery_rate": "Gusto mo bang tanggalin ang item na ito?",
        "Update_delivery_rate_success": "Ang rate ng paghahatid ay matagumpay na na-update",
        "Update_delivery_rate_fail": "Ang mga error ay nangyari habang ina-update ang rate ng paghahatid",
        "Created_delivery_rate_success": "Ang rate ng paghahatid ay matagumpay na nalikha",
        "Created_delivery_rate_fail": "Nangyari ang mga error habang gumagawa ng rate ng paghahatid",
        "Update_delivery_rate_route_success": "Ang ruta ng rate ng paghahatid ay matagumpay na na-update",
        "Update_delivery_rate_route_fail": "Ang mga error ay nangyari habang ina-update ang ruta ng paghahatid",
        "Created_delivery_rate_route_success": "Matagumpay na nalikha ang ruta ng rate ng paghahatid",
        "Created_delivery_rate_route_fail": "Nangyari ang mga pagkakamali habang gumagawa ng ruta ng paghahatid",
        "Loading_delivery_rate_fail": "Nangyari ang mga error habang naglo-load ng detalye ng rate ng paghahatid",
        "Delete_delivery_rate_route_fail": "Ang mga pagkakamali ay nangyari habang binubura ang ruta ng rate ng paghahatid",
        "Delete_delivery_rate_success": "Matagumpay na na-delete ang rate ng delivery",
        "Delete_delivery_rate_fail": "Nangyari ang mga error habang binubura ang rate ng paghahatid",
        "distance_km": "Bayad bawat km",
        "distance_mile": "Bayad bawat libo",
        "flat": "Patag na Bayad",
        "startingFee": "Bayad sa pagsisimula",
        "feeFirstDistance": "Bayad sa unang distansya",
        "feeSecondDistance": "Bayad na pangalawang distansya",
        "feeThirdDistance": "Bayad sa ikatlong distansya",
        "feeAfterThirdDistance": "Bayad pagkatapos ng ikatlong distansya",
        "feePerMinute": "Bayad bawat minuto",
        "feeMinimum": "Minimum na bayad",
        "feeFirstStop": "Bayad para sa unang hintuan",
        "feeExtraStop": "Bayad para sa bawat karagdagang paghinto"
    },
    "aiAtlasSettings": {
        "title": "Atlas AI Chatbot",
        "titleDes": "Ipaalam natin sa Atlas ang tungkol sa iyong kumpanya at iyong serbisyo.",
        "information": "Impormasyon ng Atlas",
        "informationDes": "Halimbawa, idagdag ang mga detalye ng kumpanya tulad ng email, numero ng telepono, address, atbp.",
        "updateSettingSuccess": "Matagumpay na na-update ang setting ng AI Atlas",
        "updateSettingFail": "Na-update na setting AI Atlas nabigo"
    },
    "pwaSettings": {
        "pwa": "PWA",
        "iconName": "Ikon at pangalan",
        "logoBackgroundColor": "Logo, background at kulay",
        "longName": "Mahabang pangalan",
        "shortName": "Maikling pangalan",
        "icon192": "Ikon sa Home Screen (192x192)",
        "icon512": "Ikon sa Splash Screen",
        "logo": "Logo (300x300)",
        "logoMenu": "Logo menu (300x300)",
        "backgroundImage": "Background na imahe - Transport (1024x500)",
        "backgroundImageDelivery": "Background image - Paghahatid (1024x500)",
        "mainColor": "Pangunahing kulay",
        "secondaryColor": "Pangalawang kulay",
        "showMainColor": "Ipakita ang pangunahing kulay sa halip na ang background na imahe",
        "success": "Na-update nang matagumpay ang PWA setting",
        "failed": "Nabigong i-update ang PWA setting. Pakisubukang muli!",
        "errorUploadFileSize": "Ang kinakailangang sukat ay {0}x{0} px.",
        "hideWBInstallAppBtn": "Tago ang pindutan ng pag-install ng app",
        "enableBookNow": "Ngayon",
        "enableGuestCheckout": "Pagbili bilang bisita",
        "enableBookLater": "Sa susunod",
        "enableHideRecipient": "Tago ang impormasyon ng tatanggap (Nilalaman ng pakete, Mga tagubilin sa paghahatid)",
        "pwaLink": "PWA para sa Pasahero",
        "partnerLink": "PWA para sa Kasosyo",
        "pwaDriverLink": "PWA para sa Driver",
        "providerSignUp": "Link para sa pag-sign up ng driver",
        "AdsTracking": "Pagsubaybay ng Ads",
        "googleId": "Google Tag ID",
        "placeholdergoogleId": "Ilagay ang Google Tag ID",
        "metaId": "Meta Pixel ID",
        "placeholdermetaId": "Ilagay ang Meta Pixel ID"
    },
    "emailConfig": {
        "emailServer": "Email server",
        "default": "Default",
        "customized": "Naangkop",
        "fromName": "Mula sa pangalan",
        "email": "Mula sa email",
        "replyTo": "Sumagot sa",
        "userAuth": "Username",
        "password": "Password",
        "smtpServer": "SMTP server",
        "port": "SMTP na port",
        "isAuthenticated": "Na-authenticate",
        "option": "Payagan ang Opsyon",
        "none": "Wala",
        "tls": "TLS",
        "ssl": "SSL",
        "save": "I-save",
        "cancel": "Kanselahin",
        "success": "Tagumpay sa pag-update ng email server",
        "fail": "Pag-update ng email server nabigo",
        "loadFail": "Nabigong i-load ang detalye ng email server"
    },
    "driverFields": {
        "Load_fail": "",
        "Edit": "I-edit",
        "View": "Tingnan",
        "Cancel": "Kanselahin",
        "show": "Ipakita",
        "hide": "Tago",
        "EDIT_DRIVER_FIELDS": "I-edit ang mga Patlang ng Driver",
        "DETAIL_DRIVER_FIELDS": "Mga Detalye ng Patlang ng Drayber",
        "ADD_DRIVER_FIELDS": "Magdagdag ng Mga Patlang ng Driver",
        "fieldKey": "Key ng mga patlang",
        "fieldName": "Pangalan ng mga larangan",
        "availableCC": "Available sa Command Center",
        "availableDrvSignUp": "Available sa Pag-sign up ng Driver",
        "availableCompanyCar": "Company Car - Mga drayber ng transportasyon",
        "deliveryCompany": "Company Car - Mga driver ng paghahatid",
        "availableIndividualCar": "Indibidwal na Sasakyan - Mga drayber ng transportasyon",
        "deliveryIndividual": "Indibidwal na Sasakyan - Mga tagapaghatid",
        "required": "Kailangan",
        "Update_fail": "Ang mga error ay nangyari habang ina-update ang mga patlang ng driver",
        "Update_success": "Ang Driver Fields ay matagumpay na na-update",
        "FieldKey": "Fields Key",
        "FieldName": "Pangalan ng mga Larangan (Amerikanong Ingles)",
        "CommandCenter": "Magagamit Sa Command Center",
        "SignUp": "Available Sa Pag-sign Up ng Driver",
        "CompanyTransport": "Sasakyan ng Kumpanya - Transportasyon",
        "CompanyDelivery": "Kotse ng Kumpanya - Paghahatid",
        "IndividualTransport": "Indibidwal na Sasakyan - Transportasyon",
        "IndividualDelivery": "Indibidwal na Sasakyan - Paghahatid",
        "Require": "Kailangan",
        "Actions": "Mga aksyon",
        "fieldType": "Uri ng mga Patlang",
        "default": "Default",
        "customized": "Naangkop"
    },
    "driverDocument": {
        "Load_fail": "",
        "Edit": "Isinasaayos",
        "View": "Tingnan",
        "Cancel": "Kanselahin",
        "show": "Ipakita",
        "hide": "itago",
        "EDIT_DRIVER_DOCUMENT": "I-edit ang Dokumento ng Driver",
        "DETAIL_DRIVER_DOCUMENT": "Detalyadong Dokumento ng Driver",
        "ADD_DRIVER_DOCUMENT": "Magdagdag ng Dokumento ng Driver",
        "documentKey": "Susik ng dokumento",
        "documentName": "Pangalan ng dokumento",
        "documentNameDetail": {
            "zh-HK": "Tradisyunal na Tsino",
            "it-IT": "Pamantayang Italyano",
            "es-ES": "Espanyol",
            "en-US": "Amerikanong Ingles",
            "fr-FR": "Pamantayang Pranses",
            "zh-CN": "Pinadaling Tsino",
            "id-ID": "Bahasa Indonesia",
            "vi-VN": "Biyetnames",
            "ur-PK": "Urdu (Islamikong Republika ng Pakistan)",
            "ms-MY": "Malay (Malaysia)",
            "ar-AR": "Arabic",
            "en-GB": "Ingles (United Kingdom)",
            "nb-NO": "Norwegian",
            "am-ET": "Amharic",
            "ro-RO": "Romanian",
            "th-TH": "Thai",
            "ta-IN": "Tamil",
            "hi-IN": "Hindi",
            "te-IN": "Telugu",
            "ka-GE": "Georgiano",
            "ru-RU": "Ruso",
            "kn-IN": "Kannada"
        },
        "isIndividual": "Company car - Mga drayber ng transportasyon",
        "deliveryCompany": "Company car - Mga tagapagdala",
        "isOwner": "Indibidwal na drayber - Mga drayber ng transportasyon",
        "deliveryIndividual": "Indibidwal na drayber - Mga drayber ng paghahatid",
        "availableCC": "Available sa Command Center",
        "availableDrvSignUp": "Available sa pag-sign up ng Driver",
        "isRequired": "Kailangan",
        "isExpiredDate": "Petsa ng pag-expire - Command Center",
        "expiredDateForDrvSignUp": "Petsa ng pag-expire - Pag-signup ng Driver",
        "requireExpiredDate": "Kinakailangan ang Petsa ng Pag-expire",
        "requireExpiredDateForDrvSignUp": "Kailangan ng Petsa ng Pag-expire",
        "requireDocumentId": "Kinakailangan ang Document ID",
        "documentId": "Dokumento ID - Command Center",
        "documentIdForDrvSignUp": "Document ID - Pag-signup ng Driver",
        "Update_fail": "Ang mga error ay nangyari habang ina-update ang dokumento ng driver",
        "Update_success": "Ang Driver Document ay na-update nang matagumpay",
        "DocumentKey": "Susik ng Dokumento",
        "DocumentName": "Pangalan ng Dokumento (American English)",
        "CommandCenter": "Available Sa Command Center",
        "SignUp": "Available Sa Pag-sign Up ng Driver",
        "CompanyTransport": "Sasakyan ng Kumpanya - Transportasyon",
        "CompanyDelivery": "Company Car - Paghahatid",
        "IndividualTransport": "Indibidwal na Sasakyan - Transportasyon",
        "IndividualDelivery": "Indibidwal na Sasakyan - Paghahatid",
        "Require": "Kailangan",
        "Actions": "Mga aksyon"
    },
    "holidayTaxis": {
        "title": "Mga Kredensyal ng HolidayTaxis API",
        "note": "Makipag-ugnayan sa teknikal na koponan ng HolidayTaxis upang bigyan ka ng api key para kumonekta sa kanilang sistema.",
        "apiKey": "API susi",
        "placeHolderApiKey": "Ilagay ang api key"
    },
    "trailNotes": {
        "maxLengthFiles": "Maximum na 3 file bawat komento",
        "maxSizeFiles": "Maximum na 10MB bawat file",
        "typeFiles": "Mga suportadong uri ng file: pdf, doc, docx, csv, xls, xlsx, jpeg, jpg, png, webp, txt, note",
        "maxComments": "Maximum na 20 komento bawat booking",
        "bookingActivity": "Booking Activity",
        "viewAll": "Tingnan ang lahat",
        "operator": "Operator",
        "driver": "Driver",
        "passenger": "Customer",
        "pHInput": "Magdagdag ng bagong komento. Maaari mong i-click ang i-save upang i-save ang tala. Maaari mo ring i-drag at i-drop ang maramihang mga file dito.",
        "addFiles": "Magdagdag ng mga file",
        "save": "I-save",
        "inputNotes": "Pakisok ang teksto",
        "successDeleteTrailNotes": "Matagumpay na natanggal ang mga tala ng trail",
        "successCreateTrailNotes": "Matagumpay na lumikha ng mga tala ng trail",
        "deleteTrailNote": "Burahin ang tala ng landas",
        "msgDeleteTrailNote": "Sigurado ka bang nais mong tanggalin ito?"
    },
    "supplier": {
        "permissionRequired": "Kailangan ng operator na pumili ng pahintulot",
        "offerDetail": "Detalye ng Alok",
        "orderDetail": "Detalye ng Order",
        "bookingNumber": "Numero ng Booking",
        "date": "Petsa",
        "pickupLocation": "Pick up Location",
        "dropoffLocation": "Lokasyon ng Pagbaba",
        "passenger": "Pasahero",
        "luggage": "Bagahe",
        "pickupService": "Serbisyo ng Pagkuha",
        "pickupSignage": "Karaniwang Palatandaan ng Pagkuha",
        "flightNumber": "Numero ng Flight",
        "departure": "Pag-alis",
        "arrival": "Pagdating",
        "terminal": "Terminal",
        "gate": "Tarangkahan",
        "meetGreet": "Makilala at Batiin",
        "specialRequests": "Mga Espesyal na Kahilingan",
        "additionalServices": "Karagdagang Serbisyo",
        "price": "Presyo",
        "prices": "Mga Presyo",
        "guest": "Bisitante",
        "serviceClass": "Klase ng Serbisyo",
        "distance": "Distansya",
        "duration": "Tagal",
        "acceptOffer": "Tanggapin ang Alok",
        "updateBooking": "I-update ang Booking",
        "package": "Package",
        "route": "Ruta",
        "assignedChauffer": "Nakatakdang Tsuper",
        "assignedVehicle": "Nakatakdang Sasakyan",
        "logs": "Mga tala",
        "link": "Mga Link",
        "desLink": "Mag-click upang kopyahin ang link",
        "trackLink": "Subaybayan ang link",
        "driverLink": "Driver link",
        "close": "Isara",
        "links": "Mga Link",
        "linksDes": "I-click upang kopyahin ang link",
        "status": "Katayuan",
        "rating": "Rating",
        "permissions": "Mga Pahintulot",
        "permissionsNote": "Mag-assign ng iba't ibang antas ng awtorisasyon sa iyong koponan. Maaari mong piliin kung ang iyong mga operator ay may kakayahang makita ang mga bukas na alok o mga takdang-aralin na tinanggap na lamang.",
        "owner": "May-ari",
        "ownerNote": "Buong Access",
        "manageUsers": "Pamahalaan ang mga Gumagamit",
        "manageUsersNote": "Magdagdag/alisin ng mga bagong operator",
        "manageDrivers": "Pamahalaan ang mga Driver",
        "manageDriversNote": "Magdagdag/alisin ang mga driver",
        "manageVehicles": "Pamahalaan ang mga Sasakyan",
        "manageVehiclesNote": "Magdagdag/alis ng mga sasakyan",
        "mapView": "Live Map",
        "mapViewNote": "Subaybayan ang mga drayber at aktibong biyahe nang live sa mapa.",
        "calendarView": "Tanaw ng Kalendaryo",
        "calendarViewNote": "Tingnan ang kalendaryo ng lahat ng nakatalaga na biyahe.",
        "bookingView": "Pagtingin sa Booking",
        "bookingViewNote": "Tingnan at pamahalaan ang kasalukuyang mga booking, magtalaga ng mga driver, at maglaan ng mga sasakyan.",
        "offersView": "Tanawin ng Alok",
        "offersViewNote": "Tanggapin ang mga bagong alok sa trabaho.",
        "pricing": "Pagsusuri ng Presyo",
        "pricingNote": "Tingnan ang mga presyo ng biyahe",
        "report": "Ulat",
        "reportNote": "Tingnan ang mga ulat sa booking at pananalapi",
        "reportExport": "I-export ang mga Ulat",
        "reportExportNote": "I-export ang mga ulat sa .csv",
        "userDetail": "Detalye ng Gumagamit",
        "addOperator": "Magdagdag ng Operator",
        "updateOperator": "Update Operator",
        "supplier": "Supplier",
        "zone": "Zone",
        "emails": "Mga Email",
        "email": "Email",
        "phoneNumber": "Numero ng Telepono",
        "Deactivate": "Idiskonekta",
        "Activate": "Isaaktibo",
        "ALERT_SELECT_DEACTIVATE": "Pakisuyong pumili ng supplier na idedeactivate",
        "ALERT_SELECT_ACTIVATE": "Pakisuyong pumili ng supplier upang i-activate",
        "CONFIRM_DEACTIVATE_MULTI": "Gusto mo bang i-deactivate ang mga supplier na ito?",
        "CONFIRM_ACTIVATE_MULTI": "Gusto mo bang i-activate ang mga supplier na ito?",
        "Update_supplier_user_status_success": "Ang katayuan ng supplier ay matagumpay na na-update",
        "Update_supplier_user_status_fail": "Nangyari ang mga error habang ina-update ang katayuan ng supplier",
        "agent": "Ahente",
        "Supplier": "Tagapagtustos",
        "addSupplier": "Magdagdag ng Supplier",
        "detailSupplier": "Detalye ng Supplier",
        "addUser": "Magdagdag ng Gumagamit",
        "Add": "Idagdag",
        "ContactInfo": "Impormasyon sa Pakikipag-ugnayan",
        "policy": "Patakaran",
        "users": "Mga gumagamit",
        "setting": "Setting",
        "zones": "Mga Zone",
        "actions": "Aksyon",
        "companyName": "Pangalan ng Kumpanya",
        "corporationType": "Uri ng Korporasyon",
        "country": "Bansa",
        "nationality": "Nasyonalidad",
        "driverIC": "Driver IC",
        "ADMIN_INFORMATION": "Impormasyon ng Admin",
        "firstName": "Unang Pangalan",
        "lastName": "Apelyido",
        "commissionValue": "Komisyon ng fleet",
        "commissionValueDes": "Itakda ang komisyon na kinikita ng fleet para sa bawat kumpletong order.",
        "SupplierType": "Uri ng Tagapagtustos",
        "SupplierTypeDes": "Pumili ng uri ng supplier.",
        "paymentMethodsApplyDes": "Mga paraan ng pagbabayad na tiyak sa trabaho na maaaring iproseso ng mga supplier:",
        "bookingSettings": "Mga Setting ng Pag-book",
        "bookingSettingsDes": "I-configure ang visibility ng trabaho, mga oras ng pagpapalabas, at mga pagkaantala para sa mahusay na operasyon ng supplier.",
        "advanceBookingVisibilityTooltip": "Tukuyin kung ilang araw nang maaga makikita ng mga supplier ang mga order.",
        "delayBroadcastToolTip": "Mag-set ng delay time mula sa oras ng pag-release kung ito ay naka-set o mula sa simula ng araw (00:00). Ang delay na ito ay nagkokontrol kung kailan nagiging visible ang mga trabaho sa mga supplier pagkatapos ng paunang oras ng pag-release.",
        "releaseTimeToolTip": "Itakda ang oras ng araw kung kailan inilalabas ang mga trabaho sa mga supplier, simula sa unang araw na maaari nilang makita ang mga booking. Tiyakin na ang oras na ito ay nagbibigay sa mga supplier ng sapat na oras para sa paghahanda.",
        "otherSettings": "Ibang Mga Setting",
        "hideFare": "Driver - Palaging itago ang pamasahe",
        "hideFareDes": "Tago ang pamasahe para sa lahat ng drayber ng supplier na ito.",
        "supplierJobRequired": "Kailangan ang Pagtanggap ng Trabaho ng Supplier",
        "supplierJobRequiredDes": "Dapat kilalanin at tanggapin ng mga supplier ang mga trabaho bago sila makapag-assign ng driver/sasakyan o payagan ang trabaho na makita ng mga driver sa pamilihan.",
        "supplierApproval": "Pag-apruba ng Driver/Sasakyan ng mga Supplier",
        "supplierApprovalDes": "Pahintulutan ang mga operator ng supplier na i-activate ang mga driver at sasakyan sa kanilang fleet.",
        "emailsApply": "Mga Abiso sa Email",
        "emailsApplyDes": "Mga email para magpadala ng mga bagong trabaho, mga update sa booking.",
        "address": "Address",
        "zipCode": "Zip/Postal Code",
        "city": "Lungsod",
        "state": "Estado/Probinsya",
        "tax": "Tax Identification Number",
        "businessRegistration": "Numero ng Rehistrasyon ng Negosyo",
        "vatNumber": "VAT ID/Numero",
        "mobile": "Mobile",
        "editOperator": "Edit Operator",
        "searchEmail": "Maghanap ng Email",
        "acceptOfferSuccess": "Matagumpay na tinanggap ang alok",
        "acceptOfferFail": "Walang natagpuang booking o ibang supplier ang tumanggap ng booking",
        "driverPayout": "Bayad sa driver",
        "payout": "Bayad",
        "totalPayout": "Kabuuang bayad",
        "totalPayoutDes": "Ang kabuuang bayad ay kinabibilangan ng batayang halaga ng bayad kasama ang anumang karagdagang bayarin na pinili mong ipamahagi sa iyong mga tagapagbigay.",
        "supplierPayout": "Supplier payout",
        "driverTip": "Tip para sa drayber",
        "cancel": "Ikansela",
        "save": "I-save",
        "activeSupplier": "Aktibong tagapagtustos",
        "userName": "Username",
        "bookingCompletedView": "Nakumpletong Mga Booking",
        "bookingCompletedViewNote": "Tingnan ang kasaysayan ng lahat ng natapos na booking.",
        "driverEarning": "Kita ng driver",
        "payoutCurrency": "Currency ng Bayad",
        "payoutCurrencyDes": "Salapi na babayaran sa supplier/drayber",
        "autoCreatePayout": "Auto Lumikha ng Bayad",
        "autoCreatePayoutDes": "I-set up kung kailan awtomatikong gagawa ng payout statement para sa iyong mga kasosyo",
        "startDate": "Petsa ng Pagsisimula",
        "frequency": "Dalas",
        "daily": "Araw-araw",
        "weekly": "Lingguhan",
        "biWeekly": "Bawat dalawang linggo",
        "monthly": "Buwanang",
        "commissionSupplier": "Komisyon",
        "commissionSupplierDes": "Itakda ang komisyon na kinikita ng supplier para sa bawat kumpletong order.",
        "amount": "Naayos na halaga",
        "percent": "Persyento",
        "commissionSupplierValue": "Ilagay ang halaga ng komisyon",
        "payments": "Mga Bayad",
        "paymentsDes": "Balanseng babayaran sa iyo sa bawat iskedyul ng pagbabayad",
        "ConnectWithStripe": "Ikonekta sa Stripe",
        "viewStripeAccount": "Tingnan ang Stripe Account",
        "viewBankInfo": "Tingnan ang Impormasyon ng Bangko",
        "AddBankInfo": "Magdagdag ng Impormasyon sa Bangko",
        "confirmChangeBalane": "Sigurado ka bang nais mong baguhin ang balanse ng supplier?",
        "changeBalaneSuccess": "Ang balanse ng cash ng supplier ay na-update nang matagumpay.",
        "restrictedZoneAccess": "Access sa Restriktadong Zone",
        "restrictedZoneAccessDes": "Tukuyin ang mga tiyak na mataas na seguridad o kontroladong lugar—tulad ng mga base militar o pasilidad ng puwersang panghimpapawid—kung saan ang mga pickup o drop-off ay pinahihintulutan lamang para sa mga awtorisadong drayber na may espesyal na access o permiso.",
        "DrvSignUpLink": "Link ng Pag-sign Up ng Driver"
    },
    "vehicleLeadTime": {
        "vehicleLeadTime": "Patakaran sa Oras ng Paghahatid ng Sasakyan",
        "customLocationLeadTime": "Pasadyang Lokasyon ng Oras ng Paghahatid",
        "leadTime": "Lead Time",
        "ConfirmDelete": "Sigurado ka bang nais mong tanggalin ang patakarang ito?",
        "Delete_success": "Matagumpay na na-delete ang patakaran",
        "Update_Policy_success": "Ang patakaran ay matagumpay na na-update",
        "Create_Policy_success": "Matagumpay na nalikha ang patakaran",
        "Update_Policy_fail": "Ang mga pagkakamali ay nangyari habang ina-update ang patakaran",
        "Create_Policy_fail": "Ang mga pagkakamali ay nangyari habang gumagawa ng patakaran",
        "setDefaultSuccess": "Matagumpay na naitakda ang default na patakaran sa oras ng paghatid ng sasakyan.",
        "setDefaultFail": "Nangyari ang mga pagkakamali habang nagse-set ng default na patakaran",
        "Policies": "Mga Patakaran",
        "pricingPolicy": "Patakaran sa Pagpepresyo",
        "customizeLeadTime": "I-customize ang Lead Time",
        "SelectVehiclePolicy": "Pumili ng Patakaran sa Oras ng Pagdala ng Sasakyan"
    },
    "noResultFound": "Walang nahanap na resulta",
    "invalidDate": "Di wasto ang petsa. Mangyaring ilagay ang petsa sa format na mm/dd/yyyy.",
    "billingUsage": {
        "GSNTitle": "GSN Wallet",
        "GSNNote": "Nag-top up ang mga fleet para magpadala o tumanggap ng mga trabaho mula sa network.",
        "GSNPlatform": "Platform",
        "GSNPlatformNote": "Pagsubaybay sa subscription at booking usage. Sisingilin sa katapusan ng iyong billing cycle. Hiwalay ito sa iyong GSN Wallet.",
        "GSNPlatformLimit": "Platform billing",
        "GSNPlatformLimitNote": "Pagsubaybay sa subscription at usage. Sisingilin sa katapusan ng iyong billing cycle. Hiwalay ito sa iyong GSN Wallet.",
        "usageBalanceNote": "Pagsubaybay sa subscription at usage. Sisingilin sa katapusan ng iyong billing cycle. Hiwalay ito sa iyong GSN Wallet.",
        "usageBalanceNoteDate": "May outstanding ang subscription at usage",
        "usageBalanceNoteDateValue": "dapat bayaran sa %{date}.",
        "usageBalance": "Usage balance",
        "platformUsage": "Platform usage",
        "payoutBalance": "Balanse sa payout",
        "invoicePayoutBalanceTooltip": "Kita mula sa mga kumpletong network booking, available para sa withdrawal. Kapag kulang ang Credit Balance, maaaring gamitin ang balanseng ito para sa network transactions.",
        "autoPayoutBalanceTooltip": "Ipinapakita ng balanseng ito ang kinita mo sa network at maaari mong i-withdraw. Kapag mababa ang credit, maaaring awtomatik na bawasan dito ang mga bayad.",
        "creditBalance": "Credit balance",
        "gsnCreditBalance": "GSN credit balance",
        "totalBalance": "Kabuuang balanse",
        "paid": "Nakumpleto",
        "failed": "Nabigo",
        "processing": "Pinoproseso",
        "pending": "Nakabinbin",
        "bookingDeduct": "GSN Farm-Out",
        "cancellationPenalty": "GSN late na kanselasyon",
        "noShowPenalty": "GSN walang pagdating",
        "withdraw": "Mag-withdraw",
        "bookingEarning": "GSN Farm-In",
        "booking": "Bayarin sa platform",
        "subscriptionFee": "Subscription Fee",
        "waived": "Waived*",
        "learnMore": "Matuto Nang Higit Pa",
        "viewUsage": "View Usage",
        "productDiscovery": "Pagtuklas ng Produkto",
        "productDiscoveryDescription": "Tuklasin ang lahat ng maaari mong ilunsad gamit ang GoodJourney. Alamin ang tungkol sa mga driver apps, mga tool sa pag-book sa web, at iba pang mga produkto upang mapagana ang iyong mga operasyon.",
        "overview": "Buod",
        "paymentMethods": "Mga Paraan ng Pagbabayad",
        "billingHistory": "Kasaysayan ng Pagsingil",
        "creditGrants": "Mga Pautang sa Kredito",
        "transactionHistory": "Kasaysayan ng Transaksyon",
        "getStartedDescription": "Ang iyong all-in-one na gabay sa platform. Tuklasin ang mga hakbang-hakbang na tutorial, FAQs, at mga pinakamahusay na kasanayan upang masterin ang mga booking, dispatch, pagbabayad, at iba pa.",
        "getStartedButton": "Magsimula",
        "walletOverview": "Pagtingin sa Wallet",
        "calculateTotal": "Kabuuan = Kredito + Cash",
        "autoRechargeOn": "Kapag umabot sa $0 ang iyong credit balance, babagsak ka sa libreng antas. I-enable ang awtomatikong recharge upang awtomatikong mapanatiling puno ang iyong credit balance.",
        "autoRechargeOff": "Tip: I-enable ang Auto-Recharge upang mapanatiling puno ang iyong balanse. Kapag ang iyong kredito ay bumaba sa $0, ang mga bagong booking ay ihihinto hanggang sa magdagdag ka ng pondo.",
        "updateSettingsOn": "I-update ang Mga Setting",
        "updateSettingsOff": "Payagan ang awtomatikong pag-recharge",
        "autoChargeTitle": "Mga setting ng awtomatikong pag-recharge",
        "autoChargeTitleQuestion": "Gusto mo bang mag-set up ng awtomatikong pag-recharge?",
        "autoChargeCbx": "Oo, awtomatikong i-recharge ang aking card kapag ang aking credit balance ay bumaba sa isang threshold.",
        "crdBelow": "Kapag ang balanse ng kredito ay bumaba sa ibaba",
        "crdBelowNote": "Enter an amount between $5 and $100",
        "backupTo": "Ibalik ang balanse ng kredito sa",
        "backupToNote": "Enter an amount between $10 and $100",
        "greaterThan": "Ang halaga ay dapat na mas malaki kaysa sa {0}",
        "lessThan": "Ang halaga ay dapat mas mababa sa {0}",
        "AddBalance": "Idagdag sa balanse ng kredito",
        "toAdd": "Damdaming idaragdag",
        "confirm": "Kumpirmahin ang bayad",
        "usageCredit": "Magandang Paggamit ng Kredito sa Paglalakbay",
        "estTotal": "Tinatayang Kabuuan",
        "topUpSuccess": "Matagumpay ang pagdagdag ng pondo",
        "topUpFailMessage": "Ang mga error ay nangyari habang nagdadagdag ng kredito",
        "autoRechargeSuccess": "Ang mga setting ng auto recharge ay na-update nang matagumpay.",
        "autoRechargeFailMessage": "Ang mga error ay nangyari habang ina-update ang mga setting ng auto recharge.",
        "creditBalanceTooltip": "Ang prepaid balance mo ang sumasagot sa platform fees at usage mo. Panatilihing may sapat ito para tuloy-tuloy at walang patid ang serbisyo.",
        "gsnCreditBalanceTooltip": "Prepaid credits para magpadala at tumanggap ng booking sa network. Panatilihing sapat ang balanse para tuloy-tuloy ang transaksyon.",
        "creditLineTitle": "Credit line",
        "creditLineTooltip": "Limit ng credit line para sa Good Journey Network. Ang nagamit ay ibabawas sa limit; ang available ang natitirang puwang bago magbayad.",
        "creditLineLimit": "Limit",
        "creditLineUsed": "Nagamit",
        "creditLineAvailable": "Available",
        "creditLineNextPaymentLead": "Susunod na awtomatikong bayad %{date}",
        "creditLineNextPaymentTail": "o kapag umabot ang balanse mo sa %{limitAmount}",
        "creditLineNextPaymentTailOnly": "Dapat bayaran kapag umabot ang balanse mo sa %{limitAmount}",
        "creditLineMakePayment": "Magbayad",
        "cashBalanceTooltip": "Ito ang iyong kita mula sa mga natapos na trabaho sa network. Ang halagang ito ay magagamit para sa pag-withdraw. Kung mababa ang iyong credit balance, maaaring may mga bayarin na ibawas mula dito.",
        "systemTopUp": "Pagdaragdag ng Sistema",
        "gsnManualTopUp": "Manwal na Pagdaragdag",
        "gsnSystemTopUp": "Pagdaragdag ng Sistema",
        "autoTopUp": "Auto Top-up",
        "manualTopUp": "Manwal na Pagdaragdag",
        "subscription": "Subskripsyon",
        "subscriptionOneTime": "Subscription Isang Beses",
        "subscriptionAddOn": "Karagdagang Subscription",
        "subscriptionAddOnOneTime": "Subscription Add On Isang Beses",
        "booking": "Bayad sa Pag-book",
        "addOn": "Add-On",
        "subscriptionEnded": "Natapos na ang iyong subscription. Pumili ng bagong plano upang magpatuloy.",
        "continue": "Magpatuloy",
        "openGuide": "Buksan ang gabay",
        "amountMustBeGreaterThan": "Ang halaga ay dapat mas malaki sa {0}",
        "amountMustBeLessThan": "Ang halaga ay dapat mas mababa sa {0}",
        "billingAndUsage": "Pagbabayad at Paggamit",
        "manageSubscription": "Pamahalaan ang Subscription",
        "failedToOpenBillingUrl": "Nabigong buksan ang billing url",
        "autoChargeAmountMustBeGreaterThanThreshold": "kapag naka-enable ang auto charge, ang halaga ay dapat mas mataas kaysa sa recharge threshold (5)",
        "rechargeWillHappenImmediately": "Ang pag-recharge ay mangyayari kaagad.",
        "rechargeWillHappenImmediatelyDescription": "Ang iyong credit balance ay nasa ibaba ng recharge threshold na itinakda mo, kaya ang isang recharge ay mangyayari kaagad pagkatapos mong i-save ang mga setting na ito.",
        "amountIsRequired": "Kailangan ang halaga",
        "selectPaymentMethod": "Pumili ng paraan ng pagbabayad",
        "byContinuingYouAgree": "Sa pagpapatuloy, sumasang-ayon ka sa aming",
        "serviceCreditTerms": "mga tuntunin ng serbisyo ng kredito",
        "paidCreditsNonRefundable": "Ang mga bayad na kredito ay hindi maibabalik at mag-e-expire isang taon mula sa petsa ng pagbili.",
        "back": "Balik",
        "cancel": "Ikansela",
        "topUp": "Magdagdag ng Pondo",
        "autoRechargeIs": "Ang auto recharge ay",
        "on": "sa",
        "off": "patay",
        "viewTransactions": "Tingnan ang mga Transaksyon",
        "bankInfo": "Impormasyon ng bangko",
        "setupPayment": "I-set up ang Bayad",
        "bookingUsage": "Booking Usage",
        "overages": "Overages",
        "included": "included",
        "of": "of",
        "extra": "extra",
        "received": "Nakatanggap",
        "state": "Estado",
        "active": "Aktibo",
        "expired": "Nawalang bisa",
        "balance": "Balanseng",
        "expires": "Nagtatapos",
        "last7Days": "Huling 7 Araw",
        "viewHistory": "Tingnan ang Kasaysayan",
        "creditsListedHereWillBeRemoved": "Ang mga kredito na nakalista dito ay aalisin mula sa balanse sa kanilang petsa ng pag-expire.",
        "recentTransactions": "Mga Kamakailang Transaksyon",
        "onlyPreviewShown": "Tanging isang paunang tanaw ang ipinapakita. Tingnan ang mga transaksyon para sa buong ledger.",
        "showingTransactionsPast12Months": "Nagpapakita ng mga transaksyon sa loob ng nakaraang 12 buwan",
        "filter": "Salain",
        "export": "I-export",
        "all": "Lahat",
        "date": "Petsa",
        "amount": "Dami",
        "addOns": "Mga Karagdagan",
        "edit": "I-edit",
        "usage": "Paggamit",
        "usageThisCycle": "Paggamit sa siklong ito",
        "requests": "mga kahilingan",
        "base": "Base",
        "overage": "Overage",
        "per": "bawat",
        "endOfSubscription": "Wakas ng Subskripsyon",
        "fleetPlan": "Plano ng Pangkalahatang Sasakyan",
        "currentPlan": "Kasalukuyang plano",
        "billing": "Pagbabayad",
        "startDate": "Petsa ng Pagsisimula",
        "nextBillingDate": "Pagtatapos ng Subscription",
        "change": "Palitan",
        "getStarted": "Magsimula",
        "oneTimeSetup": "Isang Beses na Pagsasaayos:",
        "fee": "Bayad:",
        "overagePerRequest": "Overage",
        "overagePerRequestText": "ayon sa kahilingan",
        "upToRequestsIncluded": "Hanggang",
        "requestsIncluded": "kasamang mga kahilingan",
        "subscribed": "Naka-subscribe",
        "contactUs": "Makipag-ugnayan sa Amin",
        "enableOnlyWhatYouNeed": "Payagan lamang ang kailangan mo. Ang mga presyo ay nag-aayos ayon sa siklo ng pagbabayad. Ang mga add-on na batay sa paggamit para sa anumang labis ay ibabawas mula sa iyong fleet wallet.",
        "subscriptionSummary": "Buod ng Subskripsyon",
        "reviewAndUpdate": "Suriin at i-update ang iyong subscription.",
        "plan": "Plano",
        "ongoingTotal": "Patuloy na kabuuan",
        "nextBillingCycle": "Susunod na Siklo ng Pagsingil",
        "cancelSubscription": "Ikansela ang Subskripsyon",
        "areYouSureCancelSubscription": "Sigurado ka bang nais mong kanselahin ang iyong subscription? Magpapatuloy kang magkaroon ng access sa serbisyo.",
        "until": "hanggang",
        "resumeSubscription": "Ipatuloy ang Subskripsyon",
        "no": "Hindi",
        "yes": "Oo",
        "updateSubscription": "I-update ang Subscription",
        "upgrade": "Pag-upgrade",
        "from": "Mula sa:",
        "totalDueToday": "Total na dapat bayaran ngayon",
        "howProrationWorks": "Paano gumagana ang proration",
        "prorationDescription": "Anumang hindi nagamit na oras mula sa iyong kasalukuyang plano o mga add-on ay ikredito sa bagong plano. Ang mga add-on na idinagdag sa gitna ng siklo ay sisingilin lamang para sa natitirang mga araw sa kasalukuyang billing period.",
        "pleaseSelectPaymentMethod": "Pakisuyong pumili ng paraan ng pagbabayad",
        "paymentConfirmedSuccessfully": "Matagumpay na nakumpirma ang bayad",
        "failedToConfirmPayment": "Nabigong makumpirma ang bayad",
        "confirmPayment": "Confirm Payment",
        "failedToGetBillingPlan": "Nabigong makuha ang plano ng pagbabayad ayon sa country code",
        "failedToGetPreview": "Nabigong makuha ang preview billing plan",
        "failedToPreviewAddOns": "Nabigong i-preview ang mga add-on",
        "subscriptionCancelledSuccessfully": "Matagumpay na nakansela ang subscription",
        "failedToCancelSubscription": "Nabigong i-cancel ang subscription",
        "addOnChangedSuccessfully": "Matagumpay na nabago ang add-on",
        "failedToChangedAddOn": "Nabigong baguhin ang add-on",
        "failedToGetUsage": "Nabigong makuha ang paggamit",
        "annual": "Taunan",
        "monthly": "Buwanang",
        "currentPlanButton": "Kasalukuyang Plano",
        "upgradeButton": "Pag-upgrade",
        "save": "I-save",
        "expiresText": "Nawawalan ng bisa",
        "noExpiry": "Walang Pagtatapos",
        "managePayment": "Pamahalaan ang Pagbabayad",
        "changePlan": "Change Plan",
        "addOns": "Mga add-on",
        "viewUsage": "Tingnan ang usage",
        "requestWithdrawal": "Humiling ng withdrawal",
        "withdraw": "Mag-withdraw",
        "withdrawalGsn": {
            "requestWithdrawal": "Humiling ng withdrawal",
            "reviewWithdrawal": "Suriin ang withdrawal",
            "payTo": "Bayaran kay",
            "availableBalance": "Available balance ({currency})",
            "payoutBalance": "Balanse sa payout ({currency})",
            "payoutBalanceLabel": "Balanse sa payout",
            "amountOwedToPlatform": "Halagang utang sa platform",
            "availableToWithdraw": "Available para i-withdraw",
            "amountToWithdraw": "Halagang iwi-withdraw ({currency})",
            "minimumWithdrawal": "Minimum withdrawal: {amount} {currency}",
            "minimumTransferAmount": "Minimum transfer amount: {amount} {currency}",
            "noPayoutMethods": "Walang payout methods",
            "review": "Suriin",
            "payoutSpeed": "Bilis ng payout",
            "normalPayout": "Normal na payout",
            "instantPayout": "Instant payout",
            "recommended": "Inirerekomenda",
            "transferFeePercent": "{percent}% transfer fee",
            "transferFee": "Transfer fee",
            "withdrawalAmount": "Halaga ng withdrawal",
            "amountDeducted": "Bawas na halaga",
            "youWillReceive": "Makukuha mo",
            "totalToReceive": "Kabuuang matatanggap",
            "confirmWithdrawal": "Kumpirmahin ang withdrawal",
            "disclaimer": "Ang mga withdrawal ay ipinapadala sa USD",
            "disclaimer1": "Maaaring i-convert ng bangko ang pondo sa lokal na pera at mag-apply ng sariling bayad at exchange rate",
            "disclaimer2": "Ang huling halagang matatanggap ay maaaring magkaiba sa ipinadala.",
            "requestSuccess": "Matagumpay na naisumite ang withdrawal request."
        },
        "addNewPaymentMethod": "Magdagdag ng bagong payment method",
        "warningCurrentBalance": "Ang halagang utang mo sa platform ay lumampas sa kasalukuyang payout balance mo. Hindi ka maaaring mag-request ng withdrawal sa ngayon."
    },
    "signup": {
        "limitation": {
            "driver": "Driver",
            "vehicle": "Vehicle",
            "operator": "Operator",
            "drivers": "Drivers",
            "vehicles": "Vehicles",
            "operators": "Operators"
        },
        "language": "Wika",
        "contactHeader": "Para sa anumang isyu o katanungan, mangyaring makipag-ugnayan sa",
        "stepAccountTitle": "Lumikha ng Account",
        "stepAccountDesc": "Pakibigay ang iyong username at password",
        "stepCompanyTitle": "Mga Detalye ng Kumpanya",
        "stepCompanyDesc": "Idagdag ang iyong logo, tema ng kulay, at impormasyon ng kumpanya.",
        "stepZoneTitle": "Operasyon Zone",
        "stepZoneDesc": "Pumili ng iyong lungsod ng operasyon.",
        "stepPlanTitle": "Pumili ng Plano",
        "stepPlanDesc": "Pumili ng isang plano sa pagbabayad na angkop para sa iyo.",
        "stepPlanCustom": "Ang Iyong Pasadyang Plano",
        "stepPlanTitleCustom": "Suriin ang Iyong Pasadyang Plano",
        "stepPlanDescCustom": "Isang plano na nilikha partikular para sa iyong fleet.",
        "accountStepTitle": "Lumikha ng Account",
        "accountStepUsername": "Username",
        "accountStepEmail": "Email",
        "accountStepChoosePassword": "Pumili ng Password",
        "accountStepConfirmPassword": "Kumpirmahin ang Password",
        "accountStepPasswordHint": "Ang password ay dapat hindi bababa sa 8 na karakter, 1 malaking titik, at 1 espesyal na karakter.",
        "accountStepCreateAccount": "Lumikha ng Account",
        "accountStepAlreadyHaveAccount": "May account ka na?",
        "accountStepCaptchaError": "Pakipatunayan ang captcha",
        "accountStepGenericError": "Nagkaroon ng error habang gumagawa ng account",
        "accountStepSuccess": "Matagumpay na nalikha ang account",
        "usernameRequired": "Kailangan ang Username",
        "usernameMinLength": "Ang username ay dapat hindi bababa sa 3 karakter",
        "usernameMaxLength": "Ang username ay dapat na mas mababa sa 20 na karakter",
        "usernamePattern": "Ang username ay dapat magsimula sa isang maliit na letra at maaari lamang maglaman ng maliit na letra at numero",
        "emailRequired": "Kailangan ang email",
        "emailInvalid": "Ang email ay hindi wasto",
        "passwordRequired": "Kailangan ang password",
        "passwordMinLength": "Ang password ay dapat hindi bababa sa 8 karakter.",
        "passwordPattern": "Ang password ay dapat naglalaman ng hindi bababa sa 1 malaking titik at 1 espesyal na karakter.",
        "confirmPasswordMismatch": "Hindi nagtutugma ang mga password",
        "companyStepTitle": "Mga Detalye ng Kumpanya",
        "companyStepAddLogo": "Magdagdag ng Logo",
        "companyStepColorTheme": "Temang Kulay",
        "companyStepSelectThemeColor": "Pumili ng Kulay ng Tema",
        "companyStepFirstName": "Unang Pangalan",
        "companyStepLastName": "Apelyido",
        "companyStepPhone": "Telepono",
        "companyStepEmail": "Email",
        "companyStepCompanyName": "Pangalan ng Kumpanya",
        "companyStepFleetId": "Fleet ID",
        "companyStepCompanyAddress": "Address ng Kumpanya",
        "companyStepCompanyWebsite": "Website ng Kumpanya",
        "companyStepDriversNumber": "Ilang drayber ang nasa iyong fleet?",
        "companyStepVehiclesNumber": "Ilang sasakyan ang nasa iyong fleet?",
        "companyStepContinue": "Magpatuloy",
        "companyStepGenericError": "Nangyari ang isang error habang sine-save ang kumpanya",
        "companyStepSuccess": "Matagumpay na na-save ang kumpanya",
        "companyStepPhoneInvalid": "Pakilagay ang wastong numero ng telepono",
        "companyNameRequired": "Kailangan ang pangalan ng kumpanya",
        "fleetIdRequired": "Kailangan ang FleetId",
        "fleetIdPattern": "Dapat ay 4-30 na karakter, dapat magsimula sa maliit na letra at maaari lamang maglaman ng maliit na letra at numero",
        "zoneStepTitle": "I-set up ang Lugar ng Operasyon",
        "zoneStepDescription": "Ito ang iyong paunang operasyon na lugar. Para sa mga susunod na pagpapalawak, huwag mag-atubiling",
        "zoneStepSearchAddress": "Maghanap ng isang address",
        "zoneStepLatitude": "Latitud",
        "zoneStepLongitude": "Longhitud",
        "zoneStepRadius": "Gaano kalayo ang iyong lalakbayin mula sa iyong sentrong sona?",
        "zoneStepRadiusDescription": "Pinakamalayong distansya mula sa sentrong punto.",
        "zoneStepContinue": "Magpatuloy",
        "zoneStepGenericError": "Nagkaroon ng error habang nagse-save ng zone",
        "zoneStepSuccess": "Matagumpay na na-save ang zone",
        "zoneStepInvalidCoordinates": "ang latitude at longitude ay hindi wasto",
        "latitudeRequired": "Kailangan ang latitude",
        "latitudeDecimalPlaces": "Ang latitude ay maaaring magkaroon ng hanggang 10 decimal na lugar.",
        "latitudeRange": "Ang latitude ay dapat nasa pagitan ng -90 at 90 degrees",
        "longitudeRequired": "Kailangan ang longitude",
        "longitudeDecimalPlaces": "Ang longitude ay maaaring magkaroon ng hanggang 10 decimal na lugar.",
        "longitudeRange": "Ang longitude ay dapat nasa pagitan ng -180 at 180 degrees",
        "radiusRequired": "Kailangan ang radius",
        "radiusMinError": "Ang radius ay dapat hindi bababa sa {0} km",
        "radiusMaxError": "Hindi maaaring lumampas sa {0} km ang radius",
        "contactUs": "makipag-ugnayan sa amin",
        "planTitle": "Pumili ng Plano",
        "planDescription": "Pumili ng plano na akma sa iyong mga pangangailangan. Mag-upgrade o mag-cancel anumang oras. Walang nakatagong bayarin, kailanman.",
        "planDescriptionCustom": "Isang plano na binuo partikular para sa iyong fleet.",
        "billingMonthly": "Buwanang",
        "billingAnnual": "Taunan",
        "saveBadge": "Mag-save ng 20%",
        "popularBadge": "PINAKA SIKAT",
        "customPricing": "Pasadya",
        "periodAnnual": "Taunan",
        "periodMonthly": "Buwanang",
        "bonusCredits": "One Time Bonus {0} Credits",
        "savePercentage": "Mag-save ng {0}%",
        "oneTimeSetupFee": "One-Time Setup Fee",
        "waived": "Waived*",
        "planFeatures": {
            "feePerBooking39": "3.9% bawat booking",
            "feePerBooking29": "2.9% bawat booking",
            "feePerBooking": "{0} bawat karagdagang booking",
            "freeBookingPerMonth": "{0} LIBRENG booking bawat buwan",
            "unlimitedUsers": "Walang limitasyong Gumagamit",
            "commandCenterAdminDashboard": "Dashboard ng Admin ng Command Center",
            "nativeDriverApp": "Native Driver App",
            "webDriverApp": "Web Driver App",
            "customerBookingLink": "Link ng Pag-book ng Customer",
            "plusEverythingInStartup": "Dagdag pa ang lahat sa Startup",
            "corporateManagement": "Pangasiwaan ng Kumpanya",
            "invoicingManagement": "Pamahalaan ng Pagsingil",
            "driverPayoutManagement": "Pamamahala ng Bayad sa Driver",
            "promotionManagement": "Pamamahala ng Promosyon",
            "plusEverythingInPro": "Dagdag pa ang lahat sa Pro",
            "tierDiscountPricing": "Presyo ng Diskwento ayon sa Antas",
            "customFeatureDevelopment": "Pagbuo ng Pasadyang Tampok",
            "unlimitedOperators": "Walang limitasyong Operator",
            "unlimitedDrivers": "Walang limitasyong Driver",
            "unlimitedVehicles": "Walang limitasyong Sasakyan"
        },
        "planDescriptions": {
            "enterprise": "Kasama sa Enterprise ang custom billing, dedicated onboarding, Tier Discount Pricing, at Custom Feature Development upang ganap na magkasya sa iyong partikular na workflow."
        },
        "limitedNotes": "(*) Limitadong oras na eksklusibong promosyon",
        "unlimitedText": "Walang hanggan",
        "volumeDiscount": "Diskwento sa Dami",
        "letsTalkButton": "Mag-usap Tayo!",
        "buildingStepTitle": "Binubuo ang iyong fleet...",
        "congratulationsTitle": "Binabati kita! Ang Iyong Account ay Handa na",
        "congratulationsDescription": "Mag-login sa iyong admin dashboard dito.",
        "congratulationsViewDashboard": "Tingnan ang Dashboard",
        "congratulationsContact": "May mga tanong? Makipag-ugnayan sa amin sa",
        "fleetIdDescription": "Pumili ng maikli at simpleng code para sa iyong fleet — madaling ibahagi at tandaan.",
        "fleetIdPlaceholder": "hal. goodjourney",
        "firstNameRequired": "Kinakailangan ang unang pangalan",
        "logIn": "Mag-log In",
        "instead": "sa halip.",
        "submittingData": "Nagsusumite ng data...",
        "upload": "I-upload",
        "phoneNumberPlaceholder": "+1 Numero ng Telepono",
        "km": "KM",
        "selectPlan": "Pumili ng Plano",
        "upgrade": "Pag-upgrade",
        "goodJourney": "Magandang Paglalakbay",
        "loading": "Nagloload...",
        "lastNameRequired": "Kailangan ang apelyido",
        "agreeToTerms": "Sa pagpapatuloy, kinikilala mo na nabasa mo at sumasang-ayon ka sa",
        "termsOfService": "Mga Tuntunin ng Serbisyo",
        "privacyPolicy": "Patakaran sa Privacy",
        "and": "at",
        "refresh": "I-refresh",
        "takingTooLong": "Masyadong matagal?"
    },
    "addonTemplate": {
        "Addon_Template": "Add-On Template",
        "Add_On_Template": "Add-On Template",
        "Create_addon_template_success": "Add-on template has been created successfully",
        "Create_addon_template_fail": "The errors occurred while creating add-on template",
        "Update_addon_template_success": "Add-on template has been updated successfully",
        "Update_addon_template_fail": "The errors occurred while updating add-on template",
        "Update_template_success": "Template has been updated successfully",
        "Update_template_fail": "The errors occurred while updating template",
        "Edit_Template": "Edit Template",
        "New_Template": "New Template",
        "Enter_Add_On_Template_Name": "Enter Add-On Template Name*",
        "Confirm_Delete": "Confirm Delete",
        "Confirm_Delete_Message": "Are you sure you want to delete this template? Deleting this template will unlink from all the partners/corp it links to",
        "Delete_success": "Template has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting template",
        "Set_Default": "Set as Default",
        "Confirm_Set_Default_Message": "Are you sure you want to set this Add-On as default?",
        "Set_Default_Success": "Add-on template has been set as default successfully",
        "Set_Default_Fail": "The errors occurred while setting add-on template as default",
        "Clone_addon_template": "Clone Add-On Template"
    },
    "addonService": {
        "Additional_Service": "Additional Service",
        "Service_Name": "Service Name",
        "Description": "Description",
        "desPlaceholder": "Brief description of the service",
        "namePlaceholder": "e.g. Meet & Greet, Local-E Sim, GST Tax",
        "Who_pays_for_this_add_on": "Who pays for this add-on?",
        "customer": "Customer",
        "driver": "Driver",
        "fleet": "Fleet",
        "Required": "Required",
        "Apply_Tax": "Apply Tax",
        "Itemize": "Itemize",
        "Attribute": "Attribute",
        "Fee_Type": "Fee Type",
        "feeType.amount": "Amount",
        "feeType.percentageSubtotal": "Percentage of Subtotal",
        "feeType.percentageTotal": "Percentage of Total",
        "feeType.custom": "Custom (Driver Input)",
        "Unit_Settings": "Unit Settings",
        "unit.none": "None",
        "unit.perDay": "per day",
        "unit.eachTime": "each time",
        "unit.perPerson": "per person",
        "Maximum_Quantity": "Maximum Quantity",
        "Maximum_Quantity_Value": "Maximum Quantity Value",
        "How_much_will_the_fleet_make": "How much will the fleet make for this add-on?",
        "Fleet_Commission": "Fleet Commission",
        "Percentage": "Percentage",
        "Amount": "Amount",
        "Currency": "Currency",
        "Unlimited": "Unlimited",
        "Limited": "Limited",
        "Vehicle_Type": "Vehicle Type",
        "Service_Type": "Service Type",
        "Meeting_Zone": "Meeting Zone",
        "Trip_Context": "Trip Context",
        "Trip_Context_Value": {
            "departure": "Departure",
            "arrival": "Arrival"
        },
        "Operation_Zone": "Operation Zone",
        "Restricted_Zone": "Restricted Zone",
        "User_Type": "User Type",
        "Price_Unit": "Price Unit",
        "Info": "Info",
        "Rules": "Rules",
        "Basic_Information": "Basic Information",
        "Delete": "Delete",
        "Delete_addon_service": "Are you sure you want to delete this add-on service?",
        "Delete_success": "Add-on service has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting add-on service",
        "Create_addon_service_success": "Add-on service has been created successfully",
        "Create_addon_service_fail": "The errors occurred while creating add-on service",
        "Update_addon_service_success": "Add-on service has been updated successfully",
        "Update_addon_service_fail": "The errors occurred while updating add-on service",
        "Please_save_template_first": "Please save the template first before adding services",
        "Attribute_Tooltip": "Travel Attribute: Used to map this add-on to its corresponding standardized service key across connected OTAs (e.g., CHILD_SEAT, MEET_GREET).",
        "feeType": {
            "amount": "Amount",
            "percentageSubtotal": "Percentage of Subtotal",
            "percentageTotal": "Percentage of Total",
            "custom": "Custom (Driver Input)"
        },
        "unit": {
            "none": "None",
            "perDay": "Per day (Charge per day)",
            "eachTime": "Each time (Charge per ride)",
            "perPerson": "Per person (Charge per person)",
            "each": "Each (Charge per quantity)"
        },
        "none": "None",
        "perDay": "Per day",
        "eachTime": "Each time",
        "perPerson": "Per person",
        "each": "Each",
        "Unit_Settings_Title": "Unit Settings",
        "Itemize_Tooltip": "Itemize: This will list the add-on as a separate line item in the fare breakdown. If this is disabled, it will be under additional services.",
        "Booking_Channel": "Booking Channel",
        "pointToPoint": "Point To Point",
        "fromAirport": "From Airport",
        "toAirport": "To Airport",
        "hourly": "Hourly",
        "roundTrip": "Round Trip",
        "ADD_ON_BOOKING_CHANNEL_VALUE": {
            "PWA": "Web App",
            "passenger": "Customer App",
            "API": "API",
            "CC": "Command Center",
            "partner": "Partner App",
            "CarHailing": "Street Hailing",
            "streetSharing": "Street Sharing"
        },
        "Select_Attribute": "Select Attribute",
        "allowNoteInput": "Driver Input: Notes or Receipts",
        "allowNoteInputTooltip": "Allows drivers to submit notes and upload supporting photos or receipts for this service at the end of the trip (e.g. parking fees, tolls, additional charges).",
        "isDriverCapability": "Driver Capability",
        "Driver_Capability_Tooltip": "Exposes this service as a selectable capability in the driver profile. Used for driver profiling and booking-to-driver matching.",
        "isVehicleAttribute": "Vehicle Attribute",
        "Vehicle_Attribute_Tooltip": "Exposes this service as a selectable attribute in the vehicle profile. Used for vehicle profiling and booking matching.",
        "linkAtr": "Link attributes to a specific driver.",
        "addOnServicePolicy": "Add-On Policy",
        "selectAddonTemplate": "Select Add-on Template"
    }
};
